import { withPaginationDetails } from 'utils/decorators/withPaginationDetails'
import gql from 'graphql-tag'
import type * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from 'legacy/apollo/codegenReactApolloHooks'
export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  BigInt: string
  CustomersBigInt: any
  CustomersDateTime: any
  DateTime: any
  ISO8601Date: any
  ISO8601DateTime: any
  JSONObject: any
  LegacyDate: any
  Time: string
  True: true
  Url: any
}

export type AccessControlAuthorizationAuthorizationCheck = {
  __typename?: 'AccessControlAuthorizationAuthorizationCheck'
  /** Determines whether the current account has access to the given rules */
  authorized: Scalars['Boolean']
  /** An array of reasons why validation failed, if any */
  reasons: Array<RejectionReasonEnum>
}

export type AccessControlConfiguration = {
  __typename?: 'AccessControlConfiguration'
  /** The flippers associated with the account */
  flippers: AccessControlFlippers
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The access control details for the retailer */
  retailerDetails: AccessControlRetailerDetails
}

export type AccessControlConfigurationRetailerDetailsArgs = {
  retailerId: Scalars['ID']
}

export type AccessControlFlippers = {
  __typename?: 'AccessControlFlippers'
  /** The modernized version of the enterprise dashboard nav */
  modernNavigation: Scalars['Boolean']
}

export type AccessControlPolicies = {
  __typename?: 'AccessControlPolicies'
  /** Permission to view the admin tools section */
  viewAdminToolsSection: Scalars['Boolean']
  /** Permission to view the retailer dashboard section */
  viewRetailerDashboardSection: Scalars['Boolean']
}

export type AccessControlRetailerDetails = {
  __typename?: 'AccessControlRetailerDetails'
  /** The policies associated with the retailer */
  policies: AccessControlRetailerPolicies
}

export type AccessControlRetailerPolicies = {
  __typename?: 'AccessControlRetailerPolicies'
  /** Permission to modify retailer location groups */
  modifyRetailerLocationGroups: Scalars['Boolean']
  /** Permission to modify retailer reports */
  modifyRetailerReports: Scalars['Boolean']
  /** Permission to view retailer location groups */
  viewRetailerLocationGroups: Scalars['Boolean']
  /** Permission to view retailer reports */
  viewRetailerReports: Scalars['Boolean']
}

export type AccessToken = {
  __typename?: 'AccessToken'
  /** The account associated with the token */
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** A unique token for authentication purposes */
  token: Scalars['ID']
}

export enum AccountStatusEnum {
  /** Active status */
  Active = 'ACTIVE',
  /** Disabled status */
  Disabled = 'DISABLED',
  /** Pending status */
  Pending = 'PENDING',
}

export type AddProductsToRetailerCollectionRequestInput = {
  products?: InputMaybe<Array<InputMaybe<AddProductsToRetailerCollectionRequestProductToAddInput>>>
  retailerCollectionId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type AddProductsToRetailerCollectionRequestProductToAddInput = {
  id?: InputMaybe<Scalars['BigInt']>
  lookupCode?: InputMaybe<Scalars['String']>
  rrc?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
}

export type AddProductsToRetailerCollectionResponse = {
  __typename?: 'AddProductsToRetailerCollectionResponse'
  productIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type Address = {
  __typename?: 'Address'
  apartmentNumber: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  streetAddress: Maybe<Scalars['String']>
}

export type AddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  streetAddress?: InputMaybe<Scalars['String']>
}

export type AdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>
}

export type AdvanceBatchStateRequestInput = {
  alcoholic?: InputMaybe<Scalars['Boolean']>
  batchId?: InputMaybe<Scalars['BigInt']>
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>
  workflowState?: InputMaybe<Scalars['String']>
}

export type AdvanceBatchStateResponse = {
  __typename?: 'AdvanceBatchStateResponse'
  id: Maybe<Scalars['BigInt']>
  workflowState: Maybe<Scalars['String']>
}

export type AisleOrder = {
  __typename?: 'AisleOrder'
  inventoryAreaAisleId: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  rank: Maybe<Scalars['BigInt']>
}

export type AisleOrderInput = {
  inventoryAreaAisleId?: InputMaybe<Scalars['BigInt']>
  name?: InputMaybe<Scalars['String']>
  rank?: InputMaybe<Scalars['BigInt']>
}

export type Analytics = {
  __typename?: 'Analytics'
  cadence: Maybe<Cadence>
  salesPerDateUsd: Maybe<Array<Maybe<AnalyticsUnit>>>
}

export type AnalyticsUnit = {
  __typename?: 'AnalyticsUnit'
  date: Maybe<Scalars['DateTime']>
  value: Maybe<Scalars['Float']>
}

export type ApiIntegrationStoreLocation = {
  __typename?: 'ApiIntegrationStoreLocation'
  active: Maybe<Scalars['Boolean']>
  currentlySynced: Maybe<Scalars['Boolean']>
  name: Maybe<Scalars['String']>
}

export enum AssetType {
  Font = 'FONT',
  LandingPageBackgroundImage = 'LANDING_PAGE_BACKGROUND_IMAGE',
  Logo = 'LOGO',
  Unknown = 'UNKNOWN',
}

/** Autogenerated return type of AssignPermissionToRole */
export type AssignPermissionToRolePayload = {
  __typename?: 'AssignPermissionToRolePayload'
  /** The role with the new permissions */
  role: EnterpriseRole
}

export type AssignVirtualBatchRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>
  batchType?: InputMaybe<BatchType>
  driverId?: InputMaybe<Scalars['BigInt']>
  order?: InputMaybe<OrderInput>
  shopperId?: InputMaybe<Scalars['BigInt']>
}

export type AssignVirtualBatchResponse = {
  __typename?: 'AssignVirtualBatchResponse'
  id: Maybe<Scalars['BigInt']>
  workflowState: Maybe<Scalars['String']>
}

export type AttributeData = {
  __typename?: 'AttributeData'
  attributeName: Maybe<Scalars['String']>
  attributeValue: Maybe<Scalars['String']>
  productSourceId: Maybe<Scalars['BigInt']>
  sourceId: Maybe<Scalars['BigInt']>
  sourceType: Maybe<Scalars['String']>
}

export type AuditBatch = {
  __typename?: 'AuditBatch'
  allowSuggestedValues: Maybe<Scalars['Boolean']>
  auditableTaskCount: Maybe<Scalars['BigInt']>
  auditedTaskCount: Maybe<Scalars['BigInt']>
  batchId: Maybe<Scalars['BigInt']>
  batchMetadata: Maybe<Scalars['String']>
  batchState: Maybe<Scalars['String']>
  batchUuid: Maybe<Scalars['String']>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  isExplicitFailedRedrive: Maybe<Scalars['Boolean']>
  recommendedSampleSize: Maybe<Scalars['BigInt']>
  sampleTaskCount: Maybe<Scalars['BigInt']>
  sampleTasks: Maybe<Array<Maybe<AuditTask>>>
  slaDueDate: Maybe<Scalars['DateTime']>
  version: Maybe<Scalars['BigInt']>
  workflow: Maybe<Scalars['String']>
}

export enum AuditLogEntityTypeEnum {
  /** Account entity */
  Account = 'ACCOUNT',
  /** Aisle entity */
  Aisle = 'AISLE',
  /** Department entity */
  Department = 'DEPARTMENT',
  /** Item entity */
  Item = 'ITEM',
  /** Product entity */
  Product = 'PRODUCT',
  /** RetailerCampaign entity */
  RetailerCampaign = 'RETAILER_CAMPAIGN',
  /** Role entity */
  Role = 'ROLE',
}

export type AuditLogsAuditLog = {
  __typename?: 'AuditLogsAuditLog'
  /** The email of the account that made the change */
  accountEmail: Scalars['String']
  /** The UUID of the account that made the change */
  accountUuid: Scalars['ID']
  /** The entities related to this change */
  entities: Maybe<Array<AuditLogsAuditLogEntity>>
  /** Event name */
  eventName: Maybe<Scalars['String']>
  /** Time that the audit log event took place */
  eventTime: Scalars['ISO8601DateTime']
  /** The internal unique identifier for the audit log */
  id: Scalars['ID']
  /** Whether or not the change was successful */
  success: Maybe<Scalars['Boolean']>
}

/** The connection type for AuditLogsAuditLog. */
export type AuditLogsAuditLogConnection = {
  __typename?: 'AuditLogsAuditLogConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AuditLogsAuditLogEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<AuditLogsAuditLog>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AuditLogsAuditLogEdge = {
  __typename?: 'AuditLogsAuditLogEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<AuditLogsAuditLog>
}

export type AuditLogsAuditLogEntity = {
  __typename?: 'AuditLogsAuditLogEntity'
  /** The entity display name */
  entityDisplayName: Maybe<Scalars['String']>
  /** The identifier of the entity */
  entityIds: Array<Scalars['ID']>
  /** The entity type */
  entityType: AuditLogEntityTypeEnum
  /** The internal unique identifier for the audit log entity */
  id: Scalars['ID']
}

export type AuditTask = {
  __typename?: 'AuditTask'
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  entityId: Maybe<EntityId>
  extComment: Maybe<Scalars['String']>
  inputData: Maybe<Scalars['String']>
  intComment: Maybe<Scalars['String']>
  taskComponents: Maybe<Array<Maybe<AuditTaskTaskComponent>>>
  taskState: Maybe<Scalars['String']>
  taskUuid: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
  workflow: Maybe<Scalars['String']>
}

export type AuditTaskTaskComponent = {
  __typename?: 'AuditTaskTaskComponent'
  explicitAuditFailed: Maybe<Scalars['Boolean']>
  extComment: Maybe<Scalars['String']>
  intComment: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  suggestedValue: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
  valueType: Maybe<Scalars['String']>
}

export type AuditWorkflow = {
  __typename?: 'AuditWorkflow'
  approvedTaskCount: Maybe<Scalars['BigInt']>
  auditableTaskCount: Maybe<Scalars['BigInt']>
  defaultSamplePct: Maybe<Scalars['Float']>
  defaultSlaDays: Maybe<Scalars['BigInt']>
  failOverPct: Maybe<Scalars['Float']>
  firstPendingSlaDueDate: Maybe<Scalars['DateTime']>
  name: Maybe<Scalars['String']>
  rejectedTaskCount: Maybe<Scalars['BigInt']>
}

/** The method of authentication associated with an account */
export type AuthenticationInterface = {
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
}

export type AuthorizationContextInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type Banner = {
  __typename?: 'Banner'
  action: Maybe<Scalars['String']>
  actionData: Maybe<Scalars['String']>
  backgroundColorHex: Maybe<Scalars['String']>
  buttonStyle: Maybe<ButtonStyle>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaColorHex: Maybe<Scalars['String']>
  dataQuery: Maybe<DataQuery>
  id: Maybe<Scalars['BigInt']>
  imageAltText: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  locale: Maybe<InstacartCustomersSharedV1Locale>
  status: Maybe<Status>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  tagline: Maybe<Scalars['String']>
  taglineColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type BannerAction = {
  __typename?: 'BannerAction'
  doNotNavigate: Maybe<DoNotNavigate>
  navigateToCategorySurface: Maybe<NavigateToCategorySurface>
  navigateToCollection: Maybe<NavigateToCollection>
  navigateToCollectionHub: Maybe<NavigateToCollectionHub>
  navigateToContainerPathViaStoreselector: Maybe<NavigateToContainerPathViaStoreSelector>
  navigateToCouponRedemption: Maybe<NavigateToCouponRedemption>
  navigateToDepartment: Maybe<NavigateToDepartment>
  navigateToPickupStoreselector: Maybe<NavigateToPickupStoreSelector>
  navigateToProduct: Maybe<NavigateToProduct>
  navigateToPromoModal: Maybe<NavigateToPromoModal>
  navigateToRetailerCollection: Maybe<NavigateToRetailerCollection>
  navigateToRetailerCollectionViaStoreselector: Maybe<NavigateToRetailerCollectionViaStoreSelector>
  navigateToSsaStoreselector: Maybe<NavigateToSsaStoreSelector>
  navigateToStorefront: Maybe<NavigateToStorefront>
  navigateToStoreselector: Maybe<NavigateToStoreSelector>
  navigateToUrl: Maybe<NavigateToUrl>
}

export type BannerActionInput = {
  doNotNavigate?: InputMaybe<DoNotNavigateInput>
  navigateToCategorySurface?: InputMaybe<NavigateToCategorySurfaceInput>
  navigateToCollection?: InputMaybe<NavigateToCollectionInput>
  navigateToCollectionHub?: InputMaybe<NavigateToCollectionHubInput>
  navigateToContainerPathViaStoreselector?: InputMaybe<NavigateToContainerPathViaStoreSelectorInput>
  navigateToCouponRedemption?: InputMaybe<NavigateToCouponRedemptionInput>
  navigateToDepartment?: InputMaybe<NavigateToDepartmentInput>
  navigateToPickupStoreselector?: InputMaybe<NavigateToPickupStoreSelectorInput>
  navigateToProduct?: InputMaybe<NavigateToProductInput>
  navigateToPromoModal?: InputMaybe<NavigateToPromoModalInput>
  navigateToRetailerCollection?: InputMaybe<NavigateToRetailerCollectionInput>
  navigateToRetailerCollectionViaStoreselector?: InputMaybe<NavigateToRetailerCollectionViaStoreSelectorInput>
  navigateToSsaStoreselector?: InputMaybe<NavigateToSsaStoreSelectorInput>
  navigateToStorefront?: InputMaybe<NavigateToStorefrontInput>
  navigateToStoreselector?: InputMaybe<NavigateToStoreSelectorInput>
  navigateToUrl?: InputMaybe<NavigateToUrlInput>
}

export type BannerInput = {
  action?: InputMaybe<Scalars['String']>
  actionData?: InputMaybe<Scalars['String']>
  backgroundColorHex?: InputMaybe<Scalars['String']>
  buttonStyle?: InputMaybe<ButtonStyle>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaColorHex?: InputMaybe<Scalars['String']>
  dataQuery?: InputMaybe<DataQueryInput>
  id?: InputMaybe<Scalars['BigInt']>
  imageAltText?: InputMaybe<Scalars['String']>
  imageMobileUrl?: InputMaybe<Scalars['String']>
  imageUrl?: InputMaybe<Scalars['String']>
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>
  status?: InputMaybe<Status>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  tagline?: InputMaybe<Scalars['String']>
  taglineColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export enum BannerLocaleEnum {
  /** Canadian English */
  EnCa = 'EN_CA',
  /** American English */
  EnUs = 'EN_US',
  /** Canadian French */
  FrCa = 'FR_CA',
}

export type BannerType = {
  __typename?: 'BannerType'
  compactBanner: Maybe<CompactBanner>
  defaultBanner: Maybe<Banner>
  heroBanner: Maybe<HeroBanner>
  imageForward: Maybe<ImageForward>
  imageForwardFlex: Maybe<ImageForwardFlex>
  infoSheet: Maybe<StandardInfoModalSheet>
  logoWithTextBanner: Maybe<LogoWithTextBanner>
  secondaryBanner: Maybe<SecondaryBanner>
  textWithThumbnail: Maybe<TextWithThumbnail>
  textWithThumbnailFlex: Maybe<TextWithThumbnailFlex>
  unknownBanner: Maybe<UnknownBanner>
}

export type BannerTypeInput = {
  compactBanner?: InputMaybe<CompactBannerInput>
  defaultBanner?: InputMaybe<BannerInput>
  heroBanner?: InputMaybe<HeroBannerInput>
  imageForward?: InputMaybe<ImageForwardInput>
  imageForwardFlex?: InputMaybe<ImageForwardFlexInput>
  infoSheet?: InputMaybe<StandardInfoModalSheetInput>
  logoWithTextBanner?: InputMaybe<LogoWithTextBannerInput>
  secondaryBanner?: InputMaybe<SecondaryBannerInput>
  textWithThumbnail?: InputMaybe<TextWithThumbnailInput>
  textWithThumbnailFlex?: InputMaybe<TextWithThumbnailFlexInput>
  unknownBanner?: InputMaybe<UnknownBannerInput>
}

export enum BannerVariant {
  AsyncImage = 'ASYNC_IMAGE',
  AsyncModal = 'ASYNC_MODAL',
  CarouselCard = 'CAROUSEL_CARD',
  CategoryHub = 'CATEGORY_HUB',
  ChurnedUserSurvey = 'CHURNED_USER_SURVEY',
  Coachmark = 'COACHMARK',
  CompactBanner = 'COMPACT_BANNER',
  Gamification = 'GAMIFICATION',
  Header = 'HEADER',
  HeroBanner = 'HERO_BANNER',
  Image = 'IMAGE',
  ImageForward = 'IMAGE_FORWARD',
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  InformationModal = 'INFORMATION_MODAL',
  Large = 'LARGE',
  LogoWithText = 'LOGO_WITH_TEXT',
  Mega = 'MEGA',
  NavigationBanner = 'NAVIGATION_BANNER',
  OccasionHub = 'OCCASION_HUB',
  OverHeader = 'OVER_HEADER',
  RichText = 'RICH_TEXT',
  SecondaryBanner = 'SECONDARY_BANNER',
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  Survey = 'SURVEY',
  Text = 'TEXT',
  TextSlim = 'TEXT_SLIM',
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  TitledMedia = 'TITLED_MEDIA',
}

export type BatchGetUsersByIdsStrictRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
}

export type BatchGetUsersByIdsStrictResponse = {
  __typename?: 'BatchGetUsersByIdsStrictResponse'
  users: Maybe<Array<Maybe<User>>>
}

export enum BatchType {
  BatchTypeUnspecified = 'BATCH_TYPE_UNSPECIFIED',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DriveAndPick = 'DRIVE_AND_PICK',
}

export type BatchUpdatePlacementsRequestInput = {
  layout?: InputMaybe<Layout>
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type BorderRadiusSchema = {
  __typename?: 'BorderRadiusSchema'
  isCircle: Maybe<Scalars['Boolean']>
  radius: Maybe<Scalars['BigInt']>
}

export enum BotAccountAssignableRoleEnum {
  /** Engineer role */
  Engineer = 'ENGINEER',
  /** Admin role */
  NonEngineer = 'NON_ENGINEER',
}

export enum BotAccountOperationTypeEnum {
  /** Account was created */
  Created = 'CREATED',
  /** Account was updated */
  Updated = 'UPDATED',
}

/** Autogenerated return type of BotEnterpriseAccountUpsert */
export type BotEnterpriseAccountUpsertPayload = {
  __typename?: 'BotEnterpriseAccountUpsertPayload'
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount
  /** What kind of operation was executed */
  operationType: BotAccountOperationTypeEnum
}

export type BrandContact = {
  __typename?: 'BrandContact'
  email: Maybe<Scalars['String']>
  jobTitle: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
}

export type BrandProfileAnalyticsRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>
}

export type BrandProfileAnalyticsResponse = {
  __typename?: 'BrandProfileAnalyticsResponse'
  analytics: Maybe<Analytics>
}

export type BrandProfileAnalyticsSummary = {
  __typename?: 'BrandProfileAnalyticsSummary'
  brandProfileId: Maybe<Scalars['String']>
  totalSalesUsd: Maybe<Scalars['Float']>
}

export type BrandProfileAnalyticsSummaryRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type BrandProfileAnalyticsSummaryResponse = {
  __typename?: 'BrandProfileAnalyticsSummaryResponse'
  analyticsSummary: Maybe<BrandProfileAnalyticsSummary>
}

export type BrandProfileAttributes = {
  __typename?: 'BrandProfileAttributes'
  aboutBrand: Maybe<Scalars['String']>
  brandContacts: Maybe<Array<Maybe<BrandContact>>>
  brandName: Maybe<Scalars['String']>
  id: Maybe<Scalars['String']>
  imageAssets: Maybe<Array<Maybe<ImageAsset>>>
}

export type BrandProfileAttributesRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>
}

export type BrandProfileAttributesResponse = {
  __typename?: 'BrandProfileAttributesResponse'
  brandProfileAttributes: Maybe<BrandProfileAttributes>
}

export type BrandProfileSellSheetCardsRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>
}

export type BrandProfileSellSheetCardsResponse = {
  __typename?: 'BrandProfileSellSheetCardsResponse'
  sellSheetCards: Maybe<Array<Maybe<SellSheetCard>>>
}

export enum ButtonStyle {
  Detrimental = 'DETRIMENTAL',
  Plus = 'PLUS',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export enum ButtonVariantEnum {
  /** Use the dismiss button style */
  Dismiss = 'DISMISS',
  /** Use the link button style */
  Link = 'LINK',
  /** Use the plus button style */
  Plus = 'PLUS',
  /** Use the primary button style */
  Primary = 'PRIMARY',
  /** Use the secondary button style */
  Secondary = 'SECONDARY',
}

export enum Cadence {
  Weekly = 'WEEKLY',
}

export type CallbackConfigurationInput = {
  /** The access token TTL */
  accessTokenTtl?: InputMaybe<Scalars['Int']>
  /** The authentication URI */
  authUri?: InputMaybe<Scalars['String']>
  /** The possible statuses to enable */
  availableStatuses?: InputMaybe<Array<Scalars['String']>>
  /** The callback URI */
  callbackUri?: InputMaybe<Scalars['String']>
  /** The client id */
  credentialsClientId?: InputMaybe<Scalars['String']>
  /** The client id */
  credentialsClientSecret?: InputMaybe<Scalars['String']>
  /** The id */
  id: Scalars['ID']
  /** The enabled statusers */
  statusesOfInterest?: InputMaybe<Array<Scalars['String']>>
}

export enum CampaignObjective {
  Activation = 'ACTIVATION',
  Custom = 'CUSTOM',
  Invalid = 'INVALID',
  Loyalty = 'LOYALTY',
  Merchandising = 'MERCHANDISING',
  Reactivation = 'REACTIVATION',
}

export type CancelOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
  orderId?: InputMaybe<Scalars['BigInt']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type CancelOrderResponse = {
  __typename?: 'CancelOrderResponse'
  instrumentationData: Maybe<Scalars['String']>
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type CancelRetailerCampaignRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CancelRetailerCampaignResponse = {
  __typename?: 'CancelRetailerCampaignResponse'
  success: Maybe<Scalars['Boolean']>
}

export type CardList = {
  __typename?: 'CardList'
  cta: Maybe<Scalars['String']>
  dataQuery: Maybe<DataQuery>
  id: Maybe<Scalars['BigInt']>
  title: Maybe<Scalars['String']>
  variant: Maybe<CardListVariant>
}

export type CardListInput = {
  cta?: InputMaybe<Scalars['String']>
  dataQuery?: InputMaybe<DataQueryInput>
  id?: InputMaybe<Scalars['BigInt']>
  title?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<CardListVariant>
}

export enum CardListVariant {
  CardList = 'CARD_LIST',
  GridList = 'GRID_LIST',
  MarketplaceList = 'MARKETPLACE_LIST',
  PillList = 'PILL_LIST',
  RetailerForwardList = 'RETAILER_FORWARD_LIST',
  StoreDirectoryStoreForwardList = 'STORE_DIRECTORY_STORE_FORWARD_LIST',
  StoreForwardList = 'STORE_FORWARD_LIST',
  TileGridList = 'TILE_GRID_LIST',
  TileList = 'TILE_LIST',
}

export type CatalogAisle = {
  __typename?: 'CatalogAisle'
  /** The department associated with this aisle */
  department: CatalogDepartment
  /** A unique identifier for the aisle */
  id: Scalars['ID']
  /** The aisle's name - ('Candy & Chocolates', 'Chips & Pretzels', ...) */
  name: Scalars['String']
}

export type CatalogChangesetNewProductRequest = {
  __typename?: 'CatalogChangesetNewProductRequest'
  /** The aisle for the product - `Candy & Chocolate` */
  aisle: CatalogAisle
  /** Is the product alcoholic? - (true, false) */
  alcoholic: Scalars['Boolean']
  /** The product's brand - `Hershey's` */
  brand: Scalars['String']
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** The cost unit of the product - (`each`, `lb`, ...) */
  costUnit: CostUnitEnum
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** The department for the product - `Snacks` */
  department: CatalogDepartment
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description: Scalars['String']
  /** Is the product fat_free? - (true, false) */
  fatFree: Scalars['Boolean']
  /** Is the product gluten_free? - (true, false) */
  glutenFree: Scalars['Boolean']
  /** A unique identifier for the catalog changeset new product request */
  id: Scalars['ID']
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack: Maybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients: Maybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft: Maybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle: Maybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition: Maybe<Scalars['Url']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary: Scalars['Url']
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight: Maybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts: Maybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop: Maybe<Scalars['Url']>
  /** The code-lookup associated with this new product request */
  importProcessCodeLookup: CatalogImportProcessCodeLookup
  /** The id for the code-lookup associated with this new product request */
  importProcessCodeLookupId: Scalars['ID']
  /** Is the product kosher? - (true, false) */
  kosher: Scalars['Boolean']
  /** Is the product low_fat? - (true, false) */
  lowFat: Scalars['Boolean']
  /** The product's name - `Hershey's Extra Large Chocolate Bar` */
  name: Scalars['String']
  /** Is the product organic? - (true, false) */
  organic: Scalars['Boolean']
  /** The price per cost unit of the product - `17.9` */
  pricePerCostUnit: Scalars['Float']
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size: Scalars['String']
  /** Is the product sugar_free? - (true, false) */
  sugarFree: Scalars['Boolean']
  /** Is the product taxable? - (true, false) */
  taxable: Scalars['Boolean']
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
  /** Is the product vegan? - (true, false) */
  vegan: Scalars['Boolean']
  /** Is the product vegetarian? - (true, false) */
  vegetarian: Scalars['Boolean']
}

/** The connection type for CatalogChangesetNewProductRequest. */
export type CatalogChangesetNewProductRequestConnection = {
  __typename?: 'CatalogChangesetNewProductRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetNewProductRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetNewProductRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetNewProductRequestEdge = {
  __typename?: 'CatalogChangesetNewProductRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetNewProductRequest>
}

export type CatalogChangesetProduct = {
  __typename?: 'CatalogChangesetProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /** When the changeset product was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog changeset product */
  id: Scalars['ID']
  /** The actual global product associated with this changeset product */
  product: CatalogProduct
  /** The aisle for the changeset product - 'Candy & Chocolate' */
  specifiedAisle: Maybe<CatalogAisle>
  /** The cost unit of the changeset product - ('each','lb', ...) */
  specifiedCostUnit: Maybe<CostUnitEnum>
  /** The department for the changeset product - 'Snacks' */
  specifiedDepartment: Maybe<CatalogDepartment>
  /** The price per cost unit of the changeset product - '17.9' */
  specifiedPricePerCostUnit: Maybe<Scalars['Float']>
  /** The form-details status of the changeset product - (completed_info, missing_info) */
  status: ChangesetProductStatusEnum
  /** When the changeset product was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogChangesetProduct. */
export type CatalogChangesetProductConnection = {
  __typename?: 'CatalogChangesetProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogChangesetProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogChangesetProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogChangesetProductEdge = {
  __typename?: 'CatalogChangesetProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogChangesetProduct>
}

export type CatalogClassificationInfo = {
  __typename?: 'CatalogClassificationInfo'
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The associated retailer (for in-house products) */
  retailer: Maybe<Retailer>
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
}

export type CatalogCodeLookup = {
  __typename?: 'CatalogCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** The batch with the code-lookup */
  codeLookupBatch: CatalogCodeLookupBatch
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  codeLookupState: CodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  codeLookupStatus: Maybe<CodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', 'RRC') */
  codeLookupType: Maybe<CodeLookupTypeEnum>
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

export type CatalogCodeLookupBatch = {
  __typename?: 'CatalogCodeLookupBatch'
  /** The owner of the code lookup batch */
  codeLookupBatchOwner: EnterpriseAccount
  /** Wheather all the code lookups in this batch were processed or not */
  codeLookupProcessCompleted: Scalars['Boolean']
  /** List of code lookups that are part of this batch */
  codeLookups: Array<CatalogCodeLookup>
  /** When the code lookup batch was created */
  createdAt: Scalars['Time']
  /** A unique identifier */
  id: Scalars['ID']
  /** The number of code lookups in this batch that perfectly matched with one product */
  perfectMatchCount: Scalars['Int']
  /** Product IDs that perfectly matched with one of the code lookup */
  perfectMatchProductIds: Array<Scalars['ID']>
  /** When the code lookup batch was last updated */
  updatedAt: Scalars['Time']
}

/** Autogenerated return type of CatalogCodeLookupBatchCreate */
export type CatalogCodeLookupBatchCreatePayload = {
  __typename?: 'CatalogCodeLookupBatchCreatePayload'
  /** The newly created code lookup batch */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
}

/** The connection type for CatalogCodeLookup. */
export type CatalogCodeLookupConnection = {
  __typename?: 'CatalogCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogCodeLookupEdge = {
  __typename?: 'CatalogCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogCodeLookup>
}

export type CatalogDepartment = {
  __typename?: 'CatalogDepartment'
  /** An array of the department's aisles */
  aisles: Array<CatalogAisle>
  /** A unique identifier for the department */
  id: Scalars['ID']
  /** The department's name - ('Snacks', 'Meat & Seafood', ...) */
  name: Scalars['String']
}

export type CatalogImportProcess = {
  __typename?: 'CatalogImportProcess'
  /** When the import process was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog import process */
  id: Scalars['ID']
  /** The owner of the import process */
  importProcessOwner: EnterpriseAccount
  /** The state of the import process */
  importProcessState: ImportProcessStateEnum
  /** The type of the import process */
  importProcessType: ImportProcessTypeEnum
  /** Description or URL of the data source for this import process */
  source: Maybe<Scalars['String']>
  /** When the import process was last updated */
  updatedAt: Scalars['Time']
  /** The workflow associated with the import process */
  workflow: CatalogWorkflow
}

export type CatalogImportProcessCodeLookup = {
  __typename?: 'CatalogImportProcessCodeLookup'
  /** The code-lookup's code - (UPC, PLU, etc. - 034000170388) */
  code: Scalars['String']
  /** When the code-lookup was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The import process associated with the code-lookup */
  importProcess: CatalogImportProcess
  /** The state of the code-lookup - ('PENDING', 'IN_PROGRESS', ...) */
  importProcessCodeLookupState: ImportProcessCodeLookupStateEnum
  /** The status of the code-lookup - ('NO_MATCHES', 'PERFECT_MATCH', ...) */
  importProcessCodeLookupStatus: Maybe<ImportProcessCodeLookupStatusEnum>
  /** The type of the code-lookup - ('UPC', ...) */
  importProcessCodeLookupType: ImportProcessCodeLookupTypeEnum
  /** An array of product_ids's matching the provided code - (123, 456, ...). */
  productIds: Maybe<Array<Scalars['ID']>>
  /** When the code-lookup was last updated */
  updatedAt: Scalars['Time']
}

/** The connection type for CatalogImportProcessCodeLookup. */
export type CatalogImportProcessCodeLookupConnection = {
  __typename?: 'CatalogImportProcessCodeLookupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessCodeLookupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcessCodeLookup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogImportProcessCodeLookupCreate */
export type CatalogImportProcessCodeLookupCreatePayload = {
  __typename?: 'CatalogImportProcessCodeLookupCreatePayload'
  /** The newly created import process */
  catalogImportProcess: CatalogImportProcess
}

/** An edge in a connection. */
export type CatalogImportProcessCodeLookupEdge = {
  __typename?: 'CatalogImportProcessCodeLookupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcessCodeLookup>
}

/** The connection type for CatalogImportProcess. */
export type CatalogImportProcessConnection = {
  __typename?: 'CatalogImportProcessConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogImportProcessEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogImportProcess>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogImportProcessEdge = {
  __typename?: 'CatalogImportProcessEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogImportProcess>
}

export type CatalogProduct = {
  __typename?: 'CatalogProduct'
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo
  /**
   * The classified code associated with the product (Also referred to as UPC - '034000170388')
   * @deprecated Use `classification info` instead, as it has more details than `classified_code`
   */
  classifiedCode: Maybe<Scalars['String']>
  /** Details about the product, e.g. 'Brown, overripe bananas, suitable for baking */
  description: Maybe<Scalars['String']>
  /** The product's name - 'Hershey's Extra Large Chocolate Bar' */
  displayName: Scalars['String']
  /** A unique identifier for the product */
  id: Scalars['ID']
  /**
   * The product's name - 'Hershey's Extra Large Chocolate Bar'
   * @deprecated Use `display name` instead, as it has more details than `name`
   */
  name: Scalars['String']
  /** An absolute url of the primary image associated with the product - 'https://www.example.com/etc' */
  primaryImageUrl: Maybe<Scalars['String']>
}

export type CatalogRetailerProduct = {
  __typename?: 'CatalogRetailerProduct'
  /** The available item count of the retailer product */
  availableItemsCount: Maybe<Scalars['Int']>
  /** The details of the retailer product */
  details: Maybe<Scalars['String']>
  /** The display_name of the retailer product */
  displayName: Maybe<Scalars['String']>
  /** A unique identifier for the retailer product */
  id: Scalars['ID']
  /** The Url of the retailer product's primary image */
  primaryImageUrl: Maybe<Scalars['Url']>
  /** The unique identifier for the associated product */
  productId: Maybe<Scalars['ID']>
  /** The size of the retailer product (e.g., 4 oz) */
  size: Maybe<Scalars['String']>
  /** The unit count of the retailer product */
  unitCount: Maybe<Scalars['Int']>
}

/** The connection type for CatalogRetailerProduct. */
export type CatalogRetailerProductConnection = {
  __typename?: 'CatalogRetailerProductConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogRetailerProductEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogRetailerProduct>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CatalogRetailerProductEdge = {
  __typename?: 'CatalogRetailerProductEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogRetailerProduct>
}

export type CatalogSchema = {
  __typename?: 'CatalogSchema'
  _: Maybe<Scalars['Boolean']>
}

export type CatalogSearchDownloadsCatalogSearchDownloadSignedUrl = {
  __typename?: 'CatalogSearchDownloadsCatalogSearchDownloadSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type CatalogTaxonomyNode = {
  __typename?: 'CatalogTaxonomyNode'
  /** A unique identifier for the taxonomy node */
  id: Scalars['ID']
  /** The taxonomy nodes's name - ('Food', 'Meat', ...) */
  name: Scalars['String']
  /** The parent taxonomy node */
  parentId: Scalars['ID']
}

export type CatalogWorkflow = {
  __typename?: 'CatalogWorkflow'
  /** The number of associated new-changeset-product-requests with */
  changesetNewProductRequestsCount: Scalars['Int']
  /** The associated changeset products */
  changesetProducts: CatalogChangesetProductConnection
  /** The number of associated changeset products */
  changesetProductsCount: Scalars['Int']
  /** The number of associated changeset products with completed info */
  completedInfoChangesetProductsCount: Scalars['Int']
  /** When the workflow was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the catalog workflow */
  id: Scalars['ID']
  /** The number of associated code lookups */
  importProcessCodeLookupsCount: Scalars['Int']
  /** The associated import processes */
  importProcesses: CatalogImportProcessConnection
  /** The most recent update time for any associated changeset/products/requests */
  latestRelatedUpdateTime: Scalars['Time']
  /** The number of associated changeset products with missing info */
  missingInfoChangesetProductsCount: Scalars['Int']
  /** The number of associated pending code lookups */
  pendingImportProcessCodeLookupsCount: Scalars['Int']
  /** The number of associated pending match code lookups */
  perfectMatchImportProcessCodeLookupsCount: Scalars['Int']
  /** The retailer that this workflow belongs to */
  retailer: Retailer
  /** The number of associated unmatched code lookups */
  unmatchedImportProcessCodeLookupsCount: Scalars['Int']
  /** When the workflow was last updated */
  updatedAt: Scalars['Time']
  /** The owner of the workflow */
  workflowOwner: EnterpriseAccount
  /** The state of the workflow */
  workflowState: WorkflowStateEnum
  /** The type of the workflow */
  workflowType: WorkflowTypeEnum
}

export type CatalogWorkflowChangesetProductsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type CatalogWorkflowImportProcessesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

/** The connection type for CatalogWorkflow. */
export type CatalogWorkflowConnection = {
  __typename?: 'CatalogWorkflowConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CatalogWorkflowEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CatalogWorkflow>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CatalogWorkflowCreate */
export type CatalogWorkflowCreatePayload = {
  __typename?: 'CatalogWorkflowCreatePayload'
  /** The newly created workflow */
  catalogWorkflow: CatalogWorkflow
}

/** Autogenerated return type of CatalogWorkflowDelete */
export type CatalogWorkflowDeletePayload = {
  __typename?: 'CatalogWorkflowDeletePayload'
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

/** An edge in a connection. */
export type CatalogWorkflowEdge = {
  __typename?: 'CatalogWorkflowEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CatalogWorkflow>
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests */
export type CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveChangesetProducts */
export type CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups */
export type CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreateBulkUpdateChangesetProducts */
export type CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload = {
  __typename?: 'CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload'
  /** A status which is true if no errors were encountered when processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowEventCreate */
export type CatalogWorkflowEventCreatePayload = {
  __typename?: 'CatalogWorkflowEventCreatePayload'
  /** A status which is true if no errors were encountered when creating/processing the workflow event */
  success: Scalars['True']
}

/** Autogenerated return type of CatalogWorkflowSubmit */
export type CatalogWorkflowSubmitPayload = {
  __typename?: 'CatalogWorkflowSubmitPayload'
  /** Whether the submission succeeded or not */
  success: Scalars['Boolean']
}

export enum CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION',
}

export enum ChangesetProductStatusEnum {
  /** This changeset product has all the necessary information for submission */
  CompletedInfo = 'COMPLETED_INFO',
  /** This changeset product is missing some details that are required for submission */
  MissingInfo = 'MISSING_INFO',
}

export type CheckIfLaunchOnboardingInProgressByPartnerRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>
}

export type CheckIfLaunchOnboardingInProgressByPartnerResponse = {
  __typename?: 'CheckIfLaunchOnboardingInProgressByPartnerResponse'
  hasInProgressLaunchOnboarding: Maybe<Scalars['Boolean']>
  workflowState: Maybe<Scalars['String']>
}

export type CheckLaunchOnboardingProgressByPartnerRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>
}

export type CheckLaunchOnboardingProgressByPartnerResponse = {
  __typename?: 'CheckLaunchOnboardingProgressByPartnerResponse'
  workflowState: Maybe<Scalars['String']>
}

export type ClassificationInfoInput = {
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String']
  /** The id for the associated retailer (for in-house products) */
  retailerId?: InputMaybe<Scalars['ID']>
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum
}

export enum ClassifiedTypeEnum {
  /** A commodity (bananas, apples, ...) */
  Commodity = 'COMMODITY',
  /** A product that is specific to a retailer (not universal) */
  InHouse = 'IN_HOUSE',
  /** A universal product (standard product with a UPC) */
  Universal = 'UNIVERSAL',
  /** The classification type is not known */
  Unknown = 'UNKNOWN',
}

export type ClearOverrideHoursCriteriaInput = {
  date?: InputMaybe<GoogleTypeDateInput>
  serviceType?: InputMaybe<RetailerServiceType>
}

export type ClientConfiguration = {
  __typename?: 'ClientConfiguration'
  applicationType: Maybe<Scalars['String']>
  clientConfigurationId: Maybe<Scalars['Int']>
  retailerName: Maybe<Scalars['String']>
  retailerSlug: Maybe<Scalars['String']>
  settings: Maybe<Scalars['JSONObject']>
  storeConfigurationIds: Maybe<Scalars['String']>
  userIsolationContextId: Maybe<Scalars['Int']>
}

export type ClientConfigurationInput = {
  applicationType?: InputMaybe<Scalars['String']>
  clientConfigurationId?: InputMaybe<Scalars['Int']>
  retailerName?: InputMaybe<Scalars['String']>
  retailerSlug?: InputMaybe<Scalars['String']>
  settings?: InputMaybe<Scalars['JSONObject']>
  storeConfigurationIds?: InputMaybe<Scalars['String']>
  userIsolationContextId?: InputMaybe<Scalars['Int']>
}

export enum ClientContextClient {
  Ipp = 'IPP',
  Unknown = 'UNKNOWN',
}

export type ClientContextInput = {
  canonicalId?: InputMaybe<Scalars['String']>
  client?: InputMaybe<ClientContextClient>
  email?: InputMaybe<Scalars['String']>
}

export type ClientInput = {
  appName?: InputMaybe<Scalars['String']>
  contextJson?: InputMaybe<Scalars['String']>
  userEmail?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
  userName?: InputMaybe<Scalars['String']>
  userType?: InputMaybe<Scalars['String']>
}

/** Attributes for creating a code lookup */
export type CodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The lookup type (e.g., upc, rrc) for search */
  codeLookupType?: InputMaybe<CodeLookupTypeEnum>
  /** The locale code for the code lookup */
  localeCode?: InputMaybe<Scalars['String']>
  /** The retailer ID for code lookup */
  retailerId?: InputMaybe<Scalars['ID']>
}

export enum CodeLookupStateEnum {
  /** The CodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the CodeLookup */
  Failed = 'FAILED',
  /** The CodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** A brand new CodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
}

export enum CodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum CodeLookupTypeEnum {
  /** A RRC code */
  Rrc = 'RRC',
  /** A UPC code */
  Upc = 'UPC',
}

export type Collection = {
  __typename?: 'Collection'
  active: Maybe<Scalars['Boolean']>
  activeAdminOnly: Maybe<Scalars['Boolean']>
  collectionStoreConfigurations: Maybe<Array<Maybe<CollectionStoreConfiguration>>>
  collectionType: Maybe<Scalars['String']>
  endDate: Maybe<Scalars['DateTime']>
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  headerImageUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imagePath: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  legacyId: Maybe<Scalars['BigInt']>
  mobileHeaderImageUrl: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  parentId: Maybe<Scalars['BigInt']>
  position: Maybe<Scalars['BigInt']>
  replaceDepartmentIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  requiredAlcoholContext: Maybe<Scalars['String']>
  requiredRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  searchThumbWideImageUrl: Maybe<Scalars['String']>
  showDepartmentTile: Maybe<Scalars['Boolean']>
  slug: Maybe<Scalars['String']>
  startDate: Maybe<Scalars['DateTime']>
}

export enum CollectionContentTypeEnum {
  /** Collection contains other child collections */
  Collections = 'COLLECTIONS',
  /** Collection contains subjects */
  Rules = 'RULES',
}

/** Autogenerated return type of CollectionCreate */
export type CollectionCreatePayload = {
  __typename?: 'CollectionCreatePayload'
  /** The newly created collection */
  collection: CollectionsCollection
}

/** Autogenerated return type of CollectionDelete */
export type CollectionDeletePayload = {
  __typename?: 'CollectionDeletePayload'
  /** Boolean response that the collection was deleted */
  response: Scalars['Boolean']
}

export type CollectionHeaderInput = {
  /** Hex color for header background */
  backgroundColor?: InputMaybe<Scalars['String']>
  /** Hex color for header text */
  color?: InputMaybe<Scalars['String']>
  /** Description of the collection header */
  description?: InputMaybe<Scalars['String']>
  /** Display style */
  displayStyle?: InputMaybe<Scalars['String']>
  /** Header image mobile */
  imageMobile?: InputMaybe<Scalars['String']>
  /** Header image web */
  imageWeb?: InputMaybe<Scalars['String']>
  /** Title of the collection header */
  title?: InputMaybe<Scalars['String']>
}

export type CollectionStoreConfiguration = {
  __typename?: 'CollectionStoreConfiguration'
  id: Maybe<Scalars['BigInt']>
  pinned: Maybe<Scalars['Boolean']>
}

export type CollectionStorefrontBannerInput = {
  /** Whether the storefront banner is active or not */
  active: Scalars['Boolean']
  /** Background color of the storefront banner */
  backgroundColor?: InputMaybe<Scalars['String']>
  /** CTA of the storefront banner */
  cta: Scalars['String']
  /** Heading of the storefront banner */
  heading: Scalars['String']
  /** Hex value for the heading color of the storefront banner */
  headingColor: Scalars['String']
  /** Image reference path of the storefront banner */
  image: Scalars['String']
  /** Sub heading of the storefront banner */
  subHeading: Scalars['String']
  /** Sub heading hex color value of the storefront banner */
  subHeadingColor: Scalars['String']
  /** Tag for the storefront banner */
  tag?: InputMaybe<Scalars['String']>
  /** Hex color value for the tag of the storefront banner */
  tagColor?: InputMaybe<Scalars['String']>
}

export type CollectionSubjectInput = {
  /** Filter for on sale items */
  criteriaOnSale?: InputMaybe<Scalars['Boolean']>
  /** Product ids to add to the collection */
  criteriaProductIds?: InputMaybe<Array<Scalars['ID']>>
  /** Search term criteria to add to the collection */
  criteriaTerms?: InputMaybe<Array<Scalars['String']>>
  /** Id of the subject when updating */
  subjectId?: InputMaybe<Scalars['ID']>
  /** Name of the subject */
  subjectName: Scalars['String']
}

export enum CollectionTypeEnum {
  /** DESCRIPTION TODO */
  CardList = 'CARD_LIST',
  /** DESCRIPTION TODO */
  Department = 'DEPARTMENT',
  /** DESCRIPTION TODO */
  Dynamic = 'DYNAMIC',
  /** DESCRIPTION TODO */
  Explore = 'EXPLORE',
  /** DESCRIPTION TODO */
  Holiday = 'HOLIDAY',
}

/** Autogenerated return type of CollectionUpdate */
export type CollectionUpdatePayload = {
  __typename?: 'CollectionUpdatePayload'
  /** The updated collection */
  collection: CollectionsCollection
}

export type CollectionsCollection = {
  __typename?: 'CollectionsCollection'
  /** Whether or not the collection is active */
  active: Scalars['Boolean']
  /** Whether or not the collection is active only for internal admins */
  activeAdminOnly: Scalars['Boolean']
  /** Whether the collection can be edited by the current user */
  canEdit: Scalars['Boolean']
  /** Children collections of the collection */
  children: Maybe<Array<CollectionsCollection>>
  /** Type of collection */
  collectionType: Maybe<CollectionTypeEnum>
  /** End date of collection */
  endDate: Maybe<Scalars['Time']>
  /** Header for the collection */
  header: Maybe<CollectionsHeader>
  /** A unique identifier for the collection */
  id: Scalars['ID']
  /** Path of the collection image */
  imagePath: Maybe<Scalars['String']>
  /** URL of the collection image */
  imageUrl: Maybe<Scalars['String']>
  /** The name of the collection */
  name: Maybe<Scalars['String']>
  /** A unique identifier for the parent collection */
  parentId: Maybe<Scalars['ID']>
  /** Whitelisted retailers for this collection */
  requiredRetailerIds: Maybe<Array<Scalars['ID']>>
  /** The slug of the collection */
  slug: Maybe<Scalars['String']>
  /** Start date of collection */
  startDate: Maybe<Scalars['Time']>
  /** Storefront banner for the collection */
  storefrontBanner: Maybe<CollectionsStorefrontBanner>
  /** Rules for the collection */
  subjects: Maybe<Array<CollectionsSubject>>
}

/** The connection type for CollectionsCollection. */
export type CollectionsCollectionConnection = {
  __typename?: 'CollectionsCollectionConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CollectionsCollectionEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CollectionsCollection>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CollectionsCollectionEdge = {
  __typename?: 'CollectionsCollectionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<CollectionsCollection>
}

export type CollectionsHeader = {
  __typename?: 'CollectionsHeader'
  /** Color hex value of the header background */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** Color hex value of the header */
  color: Maybe<Scalars['String']>
  /** Description of the header */
  description: Maybe<Scalars['String']>
  /** Display style of the header */
  displayStyle: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the header */
  imageUrl: Maybe<Scalars['String']>
  /** Mobile image url of the header */
  mobileImageUrl: Maybe<Scalars['String']>
  /** Title of the header */
  title: Scalars['String']
}

export type CollectionsStorefrontBanner = {
  __typename?: 'CollectionsStorefrontBanner'
  /** Whether the banner is active */
  active: Maybe<Scalars['Boolean']>
  /** Background color of the storefront banner */
  backgroundColor: Maybe<Scalars['String']>
  /** Collection id associated to the header */
  collectionId: Scalars['ID']
  /** CTA of the storefront banner */
  cta: Maybe<Scalars['String']>
  /** Heading content of the storefront banner */
  heading: Maybe<Scalars['String']>
  /** Hex value heading color of the storefront banner */
  headingColor: Maybe<Scalars['String']>
  /** A unique identifier for the header */
  id: Scalars['ID']
  /** Image url of the storefront banner */
  image: Maybe<Scalars['String']>
  /** Sub heading content of the storefront banner */
  subHeading: Maybe<Scalars['String']>
  /** Sub heading color of the storefront banner */
  subHeadingColor: Maybe<Scalars['String']>
  /** Tag of the storefront banner */
  tag: Maybe<Scalars['String']>
  /** Tag color of the storefront banner */
  tagColor: Maybe<Scalars['String']>
}

export type CollectionsSubject = {
  __typename?: 'CollectionsSubject'
  /** The id of the collection the subject belongs to */
  collectionId: Scalars['ID']
  /** Filter for on sale items if true */
  criteriaOnSale: Maybe<Scalars['Boolean']>
  /** List of product ids for the subject */
  criteriaProductIds: Maybe<Array<Scalars['ID']>>
  /** List of search terms for the subject */
  criteriaTerms: Maybe<Array<Scalars['String']>>
  /** A unique identifier for the subject */
  id: Maybe<Scalars['ID']>
  /** L1 Product Category IDs */
  l1CategoryId: Maybe<Array<Scalars['ID']>>
  /** L2 Product Category IDs */
  l2CategoryId: Maybe<Array<Scalars['ID']>>
  /** L3 Product Category IDs */
  l3CategoryId: Maybe<Array<Scalars['ID']>>
  /** L4 Product Category IDs */
  l4CategoryId: Maybe<Array<Scalars['ID']>>
  /** L5 Product Category IDs */
  l5CategoryId: Maybe<Array<Scalars['ID']>>
  /** L6 Product Category IDs */
  l6CategoryId: Maybe<Array<Scalars['ID']>>
  /** Name of the subject */
  subjectName: Scalars['String']
}

export type ColorsSchema = {
  __typename?: 'ColorsSchema'
  brandExpressDark: Maybe<Scalars['String']>
  brandExpressExtraDark: Maybe<Scalars['String']>
  brandExpressLight: Maybe<Scalars['String']>
  brandExpressRegular: Maybe<Scalars['String']>
  brandHighlightDark: Maybe<Scalars['String']>
  brandHighlightLight: Maybe<Scalars['String']>
  brandHighlightRegular: Maybe<Scalars['String']>
  brandLoyaltyDark: Maybe<Scalars['String']>
  brandLoyaltyLight: Maybe<Scalars['String']>
  brandLoyaltyRegular: Maybe<Scalars['String']>
  brandPrimaryDark: Maybe<Scalars['String']>
  brandPrimaryExtraDark: Maybe<Scalars['String']>
  brandPrimaryRegular: Maybe<Scalars['String']>
  brandPromotionalDark: Maybe<Scalars['String']>
  brandPromotionalLight: Maybe<Scalars['String']>
  brandPromotionalRegular: Maybe<Scalars['String']>
  brandSecondaryDark: Maybe<Scalars['String']>
  brandSecondaryLight: Maybe<Scalars['String']>
  brandSecondaryRegular: Maybe<Scalars['String']>
  highContrastColors: Maybe<HighContrastColorsSchema>
  plusDark: Maybe<Scalars['String']>
  plusExtraDark: Maybe<Scalars['String']>
  plusExtraLight: Maybe<Scalars['String']>
  plusLight: Maybe<Scalars['String']>
  plusRegular: Maybe<Scalars['String']>
  systemDetrimentalDark: Maybe<Scalars['String']>
  systemDetrimentalExtraDark: Maybe<Scalars['String']>
  systemDetrimentalLight: Maybe<Scalars['String']>
  systemDetrimentalRegular: Maybe<Scalars['String']>
  systemGrayscale_00: Maybe<Scalars['String']>
  systemGrayscale_10: Maybe<Scalars['String']>
  systemGrayscale_20: Maybe<Scalars['String']>
  systemGrayscale_30: Maybe<Scalars['String']>
  systemGrayscale_50: Maybe<Scalars['String']>
  systemGrayscale_70: Maybe<Scalars['String']>
  systemSuccessDark: Maybe<Scalars['String']>
  systemSuccessLight: Maybe<Scalars['String']>
  systemSuccessRegular: Maybe<Scalars['String']>
  tertiaryRegular: Maybe<Scalars['String']>
}

export type CombineAuditBatchesRequestInput = {
  batchUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  client?: InputMaybe<Scalars['String']>
  workflow?: InputMaybe<Scalars['String']>
}

export type CombineAuditBatchesResponse = {
  __typename?: 'CombineAuditBatchesResponse'
  batchUuid: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
}

export type CompactBanner = {
  __typename?: 'CompactBanner'
  backgroundColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type CompactBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  imageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type ConfigurableButtonInput = {
  /** Background color of the button */
  backgroundColor?: InputMaybe<Scalars['String']>
  /** Color of the button text */
  color?: InputMaybe<Scalars['String']>
  /** The button text */
  label: Scalars['String']
  /** The button style to use */
  styleVariant?: InputMaybe<ButtonVariantEnum>
}

export type ConfigurableTextInput = {
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Scalars['String']
}

export type ConfirmedStoreHours = {
  __typename?: 'ConfirmedStoreHours'
  confirmed: Maybe<Scalars['Boolean']>
  date: Maybe<GoogleTypeDate>
  retailerLocationId: Maybe<Scalars['BigInt']>
}

export type ConfirmedStoreHoursInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>
  date?: InputMaybe<GoogleTypeDateInput>
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type ConnectRetailerCallbackConfiguration = {
  __typename?: 'ConnectRetailerCallbackConfiguration'
  accessTokenTtl: Maybe<Scalars['Int']>
  authUri: Maybe<Scalars['String']>
  clientConfigurationId: Maybe<Scalars['BigInt']>
  credentials: Maybe<ConnectRetailerCallbackCredentials>
  enabled: Maybe<Scalars['Boolean']>
  environment: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  isDeleted: Maybe<Scalars['Boolean']>
  lastUpdatedAt: Maybe<Scalars['DateTime']>
  name: Maybe<Scalars['String']>
  returnsPaymentAck: Maybe<Scalars['Boolean']>
  v1Settings: Maybe<ConnectRetailerCallbackV1Settings>
  v2Settings: Maybe<ConnectRetailerCallbackV2Settings>
}

export type ConnectRetailerCallbackConfigurationInput = {
  accessTokenTtl?: InputMaybe<Scalars['Int']>
  authUri?: InputMaybe<Scalars['String']>
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>
  credentials?: InputMaybe<ConnectRetailerCallbackCredentialsInput>
  enabled?: InputMaybe<Scalars['Boolean']>
  environment?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  isDeleted?: InputMaybe<Scalars['Boolean']>
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  returnsPaymentAck?: InputMaybe<Scalars['Boolean']>
  v1Settings?: InputMaybe<ConnectRetailerCallbackV1SettingsInput>
  v2Settings?: InputMaybe<ConnectRetailerCallbackV2SettingsInput>
}

export type ConnectRetailerCallbackCredentials = {
  __typename?: 'ConnectRetailerCallbackCredentials'
  clientId: Maybe<Scalars['String']>
  clientSecret: Maybe<Scalars['String']>
  clientSecretEnvKey: Maybe<Scalars['String']>
  customKey: Maybe<Scalars['String']>
  customTokenEnvKey: Maybe<Scalars['String']>
  grantType: Maybe<Scalars['String']>
  resource: Maybe<Scalars['String']>
  scope: Maybe<Scalars['String']>
}

export type ConnectRetailerCallbackCredentialsInput = {
  clientId?: InputMaybe<Scalars['String']>
  clientSecret?: InputMaybe<Scalars['String']>
  clientSecretEnvKey?: InputMaybe<Scalars['String']>
  customKey?: InputMaybe<Scalars['String']>
  customTokenEnvKey?: InputMaybe<Scalars['String']>
  grantType?: InputMaybe<Scalars['String']>
  resource?: InputMaybe<Scalars['String']>
  scope?: InputMaybe<Scalars['String']>
}

export type ConnectRetailerCallbackV1Settings = {
  __typename?: 'ConnectRetailerCallbackV1Settings'
  callbackUri: Maybe<Scalars['String']>
  statusesOfInterest: Maybe<Array<Maybe<Scalars['String']>>>
}

export type ConnectRetailerCallbackV1SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ConnectRetailerCallbackV2Settings = {
  __typename?: 'ConnectRetailerCallbackV2Settings'
  callbackUri: Maybe<Scalars['String']>
  orderLocationCallbackFrequency: Maybe<Scalars['BigInt']>
  statusesOfInterest: Maybe<Array<Maybe<Scalars['String']>>>
}

export type ConnectRetailerCallbackV2SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>
  orderLocationCallbackFrequency?: InputMaybe<Scalars['BigInt']>
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta'
  /** The total number of connection elements */
  totalCount: Scalars['Int']
}

export type Contact = {
  __typename?: 'Contact'
  email: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  lastName: Maybe<Scalars['String']>
  phoneNumber: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
}

export type ContactInput = {
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type ContentManagementAnnouncementBannerGenericImages = {
  __typename?: 'ContentManagementAnnouncementBannerGenericImages'
  /** The foreground image url in the placement to be used on desktop clients */
  desktop: Maybe<Scalars['Url']>
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url']
}

export type ContentManagementConfigurableButton = {
  __typename?: 'ContentManagementConfigurableButton'
  /** The background color of the button (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** Color of the button text (Eg. #000000) */
  color: Maybe<Scalars['String']>
  /** The button text */
  label: Scalars['String']
  /** The button style to use */
  styleVariant: ButtonVariantEnum
}

export type ContentManagementConfigurableText = {
  __typename?: 'ContentManagementConfigurableText'
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String']
  /** The text to display */
  text: Maybe<Scalars['String']>
}

export type ContentManagementFlyoutPlacement = {
  __typename?: 'ContentManagementFlyoutPlacement'
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** The style and text of the subheading */
  descriptionText: ContentManagementConfigurableText
  /** The style and text of the secondary text */
  disclaimerText: Maybe<ContentManagementConfigurableText>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The style and text of the button within the placement */
  linkButton: Maybe<ContentManagementConfigurableButton>
  /** Where interacting with the placement leads */
  linkDestination: Maybe<ContentManagementPlacementDestination>
  /** Locale */
  locale: BannerLocaleEnum
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The style and text of the button within the placement */
  primaryButton: Maybe<ContentManagementConfigurableButton>
  /** Where interacting with the placement leads */
  primaryDestination: Maybe<ContentManagementPlacementDestination>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The style and text of the button within the placement */
  secondaryButton: Maybe<ContentManagementConfigurableButton>
  /** Where interacting with the placement leads */
  secondaryDestination: Maybe<ContentManagementPlacementDestination>
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the heading */
  titleText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementHeroBannerPlacement = {
  __typename?: 'ContentManagementHeroBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The color of the text area (Eg. #FFFFFF) */
  textareaColor: Maybe<Scalars['String']>
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementPbiConfiguration = {
  __typename?: 'ContentManagementPbiConfiguration'
  /** The url for the retailer's pbi instance */
  domainName: Scalars['String']
  /** The unique slug for the retailer */
  slug: Scalars['String']
}

export type ContentManagementPlacementDestination = {
  __typename?: 'ContentManagementPlacementDestination'
  /** The human readable value of the target */
  displayValue: Maybe<Scalars['String']>
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
}

export type ContentManagementPlacementExperiment = {
  __typename?: 'ContentManagementPlacementExperiment'
  /** Experiment Assignment or Lookup */
  accessMethod: Maybe<PlacementExperimentMethodEnum>
  /** Name of the Experiment */
  name: Maybe<Scalars['String']>
  /** Variant of the Experiment for which placement should be visible */
  variant: Maybe<Scalars['String']>
}

export type ContentManagementPlacementImages = {
  __typename?: 'ContentManagementPlacementImages'
  /** The image url of the placement to display for large viewports */
  large: Maybe<Scalars['Url']>
  /** The image url of the placement to display for small viewports */
  small: Maybe<Scalars['Url']>
}

export type ContentManagementPlacementSchedule = {
  __typename?: 'ContentManagementPlacementSchedule'
  /** When the placement should stop being active */
  endDate: Maybe<Scalars['Time']>
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Maybe<Scalars['String']>
}

export type ContentManagementSecondaryBannerPlacement = {
  __typename?: 'ContentManagementSecondaryBannerPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The style and text of the secondary text */
  secondaryText: Maybe<ContentManagementConfigurableText>
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacement = {
  __typename?: 'ContentManagementStorefrontPlacement'
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** A unique identifier of the banner associated with the placement */
  bannerId: Maybe<Scalars['ID']>
  /** The banners configured to the placement */
  banners: Array<ContentManagementStorefrontPlacementBanner>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** Where interacting with the placement leads */
  destination: Maybe<ContentManagementPlacementDestination>
  /** Whether or not the placement can be dismissed */
  dismissable: Scalars['Boolean']
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementStorefrontPlacementBanner = {
  __typename?: 'ContentManagementStorefrontPlacementBanner'
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Maybe<Scalars['String']>
  /** The style and text of the button within the placement */
  button: Maybe<ContentManagementConfigurableButton>
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText
  /** A unique identifier of the banner associated with the placement */
  id: Maybe<Scalars['ID']>
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: ContentManagementPlacementImages
  /** The banner's locale */
  locale: Maybe<BannerLocaleEnum>
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText
}

/** The connection type for ContentManagementStorefrontPlacement. */
export type ContentManagementStorefrontPlacementConnection = {
  __typename?: 'ContentManagementStorefrontPlacementConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContentManagementStorefrontPlacementEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ContentManagementStorefrontPlacement>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ContentManagementStorefrontPlacementEdge = {
  __typename?: 'ContentManagementStorefrontPlacementEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ContentManagementStorefrontPlacement>
}

export type ContentManagementUnknownBannerPlacement = {
  __typename?: 'ContentManagementUnknownBannerPlacement'
  /** When the placement was created */
  createdAt: Scalars['Time']
  /** If the placement is enabled */
  enabled: Scalars['Boolean']
  /** Experiment associated with the placement */
  experiment: Maybe<ContentManagementPlacementExperiment>
  /** A unique identifier for the placement */
  id: Scalars['ID']
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank: Scalars['Int']
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule
  /** The current status of the placement */
  status: PlacementStatusEnum
  /** The type of this placement */
  type: PlacementTypeEnum
  /** When the placement was last edited */
  updatedAt: Scalars['Time']
}

export type ContentManagementVisibilityConditionCountryIds = {
  __typename?: 'ContentManagementVisibilityConditionCountryIds'
  /** list of country ids */
  countryIds: Array<Scalars['Int']>
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionDayOfWeek = {
  __typename?: 'ContentManagementVisibilityConditionDayOfWeek'
  /** list of days within the week */
  days: Array<Scalars['String']>
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionExperimentVariant = {
  __typename?: 'ContentManagementVisibilityConditionExperimentVariant'
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum
  /** The name of the experiment */
  experimentName: Scalars['String']
  /** The name of the experiment variant */
  experimentVariant: Scalars['String']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionExpressMembership = {
  __typename?: 'ContentManagementVisibilityConditionExpressMembership'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout = {
  __typename?: 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Maybe<Scalars['ID']>
}

export type ContentManagementVisibilityConditionMatchesAnyRetailerId = {
  __typename?: 'ContentManagementVisibilityConditionMatchesAnyRetailerId'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>
}

export type ContentManagementVisibilityConditionMinimumPlatformVersion = {
  __typename?: 'ContentManagementVisibilityConditionMinimumPlatformVersion'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

export type ContentManagementVisibilityConditionNewVerticalUserTargeting = {
  __typename?: 'ContentManagementVisibilityConditionNewVerticalUserTargeting'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** The module type */
  moduleType: Scalars['String']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionRetailerAvailability = {
  __typename?: 'ContentManagementVisibilityConditionRetailerAvailability'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** A unique identifier of the retailer associated with the visibility condition */
  retailerId: Scalars['Int']
}

export type ContentManagementVisibilityConditionShopped = {
  __typename?: 'ContentManagementVisibilityConditionShopped'
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int']
  /** Number of times in the past to check */
  numberOfTimes: Scalars['Int']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int']
}

export type ContentManagementVisibilityConditionShoppedAtRetailer = {
  __typename?: 'ContentManagementVisibilityConditionShoppedAtRetailer'
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int']
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int']
}

export type ContentManagementVisibilityConditionUnknownVisibilityCondition = {
  __typename?: 'ContentManagementVisibilityConditionUnknownVisibilityCondition'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionUserInteractionLimit = {
  __typename?: 'ContentManagementVisibilityConditionUserInteractionLimit'
  /** Number of seconds to wait before resetting the counter */
  countCooldownSec: Maybe<Scalars['Int']>
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** Maximum number of dismiss events */
  maxDismissedCount: Maybe<Scalars['Int']>
  /** Maximum number of click events */
  maxEngagementsCount: Maybe<Scalars['Int']>
  /** Maximum number of view events */
  maxImpressionsCount: Maybe<Scalars['Int']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

export type ContentManagementVisibilityConditionUtmParameters = {
  __typename?: 'ContentManagementVisibilityConditionUtmParameters'
  /** coupon_code */
  couponCode: Scalars['String']
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** utm_campaign */
  utmCampaign: Scalars['String']
  /** utm_content */
  utmContent: Scalars['String']
  /** utm_medium */
  utmMedium: Scalars['String']
  /** utm_source */
  utmSource: Scalars['String']
  /** utm_term */
  utmTerm: Scalars['String']
}

export type ContentManagementVisibilityConditionWhitelistedPostalCodes = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedPostalCodes'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

export type ContentManagementVisibilityConditionWhitelistedZones = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedZones'
  /** A unique identifier for the visibility condition */
  id: Scalars['ID']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of zone ids */
  zones: Array<Scalars['String']>
}

export type ContentPage = {
  __typename?: 'ContentPage'
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  internalName: Maybe<Scalars['String']>
  layout: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
  storeConfigurationId: Maybe<Scalars['BigInt']>
}

export type ContentPageV2 = {
  __typename?: 'ContentPageV2'
  activeVersionId: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  internalName: Maybe<Scalars['String']>
  pageType: Maybe<Scalars['String']>
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  slug: Maybe<Scalars['String']>
  storeConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type ContentPageVersion = {
  __typename?: 'ContentPageVersion'
  contentPageId: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  previewToken: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum CostUnitEnum {
  /** The `each` cost unit */
  Each = 'EACH',
  /** The `kg` cost unit */
  Kilogram = 'KILOGRAM',
  /** The `lb` cost unit */
  Pound = 'POUND',
}

export type CountryIdsInput = {
  /** list of country ids */
  countryIds: Array<Scalars['Int']>
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

/** Autogenerated return type of CountryIdsVisibilityConditionCreate */
export type CountryIdsVisibilityConditionCreatePayload = {
  __typename?: 'CountryIdsVisibilityConditionCreatePayload'
  /** The newly created CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds
}

/** Autogenerated return type of CountryIdsVisibilityConditionUpdate */
export type CountryIdsVisibilityConditionUpdatePayload = {
  __typename?: 'CountryIdsVisibilityConditionUpdatePayload'
  /** The newly updated CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds
}

export type CreateClientConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>
  clientConfiguration?: InputMaybe<ClientConfigurationInput>
}

export type CreateClientConfigurationResponse = {
  __typename?: 'CreateClientConfigurationResponse'
  clientConfiguration: Maybe<ClientConfiguration>
  errorMessage: Maybe<Scalars['String']>
  success: Maybe<Scalars['Boolean']>
}

export type CreateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type CreateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'CreateConnectRetailerCallbackConfigurationResponse'
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>
  errorMessage: Maybe<Scalars['String']>
  success: Maybe<Scalars['Boolean']>
}

export type CreateContentPageRequestInput = {
  internalName?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type CreateContentPageRequestV2Input = {
  internalName?: InputMaybe<Scalars['String']>
  pageType?: InputMaybe<Scalars['String']>
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  slug?: InputMaybe<Scalars['String']>
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  teamOwner?: InputMaybe<Scalars['String']>
}

export type CreateContentPageResponse = {
  __typename?: 'CreateContentPageResponse'
  contentPage: Maybe<ContentPage>
}

export type CreateContentPageResponseV2 = {
  __typename?: 'CreateContentPageResponseV2'
  contentPage: Maybe<ContentPageV2>
}

export type CreateContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>
  baseContentPageVersionId?: InputMaybe<Scalars['BigInt']>
  contentPageId?: InputMaybe<Scalars['BigInt']>
}

export type CreateContentPageVersionResponse = {
  __typename?: 'CreateContentPageVersionResponse'
  contentPageVersion: Maybe<ContentPageVersion>
}

export type CreateDriverRequestInput = {
  email?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
}

export type CreateDriverResponse = {
  __typename?: 'CreateDriverResponse'
  id: Maybe<Scalars['BigInt']>
}

export type CreateImageUploadBatchRequestInput = {
  imagesZipKey?: InputMaybe<Scalars['String']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
}

export type CreateImageUploadBatchResponse = {
  __typename?: 'CreateImageUploadBatchResponse'
  imageUploadBatchId: Maybe<Scalars['BigInt']>
  status: Maybe<Scalars['String']>
}

export type CreateInventoryFileMappingRequestInput = {
  collectionSlug?: InputMaybe<Scalars['String']>
  retailerCollectionId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateInventoryFileMappingResponse = {
  __typename?: 'CreateInventoryFileMappingResponse'
  success: Maybe<Scalars['Boolean']>
}

export type CreateLastmileOrderFromDashboardRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateLastmileOrderFromDashboardResponse = {
  __typename?: 'CreateLastmileOrderFromDashboardResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type CreateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateLayoutVariantResponse = {
  __typename?: 'CreateLayoutVariantResponse'
  layoutVariant: Maybe<LayoutVariant>
}

export type CreateNavigationPreviewRequestInput = {
  navigation?: InputMaybe<NavigationInput>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type CreateNavigationPreviewResponse = {
  __typename?: 'CreateNavigationPreviewResponse'
  previewToken: Maybe<Scalars['String']>
}

export type CreateNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>
  navigation?: InputMaybe<NavigationInput>
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type CreateNavigationResponse = {
  __typename?: 'CreateNavigationResponse'
  navigation: Maybe<Navigation>
}

export type CreateOnboardingStoreLocationRequestInput = {
  address?: InputMaybe<AddressInput>
  token?: InputMaybe<Scalars['String']>
}

export type CreateOnboardingStoreLocationResponse = {
  __typename?: 'CreateOnboardingStoreLocationResponse'
  onboarding: Maybe<Onboarding>
}

export type CreateOosAcknowledgmentRequestInput = {
  oosId?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type CreateOosAcknowledgmentResponse = {
  __typename?: 'CreateOosAcknowledgmentResponse'
  _: Maybe<Scalars['Boolean']>
}

export type CreateOrUpdateLinkAutosuggestionAdminParametersInput = {
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionAdminInput>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateOrUpdateLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type CreateOrUpdateLinkAutosuggestionAdminResponse = {
  __typename?: 'CreateOrUpdateLinkAutosuggestionAdminResponse'
  linkAutosuggestion: Maybe<LinkAutosuggestionAdmin>
}

export type CreatePiiRequestForRetailerRequestInput = {
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  requestType?: InputMaybe<RequestType>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type CreatePiiRequestForRetailerResponse = {
  __typename?: 'CreatePiiRequestForRetailerResponse'
  piiRequestCreationStatus: Maybe<PiiRequestCreationStatus>
  piiRequestId: Maybe<Scalars['BigInt']>
}

export type CreatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>
  content?: InputMaybe<PlacementContentInput>
}

export type CreatePlacementContentResponse = {
  __typename?: 'CreatePlacementContentResponse'
  content: Maybe<PlacementContent>
}

export type CreatePlacementRequestInput = {
  placement?: InputMaybe<PlacementInput>
}

export type CreatePlacementResponse = {
  __typename?: 'CreatePlacementResponse'
  placement: Maybe<Placement>
}

export type CreateRetailerCampaignRequestInput = {
  campaignObjective?: InputMaybe<CampaignObjective>
  couponCount?: InputMaybe<Scalars['BigInt']>
  endsAt?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  startsAt?: InputMaybe<Scalars['DateTime']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>
}

export type CreateRetailerCollectionRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  defaultSortOrder?: InputMaybe<RetailerCollectionSortOrder>
  endDate?: InputMaybe<Scalars['DateTime']>
  filters?: InputMaybe<Array<InputMaybe<RetailerCollectionFilterInput>>>
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['Int']>
  products?: InputMaybe<Array<InputMaybe<RetailerCollectionProductPayloadInput>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<RetailerCollectionStatus>
  storeConfigurations?: InputMaybe<Array<InputMaybe<RetailerCollectionStoreConfigurationInput>>>
  surfaces?: InputMaybe<Array<InputMaybe<RetailerCollectionSurface>>>
  tileImageUrl?: InputMaybe<Scalars['String']>
  translations?: InputMaybe<Array<InputMaybe<RetailerCollectionTranslationInput>>>
}

export type CreateRetailerCollectionResponse = {
  __typename?: 'CreateRetailerCollectionResponse'
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type CreateRoleInput = {
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>
  /** The name of the role */
  name: Scalars['String']
  partnerId?: InputMaybe<Scalars['ID']>
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type CreateSignupRequestInput = {
  email?: InputMaybe<Scalars['String']>
  entityName?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  signupPartnerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateSignupResponse = {
  __typename?: 'CreateSignupResponse'
  token: Maybe<Scalars['String']>
}

export type CreateStoreConfigurationDraftRequestInput = {
  draftName?: InputMaybe<Scalars['String']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type CreateStoreConfigurationDraftResponse = {
  __typename?: 'CreateStoreConfigurationDraftResponse'
  domainConfigurations: Maybe<DomainConfiguration>
  draftId: Maybe<Scalars['String']>
  draftName: Maybe<Scalars['String']>
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
  storeConfigurationId: Maybe<Scalars['BigInt']>
}

export type CreateStoreConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>
  storeConfiguration?: InputMaybe<StoreConfigurationInput>
}

export type CreateStoreConfigurationResponse = {
  __typename?: 'CreateStoreConfigurationResponse'
  errorMessage: Maybe<Scalars['String']>
  storeConfiguration: Maybe<StoreConfiguration>
  success: Maybe<Scalars['Boolean']>
}

export type CreateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>
}

export type CreateThemePageResponse = {
  __typename?: 'CreateThemePageResponse'
  themePage: Maybe<ThemePage>
}

export type CreateTicketRequestInput = {
  assignee?: InputMaybe<UserInput>
  client?: InputMaybe<ClientInput>
  description?: InputMaybe<Scalars['String']>
  entityIds?: InputMaybe<Array<InputMaybe<EntityIdInput>>>
  entityType?: InputMaybe<EntityType>
  localeCode?: InputMaybe<Scalars['String']>
  problemType?: InputMaybe<ProblemType>
  reportedOnBehalfOf?: InputMaybe<UserInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type CreateTicketResponse = {
  __typename?: 'CreateTicketResponse'
  cptTicketId: Maybe<Scalars['BigInt']>
}

export type CreateValueBasedOverrideRequestInput = {
  valueBasedOverride?: InputMaybe<ValueBasedOverrideRequestInput>
}

export type CreateValueBasedOverrideResponse = {
  __typename?: 'CreateValueBasedOverrideResponse'
  valueBasedOverride: Maybe<ValueBasedOverrideResponse>
}

export type CustomFontFamilySchema = {
  __typename?: 'CustomFontFamilySchema'
  customFontFamily: Maybe<FontFamily>
}

export enum CustomersAddressType {
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED',
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL',
}

export type CustomersAdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['CustomersBigInt']>
}

export type CustomersAmounts = {
  __typename?: 'CustomersAmounts'
  amount: Maybe<CustomersGoogleTypeMoney>
  labelInEnglish: Maybe<Scalars['String']>
}

export type CustomersContext = {
  __typename?: 'CustomersContext'
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
  storeConfigurationId: Maybe<Scalars['Int']>
}

export type CustomersGetHandlingDetailsRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersGetHandlingDetailsResponse = {
  __typename?: 'CustomersGetHandlingDetailsResponse'
  handlingDetails: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>
  handlingDetailsByOrderReference: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>
}

export type CustomersGetHandlingDetailsResponseHandlingDetails = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetails'
  acceptableRetailerLocationIds: Maybe<Array<Maybe<Scalars['CustomersBigInt']>>>
  delivery: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsDelivery>
  pickup: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsPickup>
  specialRequirements: Maybe<
    Array<Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsSpecialRequirement>>
  >
}

export type CustomersGetHandlingDetailsResponseHandlingDetailsDelivery = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsDelivery'
  address: Maybe<CustomersGoogleTypePostalAddress>
  addressId: Maybe<Scalars['CustomersBigInt']>
  addressType: Maybe<CustomersAddressType>
  customerManualLatLng: Maybe<CustomersGoogleTypeLatLng>
  doorCode: Maybe<Scalars['String']>
  dropoffLocation: Maybe<Scalars['String']>
  instructions: Maybe<Scalars['String']>
  latLng: Maybe<CustomersGoogleTypeLatLng>
  notes: Maybe<Scalars['String']>
  zoneId: Maybe<Scalars['CustomersBigInt']>
}

export type CustomersGetHandlingDetailsResponseHandlingDetailsPickup = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsPickup'
  address: Maybe<CustomersGoogleTypePostalAddress>
  addressId: Maybe<Scalars['CustomersBigInt']>
  instructions: Maybe<Scalars['String']>
  latLng: Maybe<CustomersGoogleTypeLatLng>
}

export enum CustomersGetHandlingDetailsResponseHandlingDetailsSpecialRequirement {
  AlcoholCompliant = 'ALCOHOL_COMPLIANT',
  CertifiedDelivery = 'CERTIFIED_DELIVERY',
  DisableShopperAdds = 'DISABLE_SHOPPER_ADDS',
  EbtRetailerLocationConstrained = 'EBT_RETAILER_LOCATION_CONSTRAINED',
  IncludesEbtPayment = 'INCLUDES_EBT_PAYMENT',
  OrderAhead = 'ORDER_AHEAD',
  RestrictedOtcCompliant = 'RESTRICTED_OTC_COMPLIANT',
  RxCompliant = 'RX_COMPLIANT',
  RxOnlyCompliant = 'RX_ONLY_COMPLIANT',
  SpecialRequirementUnspecified = 'SPECIAL_REQUIREMENT_UNSPECIFIED',
  UnattendedDelivery = 'UNATTENDED_DELIVERY',
}

export type CustomersGetOrderAmountsSummaryV0RequestInput = {
  orderReference?: InputMaybe<Scalars['String']>
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersGetOrderAmountsSummaryV0Response = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0Response'
  orderAmountsSummary: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>
  orderAmountsSummaryByOrderReference: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>
}

export type CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary'
  orderAmounts: Maybe<Array<Maybe<CustomersAmounts>>>
}

export type CustomersGetOrderLinesRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersGetOrderLinesResponse = {
  __typename?: 'CustomersGetOrderLinesResponse'
  orderLines: Maybe<CustomersGetOrderLinesResponseOrderLines>
  orderLinesByOrderReference: Maybe<CustomersGetOrderLinesResponseOrderLines>
}

export type CustomersGetOrderLinesResponseOrderLines = {
  __typename?: 'CustomersGetOrderLinesResponseOrderLines'
  lineItems: Maybe<Array<Maybe<CustomersOrderLine>>>
}

export type CustomersGetOrderRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersGetOrderResponse = {
  __typename?: 'CustomersGetOrderResponse'
  order: Maybe<CustomersOrder>
  ordersByOrderReference: Maybe<CustomersOrder>
}

export type CustomersGetPaymentMethodSummaryRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersGetPaymentMethodSummaryResponse = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponse'
  paymentMethodSummariesByOrderReference: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>
  paymentMethodSummary: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>
}

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary'
  paymentMethod: Maybe<
    Array<Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod>>
  >
}

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod'
  label: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
}

export type CustomersGoogleTypeDate = {
  __typename?: 'CustomersGoogleTypeDate'
  day: Maybe<Scalars['Int']>
  month: Maybe<Scalars['Int']>
  year: Maybe<Scalars['Int']>
}

export type CustomersGoogleTypeLatLng = {
  __typename?: 'CustomersGoogleTypeLatLng'
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
}

export type CustomersGoogleTypeMoney = {
  __typename?: 'CustomersGoogleTypeMoney'
  currencyCode: Maybe<Scalars['String']>
  nanos: Maybe<Scalars['Int']>
  units: Maybe<Scalars['CustomersBigInt']>
}

export type CustomersGoogleTypePostalAddress = {
  __typename?: 'CustomersGoogleTypePostalAddress'
  addressLines: Maybe<Array<Maybe<Scalars['String']>>>
  administrativeArea: Maybe<Scalars['String']>
  languageCode: Maybe<Scalars['String']>
  locality: Maybe<Scalars['String']>
  organization: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  recipients: Maybe<Array<Maybe<Scalars['String']>>>
  regionCode: Maybe<Scalars['String']>
  revision: Maybe<Scalars['Int']>
  sortingCode: Maybe<Scalars['String']>
  sublocality: Maybe<Scalars['String']>
}

export enum CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType {
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
  Asap = 'ASAP',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  Eta = 'ETA',
  FiveHour = 'FIVE_HOUR',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  HyperFast = 'HYPER_FAST',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OneHour = 'ONE_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  RetailerInstore = 'RETAILER_INSTORE',
  RetailerManaged = 'RETAILER_MANAGED',
  ScanAndPay = 'SCAN_AND_PAY',
  Scheduled = 'SCHEDULED',
  ThreeHour = 'THREE_HOUR',
  TwoHour = 'TWO_HOUR',
  Ultrafast = 'ULTRAFAST',
  VirtualExpress = 'VIRTUAL_EXPRESS',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP',
}

export type CustomersInstacartCustomersSharedV1PageInfo = {
  __typename?: 'CustomersInstacartCustomersSharedV1PageInfo'
  endCursor: Maybe<Scalars['String']>
  hasNextPage: Maybe<Scalars['Boolean']>
}

export type CustomersInstacartCustomersSharedV1PaginationInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type CustomersInstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>
  countryId?: InputMaybe<Scalars['Int']>
  storeConfigurationId?: InputMaybe<Scalars['Int']>
}

export enum CustomersInstacartCustomersSharedV1ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Virtual = 'VIRTUAL',
}

export type CustomersInstacartTypesV1MeasuredQuantity = {
  __typename?: 'CustomersInstacartTypesV1MeasuredQuantity'
  quantity: Maybe<Scalars['Float']>
  unit: Maybe<CustomersInstacartTypesV1MeasurementUnit>
}

export type CustomersInstacartTypesV1MeasurementUnit = {
  __typename?: 'CustomersInstacartTypesV1MeasurementUnit'
  costUnit: Maybe<CustomersInstacartTypesV1MeasurementUnitCostUnit>
  unitCode: Maybe<Scalars['String']>
}

export enum CustomersInstacartTypesV1MeasurementUnitCostUnit {
  CostUnitUnspecified = 'COST_UNIT_UNSPECIFIED',
  Each = 'EACH',
  FlOz = 'FL_OZ',
  Gallon = 'GALLON',
  Gram = 'GRAM',
  Kg = 'KG',
  Lb = 'LB',
  Liter = 'LITER',
  Ml = 'ML',
  Oz = 'OZ',
  Pint = 'PINT',
  Quart = 'QUART',
}

export type CustomersListOrdersRequestFilterSetDateRangeInput = {
  from?: InputMaybe<Scalars['CustomersDateTime']>
  to?: InputMaybe<Scalars['CustomersDateTime']>
}

export type CustomersListOrdersRequestFilterSetInput = {
  creationDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>
  fulfillmentDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>
  orderStatusCriteria?: InputMaybe<
    Array<InputMaybe<CustomersListOrdersRequestFilterSetOrderStatusCriteria>>
  >
  query?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
  serviceType?: InputMaybe<CustomersInstacartCustomersSharedV1ServiceType>
}

export enum CustomersListOrdersRequestFilterSetOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED',
}

export type CustomersListOrdersRequestInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>
  filters?: InputMaybe<CustomersListOrdersRequestFilterSetInput>
  pagination?: InputMaybe<CustomersInstacartCustomersSharedV1PaginationInput>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
  userId?: InputMaybe<Scalars['CustomersBigInt']>
}

export type CustomersListOrdersResponse = {
  __typename?: 'CustomersListOrdersResponse'
  orderSummaries: Maybe<Array<Maybe<CustomersListOrdersResponseOrderSummary>>>
  orders: Maybe<Array<Maybe<CustomersOrder>>>
  pageInfo: Maybe<CustomersInstacartCustomersSharedV1PageInfo>
}

export type CustomersListOrdersResponseOrderSummary = {
  __typename?: 'CustomersListOrdersResponseOrderSummary'
  creationDate: Maybe<Scalars['CustomersDateTime']>
  externalId: Maybe<Scalars['String']>
  fulfillmentDate: Maybe<Scalars['CustomersDateTime']>
  fulfillmentType: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>
  id: Maybe<Scalars['CustomersBigInt']>
  legacyOrderId: Maybe<Scalars['CustomersBigInt']>
  orderReference: Maybe<Scalars['String']>
  retailerLocationId: Maybe<Scalars['CustomersBigInt']>
  totalAmount: Maybe<CustomersGoogleTypeMoney>
  userId: Maybe<Scalars['CustomersBigInt']>
  workflowState: Maybe<CustomersWorkflowState>
}

export type CustomersOrder = {
  __typename?: 'CustomersOrder'
  checkoutRetailerLocationId: Maybe<Scalars['CustomersBigInt']>
  clientConfigurationId: Maybe<Scalars['CustomersBigInt']>
  closestRetailerLocationId: Maybe<Scalars['CustomersBigInt']>
  communicationLocale: Maybe<Scalars['String']>
  countryId: Maybe<Scalars['CustomersBigInt']>
  creationDate: Maybe<Scalars['CustomersDateTime']>
  customerOrderNumber: Maybe<Scalars['CustomersBigInt']>
  expressSubscriptionId: Maybe<Scalars['CustomersBigInt']>
  fulfillmentType: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>
  fulfillmentWindow: Maybe<CustomersOrderOrderFulfillmentWindow>
  id: Maybe<Scalars['CustomersBigInt']>
  legacyOrderId: Maybe<Scalars['CustomersBigInt']>
  loyaltyNumber: Maybe<Scalars['String']>
  orderReference: Maybe<Scalars['String']>
  plannedDeliveredAt: Maybe<Scalars['CustomersDateTime']>
  plannedDeliveryStartedAt: Maybe<Scalars['CustomersDateTime']>
  retailerExternalOrderId: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['CustomersBigInt']>
  retailerOriginatedData: Maybe<CustomersOrderRetailerOriginatedData>
  retailerReferenceId: Maybe<Scalars['String']>
  serviceOptionId: Maybe<Scalars['CustomersBigInt']>
  shoppedRetailerLocationId: Maybe<Scalars['CustomersBigInt']>
  shopperOriginatedData: Maybe<CustomersOrderShopperOriginatedData>
  storeConfigurationId: Maybe<Scalars['CustomersBigInt']>
  userBirthday: Maybe<CustomersGoogleTypeDate>
  userId: Maybe<Scalars['CustomersBigInt']>
  workflowState: Maybe<CustomersWorkflowState>
  zoneId: Maybe<Scalars['CustomersBigInt']>
}

export type CustomersOrderItem = {
  __typename?: 'CustomersOrderItem'
  externalData: Maybe<CustomersOrderItemExternalData>
  imageUrl: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  productCategory: Maybe<CustomersProductCategory>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productId: Maybe<Scalars['CustomersBigInt']>
  quantity: Maybe<CustomersInstacartTypesV1MeasuredQuantity>
  retailerLookupCode: Maybe<Scalars['String']>
  sizeDetails: Maybe<Scalars['String']>
  unitPrice: Maybe<CustomersGoogleTypeMoney>
}

export type CustomersOrderItemExternalData = {
  __typename?: 'CustomersOrderItemExternalData'
  lineNum: Maybe<Scalars['String']>
  retailerRrc: Maybe<Scalars['String']>
  retailerUpc: Maybe<Scalars['String']>
  scanCode: Maybe<Scalars['String']>
}

export type CustomersOrderLine = {
  __typename?: 'CustomersOrderLine'
  addedByDriverId: Maybe<Scalars['CustomersBigInt']>
  allowedSubstitution: Maybe<Scalars['Boolean']>
  creationDate: Maybe<Scalars['CustomersDateTime']>
  customerOrderedPrice: Maybe<CustomersGoogleTypeMoney>
  customerPrice: Maybe<CustomersGoogleTypeMoney>
  customerSelectedReplacement: Maybe<CustomersOrderItem>
  fullPrice: Maybe<CustomersGoogleTypeMoney>
  id: Maybe<Scalars['CustomersBigInt']>
  item: Maybe<CustomersOrderItem>
  obfuscatedId: Maybe<Scalars['String']>
  orderedQuantity: Maybe<CustomersInstacartTypesV1MeasuredQuantity>
  replacementPolicy: Maybe<CustomersReplacementPolicy>
  specialInstructions: Maybe<Scalars['String']>
  status: Maybe<CustomersStatus>
  substitute: Maybe<CustomersOrderItem>
  substitutionStatus: Maybe<CustomersSubstitutionStatus>
}

export type CustomersOrderOrderFulfillmentWindow = {
  __typename?: 'CustomersOrderOrderFulfillmentWindow'
  windowEnd: Maybe<Scalars['CustomersDateTime']>
  windowStart: Maybe<Scalars['CustomersDateTime']>
}

export type CustomersOrderRetailerOriginatedData = {
  __typename?: 'CustomersOrderRetailerOriginatedData'
  bagLabel: Maybe<Scalars['String']>
}

export type CustomersOrderShopperOriginatedData = {
  __typename?: 'CustomersOrderShopperOriginatedData'
  customerBagCount: Maybe<Scalars['Int']>
}

export enum CustomersOrdersSortByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED',
}

export type CustomersOrdersSortByInput = {
  direction?: InputMaybe<CustomersOrdersSortByDirection>
  name?: InputMaybe<CustomersOrdersSortByOrdersAttributes>
}

export enum CustomersOrdersSortByOrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT',
}

export type CustomersProductCategory = {
  __typename?: 'CustomersProductCategory'
  l1Category: Maybe<Scalars['String']>
  l1CategoryId: Maybe<Scalars['CustomersBigInt']>
  l2Category: Maybe<Scalars['String']>
  l2CategoryId: Maybe<Scalars['CustomersBigInt']>
  l3Category: Maybe<Scalars['String']>
  l3CategoryId: Maybe<Scalars['CustomersBigInt']>
  l4Category: Maybe<Scalars['String']>
  l4CategoryId: Maybe<Scalars['CustomersBigInt']>
  l5Category: Maybe<Scalars['String']>
  l5CategoryId: Maybe<Scalars['CustomersBigInt']>
  l6Category: Maybe<Scalars['String']>
  l6CategoryId: Maybe<Scalars['CustomersBigInt']>
  productCategory: Maybe<Scalars['String']>
  productCategoryId: Maybe<Scalars['CustomersBigInt']>
}

export type CustomersQueryOrderReferenceRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['CustomersBigInt']>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersQueryOrderReferenceResponse = {
  __typename?: 'CustomersQueryOrderReferenceResponse'
  orderReference: Maybe<Scalars['String']>
  userId: Maybe<Scalars['CustomersBigInt']>
}

export type CustomersQueryOrdersRequestInput = {
  ordersSortBy?: InputMaybe<CustomersOrdersSortByInput>
  pagination?: InputMaybe<CustomersInstacartCustomersSharedV1PaginationInput>
  scenarioActivePickupOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput>
  scenarioActiveScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput>
  scenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput>
  scenarioActiveUltrafastOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput>
  scenarioCompletedScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput>
  scenarioEnterpriseRppOrdersByCreationDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput>
  scenarioEnterpriseRppOrdersByFulfillmentDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput>
  scenarioEnterpriseRppOrdersByOrderIdentifier?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput>
}

export type CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
}

export type CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>
  retailerId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
}

export type CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput =
  {
    retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
    retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
    windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>
  }

export type CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>
}

export type CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>
  retailerId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationId?: InputMaybe<Scalars['CustomersBigInt']>
}

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>
  creationDateRange?: InputMaybe<CustomersTimestampRangeInput>
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>
  orderType?: InputMaybe<CustomersRppOrderType>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
}

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>
  orderType?: InputMaybe<CustomersRppOrderType>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['CustomersBigInt']>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['CustomersBigInt']>>>
}

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>
  orderIdentifier?: InputMaybe<Scalars['String']>
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>
}

export type CustomersQueryOrdersResponse = {
  __typename?: 'CustomersQueryOrdersResponse'
  orders: Maybe<Array<Maybe<CustomersOrder>>>
  pageInfo: Maybe<CustomersInstacartCustomersSharedV1PageInfo>
}

export enum CustomersReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE',
}

export enum CustomersRppOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  New = 'NEW',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  RppOrderStatusCriteriaUnspecified = 'RPP_ORDER_STATUS_CRITERIA_UNSPECIFIED',
  Shopping = 'SHOPPING',
}

export enum CustomersRppOrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  Pickup = 'PICKUP',
  RppOrderTypeUnspecified = 'RPP_ORDER_TYPE_UNSPECIFIED',
}

export enum CustomersStatus {
  Found = 'FOUND',
  Pending = 'PENDING',
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  ToRefund = 'TO_REFUND',
}

export enum CustomersSubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED',
}

export type CustomersTimestampRangeInput = {
  from?: InputMaybe<Scalars['CustomersDateTime']>
  to?: InputMaybe<Scalars['CustomersDateTime']>
}

export enum CustomersWorkflowState {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
  AtStore = 'AT_STORE',
  BagsCheck = 'BAGS_CHECK',
  BagsVerified = 'BAGS_VERIFIED',
  BrandNew = 'BRAND_NEW',
  Canceled = 'CANCELED',
  Checkout = 'CHECKOUT',
  CustomerSamples = 'CUSTOMER_SAMPLES',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  Notified = 'NOTIFIED',
  PendingIdentityVerification = 'PENDING_IDENTITY_VERIFICATION',
  PendingReschedule = 'PENDING_RESCHEDULE',
  Picking = 'PICKING',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  Returning = 'RETURNING',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  RxCheckout = 'RX_CHECKOUT',
  RxPicking = 'RX_PICKING',
  Staged = 'STAGED',
  StagedForCbt = 'STAGED_FOR_CBT',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  StagingForCbt = 'STAGING_FOR_CBT',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
  WorkflowStateUnspecified = 'WORKFLOW_STATE_UNSPECIFIED',
}

export type DataEntryItem = {
  __typename?: 'DataEntryItem'
  deiId: Maybe<Scalars['String']>
}

export type DataItem = {
  __typename?: 'DataItem'
  groupByName: Maybe<Scalars['String']>
  metricName: Maybe<Scalars['String']>
  value: Maybe<InsightsPortalValue>
}

export type DataQuery = {
  __typename?: 'DataQuery'
  resourceDataQuery: Maybe<ResourceDataQuery>
}

export type DataQueryInput = {
  resourceDataQuery?: InputMaybe<ResourceDataQueryInput>
}

/** Attributes for a date range filter */
export type DateRange = {
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
}

export type DateRangeInput = {
  fromDate?: InputMaybe<Scalars['DateTime']>
  toDate?: InputMaybe<Scalars['DateTime']>
}

export type DayOfWeekInput = {
  /** list of days within the week */
  days: Array<Scalars['String']>
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

/** Autogenerated return type of DayOfWeekVisibilityConditionCreate */
export type DayOfWeekVisibilityConditionCreatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionCreatePayload'
  /** The newly created express_membership visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek
}

/** Autogenerated return type of DayOfWeekVisibilityConditionUpdate */
export type DayOfWeekVisibilityConditionUpdatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionUpdatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek
}

export type DeleteApiSettingRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  partnerId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteApiSettingResponse = {
  __typename?: 'DeleteApiSettingResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'DeleteConnectRetailerCallbackConfigurationResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>
  id?: InputMaybe<Scalars['BigInt']>
}

export type DeleteContentPageResponse = {
  __typename?: 'DeleteContentPageResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DeleteContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>
  id?: InputMaybe<Scalars['BigInt']>
}

export type DeleteContentPageVersionResponse = {
  __typename?: 'DeleteContentPageVersionResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DeleteImageRequestInput = {
  imageId?: InputMaybe<Scalars['Int']>
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteImageResponse = {
  __typename?: 'DeleteImageResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DeleteInventoryFileMappingRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteInventoryFileMappingResponse = {
  __typename?: 'DeleteInventoryFileMappingResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteLaunchOnboardingWarehouseLocationRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>
  token?: InputMaybe<Scalars['String']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteLaunchOnboardingWarehouseLocationResponse = {
  __typename?: 'DeleteLaunchOnboardingWarehouseLocationResponse'
  launchOnboarding: Maybe<LaunchOnboarding>
}

export type DeleteLayoutVariantRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteLayoutVariantResponse = {
  __typename?: 'DeleteLayoutVariantResponse'
  response: Maybe<Scalars['Boolean']>
}

export type DeleteLinkAutosuggestionAdminParametersInput = {
  linkId?: InputMaybe<Scalars['BigInt']>
  linkName?: InputMaybe<Scalars['String']>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<DeleteLinkAutosuggestionAdminParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type DeleteLinkAutosuggestionAdminResponse = {
  __typename?: 'DeleteLinkAutosuggestionAdminResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteNavigationCollectionsNodeRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteNavigationCollectionsNodeResponse = {
  __typename?: 'DeleteNavigationCollectionsNodeResponse'
  success: Maybe<Scalars['Boolean']>
}

export type DeleteNavigationRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteNavigationResponse = {
  __typename?: 'DeleteNavigationResponse'
  response: Maybe<Scalars['Boolean']>
}

export type DeletePlacementRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
}

export type DeletePlacementResponse = {
  __typename?: 'DeletePlacementResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DeleteRetailerCollectionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type DeleteRetailerCollectionResponse = {
  __typename?: 'DeleteRetailerCollectionResponse'
  success: Maybe<Scalars['Boolean']>
}

export enum DeviceTypeEnum {
  /** Phone plan */
  Phone = 'phone',
  /** Wi-Fi */
  Wifi = 'wifi',
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type DisablePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>
  id?: InputMaybe<Scalars['BigInt']>
}

export type DisablePlacementContentResponse = {
  __typename?: 'DisablePlacementContentResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DisableThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
}

export type DisableThemePageResponse = {
  __typename?: 'DisableThemePageResponse'
  _: Maybe<Scalars['Boolean']>
}

export type DoNotNavigate = {
  __typename?: 'DoNotNavigate'
  recordClickAttempt: Maybe<Scalars['Boolean']>
}

export type DoNotNavigateInput = {
  recordClickAttempt?: InputMaybe<Scalars['Boolean']>
}

export type DomainConfiguration = {
  __typename?: 'DomainConfiguration'
  catalog: Maybe<CatalogSchema>
  idsTheme: Maybe<IdsThemeSchema>
  pricing: Maybe<PricingSchema>
  theme: Maybe<ThemeSchema>
}

export type DownloadCatalogSearchResultsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  costUnitType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  creationDate?: InputMaybe<DateRangeInput>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  isParWeighted?: InputMaybe<Scalars['Boolean']>
  itemFilename?: InputMaybe<Scalars['String']>
  itemsOnPromoDateRange?: InputMaybe<DateRangeInput>
  itemsOnSaleDateRange?: InputMaybe<DateRangeInput>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  loyaltyPricing?: InputMaybe<Scalars['Boolean']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  primaryImageUrl?: InputMaybe<Scalars['Boolean']>
  productAvailability?: InputMaybe<Scalars['Boolean']>
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  productFilename?: InputMaybe<Scalars['String']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  query?: InputMaybe<Scalars['String']>
  requestItemData?: InputMaybe<Scalars['Boolean']>
  requestProductData?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  snapEbtEligible?: InputMaybe<Scalars['Boolean']>
  storeBrandProduct?: InputMaybe<Scalars['Boolean']>
}

export type DownloadCatalogSearchResultsResponse = {
  __typename?: 'DownloadCatalogSearchResultsResponse'
  filename: Maybe<Scalars['String']>
}

export type DuplicateInstacartCollectionRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  endDate?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  sourceCollectionId?: InputMaybe<Scalars['BigInt']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<RetailerCollectionStatus>
  storeConfigurations?: InputMaybe<Array<InputMaybe<RetailerCollectionStoreConfigurationInput>>>
  surfaces?: InputMaybe<Array<InputMaybe<RetailerCollectionSurface>>>
  tileImageUrl?: InputMaybe<Scalars['String']>
  translations?: InputMaybe<Array<InputMaybe<RetailerCollectionTranslationInput>>>
}

export type DuplicateInstacartCollectionResponse = {
  __typename?: 'DuplicateInstacartCollectionResponse'
  instacartCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type DuplicateRetailerCollectionRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  endDate?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  sourceCollectionId?: InputMaybe<Scalars['BigInt']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<RetailerCollectionStatus>
  storeConfigurations?: InputMaybe<Array<InputMaybe<RetailerCollectionStoreConfigurationInput>>>
  surfaces?: InputMaybe<Array<InputMaybe<RetailerCollectionSurface>>>
  tileImageUrl?: InputMaybe<Scalars['String']>
  translations?: InputMaybe<Array<InputMaybe<RetailerCollectionTranslationInput>>>
}

export type DuplicateRetailerCollectionResponse = {
  __typename?: 'DuplicateRetailerCollectionResponse'
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type EnterpriseAccount = {
  __typename?: 'EnterpriseAccount'
  /** Whether or not the user is fully set up */
  accountStateValid: Maybe<Scalars['Boolean']>
  /** Whether account must use SSO/auth service for authentication */
  authServiceRequired: Scalars['Boolean']
  /** The associated authentication */
  authentication: Maybe<AuthenticationInterface>
  /** The external unique identifier for the enterprise account */
  canonicalId: Scalars['ID']
  /** When the account was created */
  createdAt: Scalars['Time']
  /** Whether account is active */
  disabled: Scalars['Boolean']
  /** The email associated with the account */
  email: Maybe<Scalars['String']>
  /** The feature toggles associated with the account */
  featureToggles: Array<FeatureToggle>
  /**
   * The flippers associated with the account
   * @deprecated Use feature_toggles instead
   */
  flippers: AccessControlFlippers
  /** Given name of user */
  givenName: Maybe<Scalars['String']>
  /** The internal unique identifier for the enterprise account */
  id: Scalars['ID']
  /** The associated internal access configuration for the account */
  internalAccessConfiguration: EnterpriseInternalAccessConfiguration
  /** Whether account is an internal account */
  isInternal: Scalars['Boolean']
  /** The permissions associated with this account */
  permissions: Array<EnterprisePermission>
  /** Phone number for the user */
  phone: Maybe<Scalars['String']>
  /** The policies associated with the account */
  policies: AccessControlPolicies
  /** The roles associated with this account */
  roles: Array<EnterpriseRole>
  /** Surname of user */
  surname: Maybe<Scalars['String']>
  /** The title of the user */
  title: Maybe<Scalars['String']>
}

/** Autogenerated return type of EnterpriseAccountAccountSetup */
export type EnterpriseAccountAccountSetupPayload = {
  __typename?: 'EnterpriseAccountAccountSetupPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticateEmailPassword */
export type EnterpriseAccountAuthenticateEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountAuthenticateEmailPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountAuthenticatePreflight */
export type EnterpriseAccountAuthenticatePreflightPayload = {
  __typename?: 'EnterpriseAccountAuthenticatePreflightPayload'
  useAuthService: Scalars['Boolean']
}

/** The connection type for EnterpriseAccount. */
export type EnterpriseAccountConnection = {
  __typename?: 'EnterpriseAccountConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EnterpriseAccountEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EnterpriseAccount>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EnterpriseAccountCreate */
export type EnterpriseAccountCreatePayload = {
  __typename?: 'EnterpriseAccountCreatePayload'
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount
}

/** An edge in a connection. */
export type EnterpriseAccountEdge = {
  __typename?: 'EnterpriseAccountEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<EnterpriseAccount>
}

/** Autogenerated return type of EnterpriseAccountPartnerOnboardingRequestAccountSetupEmail */
export type EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestAccountSetupEmail */
export type EnterpriseAccountRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountRequestAccountSetupEmailPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestEmailVerification */
export type EnterpriseAccountRequestEmailVerificationPayload = {
  __typename?: 'EnterpriseAccountRequestEmailVerificationPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountRequestPasswordReset */
export type EnterpriseAccountRequestPasswordResetPayload = {
  __typename?: 'EnterpriseAccountRequestPasswordResetPayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of EnterpriseAccountResetPassword */
export type EnterpriseAccountResetPasswordPayload = {
  __typename?: 'EnterpriseAccountResetPasswordPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

/** Autogenerated return type of EnterpriseAccountSetDisabled */
export type EnterpriseAccountSetDisabledPayload = {
  __typename?: 'EnterpriseAccountSetDisabledPayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountSignUpEmailPassword */
export type EnterpriseAccountSignUpEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountSignUpEmailPasswordPayload'
  /** The newly created Account */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountUpdate */
export type EnterpriseAccountUpdatePayload = {
  __typename?: 'EnterpriseAccountUpdatePayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountUpdateRoles */
export type EnterpriseAccountUpdateRolesPayload = {
  __typename?: 'EnterpriseAccountUpdateRolesPayload'
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount
}

/** Autogenerated return type of EnterpriseAccountVerifyAccountSetupToken */
export type EnterpriseAccountVerifyAccountSetupTokenPayload = {
  __typename?: 'EnterpriseAccountVerifyAccountSetupTokenPayload'
  /** Email of the verified account */
  email: Scalars['String']
  /** List of partners with partner id and name */
  partners: Array<Partner>
}

/** Autogenerated return type of EnterpriseAccountVerifyEmail */
export type EnterpriseAccountVerifyEmailPayload = {
  __typename?: 'EnterpriseAccountVerifyEmailPayload'
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken
}

export type EnterpriseAuthenticationEmailPassword = AuthenticationInterface & {
  __typename?: 'EnterpriseAuthenticationEmailPassword'
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID']
  /** Whether or not the email has been verified */
  emailVerified: Scalars['Boolean']
  /** Whether or not the password has been set */
  passwordSet: Scalars['Boolean']
}

export type EnterpriseFeatureTour = {
  __typename?: 'EnterpriseFeatureTour'
  lastShownAt: Maybe<Scalars['String']>
  /** The name of the feature tour */
  name: Scalars['String']
  /** The current completion status of the feature tour */
  status: Scalars['String']
}

export type EnterpriseInternalAccessConfiguration = {
  __typename?: 'EnterpriseInternalAccessConfiguration'
  /** The associated assigned partners */
  assignedPartners: Array<Partner>
  /** The associated assigned retailer locations */
  assignedRetailerLocations: Array<RetailerLocation>
  /** The associated assigned retailers */
  assignedRetailers: Array<Retailer>
  /** Whether access is granted for every partner, retailer and location */
  hasAllPartnersFullAccess: Scalars['Boolean']
  /** Whether access is granted for every retailer and location for partners assigned */
  hasFullPartnerAccess: Scalars['Boolean']
  /** Whether access is granted for every location for retailers assigned */
  hasFullRetailerAccess: Scalars['Boolean']
  /** Whether access is not granted to any partner, retailer or location */
  hasNothingAccessible: Scalars['Boolean']
}

export type EnterprisePermission = {
  __typename?: 'EnterprisePermission'
  /** A description of the permission */
  description: Maybe<Scalars['String']>
  /** A unique identifier for the permission */
  slug: Scalars['ID']
}

export type EnterpriseRole = {
  __typename?: 'EnterpriseRole'
  /** The number of accounts currently attached to the role */
  attachedAccounts: Maybe<Scalars['Int']>
  /** A description of the role */
  description: Maybe<Scalars['String']>
  /** The role ID */
  id: Scalars['ID']
  /** Whether this role can only be assigned to internal IC employees */
  internalOnly: Scalars['Boolean']
  /** The name of the role */
  name: Scalars['String']
  partnerId: Maybe<Scalars['ID']>
  /** The permissions associated with this role */
  permissions: Array<EnterprisePermission>
  retailerId: Maybe<Scalars['ID']>
  /** A unique identifier for the role */
  slug: Scalars['ID']
  updatedAt: Scalars['Time']
}

export type EnterpriseWelcomeModal = {
  __typename?: 'EnterpriseWelcomeModal'
  /** slug identifying type of welcome modal to be shown. */
  slug: Scalars['String']
}

export type EntityId = {
  __typename?: 'EntityId'
  dataEntryItem: Maybe<DataEntryItem>
  itemId: Maybe<ItemId>
  localeProduct: Maybe<LocaleProduct>
  productId: Maybe<ProductId>
  retailerProductId: Maybe<RetailerProductId>
  upc: Maybe<Upc>
}

export type EntityIdInput = {
  itemId?: InputMaybe<ItemIdInput>
  productId?: InputMaybe<ProductIdInput>
  retailerProductId?: InputMaybe<RetailerProductIdInput>
  upc?: InputMaybe<UpcInput>
}

export enum EntityStatus {
  EntityStatusCancelled = 'ENTITY_STATUS_CANCELLED',
  EntityStatusCompleted = 'ENTITY_STATUS_COMPLETED',
  EntityStatusDeduplicated = 'ENTITY_STATUS_DEDUPLICATED',
  EntityStatusEntityNotFound = 'ENTITY_STATUS_ENTITY_NOT_FOUND',
  EntityStatusFailed = 'ENTITY_STATUS_FAILED',
  EntityStatusFailedUncaught = 'ENTITY_STATUS_FAILED_UNCAUGHT',
  EntityStatusInProgress = 'ENTITY_STATUS_IN_PROGRESS',
  EntityStatusNonNormalizedUpc = 'ENTITY_STATUS_NON_NORMALIZED_UPC',
  EntityStatusStarted = 'ENTITY_STATUS_STARTED',
  EntityStatusSubmittedToFixService = 'ENTITY_STATUS_SUBMITTED_TO_FIX_SERVICE',
  EntityStatusUnknown = 'ENTITY_STATUS_UNKNOWN',
  EntityStatusUnknownError = 'ENTITY_STATUS_UNKNOWN_ERROR',
  EntityStatusUpcCollision = 'ENTITY_STATUS_UPC_COLLISION',
  EntityStatusWarning = 'ENTITY_STATUS_WARNING',
  EntityStatusWontDo = 'ENTITY_STATUS_WONT_DO',
}

export enum EntityType {
  EntityTypeItemIds = 'ENTITY_TYPE_ITEM_IDS',
  EntityTypeProductIds = 'ENTITY_TYPE_PRODUCT_IDS',
  EntityTypeRetailerProductIds = 'ENTITY_TYPE_RETAILER_PRODUCT_IDS',
  EntityTypeUnknown = 'ENTITY_TYPE_UNKNOWN',
  EntityTypeUpcs = 'ENTITY_TYPE_UPCS',
}

export enum ErrorReason {
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  ErrorReasonModificationNotPermitted = 'ERROR_REASON_MODIFICATION_NOT_PERMITTED',
  ErrorReasonUnknown = 'ERROR_REASON_UNKNOWN',
}

export enum ExperimentMethod {
  Assign = 'ASSIGN',
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  Lookup = 'LOOKUP',
  Preview = 'PREVIEW',
}

export type ExperimentVariantInput = {
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum
  /** The name of the experiment */
  experimentName: Scalars['String']
  /** The name of the experiment variant */
  experimentVariant: Scalars['String']
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

/** Autogenerated return type of ExperimentVariantVisibilityConditionCreate */
export type ExperimentVariantVisibilityConditionCreatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionCreatePayload'
  /** The newly created ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant
}

/** Autogenerated return type of ExperimentVariantVisibilityConditionUpdate */
export type ExperimentVariantVisibilityConditionUpdatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionUpdatePayload'
  /** The newly updated ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant
}

export type ExpressMembershipInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionCreate */
export type ExpressMembershipVisibilityConditionCreatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionCreatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

/** Autogenerated return type of ExpressMembershipVisibilityConditionUpdate */
export type ExpressMembershipVisibilityConditionUpdatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionUpdatePayload'
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership
}

export type ExpressNonmemberLongTermHoldoutInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>
}

/** Autogenerated return type of ExpressNonmemberLongTermHoldoutVisibilityConditionCreate */
export type ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload = {
  __typename?: 'ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload'
  /** The newly created ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityCondition: ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
}

export type FailedUpdate = {
  __typename?: 'FailedUpdate'
  reason: Maybe<Scalars['String']>
  retailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type FeatureToggle = {
  __typename?: 'FeatureToggle'
  /** The name of this feature toggle */
  name: Scalars['String']
}

export type FeatureTogglesEnabledCheck = {
  __typename?: 'FeatureTogglesEnabledCheck'
  /** Whether the feature toggle is enabled */
  enabled: Scalars['Boolean']
}

/** Autogenerated return type of FeatureTourUpdate */
export type FeatureTourUpdatePayload = {
  __typename?: 'FeatureTourUpdatePayload'
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True']
}

export type FlattenedTaxonomy = {
  __typename?: 'FlattenedTaxonomy'
  createdAt: Maybe<Scalars['DateTime']>
  productCategoryId: Maybe<Scalars['BigInt']>
  productCategoryPath: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type FlattenedTaxonomyFilterInput = {
  updatedSince?: InputMaybe<Scalars['DateTime']>
}

/** Autogenerated return type of FlyoutPlacementCreate */
export type FlyoutPlacementCreatePayload = {
  __typename?: 'FlyoutPlacementCreatePayload'
  /** The newly created flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement
}

export type FlyoutPlacementInput = {
  /** The style and text of the subheading */
  descriptionText: ConfigurableTextInput
  /** The style and text of the secondary text */
  disclaimerText?: InputMaybe<ConfigurableTextInput>
  enabled?: InputMaybe<Scalars['Boolean']>
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>
  /** The images on the banner */
  images: GenericImagesInput
  /** The style and text of the button within the placement */
  linkButton: ConfigurableButtonInput
  /** Where interacting with the placement leads */
  linkDestination?: InputMaybe<PlacementDestinationInput>
  /** Locale */
  locale: BannerLocaleEnum
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The style and text of the button within the placement */
  primaryButton: ConfigurableButtonInput
  /** Where interacting with the placement leads */
  primaryDestination?: InputMaybe<PlacementDestinationInput>
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the button within the placement */
  secondaryButton: ConfigurableButtonInput
  /** Where interacting with the placement leads */
  secondaryDestination?: InputMaybe<PlacementDestinationInput>
  /** The style and text of the heading */
  titleText: ConfigurableTextInput
  /** The type of this placement */
  type: PlacementTypeEnum
}

/** Autogenerated return type of FlyoutPlacementUpdate */
export type FlyoutPlacementUpdatePayload = {
  __typename?: 'FlyoutPlacementUpdatePayload'
  /** The updated flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement
}

export type FontFamily = {
  __typename?: 'FontFamily'
  files: Maybe<FontFiles>
  name: Maybe<Scalars['String']>
}

export type FontFile = {
  __typename?: 'FontFile'
  otf: Maybe<Scalars['String']>
  ttf: Maybe<Scalars['String']>
  woff: Maybe<Scalars['String']>
  woff2: Maybe<Scalars['String']>
}

export type FontFiles = {
  __typename?: 'FontFiles'
  bold: Maybe<FontFile>
  normal: Maybe<FontFile>
  semiBold: Maybe<FontFile>
}

export enum FulfillmentModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** In store shoppers */
  Iss = 'ISS',
  /** Locker */
  Locker = 'LOCKER',
  /** Partner managed */
  Retailer = 'RETAILER',
}

export type GenerateBatchRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>
  batchType?: InputMaybe<Scalars['String']>
  driverId?: InputMaybe<Scalars['BigInt']>
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  shopperId?: InputMaybe<Scalars['BigInt']>
  workflowState?: InputMaybe<Scalars['String']>
}

export type GenerateBatchResponse = {
  __typename?: 'GenerateBatchResponse'
  id: Maybe<Scalars['BigInt']>
  workflowState: Maybe<Scalars['String']>
}

export type GenericImagesInput = {
  /** The image url of the placement to display for large viewports */
  desktop?: InputMaybe<Scalars['Url']>
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url']
}

export type GetAcknowledgedOosIdsRequestInput = {
  retailerId?: InputMaybe<Scalars['String']>
}

export type GetAcknowledgedOosIdsResponse = {
  __typename?: 'GetAcknowledgedOosIdsResponse'
  oosIds: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetApiSettingsRequestInput = {
  apiType?: InputMaybe<Scalars['String']>
  enabled?: InputMaybe<Scalars['Boolean']>
  integrationType?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetApiSettingsResponse = {
  __typename?: 'GetApiSettingsResponse'
  apiSettings: Maybe<Array<Maybe<GetApiSettingsResponseApiSetting>>>
}

export type GetApiSettingsResponseApiSetting = {
  __typename?: 'GetApiSettingsResponseApiSetting'
  apiType: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  cron: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['BigInt']>
  integrationType: Maybe<Scalars['String']>
  partnerId: Maybe<Scalars['BigInt']>
}

export type GetAuditBatchRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>
  client?: InputMaybe<Scalars['String']>
  orderByComponent?: InputMaybe<OrderByComponentInput>
  page?: InputMaybe<PaginationInput>
  returnSampleTasks?: InputMaybe<Scalars['Boolean']>
}

export type GetAuditBatchResponse = {
  __typename?: 'GetAuditBatchResponse'
  auditBatch: Maybe<AuditBatch>
}

export type GetAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>
  taskUuid?: InputMaybe<Scalars['String']>
}

export type GetAuditTaskResponse = {
  __typename?: 'GetAuditTaskResponse'
  auditTask: Maybe<AuditTask>
}

export type GetAuthenticationUrlRequestInput = {
  errorRedirectUrl?: InputMaybe<Scalars['String']>
  integrationType?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  successRedirectUrl?: InputMaybe<Scalars['String']>
}

export type GetAuthenticationUrlResponse = {
  __typename?: 'GetAuthenticationUrlResponse'
  authenticationUrl: Maybe<Scalars['String']>
}

export type GetAvailableStoreLocationsRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  integrationType?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
}

export type GetAvailableStoreLocationsResponse = {
  __typename?: 'GetAvailableStoreLocationsResponse'
  storeLocations: Maybe<Array<Maybe<ApiIntegrationStoreLocation>>>
}

export type GetCatalogFaqFileRequestInput = {
  fileName?: InputMaybe<Scalars['String']>
}

export type GetCatalogFaqFileResponse = {
  __typename?: 'GetCatalogFaqFileResponse'
  file: Maybe<Scalars['String']>
}

export type GetCollectionFiltersRequestInput = {
  collectionId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetCollectionFiltersResponse = {
  __typename?: 'GetCollectionFiltersResponse'
  filters: Maybe<Array<Maybe<RetailerCollectionFilter>>>
}

export type GetCollectionRulesRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetCollectionRulesResponse = {
  __typename?: 'GetCollectionRulesResponse'
  rules: Maybe<Array<Maybe<RetailerCollectionRule>>>
}

export type GetCollectionsRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>
  admin?: InputMaybe<Scalars['Boolean']>
  collectionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  includeAlcohol?: InputMaybe<Scalars['Boolean']>
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>
  parentId?: InputMaybe<Scalars['String']>
  replaceDepartmentId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  scheduled?: InputMaybe<Scalars['Boolean']>
  searchTerm?: InputMaybe<Scalars['String']>
  showDepartmentTile?: InputMaybe<Scalars['Boolean']>
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
  useRetailerTypeMapping?: InputMaybe<Scalars['Boolean']>
}

export type GetCollectionsResponse = {
  __typename?: 'GetCollectionsResponse'
  collections: Maybe<Array<Maybe<Collection>>>
}

export type GetConfirmedStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  startDate?: InputMaybe<GoogleTypeDateInput>
}

export type GetConfirmedStoreHoursResponse = {
  __typename?: 'GetConfirmedStoreHoursResponse'
  confirmations: Maybe<Array<Maybe<ConfirmedStoreHours>>>
}

export type GetConnectRetailerCallbackConfigurationByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
}

export type GetConnectRetailerCallbackConfigurationByIdResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationByIdResponse'
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>
}

export type GetConnectRetailerCallbackConfigurationsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>
  environment?: InputMaybe<Scalars['String']>
  includeDeleted?: InputMaybe<Scalars['Boolean']>
}

export type GetConnectRetailerCallbackConfigurationsResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationsResponse'
  callbackConfigurations: Maybe<Array<Maybe<ConnectRetailerCallbackConfiguration>>>
}

export type GetConnectSettingsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>
}

export type GetConnectSettingsResponse = {
  __typename?: 'GetConnectSettingsResponse'
  enableEtaServiceOptions: Maybe<Scalars['Boolean']>
  postCheckoutAppDomain: Maybe<Scalars['String']>
}

export type GetCustomersContextRequestInput = {
  parameters?: InputMaybe<GetCustomersContextRequestParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type GetCustomersContextRequestParametersInput = {
  partnerId?: InputMaybe<Scalars['Int']>
}

export type GetCustomersContextResponse = {
  __typename?: 'GetCustomersContextResponse'
  context: Maybe<CustomersContext>
}

export type GetDashboardOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>
  orderId?: InputMaybe<Scalars['BigInt']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type GetDashboardOrderResponse = {
  __typename?: 'GetDashboardOrderResponse'
  dashboardOrder: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrder>
}

export type GetFlattenedTaxonomiesParametersInput = {
  filter?: InputMaybe<FlattenedTaxonomyFilterInput>
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type GetFlattenedTaxonomiesRequestInput = {
  parameters?: InputMaybe<GetFlattenedTaxonomiesParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type GetFlattenedTaxonomiesResponse = {
  __typename?: 'GetFlattenedTaxonomiesResponse'
  taxonomies: Maybe<Array<Maybe<FlattenedTaxonomy>>>
}

export type GetHolidaysStatusRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetHolidaysStatusResponse = {
  __typename?: 'GetHolidaysStatusResponse'
  holidays: Maybe<Array<Maybe<HolidayStatus>>>
}

export type GetImageUploadBatchDetailsRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>
  page?: InputMaybe<Scalars['BigInt']>
  pageSize?: InputMaybe<Scalars['BigInt']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
}

export type GetImageUploadBatchDetailsResponse = {
  __typename?: 'GetImageUploadBatchDetailsResponse'
  imageUploadBatchDetails: Maybe<Array<Maybe<ImageUploadBatchDetails>>>
  imageUploadBatchMetadata: Maybe<ImageUploadBatchMetadata>
}

export type GetImageUploadBatchesRequestInput = {
  endAt?: InputMaybe<Scalars['DateTime']>
  page?: InputMaybe<Scalars['BigInt']>
  pageSize?: InputMaybe<Scalars['BigInt']>
  startAt?: InputMaybe<Scalars['DateTime']>
  timeRange?: InputMaybe<Scalars['String']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
}

export type GetImageUploadBatchesResponse = {
  __typename?: 'GetImageUploadBatchesResponse'
  imageUploadBatch: Maybe<Array<Maybe<ImageUploadBatch>>>
  imageUploadBatchMetadata: Maybe<ImageUploadBatchMetadata>
}

export type GetInstacartCollectionRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  id?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetInstacartCollectionResponse = {
  __typename?: 'GetInstacartCollectionResponse'
  hasChildCollections: Maybe<Scalars['Boolean']>
  hierarchy: Maybe<Array<Maybe<Scalars['BigInt']>>>
  instacartCollection: Maybe<RetailerCollection>
  localeCode: Maybe<InstacartCustomersSharedV1Locale>
  retailerId: Maybe<Scalars['BigInt']>
}

export type GetInstacartCollectionsTreeRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type GetInstacartCollectionsTreeResponse = {
  __typename?: 'GetInstacartCollectionsTreeResponse'
  instacartCollections: Maybe<Array<Maybe<RetailerCollectionTreeNode>>>
}

export type GetInventoryFileMappingsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetInventoryFileMappingsResponse = {
  __typename?: 'GetInventoryFileMappingsResponse'
  inventoryFileMappings: Maybe<Array<Maybe<InventoryFileMapping>>>
}

export type GetInventoryFileMismatchesRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetInventoryFileMismatchesResponse = {
  __typename?: 'GetInventoryFileMismatchesResponse'
  inventoryFileMismatches: Maybe<Array<Maybe<InventoryFileMismatch>>>
}

export type GetIsGrocerRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type GetIsGrocerResponse = {
  __typename?: 'GetIsGrocerResponse'
  isGrocer: Maybe<Scalars['Boolean']>
}

export type GetItemsRequestInput = {
  parameters?: InputMaybe<GetItemsRequestParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type GetItemsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>
  limit?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  offset?: InputMaybe<Scalars['BigInt']>
  primaryAisleId?: InputMaybe<Scalars['BigInt']>
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetItemsResponse = {
  __typename?: 'GetItemsResponse'
  results: Maybe<Array<Maybe<Item>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GetLaunchOnboardingRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>
  token?: InputMaybe<Scalars['String']>
}

export type GetLaunchOnboardingResponse = {
  __typename?: 'GetLaunchOnboardingResponse'
  launchOnboarding: Maybe<LaunchOnboarding>
}

export type GetLayoutVariantsRequestInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  status?: InputMaybe<Status>
}

export type GetLayoutVariantsResponse = {
  __typename?: 'GetLayoutVariantsResponse'
  layoutVariants: Maybe<Array<Maybe<LayoutVariant>>>
}

export type GetLegacyElasticsearchRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput = {
  factor?: InputMaybe<Scalars['BigInt']>
  value?: InputMaybe<Scalars['BigInt']>
}

export type GetLegacyItemsShoppersRequestBoostWhereInput = {
  primaryDepartmentId?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput>
}

export type GetLegacyItemsShoppersRequestInput = {
  aisleId?: InputMaybe<Scalars['BigInt']>
  alcoholic?: InputMaybe<Scalars['Boolean']>
  anyMatchingProductCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  available?: InputMaybe<Scalars['Boolean']>
  boostWhere?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereInput>
  departmentId?: InputMaybe<Scalars['BigInt']>
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hasImage?: InputMaybe<Scalars['Boolean']>
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  limit?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  offset?: InputMaybe<Scalars['BigInt']>
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>
  productCodes?: InputMaybe<Scalars['String']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  query?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerReferenceCode?: InputMaybe<Scalars['String']>
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  source?: InputMaybe<Scalars['String']>
  tsqueryQuery?: InputMaybe<Scalars['String']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type GetLegacyProductsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  availableInventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  query?: InputMaybe<Scalars['String']>
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  source?: InputMaybe<Scalars['String']>
}

export type GetLocalesByRetailerRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetLocalesByRetailerResponse = {
  __typename?: 'GetLocalesByRetailerResponse'
  retailerLocales: Maybe<Array<Maybe<RetailerLocale>>>
}

export type GetNavigationCollectionsTreeRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type GetNavigationCollectionsTreeResponse = {
  __typename?: 'GetNavigationCollectionsTreeResponse'
  nodes: Maybe<Array<Maybe<RetailerCollectionNavigationNode>>>
}

export type GetNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type GetNavigationResponse = {
  __typename?: 'GetNavigationResponse'
  navigation: Maybe<Navigation>
}

export type GetOnboardingRequestInput = {
  token?: InputMaybe<Scalars['String']>
}

export type GetOnboardingResponse = {
  __typename?: 'GetOnboardingResponse'
  onboarding: Maybe<Onboarding>
}

export type GetOrderFulfillmentOverviewRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>
}

export type GetOrderFulfillmentOverviewResponse = {
  __typename?: 'GetOrderFulfillmentOverviewResponse'
  activeShopper: Maybe<Scalars['Int']>
  isFullService: Maybe<Scalars['Boolean']>
  shoppers: Maybe<Array<Maybe<ShopperOrderProfile>>>
  warehouseLocationId: Maybe<Scalars['BigInt']>
}

export type GetOrderLocationRequestInput = {
  externalId?: InputMaybe<Scalars['String']>
  orderId?: InputMaybe<Scalars['BigInt']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetOrderLocationResponse = {
  __typename?: 'GetOrderLocationResponse'
  shopperCoordinates: Maybe<GoogleTypeLatLng>
}

export type GetOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>
  orderId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
  orderItems: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>
}

export type GetParkingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
  type?: InputMaybe<PickupType>
}

export type GetParkingSettingsResponse = {
  __typename?: 'GetParkingSettingsResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>
  instruction: Maybe<Scalars['String']>
  retailerLocationConfig: Maybe<RetailerLocationInfo>
}

export type GetPartnerIdRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>
  retailerAppId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type GetPartnerIdResponse = {
  __typename?: 'GetPartnerIdResponse'
  partnerId: Maybe<Scalars['BigInt']>
}

export type GetPickupSettingsMetadataRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type GetPickupSettingsMetadataResponse = {
  __typename?: 'GetPickupSettingsMetadataResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  isCurbsidePickupEnabled: Maybe<Scalars['Boolean']>
  isReadyForPickup: Maybe<Scalars['Boolean']>
  isSettingsOnboardingComplete: Maybe<Scalars['Boolean']>
  pickupEnableDate: Maybe<GoogleTypeDate>
}

export type GetPiiRequestsForRetailerRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  requestCreatedAfter?: InputMaybe<Scalars['DateTime']>
  requestCreatedBefore?: InputMaybe<Scalars['DateTime']>
  requestTypes?: InputMaybe<Array<InputMaybe<RequestType>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
  workflowStatus?: InputMaybe<Array<InputMaybe<WorkflowStatus>>>
}

export type GetPiiRequestsForRetailerResponse = {
  __typename?: 'GetPiiRequestsForRetailerResponse'
  piiRequests: Maybe<Array<Maybe<PiiRequest>>>
}

export type GetPlacementContentByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
}

export type GetPlacementContentByIdResponse = {
  __typename?: 'GetPlacementContentByIdResponse'
  content: Maybe<PlacementContent>
}

export type GetPlacementsRequestInput = {
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>
  enabledOnly?: InputMaybe<Scalars['Boolean']>
  layout?: InputMaybe<Layout>
  layoutVariantId?: InputMaybe<Scalars['BigInt']>
  limit?: InputMaybe<Scalars['BigInt']>
  placementId?: InputMaybe<Scalars['BigInt']>
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  searchTerm?: InputMaybe<Scalars['String']>
  sortBy?: InputMaybe<Scalars['String']>
  sortDirection?: InputMaybe<Direction>
  status?: InputMaybe<Array<InputMaybe<Status>>>
  type?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['BigInt']>
  variant?: InputMaybe<Array<InputMaybe<BannerVariant>>>
}

export type GetProductDataRequestInput = {
  productId?: InputMaybe<ProductIdInput>
}

export type GetProductDataResponse = {
  __typename?: 'GetProductDataResponse'
  productData: Maybe<Array<Maybe<ProductData>>>
  productId: Maybe<ProductId>
}

export type GetProductSourcesRequestInput = {
  sourceLevel?: InputMaybe<SourceLevel>
}

export type GetProductSourcesResponse = {
  __typename?: 'GetProductSourcesResponse'
  sourceCount: Maybe<Scalars['BigInt']>
  sources: Maybe<Array<Maybe<ProductSource>>>
}

export type GetRequestContextsRequestInput = {
  partnerId?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['Int']>
}

export type GetRequestContextsResponse = {
  __typename?: 'GetRequestContextsResponse'
  requestContexts: Maybe<Array<Maybe<InstacartCustomersSharedV1RequestContext>>>
}

export type GetRetailerAisleTemplateRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
  shopperType?: InputMaybe<ShopperType>
}

export type GetRetailerAisleTemplateResponse = {
  __typename?: 'GetRetailerAisleTemplateResponse'
  activeAt: Maybe<Scalars['DateTime']>
  aisleOrders: Maybe<Array<Maybe<AisleOrder>>>
  aisleTemplateId: Maybe<Scalars['BigInt']>
  layoutId: Maybe<Scalars['String']>
}

export type GetRetailerCampaignRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerCollectionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerCollectionResponse = {
  __typename?: 'GetRetailerCollectionResponse'
  hasChildCollections: Maybe<Scalars['Boolean']>
  hierarchy: Maybe<Array<Maybe<Scalars['BigInt']>>>
  localeCode: Maybe<InstacartCustomersSharedV1Locale>
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type GetRetailerCollectionsCsvRequestInput = {
  bulkUploadType?: InputMaybe<RetailerCollectionBulkUploadType>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerCollectionsCsvResponse = {
  __typename?: 'GetRetailerCollectionsCsvResponse'
  filePath: Maybe<Scalars['String']>
}

export type GetRetailerCollectionsTreeRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
  surface?: InputMaybe<RetailerCollectionSurface>
}

export type GetRetailerCollectionsTreeResponse = {
  __typename?: 'GetRetailerCollectionsTreeResponse'
  retailerCollections: Maybe<Array<Maybe<RetailerCollectionTreeNode>>>
}

export type GetRetailerConfigRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerConfigResponse = {
  __typename?: 'GetRetailerConfigResponse'
  maxActiveTopLevelCollections: Maybe<Scalars['BigInt']>
  maxActiveTopLevelStorefrontCollections: Maybe<Scalars['Int']>
  maxActiveTopLevelStorefrontProCollections: Maybe<Scalars['Int']>
  numActiveTopLevelCollections: Maybe<Scalars['BigInt']>
  storeConfigurationConfigs: Maybe<Array<Maybe<RetailerCollectionStoreConfigurationConfig>>>
  supportedSurfaces: Maybe<Array<Maybe<RetailerCollectionSurface>>>
}

export type GetRetailerLocationByLayoutRequestInput = {
  layoutId?: InputMaybe<Scalars['String']>
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerLocationByLayoutResponse = {
  __typename?: 'GetRetailerLocationByLayoutResponse'
  retailerLocationAisles: Maybe<Array<Maybe<RetailerLocationAisle>>>
}

export type GetRetailerLocationsByLocationCodesRequestInput = {
  locationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  skipCache?: InputMaybe<Scalars['Boolean']>
  skipStatusCheck?: InputMaybe<Scalars['Boolean']>
}

export type GetRetailerLocationsByLocationCodesResponse = {
  __typename?: 'GetRetailerLocationsByLocationCodesResponse'
  retailerLocations: Maybe<Array<Maybe<RetailerLocationDetails>>>
}

export type GetRetailerLocationsDetailsRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type GetRetailerLocationsDetailsResponse = {
  __typename?: 'GetRetailerLocationsDetailsResponse'
  retailerLocations: Maybe<Array<Maybe<RetailerLocationDetails>>>
}

export type GetRetailerProductDataRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerProductDataResponse = {
  __typename?: 'GetRetailerProductDataResponse'
  retailerProductData: Maybe<Array<Maybe<RetailerProductData>>>
}

export type GetRetailerProductsRequestInput = {
  parameters?: InputMaybe<GetRetailerProductsRequestParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerProductsRequestParametersDateTimeRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>
  to?: InputMaybe<Scalars['DateTime']>
}

export type GetRetailerProductsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  hasPrimaryImageUrl?: InputMaybe<Scalars['Boolean']>
  isStoreBrandProduct?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  offset?: InputMaybe<Scalars['BigInt']>
  omniSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>
  primaryAisleId?: InputMaybe<Scalars['BigInt']>
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  productCreationDateRange?: InputMaybe<GetRetailerProductsRequestParametersDateTimeRangeInput>
  query?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerProductIds?: InputMaybe<
    Array<InputMaybe<GetRetailerProductsRequestParametersRetailerProductIdInput>>
  >
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type GetRetailerProductsRequestParametersRetailerProductIdInput = {
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GetRetailerProductsResponse = {
  __typename?: 'GetRetailerProductsResponse'
  results: Maybe<Array<Maybe<RetailerProduct>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type GetRetailerRegionsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  skipCache?: InputMaybe<Scalars['Boolean']>
}

export type GetRetailerRegionsResponse = {
  __typename?: 'GetRetailerRegionsResponse'
  regions: Maybe<Array<Maybe<Region>>>
}

export type GetRppConfigurableItemsRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type GetRppConfigurableItemsResponse = {
  __typename?: 'GetRppConfigurableItemsResponse'
  configurableProducts: Maybe<Scalars['String']>
}

export type GetServiceOptionsFiltersInput = {
  addressId?: InputMaybe<Scalars['BigInt']>
  cartTotal?: InputMaybe<Scalars['Float']>
  earliestOptionStartAt?: InputMaybe<Scalars['DateTime']>
  itemsCount?: InputMaybe<Scalars['Int']>
  postalCode?: InputMaybe<Scalars['String']>
  serviceType?: InputMaybe<Scalars['String']>
  unitsCount?: InputMaybe<Scalars['Float']>
  warehouseId?: InputMaybe<Scalars['Int']>
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>
  withEtaOptions?: InputMaybe<Scalars['Boolean']>
  withPriorityEtaOptions?: InputMaybe<Scalars['Boolean']>
}

export type GetServiceOptionsRequestInput = {
  filters?: InputMaybe<GetServiceOptionsFiltersInput>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type GetServiceOptionsResponse = {
  __typename?: 'GetServiceOptionsResponse'
  serviceOptions: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOption>>>
}

export type GetSignupPartnerRequestInput = {
  name?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
}

export type GetSignupPartnerResponse = {
  __typename?: 'GetSignupPartnerResponse'
  signupPartner: Maybe<SignupPartner>
}

export type GetStagingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
}

export type GetStagingSettingsResponse = {
  __typename?: 'GetStagingSettingsResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  freezer: Maybe<Array<Maybe<Scalars['String']>>>
  fridge: Maybe<Array<Maybe<Scalars['String']>>>
  imageUrl: Maybe<Scalars['String']>
  instruction: Maybe<Scalars['String']>
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  shelf: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetStoreConfigurationDraftsRequestInput = {
  includeOutdatedDrafts?: InputMaybe<Scalars['Boolean']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type GetStoreConfigurationDraftsResponse = {
  __typename?: 'GetStoreConfigurationDraftsResponse'
  drafts: Maybe<Array<Maybe<StoreConfigurationDraft>>>
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
}

export type GetStoreHoursByDateRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  startDate?: InputMaybe<GoogleTypeDateInput>
  verticalType?: InputMaybe<VerticalType>
}

export type GetStoreHoursByDateResponse = {
  __typename?: 'GetStoreHoursByDateResponse'
  storeHours: Maybe<Array<Maybe<StoreHoursByDate>>>
}

export type GetStoreHoursByDayOfWeekRequestInput = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<GoogleTypeDayOfWeek>>>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  verticalType?: InputMaybe<VerticalType>
}

export type GetStoreHoursByDayOfWeekResponse = {
  __typename?: 'GetStoreHoursByDayOfWeekResponse'
  storeHours: Maybe<Array<Maybe<StoreHoursByDayOfWeek>>>
}

export type GetStoreHoursByZoneRetailerRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>
  includeClosedRetailer?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  startDate?: InputMaybe<GoogleTypeDateInput>
  verticalType?: InputMaybe<VerticalType>
  zoneId?: InputMaybe<Scalars['BigInt']>
}

export type GetStoreHoursByZoneRetailerResponse = {
  __typename?: 'GetStoreHoursByZoneRetailerResponse'
  storeHours: Maybe<Array<Maybe<StoreHoursByZoneRetailer>>>
}

export type GetStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  serviceTypes?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>
  startDate?: InputMaybe<GoogleTypeDateInput>
}

export type GetStoreHoursResponse = {
  __typename?: 'GetStoreHoursResponse'
  storeHours: Maybe<Array<Maybe<StoreHours>>>
}

export type GetStoreHoursUpdateTasksRequestInput = {
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  startDate?: InputMaybe<GoogleTypeDateInput>
}

export type GetStoreHoursUpdateTasksResponse = {
  __typename?: 'GetStoreHoursUpdateTasksResponse'
  tasks: Maybe<Array<Maybe<StoreHoursUpdateTask>>>
}

export type GetThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
}

export type GetThemePageResponse = {
  __typename?: 'GetThemePageResponse'
  themePage: Maybe<ThemePage>
}

export type GetTicketRequestInput = {
  client?: InputMaybe<ClientInput>
  cptTicketId?: InputMaybe<Scalars['BigInt']>
}

export type GetTicketResponse = {
  __typename?: 'GetTicketResponse'
  comments: Maybe<Array<Maybe<ProblemTrackerTicketComment>>>
  entities: Maybe<Array<Maybe<ProblemTrackerEntityStatus>>>
  ticket: Maybe<ProblemTrackerTicket>
}

export type GetValueBasedOverridesRequestInput = {
  entityId?: InputMaybe<EntityIdInput>
}

export type GetValueBasedOverridesResponse = {
  __typename?: 'GetValueBasedOverridesResponse'
  entityId: Maybe<EntityId>
  valueBasedOverride: Maybe<Array<Maybe<ValueBasedOverrideResponse>>>
}

export type GetVirtualRetailersRequestInput = {
  parameters?: InputMaybe<GetVirtualRetailersRequestParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type GetVirtualRetailersRequestParametersInput = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type GetVirtualRetailersResponse = {
  __typename?: 'GetVirtualRetailersResponse'
  virtualRetailers: Maybe<Array<Maybe<VirtualRetailer>>>
}

export type GoogleProtobufDoubleValueInput = {
  value?: InputMaybe<Scalars['Float']>
}

export type GoogleTypeDate = {
  __typename?: 'GoogleTypeDate'
  day: Maybe<Scalars['Int']>
  month: Maybe<Scalars['Int']>
  year: Maybe<Scalars['Int']>
}

export type GoogleTypeDateInput = {
  day?: InputMaybe<Scalars['Int']>
  month?: InputMaybe<Scalars['Int']>
  year?: InputMaybe<Scalars['Int']>
}

export enum GoogleTypeDayOfWeek {
  DayOfWeekUnspecified = 'DAY_OF_WEEK_UNSPECIFIED',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type GoogleTypeLatLng = {
  __typename?: 'GoogleTypeLatLng'
  latitude: Maybe<Scalars['Float']>
  longitude: Maybe<Scalars['Float']>
}

export type GoogleTypeMoney = {
  __typename?: 'GoogleTypeMoney'
  currencyCode: Maybe<Scalars['String']>
  nanos: Maybe<Scalars['Int']>
  units: Maybe<Scalars['BigInt']>
}

export type GoogleTypeMoneyInput = {
  currencyCode?: InputMaybe<Scalars['String']>
  nanos?: InputMaybe<Scalars['Int']>
  units?: InputMaybe<Scalars['BigInt']>
}

export type GoogleTypeTimeOfDay = {
  __typename?: 'GoogleTypeTimeOfDay'
  hours: Maybe<Scalars['Int']>
  minutes: Maybe<Scalars['Int']>
  nanos: Maybe<Scalars['Int']>
  seconds: Maybe<Scalars['Int']>
}

export type GoogleTypeTimeOfDayInput = {
  hours?: InputMaybe<Scalars['Int']>
  minutes?: InputMaybe<Scalars['Int']>
  nanos?: InputMaybe<Scalars['Int']>
  seconds?: InputMaybe<Scalars['Int']>
}

export type GrantImpersonationRequestInput = {
  clientContext?: InputMaybe<ClientContextInput>
  impersonatedUserId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type GrantImpersonationResponse = {
  __typename?: 'GrantImpersonationResponse'
  authorizationCode: Maybe<Scalars['String']>
}

export type HealthCheck = {
  __typename?: 'HealthCheck'
  /** Server health status */
  alive: Scalars['True']
  /** Postgresql health status */
  postgresql: Maybe<Scalars['Boolean']>
  /** Redis health status */
  redis: Maybe<Scalars['Boolean']>
  /** Snowflake health status */
  snowflake: Maybe<Scalars['Boolean']>
}

export type HeroBanner = {
  __typename?: 'HeroBanner'
  backgroundColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  mobileImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  textAreaColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type HeroBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  desktopImageUrl?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  mobileImageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  textAreaColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

/** Autogenerated return type of HeroBannerPlacementCreate */
export type HeroBannerPlacementCreatePayload = {
  __typename?: 'HeroBannerPlacementCreatePayload'
  /** The newly created hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HeroBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>
  enabled?: InputMaybe<Scalars['Boolean']>
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The images on the banner */
  images: GenericImagesInput
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The color of the text area for placements (Eg. #FFFFFF) */
  textareaColor?: InputMaybe<Scalars['String']>
  /** The type of this placement */
  type: PlacementTypeEnum
}

/** Autogenerated return type of HeroBannerPlacementUpdate */
export type HeroBannerPlacementUpdatePayload = {
  __typename?: 'HeroBannerPlacementUpdatePayload'
  /** The updated hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement
}

export type HighContrastColorsSchema = {
  __typename?: 'HighContrastColorsSchema'
  brandExpressDark: Maybe<Scalars['String']>
  brandExpressExtraDark: Maybe<Scalars['String']>
  brandExpressLight: Maybe<Scalars['String']>
  brandExpressRegular: Maybe<Scalars['String']>
  brandHighlightDark: Maybe<Scalars['String']>
  brandHighlightLight: Maybe<Scalars['String']>
  brandHighlightRegular: Maybe<Scalars['String']>
  brandLoyaltyDark: Maybe<Scalars['String']>
  brandLoyaltyLight: Maybe<Scalars['String']>
  brandLoyaltyRegular: Maybe<Scalars['String']>
  brandPrimaryDark: Maybe<Scalars['String']>
  brandPrimaryExtraDark: Maybe<Scalars['String']>
  brandPrimaryRegular: Maybe<Scalars['String']>
  brandPromotionalDark: Maybe<Scalars['String']>
  brandPromotionalLight: Maybe<Scalars['String']>
  brandPromotionalRegular: Maybe<Scalars['String']>
  brandSecondaryDark: Maybe<Scalars['String']>
  brandSecondaryLight: Maybe<Scalars['String']>
  brandSecondaryRegular: Maybe<Scalars['String']>
}

export type HistoricalPerformanceOverviewRecord = {
  __typename?: 'HistoricalPerformanceOverviewRecord'
  currentValue: Maybe<InstacartTypesV1BigDecimal>
  metricType: Maybe<MetricType>
  pastValue: Maybe<InstacartTypesV1BigDecimal>
}

export type HistoricalStorePerformanceRecord = {
  __typename?: 'HistoricalStorePerformanceRecord'
  dedicatedMatchRate: Maybe<InstacartTypesV1BigDecimal>
  dedicatedUtilizationRate: Maybe<InstacartTypesV1BigDecimal>
  fiveHourAvailabilityRate: Maybe<InstacartTypesV1BigDecimal>
  fssOrdersCount: Maybe<Scalars['Int']>
  matchRate: Maybe<InstacartTypesV1BigDecimal>
  name: Maybe<Scalars['String']>
  partnerPickOrdersCount: Maybe<Scalars['Int']>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledGaps: Maybe<Scalars['Int']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  utilizationRate: Maybe<InstacartTypesV1BigDecimal>
  warehouseLocationId: Maybe<Scalars['BigInt']>
}

export type HistoricalStorePerformanceRequestInput = {
  devicePrioritizationEnabled?: InputMaybe<Scalars['Boolean']>
  endDate?: InputMaybe<GoogleTypeDateInput>
  metricThresholds?: InputMaybe<Array<InputMaybe<MetricThresholdInput>>>
  startDate?: InputMaybe<GoogleTypeDateInput>
  warehouseId?: InputMaybe<Scalars['BigInt']>
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type HistoricalStorePerformanceResponse = {
  __typename?: 'HistoricalStorePerformanceResponse'
  metrics: Maybe<Array<Maybe<HistoricalStorePerformanceRecord>>>
  overviewMetrics: Maybe<Array<Maybe<HistoricalPerformanceOverviewRecord>>>
  updatedAt: Maybe<Scalars['DateTime']>
  warehouseId: Maybe<Scalars['BigInt']>
}

export type Holiday = {
  __typename?: 'Holiday'
  date: Maybe<GoogleTypeDate>
  holidaySlug: Maybe<Scalars['String']>
  regions: Maybe<Array<Maybe<Scalars['String']>>>
}

export type HolidayStatus = {
  __typename?: 'HolidayStatus'
  confirmedRetailerLocationCount: Maybe<Scalars['Int']>
  holiday: Maybe<Holiday>
  unconfirmedRetailerLocationCount: Maybe<Scalars['Int']>
}

/** Types of Home Placements which may be returned */
export type HomePlacement =
  | ContentManagementFlyoutPlacement
  | ContentManagementHeroBannerPlacement
  | ContentManagementSecondaryBannerPlacement
  | ContentManagementUnknownBannerPlacement

export type HubPaginationMeta = {
  __typename?: 'HubPaginationMeta'
  perPage: Scalars['Int']
  totalCount: Scalars['Int']
  totalPages: Scalars['Int']
}

export type IdsThemeSchema = {
  __typename?: 'IdsThemeSchema'
  buttonBorderRadius: Maybe<BorderRadiusSchema>
  colors: Maybe<ColorsSchema>
  fonts: Maybe<Array<Maybe<CustomFontFamilySchema>>>
  inputBorderRadius: Maybe<BorderRadiusSchema>
  radius: Maybe<RadiusSchema>
  typography: Maybe<TypographySchema>
}

export type ImageAsset = {
  __typename?: 'ImageAsset'
  altText: Maybe<Scalars['String']>
  identifier: Maybe<Scalars['String']>
  url: Maybe<Scalars['String']>
}

export type ImageConfig = {
  __typename?: 'ImageConfig'
  caption: Maybe<Scalars['String']>
  id: Maybe<Scalars['Int']>
  url: Maybe<Scalars['String']>
}

export type ImageConfigInput = {
  caption?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  url?: InputMaybe<Scalars['String']>
}

export type ImageForward = {
  __typename?: 'ImageForward'
  backgroundColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  mobileImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type ImageForwardFlex = {
  __typename?: 'ImageForwardFlex'
  backgroundColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  mobileImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type ImageForwardFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  desktopImageUrl?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  mobileImageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type ImageForwardInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  desktopImageUrl?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  mobileImageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type ImageUploadBatch = {
  __typename?: 'ImageUploadBatch'
  batchId: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  processedImageUploads: Maybe<Scalars['BigInt']>
  state: Maybe<Scalars['String']>
  successfulImageUploads: Maybe<Scalars['BigInt']>
  totalImageUploads: Maybe<Scalars['BigInt']>
}

export type ImageUploadBatchDetails = {
  __typename?: 'ImageUploadBatchDetails'
  filename: Maybe<Scalars['String']>
  imageUploadId: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  isSuccessful: Maybe<Scalars['Boolean']>
  productName: Maybe<Scalars['String']>
}

export type ImageUploadBatchMetadata = {
  __typename?: 'ImageUploadBatchMetadata'
  perPage: Maybe<Scalars['BigInt']>
  totalCount: Maybe<Scalars['BigInt']>
  totalPages: Maybe<Scalars['BigInt']>
}

/** Attributes for creating a code lookup */
export type ImportProcessCodeLookupDataInput = {
  /** The lookup code of the product */
  code: Scalars['String']
  /** The price per cost unit of the product */
  pricePerCostUnit?: InputMaybe<Scalars['Float']>
}

export enum ImportProcessCodeLookupStateEnum {
  /** The ImportProcessCodeLookup was processed successfully, returning zero or more product_ids */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to fetch the associated product_ids for the ImportProcessCodeLookup */
  Failed = 'FAILED',
  /** The ImportProcessCodeLookup is being processed (we are fetching the associated product_ids) */
  InProgress = 'IN_PROGRESS',
  /** A brand new ImportProcessCodeLookup which hasn't been processed yet (no product_ids have been fetched) */
  Pending = 'PENDING',
}

export enum ImportProcessCodeLookupStatusEnum {
  /** We haven't tried to match this code lookup yet, so we don't know the match status */
  Pending = 'PENDING',
  /** There was exactly one product matching the provided lookup code */
  PerfectMatch = 'PERFECT_MATCH',
  /** There was not exactly one product matching the provided lookup code (either 0 or 2+ items were found) */
  Unmatched = 'UNMATCHED',
}

export enum ImportProcessCodeLookupTypeEnum {
  /** A UPC code */
  Upc = 'UPC',
}

export enum ImportProcessStateEnum {
  /** The associated ImportProcessCodeLookups have all been created */
  Completed = 'COMPLETED',
  /** Something went wrong when trying to create the ImportProcessCodeLookups */
  Failed = 'FAILED',
  /** The associated ImportProcessCodeLookups have started to be created */
  InProgress = 'IN_PROGRESS',
  /** A new import process with no associated ImportProcessCodeLookups */
  Pending = 'PENDING',
}

export enum ImportProcessTypeEnum {
  /** A code-lookup type import process */
  CodeLookup = 'CODE_LOOKUP',
}

export type InsightsPortalAuthorizationContextInput = {
  accountId?: InputMaybe<Scalars['BigInt']>
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type InsightsPortalCreateCustomReportRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  groupBys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  name?: InputMaybe<Scalars['String']>
  orderBys?: InputMaybe<Array<InputMaybe<InsightsPortalOrderByInput>>>
  schema?: InputMaybe<InsightsPortalSchema>
}

export type InsightsPortalCreateCustomReportResponse = {
  __typename?: 'InsightsPortalCreateCustomReportResponse'
  customReport: Maybe<InsightsPortalCustomReport>
  success: Maybe<Scalars['Boolean']>
}

export type InsightsPortalCustomReport = {
  __typename?: 'InsightsPortalCustomReport'
  createdAt: Maybe<Scalars['DateTime']>
  downloadUrl: Maybe<Scalars['String']>
  fileGenerationStatus: Maybe<InsightsPortalCustomReportFileGenerationStatus>
  filterSelections: Maybe<Scalars['String']>
  groupBys: Maybe<Array<Maybe<Scalars['String']>>>
  id: Maybe<Scalars['BigInt']>
  metrics: Maybe<Array<Maybe<Scalars['String']>>>
  name: Maybe<Scalars['String']>
  orderBys: Maybe<Array<Maybe<InsightsPortalOrderBy>>>
}

export enum InsightsPortalCustomReportFileGenerationStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Ready = 'READY',
}

export type InsightsPortalFilterOption = {
  __typename?: 'InsightsPortalFilterOption'
  displayValue: Maybe<Scalars['String']>
  rawValue: Maybe<InsightsPortalValue>
}

export type InsightsPortalFilterOptionsRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  owner?: InputMaybe<InsightsPortalOwner>
  queryTags?: InputMaybe<Array<InputMaybe<InsightsPortalQueryTagInput>>>
  schema?: InputMaybe<InsightsPortalSchema>
  whitelistFilterOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type InsightsPortalFilterOptionsResponse = {
  __typename?: 'InsightsPortalFilterOptionsResponse'
  filterOptions: Maybe<Array<Maybe<InsightsPortalFilterOptionsResponseFilterOptions>>>
}

export type InsightsPortalFilterOptionsResponseFilterOptions = {
  __typename?: 'InsightsPortalFilterOptionsResponseFilterOptions'
  name: Maybe<Scalars['String']>
  options: Maybe<Array<Maybe<InsightsPortalFilterOption>>>
}

export type InsightsPortalFilterSelectionBetweenFilterInput = {
  end?: InputMaybe<InsightsPortalValueInput>
  start?: InputMaybe<InsightsPortalValueInput>
}

export type InsightsPortalFilterSelectionEqualFilterInput = {
  value?: InputMaybe<InsightsPortalValueInput>
}

export type InsightsPortalFilterSelectionInFilterInput = {
  values?: InputMaybe<Array<InputMaybe<InsightsPortalValueInput>>>
}

export type InsightsPortalFilterSelectionInput = {
  betweenFilter?: InputMaybe<InsightsPortalFilterSelectionBetweenFilterInput>
  equalFilter?: InputMaybe<InsightsPortalFilterSelectionEqualFilterInput>
  inFilter?: InputMaybe<InsightsPortalFilterSelectionInFilterInput>
  name?: InputMaybe<Scalars['String']>
}

export type InsightsPortalGetCustomReportRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  customReportId?: InputMaybe<Scalars['BigInt']>
}

export type InsightsPortalGetCustomReportResponse = {
  __typename?: 'InsightsPortalGetCustomReportResponse'
  customReport: Maybe<InsightsPortalCustomReport>
}

export type InsightsPortalGroupComparisonRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  comparisonDataset?: InputMaybe<InsightsPortalGroupComparisonRequestInsightsPortalGroupComparisonDatasetInput>
  joinBy?: InputMaybe<InsightsPortalGroupComparisonRequestJoinBy>
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  orderBy?: InputMaybe<InsightsPortalGroupComparisonRequestOrderBy>
  orderDirection?: InputMaybe<InsightsPortalGroupComparisonRequestOrderDirection>
  owner?: InputMaybe<InsightsPortalOwner>
  primaryDataset?: InputMaybe<InsightsPortalGroupComparisonRequestInsightsPortalGroupComparisonDatasetInput>
  queryTags?: InputMaybe<Array<InputMaybe<InsightsPortalQueryTagInput>>>
}

export type InsightsPortalGroupComparisonRequestInsightsPortalGroupComparisonDatasetInput = {
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  groupBy?: InputMaybe<Scalars['String']>
  metric?: InputMaybe<Scalars['String']>
  schema?: InputMaybe<InsightsPortalSchema>
  secondaryMetrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export enum InsightsPortalGroupComparisonRequestJoinBy {
  CustomJoinProductToCategory = 'CUSTOM_JOIN_PRODUCT_TO_CATEGORY',
  GroupValue = 'GROUP_VALUE',
  RowNumber = 'ROW_NUMBER',
  Unknown = 'UNKNOWN',
}

export enum InsightsPortalGroupComparisonRequestOrderBy {
  Default = 'DEFAULT',
  Growth = 'GROWTH',
  GrowthPercentage = 'GROWTH_PERCENTAGE',
  Total = 'TOTAL',
}

export enum InsightsPortalGroupComparisonRequestOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE',
}

export type InsightsPortalGroupComparisonResponse = {
  __typename?: 'InsightsPortalGroupComparisonResponse'
  values: Maybe<
    Array<Maybe<InsightsPortalGroupComparisonResponseInsightsPortalGroupComparisonValues>>
  >
}

export type InsightsPortalGroupComparisonResponseInsightsPortalGroupComparisonValues = {
  __typename?: 'InsightsPortalGroupComparisonResponseInsightsPortalGroupComparisonValues'
  comparisonGroupValue: Maybe<InsightsPortalValue>
  comparisonMetricValue: Maybe<InsightsPortalValue>
  comparisonSecondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
  growth: Maybe<Scalars['Float']>
  growthPercentage: Maybe<Scalars['Float']>
  metricName: Maybe<Scalars['String']>
  primaryGroupValue: Maybe<InsightsPortalValue>
  primaryMetricValue: Maybe<InsightsPortalValue>
  primarySecondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
}

export type InsightsPortalGroupMetricValueRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  groupBy?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  orderDirection?: InputMaybe<InsightsPortalGroupMetricValueRequestOrderDirection>
  owner?: InputMaybe<InsightsPortalOwner>
  primaryMetric?: InputMaybe<Scalars['String']>
  queryTags?: InputMaybe<Array<InputMaybe<InsightsPortalQueryTagInput>>>
  schema?: InputMaybe<InsightsPortalSchema>
  secondaryMetrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export enum InsightsPortalGroupMetricValueRequestOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE',
}

export type InsightsPortalGroupMetricValueResponse = {
  __typename?: 'InsightsPortalGroupMetricValueResponse'
  values: Maybe<Array<Maybe<InsightsPortalGroupMetricValueResponseGroupMetricValue>>>
}

export type InsightsPortalGroupMetricValueResponseGroupMetricValue = {
  __typename?: 'InsightsPortalGroupMetricValueResponseGroupMetricValue'
  groupValue: Maybe<InsightsPortalValue>
  metricValue: Maybe<InsightsPortalValue>
  secondaryMetricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
}

export type InsightsPortalListCustomReportsRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  from?: InputMaybe<Scalars['DateTime']>
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  to?: InputMaybe<Scalars['DateTime']>
}

export type InsightsPortalListCustomReportsResponse = {
  __typename?: 'InsightsPortalListCustomReportsResponse'
  customReports: Maybe<Array<Maybe<InsightsPortalCustomReport>>>
}

export type InsightsPortalMetricValue = {
  __typename?: 'InsightsPortalMetricValue'
  metric: Maybe<Scalars['String']>
  value: Maybe<InsightsPortalValue>
}

export type InsightsPortalMetricValuesRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  owner?: InputMaybe<InsightsPortalOwner>
  queryTags?: InputMaybe<Array<InputMaybe<InsightsPortalQueryTagInput>>>
  schema?: InputMaybe<InsightsPortalSchema>
}

export type InsightsPortalMetricValuesResponse = {
  __typename?: 'InsightsPortalMetricValuesResponse'
  metricValues: Maybe<Array<Maybe<InsightsPortalMetricValue>>>
}

export type InsightsPortalMultiGroupRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  filters?: InputMaybe<Array<InputMaybe<InsightsPortalFilterSelectionInput>>>
  groupBys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  limit?: InputMaybe<Scalars['BigInt']>
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  offset?: InputMaybe<Scalars['BigInt']>
  orderBys?: InputMaybe<Array<InputMaybe<InsightsPortalOrderByInput>>>
  owner?: InputMaybe<InsightsPortalOwner>
  queryTags?: InputMaybe<Array<InputMaybe<InsightsPortalQueryTagInput>>>
  schema?: InputMaybe<InsightsPortalSchema>
}

export type InsightsPortalMultiGroupResponse = {
  __typename?: 'InsightsPortalMultiGroupResponse'
  dataHeaders: Maybe<Array<Maybe<InsightsPortalMultiGroupResponseDataHeaders>>>
  dataRows: Maybe<Array<Maybe<InsightsPortalMultiGroupResponseDataRow>>>
  totalRows: Maybe<Scalars['BigInt']>
}

export type InsightsPortalMultiGroupResponseDataHeaders = {
  __typename?: 'InsightsPortalMultiGroupResponseDataHeaders'
  groupByName: Maybe<Scalars['String']>
  metricName: Maybe<Scalars['String']>
}

export type InsightsPortalMultiGroupResponseDataRow = {
  __typename?: 'InsightsPortalMultiGroupResponseDataRow'
  dataItems: Maybe<Array<Maybe<DataItem>>>
}

export type InsightsPortalOrderBy = {
  __typename?: 'InsightsPortalOrderBy'
  columnName: Maybe<Scalars['String']>
  orderDirection: Maybe<InsightsPortalOrderDirection>
}

export type InsightsPortalOrderByInput = {
  columnName?: InputMaybe<Scalars['String']>
  orderDirection?: InputMaybe<InsightsPortalOrderDirection>
}

export enum InsightsPortalOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE',
}

export enum InsightsPortalOwner {
  RetailerTools = 'RETAILER_TOOLS',
  Unspecified = 'UNSPECIFIED',
}

export type InsightsPortalQueryTagInput = {
  name?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export enum InsightsPortalSchema {
  AdsDisplayBanner = 'ADS_DISPLAY_BANNER',
  AdsSponsoredProduct = 'ADS_SPONSORED_PRODUCT',
  AggWarehouseLocationCampaignPerformance = 'AGG_WAREHOUSE_LOCATION_CAMPAIGN_PERFORMANCE',
  AggWarehouseLocationCampaignPerformanceHistoricalGrowth = 'AGG_WAREHOUSE_LOCATION_CAMPAIGN_PERFORMANCE_HISTORICAL_GROWTH',
  AggWarehouseLocationPerformance = 'AGG_WAREHOUSE_LOCATION_PERFORMANCE',
  AggWarehouseLocationPerformanceHistoricalGrowth = 'AGG_WAREHOUSE_LOCATION_PERFORMANCE_HISTORICAL_GROWTH',
  AggWarehousePerformance = 'AGG_WAREHOUSE_PERFORMANCE',
  ImageCoverage = 'IMAGE_COVERAGE',
  ImageCoverageClickhouse = 'IMAGE_COVERAGE_CLICKHOUSE',
  ImageCoverageDemo = 'IMAGE_COVERAGE_DEMO',
  ImageCoverageHistoricalGrowth = 'IMAGE_COVERAGE_HISTORICAL_GROWTH',
  ImageCoverageHistoricalGrowthClickhouse = 'IMAGE_COVERAGE_HISTORICAL_GROWTH_CLICKHOUSE',
  InventoryIntelligenceOosSignalsAgg = 'INVENTORY_INTELLIGENCE_OOS_SIGNALS_AGG',
  MissingImage_90DayRetailerInsights = 'MISSING_IMAGE_90DAY_RETAILER_INSIGHTS',
  MissingImage_90DayRetailerInsightsClickhouse = 'MISSING_IMAGE_90DAY_RETAILER_INSIGHTS_CLICKHOUSE',
  OrderDelivery = 'ORDER_DELIVERY',
  OrderDeliveryClickhouse = 'ORDER_DELIVERY_CLICKHOUSE',
  OrderDeliveryDemo = 'ORDER_DELIVERY_DEMO',
  OrderDeliveryHistoricalGrowth = 'ORDER_DELIVERY_HISTORICAL_GROWTH',
  OrderDeliveryHistoricalGrowthClickhouse = 'ORDER_DELIVERY_HISTORICAL_GROWTH_CLICKHOUSE',
  OrderItem = 'ORDER_ITEM',
  OrderItemClickhouse = 'ORDER_ITEM_CLICKHOUSE',
  OrderItemDemo = 'ORDER_ITEM_DEMO',
  OrderItemHistoricalGrowth = 'ORDER_ITEM_HISTORICAL_GROWTH',
  OrderItemHistoricalGrowthClickhouse = 'ORDER_ITEM_HISTORICAL_GROWTH_CLICKHOUSE',
  OrderItemStitchProductByCategoryBenchmark = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK',
  OrderItemStitchProductByCategoryBenchmarkClickhouse = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK_CLICKHOUSE',
  OrderItemStitchProductByCategoryBenchmarkHistoricalGrowth = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK_HISTORICAL_GROWTH',
  OrderItemStitchProductByCategoryBenchmarkHistoricalGrowthClickhouse = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK_HISTORICAL_GROWTH_CLICKHOUSE',
  ProductByCategoryBenchmark = 'PRODUCT_BY_CATEGORY_BENCHMARK',
  ProductByCategoryBenchmarkClickhouse = 'PRODUCT_BY_CATEGORY_BENCHMARK_CLICKHOUSE',
  ProductByPartnerBenchmark = 'PRODUCT_BY_PARTNER_BENCHMARK',
  ProductByPartnerBenchmarkClickhouse = 'PRODUCT_BY_PARTNER_BENCHMARK_CLICKHOUSE',
  SearchTerm = 'SEARCH_TERM',
  SearchTermByPartnerBenchmark = 'SEARCH_TERM_BY_PARTNER_BENCHMARK',
  SearchTermByPartnerBenchmarkClickhouse = 'SEARCH_TERM_BY_PARTNER_BENCHMARK_CLICKHOUSE',
  SearchTermByTermBenchmark = 'SEARCH_TERM_BY_TERM_BENCHMARK',
  SearchTermByTermBenchmarkClickhouse = 'SEARCH_TERM_BY_TERM_BENCHMARK_CLICKHOUSE',
  SearchTermClickhouse = 'SEARCH_TERM_CLICKHOUSE',
  SearchTermDemo = 'SEARCH_TERM_DEMO',
  SearchTermHistoricalGrowth = 'SEARCH_TERM_HISTORICAL_GROWTH',
  SearchTermHistoricalGrowthClickhouse = 'SEARCH_TERM_HISTORICAL_GROWTH_CLICKHOUSE',
  SearchTermStitchSearchTermByTermBenchmark = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK',
  SearchTermStitchSearchTermByTermBenchmarkClickhouse = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK_CLICKHOUSE',
  SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowth = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK_HISTORICAL_GROWTH',
  SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowthClickhouse = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK_HISTORICAL_GROWTH_CLICKHOUSE',
  Unknown = 'UNKNOWN',
}

export type InsightsPortalSchemaMetadataRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  schema?: InputMaybe<InsightsPortalSchema>
}

export type InsightsPortalSchemaMetadataResponse = {
  __typename?: 'InsightsPortalSchemaMetadataResponse'
  filters: Maybe<Array<Maybe<Scalars['String']>>>
  groupBys: Maybe<Array<Maybe<Scalars['String']>>>
  metrics: Maybe<Array<Maybe<Scalars['String']>>>
  name: Maybe<Scalars['String']>
}

export type InsightsPortalSetCustomReportDisabledRequestInput = {
  authorizationContext?: InputMaybe<InsightsPortalAuthorizationContextInput>
  customReportId?: InputMaybe<Scalars['BigInt']>
}

export type InsightsPortalSetCustomReportDisabledResponse = {
  __typename?: 'InsightsPortalSetCustomReportDisabledResponse'
  customReport: Maybe<InsightsPortalCustomReport>
  success: Maybe<Scalars['Boolean']>
}

export type InsightsPortalSnowflakeHeartbeatRequestInput = {
  token?: InputMaybe<Scalars['String']>
}

export type InsightsPortalSnowflakeHeartbeatResponse = {
  __typename?: 'InsightsPortalSnowflakeHeartbeatResponse'
  authenticated: Maybe<Scalars['Boolean']>
}

export type InsightsPortalValue = {
  __typename?: 'InsightsPortalValue'
  doubleValue: Maybe<Scalars['Float']>
  intValue: Maybe<Scalars['BigInt']>
  stringValue: Maybe<Scalars['String']>
  timestampValue: Maybe<Scalars['DateTime']>
}

export type InsightsPortalValueInput = {
  doubleValue?: InputMaybe<Scalars['Float']>
  intValue?: InputMaybe<Scalars['BigInt']>
  stringValue?: InputMaybe<Scalars['String']>
  timestampValue?: InputMaybe<Scalars['DateTime']>
}

export enum InstacartCustomersCommerceTypesV1FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Retailer = 'RETAILER',
}

export type InstacartCustomersCommerceTypesV1SlimOffer = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOffer'
  conditionRewardString: Maybe<Scalars['String']>
  description: Maybe<Scalars['String']>
  endsAt: Maybe<Scalars['DateTime']>
  fundingDetail: Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetail>
  imageUrl: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  offerConditions: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferCondition>>>
  offerExternalReference: Maybe<Scalars['String']>
  offerId: Maybe<Scalars['String']>
  offerRequestKey: Maybe<Scalars['String']>
  offerRewards: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferReward>>>
  offerSource: Maybe<Scalars['String']>
  offerType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>
  promoCode: Maybe<Scalars['String']>
  redemptionLimits: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits>
  startsAt: Maybe<Scalars['DateTime']>
  terms: Maybe<Scalars['String']>
}

export enum InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
}

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetail = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingDetail'
  budgetLimit: Maybe<GoogleTypeMoney>
  fundingProviderInfo: Maybe<
    Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation>>
  >
}

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput = {
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>
  fundingProviderInfo?: InputMaybe<
    Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput>>
  >
}

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation'
  percent: Maybe<Scalars['BigInt']>
  source: Maybe<InstacartCustomersCommerceTypesV1FundingSource>
  sourceName: Maybe<Scalars['String']>
}

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput = {
  percent?: InputMaybe<Scalars['BigInt']>
  source?: InputMaybe<InstacartCustomersCommerceTypesV1FundingSource>
  sourceName?: InputMaybe<Scalars['String']>
}

export type InstacartCustomersCommerceTypesV1SlimOfferInput = {
  conditionRewardString?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  endsAt?: InputMaybe<Scalars['DateTime']>
  fundingDetail?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput>
  imageUrl?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  offerConditions?: InputMaybe<
    Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput>>
  >
  offerExternalReference?: InputMaybe<Scalars['String']>
  offerId?: InputMaybe<Scalars['String']>
  offerRequestKey?: InputMaybe<Scalars['String']>
  offerRewards?: InputMaybe<
    Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput>>
  >
  offerSource?: InputMaybe<Scalars['String']>
  offerType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>
  promoCode?: InputMaybe<Scalars['String']>
  redemptionLimits?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput>
  startsAt?: InputMaybe<Scalars['DateTime']>
  terms?: InputMaybe<Scalars['String']>
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferCondition = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferCondition'
  conditionProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  maximumQuantity: Maybe<Scalars['BigInt']>
  minimumQuantity: Maybe<Scalars['BigInt']>
  minimumSpend: Maybe<GoogleTypeMoney>
  offerConditionType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput = {
  conditionProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  maximumQuantity?: InputMaybe<Scalars['BigInt']>
  minimumQuantity?: InputMaybe<Scalars['BigInt']>
  minimumSpend?: InputMaybe<GoogleTypeMoneyInput>
  offerConditionType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED',
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits'
  redemptionLimit: Maybe<Scalars['BigInt']>
  redemptionLimitPerOrder: Maybe<Scalars['BigInt']>
  redemptionLimitPerUser: Maybe<Scalars['BigInt']>
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput = {
  redemptionLimit?: InputMaybe<Scalars['BigInt']>
  redemptionLimitPerOrder?: InputMaybe<Scalars['BigInt']>
  redemptionLimitPerUser?: InputMaybe<Scalars['BigInt']>
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferReward = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferReward'
  amountDiscount: Maybe<GoogleTypeMoney>
  discountRewardType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>
  includeConditionGroup: Maybe<Scalars['Boolean']>
  offerPrice: Maybe<GoogleTypeMoney>
  offerRewardType: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>
  percentDiscount: Maybe<InstacartTypesV1BigDecimal>
  quantityLimit: Maybe<Scalars['BigInt']>
  rewardProductIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput = {
  amountDiscount?: InputMaybe<GoogleTypeMoneyInput>
  discountRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>
  offerPrice?: InputMaybe<GoogleTypeMoneyInput>
  offerRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>
  percentDiscount?: InputMaybe<InstacartTypesV1BigDecimalInput>
  quantityLimit?: InputMaybe<Scalars['BigInt']>
  rewardProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED',
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferType {
  AutoApply = 'AUTO_APPLY',
  Coupon = 'COUPON',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED',
}

export enum InstacartCustomersSharedV1Locale {
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnUs = 'EN_US',
  FrCa = 'FR_CA',
  LocaleUnspecified = 'LOCALE_UNSPECIFIED',
}

export enum InstacartCustomersSharedV1OrderAttributeDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type InstacartCustomersSharedV1OrderAttributeInput = {
  direction?: InputMaybe<InstacartCustomersSharedV1OrderAttributeDirection>
  name?: InputMaybe<Scalars['String']>
}

export type InstacartCustomersSharedV1OrderInput = {
  attributes?: InputMaybe<Array<InputMaybe<InstacartCustomersSharedV1OrderAttributeInput>>>
}

export type InstacartCustomersSharedV1PageInfo = {
  __typename?: 'InstacartCustomersSharedV1PageInfo'
  endCursor: Maybe<Scalars['String']>
  hasNextPage: Maybe<Scalars['Boolean']>
}

export type InstacartCustomersSharedV1PaginationInput = {
  after?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}

export type InstacartCustomersSharedV1RequestContext = {
  __typename?: 'InstacartCustomersSharedV1RequestContext'
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
  storeConfigurationId: Maybe<Scalars['Int']>
}

export type InstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>
  countryId?: InputMaybe<Scalars['Int']>
  storeConfigurationId?: InputMaybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput = {
  addressLineOne?: InputMaybe<Scalars['String']>
  addressLineTwo?: InputMaybe<Scalars['String']>
  addressType?: InputMaybe<Scalars['String']>
  postalCode?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1AddressInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1AddressInformation'
  city: Maybe<Scalars['String']>
  streetName: Maybe<Scalars['String']>
  unitNumber: Maybe<Scalars['String']>
  zipCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1CustomerInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1CustomerInformation'
  customerFirstName: Maybe<Scalars['String']>
  customerFullName: Maybe<Scalars['String']>
  customerLastName: Maybe<Scalars['String']>
  customerPhoneNumber: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrder = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrder'
  addressInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressInformation>
  addressLatitude: Maybe<Scalars['Float']>
  addressLongitude: Maybe<Scalars['Float']>
  alcoholic: Maybe<Scalars['Boolean']>
  cancellationOrigin: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin>
  cancellationReason: Maybe<Scalars['String']>
  carModelAndColor: Maybe<Scalars['String']>
  customerContext: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext>
  customerInformation: Maybe<InstacartEnterpriseBobaCoreTypesV1CustomerInformation>
  dashboardOptions: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions>
  displayId: Maybe<Scalars['BigInt']>
  estimatedDeliveryTime: Maybe<Scalars['DateTime']>
  estimatedPickupTime: Maybe<Scalars['DateTime']>
  externalId: Maybe<Scalars['String']>
  formattedTipAmount: Maybe<Scalars['String']>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  id: Maybe<Scalars['BigInt']>
  initialTip: Maybe<Scalars['Float']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  orderHistoryEvents: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent>>>
  previouslyRescheduled: Maybe<Scalars['Boolean']>
  retailerProvidedAmounts: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts>
  shopperAvatarUrl: Maybe<Scalars['String']>
  shopperFirstName: Maybe<Scalars['String']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['Int']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  warehouseLocationName: Maybe<Scalars['String']>
  workflowState: Maybe<Scalars['String']>
}

export enum InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin {
  CancellationOriginUnspecified = 'CANCELLATION_ORIGIN_UNSPECIFIED',
  Customer = 'CUSTOMER',
  Instacart = 'INSTACART',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Shopper = 'SHOPPER',
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext'
  clientConfigurationId: Maybe<Scalars['Int']>
  countryId: Maybe<Scalars['Int']>
  storeConfigurationId: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions'
  leaveUnattended: Maybe<Scalars['Boolean']>
  specialInstructions: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails'
  addressId: Maybe<Scalars['BigInt']>
  fulfillmentType: Maybe<Scalars['String']>
  numOfBags: Maybe<Scalars['BigInt']>
  serviceOptionId: Maybe<Scalars['BigInt']>
  warehouseLocationId: Maybe<Scalars['BigInt']>
  windowEndsAt: Maybe<Scalars['DateTime']>
  windowStartsAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1ItemReplacement = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ItemReplacement'
  itemRrc: Maybe<Scalars['String']>
  itemUpc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput = {
  addressCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput>
  alcoholic?: InputMaybe<Scalars['Boolean']>
  endAt?: InputMaybe<Scalars['String']>
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
  initialTip?: InputMaybe<Scalars['Float']>
  locale?: InputMaybe<Scalars['String']>
  locationCode?: InputMaybe<Scalars['String']>
  options?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput>
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>
  serviceOptionId?: InputMaybe<Scalars['BigInt']>
  serviceOptionReference?: InputMaybe<Scalars['String']>
  startAt?: InputMaybe<Scalars['String']>
  userBirthday?: InputMaybe<Scalars['String']>
  userCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput>
  userPhone?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1ModificationEventInput = {
  reason?: InputMaybe<Scalars['String']>
  reasonDetailed?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
  userType?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType>
}

export enum InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType {
  Rpp = 'RPP',
  UserTypeUnspecified = 'USER_TYPE_UNSPECIFIED',
}

export type InstacartEnterpriseBobaCoreTypesV1Order = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1Order'
  canceledAt: Maybe<Scalars['DateTime']>
  cancellationReason: Maybe<Scalars['String']>
  cancellationType: Maybe<Scalars['String']>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  deliveredAt: Maybe<Scalars['DateTime']>
  deliveryEta: Maybe<Scalars['DateTime']>
  displayId: Maybe<Scalars['BigInt']>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalData>
  fulfillmentDetails: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>
  id: Maybe<Scalars['BigInt']>
  isExpress: Maybe<Scalars['Boolean']>
  locale: Maybe<Scalars['String']>
  loyaltyCardId: Maybe<Scalars['BigInt']>
  orderDeliveryId: Maybe<Scalars['BigInt']>
  postCheckoutLink: Maybe<Scalars['String']>
  statusUrl: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  userId: Maybe<Scalars['BigInt']>
  warehouseId: Maybe<Scalars['BigInt']>
  warnings: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderWarning>>>
  workflowState: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderExternalData'
  externalId: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput = {
  externalId?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent'
  action: Maybe<Scalars['String']>
  actionedAt: Maybe<Scalars['DateTime']>
  windowEndsAt: Maybe<Scalars['DateTime']>
  windowStartsAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItem = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItem'
  createdAt: Maybe<Scalars['DateTime']>
  externalData: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData>
  id: Maybe<Scalars['BigInt']>
  isAddOnItem: Maybe<Scalars['Boolean']>
  itemCodes: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemCodes>
  itemId: Maybe<Scalars['BigInt']>
  itemProperties: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemProperties>
  orderId: Maybe<Scalars['BigInt']>
  pickedAt: Maybe<Scalars['DateTime']>
  quantity: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity>
  replacementItem: Maybe<InstacartEnterpriseBobaCoreTypesV1ItemReplacement>
  replacementPolicy: Maybe<Scalars['String']>
  status: Maybe<Scalars['String']>
  substituteId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemCodes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemCodes'
  deliveredRrc: Maybe<Scalars['String']>
  deliveredUpc: Maybe<Scalars['String']>
  requestedRrc: Maybe<Scalars['String']>
  requestedUpc: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData'
  itemRrc: Maybe<Scalars['String']>
  itemUpc: Maybe<Scalars['String']>
  lineNum: Maybe<Scalars['String']>
  scanCode: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemProperties = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemProperties'
  name: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  productType: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity'
  countDelivered: Maybe<Scalars['Int']>
  countOrdered: Maybe<Scalars['Int']>
  unit: Maybe<Scalars['String']>
  weightDelivered: Maybe<Scalars['Float']>
  weightOrdered: Maybe<Scalars['Float']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput = {
  leaveUnattended?: InputMaybe<Scalars['Boolean']>
  smsOptIn?: InputMaybe<Scalars['Boolean']>
  specialInstructions?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1OrderWarning = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderWarning'
  errorCode: Maybe<Scalars['Int']>
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>
  message: Maybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput = {
  canceledExternalOrderId?: InputMaybe<Scalars['String']>
  canceledOrderId?: InputMaybe<Scalars['BigInt']>
  endAt?: InputMaybe<Scalars['String']>
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
  serviceOptionId?: InputMaybe<Scalars['BigInt']>
  serviceOptionReference?: InputMaybe<Scalars['String']>
  startAt?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput = {
  endAt?: InputMaybe<Scalars['String']>
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>
  id?: InputMaybe<Scalars['BigInt']>
  serviceOptionId?: InputMaybe<Scalars['BigInt']>
  serviceOptionReference?: InputMaybe<Scalars['String']>
  startAt?: InputMaybe<Scalars['String']>
}

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts'
  bagLabel: Maybe<Scalars['String']>
  bagScanCodes: Maybe<Array<Maybe<Scalars['String']>>>
  bagsCount: Maybe<Scalars['Int']>
  cartTotal: Maybe<Scalars['Float']>
  itemsCount: Maybe<Scalars['Int']>
  itemsWeight: Maybe<Scalars['Float']>
}

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput = {
  bagLabel?: InputMaybe<Scalars['String']>
  bagScanCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  bagsCount?: InputMaybe<Scalars['Int']>
  cartTotal?: InputMaybe<Scalars['Float']>
  itemsCount?: InputMaybe<Scalars['Int']>
  itemsWeight?: InputMaybe<Scalars['Float']>
}

export type InstacartEnterpriseBobaCoreTypesV1ServiceOption = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOption'
  asapWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow>
  availability: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability>
  date: Maybe<GoogleTypeDate>
  id: Maybe<Scalars['BigInt']>
  immediateWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow>
  scheduledWindow: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow>
  serviceOptionReference: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  warehouseId: Maybe<Scalars['Int']>
  warehouseLocationId: Maybe<Scalars['Int']>
}

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow'
  asap: Maybe<Scalars['Boolean']>
  descriptor: Maybe<Scalars['String']>
  endAt: Maybe<Scalars['DateTime']>
  startAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability'
  available: Maybe<Scalars['Boolean']>
  itemCodes: Maybe<Array<Maybe<Scalars['String']>>>
  reasons: Maybe<Array<Maybe<Scalars['String']>>>
}

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow'
  descriptor: Maybe<Scalars['String']>
  endAt: Maybe<Scalars['DateTime']>
  immediateHour: Maybe<Scalars['Int']>
  startAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow'
  descriptor: Maybe<Scalars['String']>
  endAt: Maybe<Scalars['DateTime']>
  startAt: Maybe<Scalars['DateTime']>
}

export type InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput = {
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  userPhone?: InputMaybe<Scalars['String']>
}

export type InstacartStoreConfiguration = {
  __typename?: 'InstacartStoreConfiguration'
  /** Indicates if the Store Configuration is active or not */
  active: Scalars['Boolean']
  /** Flag to indicate if this StoreConfiguration is associated to all warehouses */
  allowAllWarehouses: Scalars['Boolean']
  /** The brand name as customers would see on Instacart, PBI, etc */
  brandedName: Scalars['String']
  /** When the Store Configuration was created */
  createdAt: Scalars['Time']
  /** Unata, etc... */
  deApplicationPlatform: Maybe<Scalars['String']>
  /** The domain name of the Storefront (eg. costco.ca) */
  domainName: Maybe<Scalars['String']>
  /** A unique identifier for the Store Configuration */
  id: Scalars['ID']
  /** Legal data */
  legal: Maybe<InstacartStoreConfigurationLegal>
  /** The primary logo URL */
  logoUrl: Scalars['String']
  /** The rules on how Partners can access this Store Configuration */
  partnerAccessSettings: InstacartStoreConfigurationPartnerAccessSettings
  /** The unique slug for this Store Configuration */
  slug: Scalars['String']
  /** When the Store Configuration was last updated */
  updatedAt: Scalars['Time']
  /** Indicates if the user is permitted to modify data related to this Store Configuration */
  userAccessToModify: Scalars['Boolean']
  /** The unique identifier for the User Isolation Context this Store Configuration uses */
  userIsolationContextId: Scalars['ID']
  /** The list of associated warehouses */
  whitelistedWarehouseIds: Maybe<Array<Scalars['ID']>>
}

export type InstacartStoreConfigurationLegal = {
  __typename?: 'InstacartStoreConfigurationLegal'
  /** The shorter name for business entity */
  shortName: Scalars['String']
}

export type InstacartStoreConfigurationModificationRules = {
  __typename?: 'InstacartStoreConfigurationModificationRules'
  /** The list of Partner IDs who are permitted to make modificaftions to this Store Configuration */
  allowlistPartnerIds: Maybe<Array<Scalars['ID']>>
}

export type InstacartStoreConfigurationPartnerAccessSettings = {
  __typename?: 'InstacartStoreConfigurationPartnerAccessSettings'
  /** The ruleset for allowing modifications for this Store Configuration */
  modificationRules: Maybe<InstacartStoreConfigurationModificationRules>
  /** True if Partners are allow to view this Store Configuration on IPP */
  visibleToPartnersOnIpp: Scalars['Boolean']
}

export type InstacartTypesV1BigDecimal = {
  __typename?: 'InstacartTypesV1BigDecimal'
  nanos: Maybe<Scalars['Int']>
  units: Maybe<Scalars['BigInt']>
}

export type InstacartTypesV1BigDecimalInput = {
  nanos?: InputMaybe<Scalars['Int']>
  units?: InputMaybe<Scalars['BigInt']>
}

export type InstacartTypesV1RequestContextInput = {
  applicationId?: InputMaybe<Scalars['Int']>
  clientConfigurationId?: InputMaybe<Scalars['Int']>
  countryId?: InputMaybe<Scalars['Int']>
  storeConfigurationId?: InputMaybe<Scalars['Int']>
}

export type InventoryFileMapping = {
  __typename?: 'InventoryFileMapping'
  collectionSlug: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  retailerCollection: Maybe<RetailerCollection>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type InventoryFileMismatch = {
  __typename?: 'InventoryFileMismatch'
  collectionSlug: Maybe<Scalars['String']>
  count: Maybe<Scalars['BigInt']>
  lastSeen: Maybe<Scalars['DateTime']>
  leadCode: Maybe<Scalars['String']>
}

export type Item = {
  __typename?: 'Item'
  localeCode: Maybe<Scalars['String']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
}

export type ItemId = {
  __typename?: 'ItemId'
  itemId: Maybe<Scalars['BigInt']>
}

export type ItemIdInput = {
  itemId?: InputMaybe<Scalars['BigInt']>
}

export type ItemList = {
  __typename?: 'ItemList'
  cta: Maybe<Scalars['String']>
  ctaVisibilityMin: Maybe<Scalars['BigInt']>
  dataQuery: Maybe<DataQuery>
  disclaimer: Maybe<Scalars['String']>
  iconUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  placementId: Maybe<Scalars['BigInt']>
  selectable: Maybe<Scalars['Boolean']>
  subTitle: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  variant: Maybe<ItemListVariant>
}

export type ItemListInput = {
  cta?: InputMaybe<Scalars['String']>
  ctaVisibilityMin?: InputMaybe<Scalars['BigInt']>
  dataQuery?: InputMaybe<DataQueryInput>
  disclaimer?: InputMaybe<Scalars['String']>
  iconUrl?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  placementId?: InputMaybe<Scalars['BigInt']>
  selectable?: InputMaybe<Scalars['Boolean']>
  subTitle?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<ItemListVariant>
}

export enum ItemListVariant {
  CarouselItemList = 'CAROUSEL_ITEM_LIST',
  DoubleDeckerItemList = 'DOUBLE_DECKER_ITEM_LIST',
  FilterableItemList = 'FILTERABLE_ITEM_LIST',
  GridItemList = 'GRID_ITEM_LIST',
  ItemList = 'ITEM_LIST',
  UnspecifiedItemList = 'UNSPECIFIED_ITEM_LIST',
}

export type ItemsSchema = {
  __typename?: 'ItemsSchema'
  promoPricingBackgroundColor: Maybe<ItemsSchemaAtomsColor>
  promoPricingTextColor: Maybe<ItemsSchemaAtomsColor>
}

export enum ItemsSchemaAtomsColor {
  BrandHighlightDark = 'BRAND_HIGHLIGHT_DARK',
  BrandHighlightLight = 'BRAND_HIGHLIGHT_LIGHT',
  BrandHighlightRegular = 'BRAND_HIGHLIGHT_REGULAR',
  BrandLoyaltyDark = 'BRAND_LOYALTY_DARK',
  BrandLoyaltyLight = 'BRAND_LOYALTY_LIGHT',
  BrandLoyaltyRegular = 'BRAND_LOYALTY_REGULAR',
  BrandPrimaryDark = 'BRAND_PRIMARY_DARK',
  BrandPrimaryExtraDark = 'BRAND_PRIMARY_EXTRA_DARK',
  BrandPrimaryRegular = 'BRAND_PRIMARY_REGULAR',
  BrandPromotionalDark = 'BRAND_PROMOTIONAL_DARK',
  BrandPromotionalLight = 'BRAND_PROMOTIONAL_LIGHT',
  BrandPromotionalRegular = 'BRAND_PROMOTIONAL_REGULAR',
  BrandSecondaryDark = 'BRAND_SECONDARY_DARK',
  BrandSecondaryLight = 'BRAND_SECONDARY_LIGHT',
  BrandSecondaryRegular = 'BRAND_SECONDARY_REGULAR',
  BrandTertiaryRegular = 'BRAND_TERTIARY_REGULAR',
  MaxYellow = 'MAX_YELLOW',
  PlusDark = 'PLUS_DARK',
  PlusExtraDark = 'PLUS_EXTRA_DARK',
  PlusExtraLight = 'PLUS_EXTRA_LIGHT',
  PlusLight = 'PLUS_LIGHT',
  PlusRegular = 'PLUS_REGULAR',
  SystemDetrimentalDark = 'SYSTEM_DETRIMENTAL_DARK',
  SystemDetrimentalExtraDark = 'SYSTEM_DETRIMENTAL_EXTRA_DARK',
  SystemDetrimentalLight = 'SYSTEM_DETRIMENTAL_LIGHT',
  SystemDetrimentalRegular = 'SYSTEM_DETRIMENTAL_REGULAR',
  SystemGrayscale00 = 'SYSTEM_GRAYSCALE00',
  SystemGrayscale10 = 'SYSTEM_GRAYSCALE10',
  SystemGrayscale20 = 'SYSTEM_GRAYSCALE20',
  SystemGrayscale30 = 'SYSTEM_GRAYSCALE30',
  SystemGrayscale50 = 'SYSTEM_GRAYSCALE50',
  SystemGrayscale70 = 'SYSTEM_GRAYSCALE70',
  SystemSuccessDark = 'SYSTEM_SUCCESS_DARK',
  SystemSuccessLight = 'SYSTEM_SUCCESS_LIGHT',
  SystemSuccessRegular = 'SYSTEM_SUCCESS_REGULAR',
}

export type LaunchOnboarding = {
  __typename?: 'LaunchOnboarding'
  createdAt: Maybe<Scalars['DateTime']>
  entityName: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  partner: Maybe<LaunchOnboardingPartner>
  updatedAt: Maybe<Scalars['DateTime']>
  warehouse: Maybe<LaunchOnboardingWarehouse>
  warehouseLocations: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>
  workflowState: Maybe<Scalars['String']>
}

export type LaunchOnboardingAddress = {
  __typename?: 'LaunchOnboardingAddress'
  apartmentNumber: Maybe<Scalars['String']>
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>
  approved: Maybe<Scalars['Boolean']>
  city: Maybe<Scalars['String']>
  country: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  streetAddress: Maybe<Scalars['String']>
}

export type LaunchOnboardingAddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>
  approvalRequests?: InputMaybe<Array<InputMaybe<LaunchOnboardingApprovalRequestInput>>>
  approved?: InputMaybe<Scalars['Boolean']>
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  streetAddress?: InputMaybe<Scalars['String']>
}

export type LaunchOnboardingApprovalRequest = {
  __typename?: 'LaunchOnboardingApprovalRequest'
  approveableId: Maybe<Scalars['BigInt']>
  approveableType: Maybe<Scalars['String']>
  attributeName: Maybe<Scalars['String']>
  attributeValue: Maybe<Scalars['String']>
  comment: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  status: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  userId: Maybe<Scalars['BigInt']>
}

export type LaunchOnboardingApprovalRequestInput = {
  approveableId?: InputMaybe<Scalars['BigInt']>
  approveableType?: InputMaybe<Scalars['String']>
  attributeName?: InputMaybe<Scalars['String']>
  attributeValue?: InputMaybe<Scalars['String']>
  comment?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  id?: InputMaybe<Scalars['BigInt']>
  status?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type LaunchOnboardingPartner = {
  __typename?: 'LaunchOnboardingPartner'
  createdAt: Maybe<Scalars['DateTime']>
  externalId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  partnerType: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type LaunchOnboardingWarehouse = {
  __typename?: 'LaunchOnboardingWarehouse'
  allowAlcohol: Maybe<Scalars['Boolean']>
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>
  approved: Maybe<Scalars['Boolean']>
  backgroundColor: Maybe<Scalars['String']>
  categories: Maybe<Array<Maybe<Scalars['String']>>>
  certifiedDeliveryThreshold: Maybe<Scalars['Float']>
  country: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  description: Maybe<Scalars['String']>
  externalId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  logo: Maybe<Scalars['String']>
  merchantId: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  pricingPolicy: Maybe<Scalars['String']>
  pricingPolicyText: Maybe<Scalars['String']>
  retailerType: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  visible: Maybe<Scalars['Boolean']>
}

export type LaunchOnboardingWarehouseLocation = {
  __typename?: 'LaunchOnboardingWarehouseLocation'
  address: Maybe<LaunchOnboardingAddress>
  approvalRequests: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>
  approved: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  externalId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  locationCode: Maybe<Scalars['String']>
  merchantId: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum LaunchOnboardingWorkflowStateAction {
  LaunchOnboardingWorkflowStateActionCompleteInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCompleteLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCreateIppAccount = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_CREATE_IPP_ACCOUNT',
  LaunchOnboardingWorkflowStateActionLaunch = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_LAUNCH',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_INFO',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseLocationsInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_LOCATIONS_INFO',
  LaunchOnboardingWorkflowStateActionSendEmailInvite = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_SEND_EMAIL_INVITE',
  LaunchOnboardingWorkflowStateActionStartInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionStartLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionUnknown = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN',
}

export enum Layout {
  ActionSheet = 'ACTION_SHEET',
  CheckoutAisle = 'CHECKOUT_AISLE',
  CollectionDepartment = 'COLLECTION_DEPARTMENT',
  CollectionHub = 'COLLECTION_HUB',
  CollectionHubOnLoad = 'COLLECTION_HUB_ON_LOAD',
  DealsTabHero = 'DEALS_TAB_HERO',
  DealsTabSecondary = 'DEALS_TAB_SECONDARY',
  EntStorefront = 'ENT_STOREFRONT',
  Home = 'HOME',
  HomeCategoryForward = 'HOME_CATEGORY_FORWARD',
  HomeEyebrow = 'HOME_EYEBROW',
  HomeFeed = 'HOME_FEED',
  HomeFeedAlcohol = 'HOME_FEED_ALCOHOL',
  HomeFeedBeauty = 'HOME_FEED_BEAUTY',
  HomeFeedConvenience = 'HOME_FEED_CONVENIENCE',
  HomeFeedDefault = 'HOME_FEED_DEFAULT',
  HomeFeedGifts = 'HOME_FEED_GIFTS',
  HomeFeedGrocery = 'HOME_FEED_GROCERY',
  HomeFeedHeader = 'HOME_FEED_HEADER',
  HomeFeedNewUser = 'HOME_FEED_NEW_USER',
  HomeFeedPets = 'HOME_FEED_PETS',
  HomeFeedPharmacy = 'HOME_FEED_PHARMACY',
  HomeFeedUseCaseTiles = 'HOME_FEED_USE_CASE_TILES',
  HomeFeedWholesale = 'HOME_FEED_WHOLESALE',
  HomeHero = 'HOME_HERO',
  HomeItemForward = 'HOME_ITEM_FORWARD',
  HomeMarketplace = 'HOME_MARKETPLACE',
  HomeOnLoad = 'HOME_ON_LOAD',
  HomeSecondary = 'HOME_SECONDARY',
  Hub = 'HUB',
  HubHeader = 'HUB_HEADER',
  InStoreDeals = 'IN_STORE_DEALS',
  IsolatedStorefront = 'ISOLATED_STOREFRONT',
  ItemDetailsRecommendations = 'ITEM_DETAILS_RECOMMENDATIONS',
  MealsTabOnStorefront = 'MEALS_TAB_ON_STOREFRONT',
  NewVerticalsStorefront = 'NEW_VERTICALS_STOREFRONT',
  OrderStatusSecondary = 'ORDER_STATUS_SECONDARY',
  PostCheckoutRecommendations = 'POST_CHECKOUT_RECOMMENDATIONS',
  PostCheckoutSheet = 'POST_CHECKOUT_SHEET',
  RecommendationsTray = 'RECOMMENDATIONS_TRAY',
  Search = 'SEARCH',
  ShopContentPage = 'SHOP_CONTENT_PAGE',
  Storefront = 'STOREFRONT',
  StorefrontCoachmark = 'STOREFRONT_COACHMARK',
  StorefrontEyebrow = 'STOREFRONT_EYEBROW',
  StorefrontHero = 'STOREFRONT_HERO',
  StorefrontNavigationFooter = 'STOREFRONT_NAVIGATION_FOOTER',
  StorefrontNavigationHeader = 'STOREFRONT_NAVIGATION_HEADER',
  StorefrontNewUser = 'STOREFRONT_NEW_USER',
  StorefrontOnLoad = 'STOREFRONT_ON_LOAD',
  StorefrontOverHeader = 'STOREFRONT_OVER_HEADER',
  YourItems = 'YOUR_ITEMS',
}

export type LayoutVariant = {
  __typename?: 'LayoutVariant'
  contentPageId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  placements: Maybe<Array<Maybe<Placement>>>
  platform: Maybe<Array<Maybe<PlatformType>>>
  previewToken: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['BigInt']>
  status: Maybe<Status>
}

export type LayoutVariantInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>
  id?: InputMaybe<Scalars['BigInt']>
  name?: InputMaybe<Scalars['String']>
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>
  previewToken?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  status?: InputMaybe<Status>
}

export type LegacyBaseImage = {
  __typename?: 'LegacyBaseImage'
  /** The image url */
  url: Maybe<Scalars['String']>
}

export type LegacyConfiguration = {
  __typename?: 'LegacyConfiguration'
  knowledgeOwl: LegacyKnowledgeOwl
}

export type LegacyCountry = {
  __typename?: 'LegacyCountry'
  /** Unique identifier */
  id: Scalars['ID']
  /** country name */
  name: Scalars['String']
}

export type LegacyDeliveryHours = {
  __typename?: 'LegacyDeliveryHours'
  /** Date of Delivery Hours */
  date: Scalars['LegacyDate']
  /** Ending hour of Delivery Hours on specified date */
  endsAtHour: Scalars['Int']
  /** Starting hour of Delivery Hours on specified date */
  startsAtHour: Scalars['Int']
  /** The associated warehouse of the delivery hours */
  warehouse: LegacyWarehouse
}

export type LegacyElasticsearchResponse = {
  __typename?: 'LegacyElasticsearchResponse'
  docs: Maybe<Array<Maybe<Scalars['JSONObject']>>>
}

export type LegacyHealthCheck = {
  __typename?: 'LegacyHealthCheck'
  /** Server health status */
  ok: Scalars['Boolean']
}

export type LegacyItemTyped = {
  __typename?: 'LegacyItemTyped'
  aisleId: Maybe<Scalars['BigInt']>
  aisleName: Maybe<Scalars['String']>
  alcoholic: Maybe<Scalars['Boolean']>
  allergensKeywords: Maybe<Array<Maybe<Scalars['String']>>>
  available: Maybe<Scalars['Boolean']>
  brandName: Maybe<Scalars['String']>
  configurableProducts: Maybe<Scalars['JSONObject']>
  costPricePerUnit: Maybe<InstacartTypesV1BigDecimal>
  costUnit: Maybe<Scalars['String']>
  dairyFree: Maybe<Scalars['Boolean']>
  departmentId: Maybe<Scalars['BigInt']>
  departmentName: Maybe<Scalars['String']>
  displayName: Maybe<Scalars['String']>
  fullPrice: Maybe<InstacartTypesV1BigDecimal>
  halal: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  inStoreLocation: Maybe<Scalars['String']>
  inventoryAreaId: Maybe<Scalars['BigInt']>
  isCatering: Maybe<Scalars['Boolean']>
  isHot: Maybe<Scalars['Boolean']>
  isPackagedByWeight: Maybe<Scalars['Boolean']>
  ketoDiet: Maybe<Scalars['Boolean']>
  largeImageUrl: Maybe<Scalars['String']>
  localeCode: Maybe<Scalars['String']>
  lowSodium: Maybe<Scalars['Boolean']>
  name: Maybe<Scalars['String']>
  nonenumeratedManagedAttributes: Maybe<NonenumeratedManagedAttributes>
  normalizedHeightCm: Maybe<InstacartTypesV1BigDecimal>
  normalizedLengthCm: Maybe<InstacartTypesV1BigDecimal>
  normalizedWeightG: Maybe<InstacartTypesV1BigDecimal>
  normalizedWidthCm: Maybe<InstacartTypesV1BigDecimal>
  parWeight: Maybe<InstacartTypesV1BigDecimal>
  price: Maybe<InstacartTypesV1BigDecimal>
  pricePerUnit: Maybe<InstacartTypesV1BigDecimal>
  primaryImageUrl: Maybe<Scalars['String']>
  productCategory: Maybe<ProductCategory>
  productCategoryTaxonomy: Maybe<ProductCategoryTaxonomy>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productEnrichmentKeywords: Maybe<Array<Maybe<Scalars['String']>>>
  productId: Maybe<Scalars['BigInt']>
  productType: Maybe<Scalars['String']>
  requestUnit: Maybe<Scalars['String']>
  restrictedOtc: Maybe<Scalars['Boolean']>
  restrictedReasons: Maybe<Array<Maybe<Scalars['String']>>>
  retailerMetadata: Maybe<LegacyItemTypedLegacyRetailerMetadataTyped>
  retailerOmsEligible: Maybe<Scalars['Boolean']>
  retailerProductSize: Maybe<Scalars['String']>
  retailerReferenceCode: Maybe<Scalars['String']>
  retailerSpecificMetadata: Maybe<LegacyItemTypedLegacyRetailerSpecificMetadataTyped>
  shopperHeroImageUrl: Maybe<Scalars['String']>
  shopperHeroLargeImageUrl: Maybe<Scalars['String']>
  shouldScan: Maybe<Scalars['Boolean']>
  size: Maybe<Scalars['String']>
  sizeUomVariable: Maybe<Scalars['String']>
  storageTemp: Maybe<Scalars['String']>
  sugarFree: Maybe<Scalars['Boolean']>
  suggestedReplacementIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  syntheticCodes: Maybe<Array<Maybe<Scalars['String']>>>
  tobacco: Maybe<Scalars['Boolean']>
  unitCount: Maybe<Scalars['BigInt']>
  unitPrice: Maybe<InstacartTypesV1BigDecimal>
  unlisted: Maybe<Scalars['Boolean']>
  usaSnapEligible: Maybe<Scalars['Boolean']>
  variantDimensionValues: Maybe<Array<Maybe<LegacyItemTypedLegacyVariantDimensionValueTyped>>>
  warehouseId: Maybe<Scalars['BigInt']>
}

export type LegacyItemTypedLegacyRetailerMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerMetadataTyped'
  aldiProductCode: Maybe<Scalars['String']>
}

export type LegacyItemTypedLegacyRetailerSpecificMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerSpecificMetadataTyped'
  aldiProductCode: Maybe<Scalars['String']>
}

export type LegacyItemTypedLegacyVariantDimensionValueTyped = {
  __typename?: 'LegacyItemTypedLegacyVariantDimensionValueTyped'
  heading: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

export type LegacyItemsTyped = {
  __typename?: 'LegacyItemsTyped'
  items: Maybe<Array<Maybe<LegacyItemTyped>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type LegacyKnowledgeOwl = {
  __typename?: 'LegacyKnowledgeOwl'
  /** Knowledge Base Domain */
  domain: Scalars['String']
  /** OAuth Token */
  oauthToken: Scalars['String']
  /** Knowledge Base Project ID */
  projectId: Scalars['String']
}

export enum LegacyOrderSource {
  /** Orders from a retailer via API. */
  Api = 'API',
  /** Orders from the Instacart Marketplace. */
  Marketplace = 'MARKETPLACE',
  /** Orders from a Powered by Instacart whitelabel site. */
  Pbi = 'PBI',
  /** Orders from a Unata site. */
  Unata = 'UNATA',
}

export type LegacyPartner = {
  __typename?: 'LegacyPartner'
  /** The Partner's unique identifier  */
  id: Scalars['ID']
  /** The name of the Partner */
  name: Scalars['String']
  /** The associated Warehouses */
  warehouses: Array<LegacyWarehouse>
}

export type LegacyPartnerUser = {
  __typename?: 'LegacyPartnerUser'
  /** The way the PartnerUser was created */
  createdVia: Maybe<Scalars['String']>
  /** The user's email */
  email: Scalars['String']
  /** The user's given name */
  firstName: Scalars['String']
  /** The user's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The user's surname */
  lastName: Scalars['String']
  /** The Partners which can be accessed */
  partners: Array<LegacyPartner>
  /** The user's list of permissions */
  permissions: Array<Scalars['String']>
  /** The user's phone number */
  phone: Maybe<Scalars['String']>
  /** The user's list of roles */
  roles: Array<Scalars['String']>
  /** A unique external identifier for the PartnerUser */
  uuid: Scalars['ID']
  /** The Warehouses which can be accessed */
  warehouses: Array<LegacyWarehouse>
}

export type LegacyProducts = {
  __typename?: 'LegacyProducts'
  items: Maybe<Array<Maybe<Scalars['JSONObject']>>>
  totalCount: Maybe<Scalars['BigInt']>
  totalPages: Maybe<Scalars['BigInt']>
}

export type LegacyWarehouse = {
  __typename?: 'LegacyWarehouse'
  /** Country of Warehouse */
  country: Maybe<LegacyCountry>
  /** Warehouse early picking hour [if one is set] */
  earlyPickingHour: Maybe<Scalars['Int']>
  /** The warehouse's list of enabled flippers */
  flippers: Array<Scalars['String']>
  /** The Warehouse's unique identifier */
  id: Scalars['ID']
  /** The Warehouses' logo */
  logo: Maybe<LegacyWarehouseLogo>
  /** The name of the Warehouse */
  name: Maybe<Scalars['String']>
  /** The warehouse's order sources. */
  orderSources: Maybe<Array<LegacyOrderSource>>
  /** The associated Partner */
  partner: Maybe<LegacyPartner>
}

export type LegacyWarehouseLocation = {
  __typename?: 'LegacyWarehouseLocation'
  /** The delivery hours of the Warehouse Location */
  deliveryHours: Array<LegacyDeliveryHours>
  /** The unique ID */
  id: Scalars['ID']
}

export type LegacyWarehouseLocationDeliveryHoursArgs = {
  dates: Array<Scalars['LegacyDate']>
}

export type LegacyWarehouseLogo = {
  __typename?: 'LegacyWarehouseLogo'
  /** A header-specific version of the logo */
  header: Maybe<LegacyBaseImage>
  /** A tiny version of the logo */
  tiny: Maybe<LegacyBaseImage>
  /** The image url */
  url: Maybe<Scalars['String']>
  /** The whitelabeled logo */
  whiteLabelLandingPage: Maybe<LegacyBaseImage>
}

export type LinkAutosuggestion = {
  __typename?: 'LinkAutosuggestion'
  linkDescription: Maybe<Scalars['String']>
  linkId: Maybe<Scalars['BigInt']>
  linkName: Maybe<Scalars['String']>
  linkUrl: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['BigInt']>
}

export type LinkAutosuggestionAdmin = {
  __typename?: 'LinkAutosuggestionAdmin'
  keywords: Maybe<Array<Maybe<Scalars['String']>>>
  linkAutosuggestion: Maybe<LinkAutosuggestion>
}

export type LinkAutosuggestionAdminInput = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionInput>
}

export type LinkAutosuggestionInput = {
  linkDescription?: InputMaybe<Scalars['String']>
  linkId?: InputMaybe<Scalars['BigInt']>
  linkName?: InputMaybe<Scalars['String']>
  linkUrl?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ListAuditBatchesRequestInput = {
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  client?: InputMaybe<Scalars['String']>
  fromDate?: InputMaybe<Scalars['DateTime']>
  page?: InputMaybe<PaginationInput>
  showReassignmentMappings?: InputMaybe<Scalars['Boolean']>
  toDate?: InputMaybe<Scalars['DateTime']>
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ListAuditBatchesResponse = {
  __typename?: 'ListAuditBatchesResponse'
  auditBatches: Maybe<Array<Maybe<AuditBatch>>>
  totalResultCount: Maybe<Scalars['BigInt']>
  workflowReassignmentMappings: Maybe<
    Array<Maybe<ListAuditBatchesResponseWorkflowReassignmentMapping>>
  >
}

export type ListAuditBatchesResponseWorkflowReassignmentMapping = {
  __typename?: 'ListAuditBatchesResponseWorkflowReassignmentMapping'
  fromWorkflow: Maybe<Scalars['String']>
  toWorkflows: Maybe<Array<Maybe<Scalars['String']>>>
}

export type ListAuditWorkflowsRequestInput = {
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  client?: InputMaybe<Scalars['String']>
  fromDate?: InputMaybe<Scalars['DateTime']>
  returnTaskInformation?: InputMaybe<Scalars['Boolean']>
  toDate?: InputMaybe<Scalars['DateTime']>
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ListAuditWorkflowsResponse = {
  __typename?: 'ListAuditWorkflowsResponse'
  auditWorkflows: Maybe<Array<Maybe<AuditWorkflow>>>
}

export type ListContentPageVersionsRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>
  contentPageId?: InputMaybe<Scalars['BigInt']>
  id?: InputMaybe<Scalars['BigInt']>
}

export type ListContentPageVersionsResponse = {
  __typename?: 'ListContentPageVersionsResponse'
  contentPageVersions: Maybe<Array<Maybe<ContentPageVersion>>>
}

export type ListContentPagesRequestV2Input = {
  id?: InputMaybe<Scalars['BigInt']>
  pageType?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type ListContentPagesResponseV2 = {
  __typename?: 'ListContentPagesResponseV2'
  contentPages: Maybe<Array<Maybe<ContentPageV2>>>
}

export type ListInstacartCollectionsRequestInput = {
  parentId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type ListInstacartCollectionsResponse = {
  __typename?: 'ListInstacartCollectionsResponse'
  instacartCollections: Maybe<Array<Maybe<RetailerCollection>>>
  parentId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
}

export type ListLinkAutosuggestionAdminParametersInput = {
  keyword?: InputMaybe<Scalars['String']>
  linkIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  linkNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  name?: InputMaybe<Scalars['String']>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ListLinkAutosuggestionAdminRequestInput = {
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>
  parameters?: InputMaybe<ListLinkAutosuggestionAdminParametersInput>
  timeoutMs?: InputMaybe<Scalars['BigInt']>
}

export type ListLinkAutosuggestionAdminResponse = {
  __typename?: 'ListLinkAutosuggestionAdminResponse'
  linkAutosuggestions: Maybe<Array<Maybe<LinkAutosuggestionAdmin>>>
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>
}

export type ListPlacementContentParamsInput = {
  campaignEndsAfter?: InputMaybe<Scalars['DateTime']>
  campaignEndsBefore?: InputMaybe<Scalars['DateTime']>
  campaignStartsAfter?: InputMaybe<Scalars['DateTime']>
  campaignStartsBefore?: InputMaybe<Scalars['DateTime']>
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>
  createdAfter?: InputMaybe<Scalars['DateTime']>
  createdBefore?: InputMaybe<Scalars['DateTime']>
  enabledOnly?: InputMaybe<Scalars['Boolean']>
  excludedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  excludedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  excludedNamesRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  excludedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  excludedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  experimentNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  includedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  includedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  includedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  includedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  internalNameRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  pagination?: InputMaybe<PlacementContentRequestPaginationInput>
  parentPlacementId?: InputMaybe<Scalars['BigInt']>
  placementSurface?: InputMaybe<PlacementContentSurfaceInput>
  placementTypeVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  placementTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ListPlacementContentRequestInput = {
  excludingLocales?: InputMaybe<InstacartCustomersSharedV1Locale>
  params?: InputMaybe<ListPlacementContentParamsInput>
}

export type ListPlacementContentResponse = {
  __typename?: 'ListPlacementContentResponse'
  contents: Maybe<Array<Maybe<PlacementContent>>>
  pagination: Maybe<PlacementContentResponsePagination>
}

export type ListRetailerCampaignsRequestFilterSetInput = {
  campaignObjective?: InputMaybe<CampaignObjective>
  endsAt?: InputMaybe<Scalars['DateTime']>
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  startsAt?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<Scalars['String']>
}

export type ListRetailerCampaignsRequestInput = {
  filters?: InputMaybe<ListRetailerCampaignsRequestFilterSetInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ListRetailerCampaignsResponse = {
  __typename?: 'ListRetailerCampaignsResponse'
  retailerCampaigns: Maybe<Array<Maybe<RetailerCampaign>>>
}

export type ListRetailerCollectionProductsRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>
  lookupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  offset?: InputMaybe<Scalars['BigInt']>
  parentId?: InputMaybe<Scalars['BigInt']>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  rrcs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ListRetailerCollectionProductsResponse = {
  __typename?: 'ListRetailerCollectionProductsResponse'
  parentId: Maybe<Scalars['BigInt']>
  retailerCollectionProducts: Maybe<Array<Maybe<RetailerCollectionProduct>>>
  retailerId: Maybe<Scalars['BigInt']>
  totalCount: Maybe<Scalars['BigInt']>
}

export type ListRetailerCollectionsRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  parentId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  surfaces?: InputMaybe<Array<InputMaybe<RetailerCollectionSurface>>>
}

export type ListRetailerCollectionsResponse = {
  __typename?: 'ListRetailerCollectionsResponse'
  localeCode: Maybe<InstacartCustomersSharedV1Locale>
  parentId: Maybe<Scalars['BigInt']>
  retailerCollections: Maybe<Array<Maybe<RetailerCollection>>>
  retailerId: Maybe<Scalars['BigInt']>
  surfaces: Maybe<Array<Maybe<RetailerCollectionSurface>>>
}

export type ListStoreConfigurationsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ListStoreConfigurationsResponse = {
  __typename?: 'ListStoreConfigurationsResponse'
  retailerId: Maybe<Scalars['BigInt']>
  storeConfigurations: Maybe<Array<Maybe<RetailerCollectionStoreConfiguration>>>
}

export type ListThemePagesRequestInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']>
  includeSections?: InputMaybe<Scalars['Boolean']>
  slug?: InputMaybe<Scalars['String']>
}

export type ListThemePagesResponse = {
  __typename?: 'ListThemePagesResponse'
  themePages: Maybe<Array<Maybe<ThemePage>>>
}

export type ListTicketsRequestInput = {
  associatedUser?: InputMaybe<UserInput>
  client?: InputMaybe<ClientInput>
  createdBy?: InputMaybe<UserInput>
  endTime?: InputMaybe<Scalars['DateTime']>
  entityType?: InputMaybe<EntityType>
  getSummaryStatus?: InputMaybe<Scalars['Boolean']>
  page?: InputMaybe<PaginationInput>
  problemType?: InputMaybe<ProblemType>
  reportedOnBehalfOf?: InputMaybe<UserInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  severity?: InputMaybe<Scalars['BigInt']>
  sourceAppNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  startTime?: InputMaybe<Scalars['DateTime']>
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type ListTicketsResponse = {
  __typename?: 'ListTicketsResponse'
  includesOnBehalfOf: Maybe<Scalars['Boolean']>
  page: Maybe<Pagination>
  tickets: Maybe<Array<Maybe<ProblemTrackerTicket>>>
  totalCount: Maybe<Scalars['BigInt']>
}

export type ListUserSettingsRequestInput = {
  appNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  client?: InputMaybe<ClientInput>
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type ListUserSettingsResponse = {
  __typename?: 'ListUserSettingsResponse'
  settings: Maybe<Array<Maybe<UserSetting>>>
}

export type ListUsersByPersonalIdentifiersStrictRequestInput = {
  identifier?: InputMaybe<Scalars['String']>
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
}

export type ListUsersByPersonalIdentifiersStrictResponse = {
  __typename?: 'ListUsersByPersonalIdentifiersStrictResponse'
  pageInfo: Maybe<InstacartCustomersSharedV1PageInfo>
  users: Maybe<Array<Maybe<User>>>
}

export type LocaleProduct = {
  __typename?: 'LocaleProduct'
  localeId: Maybe<Scalars['String']>
  productId: Maybe<Scalars['String']>
}

export type LogoWithTextBanner = {
  __typename?: 'LogoWithTextBanner'
  backgroundColorHex: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  id: Maybe<Scalars['BigInt']>
  imageAltText: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type LogoWithTextBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  id?: InputMaybe<Scalars['BigInt']>
  imageAltText?: InputMaybe<Scalars['String']>
  imageMobileUrl?: InputMaybe<Scalars['String']>
  imageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type MatchesAnyRetailerIdInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>
}

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionCreate */
export type MatchesAnyRetailerIdVisibilityConditionCreatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionCreatePayload'
  /** The newly created MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId
}

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionUpdate */
export type MatchesAnyRetailerIdVisibilityConditionUpdatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionUpdatePayload'
  /** The newly updated MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId
}

export enum MergeableReportTypeEnum {
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
}

export type MetricThresholdInput = {
  metricType?: InputMaybe<MetricType>
  threshold?: InputMaybe<Scalars['BigInt']>
}

export enum MetricType {
  DedicatedMatchRate = 'DEDICATED_MATCH_RATE',
  DedicatedUtilizationRate = 'DEDICATED_UTILIZATION_RATE',
  Default = 'DEFAULT',
  FiveHourAvailabilityRate = 'FIVE_HOUR_AVAILABILITY_RATE',
  FulfilledOrders = 'FULFILLED_ORDERS',
  MatchRate = 'MATCH_RATE',
  RecommendedHours = 'RECOMMENDED_HOURS',
  ScheduledGaps = 'SCHEDULED_GAPS',
  ScheduledHours = 'SCHEDULED_HOURS',
  StaffingRate = 'STAFFING_RATE',
  UtilizationRate = 'UTILIZATION_RATE',
}

export type MinimumPlatformVersionInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum
  /** Version used for the check */
  version: Scalars['String']
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionCreate */
export type MinimumPlatformVersionVisibilityConditionCreatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionCreatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionUpdate */
export type MinimumPlatformVersionVisibilityConditionUpdatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionUpdatePayload'
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion
}

export type MoveRetailerAssetsFromFilestackBucketRequestInput = {
  assetType?: InputMaybe<AssetType>
  isPublicAccessible?: InputMaybe<Scalars['Boolean']>
  objectKeyMappings?: InputMaybe<Array<InputMaybe<ObjectKeyMappingInput>>>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type MoveRetailerAssetsFromFilestackBucketResponse = {
  __typename?: 'MoveRetailerAssetsFromFilestackBucketResponse'
  assetUrls: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Mutation = {
  __typename?: 'Mutation'
  apiIntegrationsServiceDeleteApiSetting: Maybe<DeleteApiSettingResponse>
  apiIntegrationsServiceUpdateApiSetting: Maybe<UpdateApiSettingResponse>
  /** Assign a permission to a role */
  assignPermissionToRole: Maybe<AssignPermissionToRolePayload>
  /** Create/update a new enterprise account by its email */
  botEnterpriseAccountUpsert: Maybe<BotEnterpriseAccountUpsertPayload>
  /** Update an existing callback configuration */
  callbackConfigurationUpdate: Maybe<PartnerCallbackConfigurationUpdatePayload>
  /** Create a new catalog 'code lookup batch' and add the given codes to it */
  catalogCodeLookupBatchCreate: Maybe<CatalogCodeLookupBatchCreatePayload>
  /** Create a new catalog 'code lookup' import process and add the given codes to it */
  catalogImportProcessCodeLookupCreate: Maybe<CatalogImportProcessCodeLookupCreatePayload>
  catalogProblemTrackerServiceCreateTicket: Maybe<CreateTicketResponse>
  /** Create a new catalog workflow */
  catalogWorkflowCreate: Maybe<CatalogWorkflowCreatePayload>
  /** Delete an existing workflow (only workflows in the `draft` state can be deleted) */
  catalogWorkflowDelete: Maybe<CatalogWorkflowDeletePayload>
  /** Create a new catalog workflow */
  catalogWorkflowEventCreate: Maybe<CatalogWorkflowEventCreatePayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetNewProductRequests: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsPayload>
  /** Create a new 'BulkRemoveChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkRemoveChangesetProductsPayload>
  /** Create a new 'BulkRemoveImportProcessCodeLookups' catalog workflow event */
  catalogWorkflowEventCreateBulkRemoveImportProcessCodeLookups: Maybe<CatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsPayload>
  /** Create a new 'BulkUpdateChangesetProducts' catalog workflow event */
  catalogWorkflowEventCreateBulkUpdateChangesetProducts: Maybe<CatalogWorkflowEventCreateBulkUpdateChangesetProductsPayload>
  /** Submit a workflow to the catalog */
  catalogWorkflowSubmit: Maybe<CatalogWorkflowSubmitPayload>
  /** Create a new collection */
  collectionCreate: Maybe<CollectionCreatePayload>
  /** Delete an existing collection */
  collectionDelete: Maybe<CollectionDeletePayload>
  /** Update an existing collection */
  collectionUpdate: Maybe<CollectionUpdatePayload>
  configurableItemsServicePublishRppConfigurableItems: Maybe<PublishRppConfigurableItemsResponse>
  connectPlatformServiceAdvanceBatchState: Maybe<AdvanceBatchStateResponse>
  connectPlatformServiceAssignVirtualBatch: Maybe<AssignVirtualBatchResponse>
  connectPlatformServiceCreateDriver: Maybe<CreateDriverResponse>
  connectPlatformServiceGenerateBatch: Maybe<GenerateBatchResponse>
  connectPlatformServiceUpdateShopperOrderItem: Maybe<UpdateShopperOrderItemResponse>
  contentManagementAdminServiceCreateContentPage: Maybe<CreateContentPageResponse>
  contentManagementAdminServiceCreateContentPageV2: Maybe<CreateContentPageResponseV2>
  contentManagementAdminServiceCreateContentPageVersion: Maybe<CreateContentPageVersionResponse>
  contentManagementAdminServiceCreateNavigation: Maybe<CreateNavigationResponse>
  contentManagementAdminServiceCreateNavigationPreview: Maybe<CreateNavigationPreviewResponse>
  contentManagementAdminServiceCreatePlacementContent: Maybe<CreatePlacementContentResponse>
  contentManagementAdminServiceDeleteContentPage: Maybe<DeleteContentPageResponse>
  contentManagementAdminServiceDeleteContentPageVersion: Maybe<DeleteContentPageVersionResponse>
  contentManagementAdminServiceDeleteNavigation: Maybe<DeleteNavigationResponse>
  contentManagementAdminServiceDisablePlacementContent: Maybe<DisablePlacementContentResponse>
  contentManagementAdminServiceUpdateContentPageV2: Maybe<UpdateContentPageResponseV2>
  contentManagementAdminServiceUpdateNavigation: Maybe<UpdateNavigationResponse>
  contentManagementAdminServiceUpdatePlacementContent: Maybe<UpdatePlacementContentResponse>
  contentManagementServiceBatchUpdatePlacements: Maybe<PlacementsResponse>
  contentManagementServiceCreateLayoutVariant: Maybe<CreateLayoutVariantResponse>
  contentManagementServiceCreatePlacement: Maybe<CreatePlacementResponse>
  contentManagementServiceCreateThemePage: Maybe<CreateThemePageResponse>
  contentManagementServiceDeleteLayoutVariant: Maybe<DeleteLayoutVariantResponse>
  contentManagementServiceDeletePlacement: Maybe<DeletePlacementResponse>
  contentManagementServiceDisableThemePage: Maybe<DisableThemePageResponse>
  contentManagementServiceUpdateLayoutVariant: Maybe<UpdateLayoutVariantResponse>
  contentManagementServiceUpdateThemePage: Maybe<UpdateThemePageResponse>
  /** Create a CountryIds visibility condition */
  countryIdsVisibilityConditionCreate: Maybe<CountryIdsVisibilityConditionCreatePayload>
  /** Update a CountryIds visibility condition */
  countryIdsVisibilityConditionUpdate: Maybe<CountryIdsVisibilityConditionUpdatePayload>
  /** Create a ExpressMembership visibility condition */
  dayOfWeekVisibilityConditionCreate: Maybe<DayOfWeekVisibilityConditionCreatePayload>
  /** Update an existing ShoppedAtRetailer visibility condition */
  dayOfWeekVisibilityConditionUpdate: Maybe<DayOfWeekVisibilityConditionUpdatePayload>
  demeterServiceCombineAuditBatches: Maybe<CombineAuditBatchesResponse>
  demeterServiceReassignAuditBatchWorkflow: Maybe<ReassignAuditBatchWorkflowResponse>
  demeterServiceUpdateAuditBatch: Maybe<UpdateAuditBatchResponse>
  demeterServiceUpdateAuditTask: Maybe<UpdateAuditTaskResponse>
  /** Set up a new account using an account setup token */
  enterpriseAccountAccountSetup: Maybe<EnterpriseAccountAccountSetupPayload>
  /** Authenticate an account using an email and password */
  enterpriseAccountAuthenticateEmailPassword: Maybe<EnterpriseAccountAuthenticateEmailPasswordPayload>
  /** Preflight authentication info per email address */
  enterpriseAccountAuthenticatePreflight: Maybe<EnterpriseAccountAuthenticatePreflightPayload>
  /** Create a new enterprise account */
  enterpriseAccountCreate: Maybe<EnterpriseAccountCreatePayload>
  /** Partner Onboarding new account token request, generate new email that will be sent to an Account's email address */
  enterpriseAccountPartnerOnboardingRequestAccountSetupEmail: Maybe<EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload>
  /** Request that an account setup email be sent to an Account's email address */
  enterpriseAccountRequestAccountSetupEmail: Maybe<EnterpriseAccountRequestAccountSetupEmailPayload>
  /** Request that a verification email be sent to an Account's email address */
  enterpriseAccountRequestEmailVerification: Maybe<EnterpriseAccountRequestEmailVerificationPayload>
  /** Request that a password reset email be sent to an Account's email address */
  enterpriseAccountRequestPasswordReset: Maybe<EnterpriseAccountRequestPasswordResetPayload>
  /** Set/Reset an account's password using a password reset token */
  enterpriseAccountResetPassword: Maybe<EnterpriseAccountResetPasswordPayload>
  /** Sets the disabled flag on an account to true/false */
  enterpriseAccountSetDisabled: Maybe<EnterpriseAccountSetDisabledPayload>
  /** Sign up for an account using an email */
  enterpriseAccountSignUpEmailPassword: Maybe<EnterpriseAccountSignUpEmailPasswordPayload>
  /** Update an enterprise account */
  enterpriseAccountUpdate: Maybe<EnterpriseAccountUpdatePayload>
  /** Update an enterprise account's roles */
  enterpriseAccountUpdateRoles: Maybe<EnterpriseAccountUpdateRolesPayload>
  /** Verify an account via account setup token */
  enterpriseAccountVerifyAccountSetupToken: Maybe<EnterpriseAccountVerifyAccountSetupTokenPayload>
  /** Verify an account's email using a verification token */
  enterpriseAccountVerifyEmail: Maybe<EnterpriseAccountVerifyEmailPayload>
  /** Create a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionCreate: Maybe<ExperimentVariantVisibilityConditionCreatePayload>
  /** Update a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionUpdate: Maybe<ExperimentVariantVisibilityConditionUpdatePayload>
  /** Create a ExpressMembership visibility condition */
  expressMembershipVisibilityConditionCreate: Maybe<ExpressMembershipVisibilityConditionCreatePayload>
  /** Update an existing ExpressMembership visibility condition */
  expressMembershipVisibilityConditionUpdate: Maybe<ExpressMembershipVisibilityConditionUpdatePayload>
  /** Create an ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityConditionCreate: Maybe<ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload>
  /** Update the feature tour status for the currently logged in account */
  featureTourUpdate: Maybe<FeatureTourUpdatePayload>
  /** Create a new flyout placement */
  flyoutPlacementCreate: Maybe<FlyoutPlacementCreatePayload>
  /** Update an existing flyout placement */
  flyoutPlacementUpdate: Maybe<FlyoutPlacementUpdatePayload>
  /** Create a new home placement with HeroBanner banner */
  heroBannerPlacementCreate: Maybe<HeroBannerPlacementCreatePayload>
  /** Update an existing hero_banner placement placement */
  heroBannerPlacementUpdate: Maybe<HeroBannerPlacementUpdatePayload>
  insightsPortalServiceCreateInsightsPortalCustomReport: Maybe<InsightsPortalCreateCustomReportResponse>
  insightsPortalServiceSetInsightsPortalCustomReportDisabled: Maybe<InsightsPortalSetCustomReportDisabledResponse>
  inventoryIntelligenceServiceCreateOosAcknowledgment: Maybe<CreateOosAcknowledgmentResponse>
  linkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdmin: Maybe<CreateOrUpdateLinkAutosuggestionAdminResponse>
  linkAutosuggestServiceDeleteLinkAutosuggestionAdmin: Maybe<DeleteLinkAutosuggestionAdminResponse>
  /** Create a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionCreate: Maybe<MatchesAnyRetailerIdVisibilityConditionCreatePayload>
  /** Update a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionUpdate: Maybe<MatchesAnyRetailerIdVisibilityConditionUpdatePayload>
  /** Create a MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionCreate: Maybe<MinimumPlatformVersionVisibilityConditionCreatePayload>
  /** Update an existing MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionUpdate: Maybe<MinimumPlatformVersionVisibilityConditionUpdatePayload>
  /** Create a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionCreate: Maybe<NewVerticalUserTargetingVisibilityConditionCreatePayload>
  /** Update a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionUpdate: Maybe<NewVerticalUserTargetingVisibilityConditionUpdatePayload>
  /** Merges two or more normalized-reports by combining their contents into one file */
  normalizedReportsMerge: Maybe<NormalizedReportsMergePayload>
  /** Subscribe an account to a notification type for a retailer */
  notificationSubscriptionCreate: Maybe<NotificationSubscriptionCreatePayload>
  /** Unsubscribe an account to a notification type for a retailer */
  notificationSubscriptionDelete: Maybe<NotificationSubscriptionDeletePayload>
  onboardingServiceCreateOnboardingStoreLocation: Maybe<CreateOnboardingStoreLocationResponse>
  onboardingServiceCreateSignup: Maybe<CreateSignupResponse>
  onboardingServiceDeleteLaunchOnboardingWarehouseLocation: Maybe<DeleteLaunchOnboardingWarehouseLocationResponse>
  onboardingServiceUpdateLaunchOnboardingWarehouseInfo: Maybe<UpdateLaunchOnboardingWarehouseInfoResponse>
  onboardingServiceUpdateLaunchOnboardingWarehouseLocationInfo: Maybe<UpdateLaunchOnboardingWarehouseLocationInfoResponse>
  onboardingServiceUpdateLaunchOnboardingWorkflowState: Maybe<UpdateLaunchOnboardingWorkflowStateResponse>
  onboardingServiceUpdateOnboarding: Maybe<UpdateOnboardingResponse>
  onboardingServiceUpdateOnboardingBillingAddress: Maybe<UpdateOnboardingBillingAddressResponse>
  onboardingServiceUpdateOnboardingWorkflowState: Maybe<UpdateOnboardingWorkflowStateResponse>
  orderServiceCancelOrder: Maybe<CancelOrderResponse>
  orderServiceCreateLastmileOrderFromDashboard: Maybe<CreateLastmileOrderFromDashboardResponse>
  orderServiceReopenLastmileOrder: Maybe<ReopenLastmileOrderResponse>
  orderServiceRescheduleOrder: Maybe<RescheduleOrderResponse>
  orderServiceStageLastmileOrder: Maybe<StageLastmileOrderResponse>
  /** Sends a test callback for a partner */
  partnerCallbackCreate: Maybe<PartnerCallbackCreatePayload>
  /** Create a new partner pick device */
  partnerPickDeviceCreate: Maybe<PartnerPickDeviceCreatePayload>
  /** Update an existing partner pick device's status */
  partnerPickDeviceSetStatus: Maybe<PartnerPickDeviceSetStatusPayload>
  /** Update an existing partner pick device */
  partnerPickDeviceUpdate: Maybe<PartnerPickDeviceUpdatePayload>
  /** Create a new partner pick recurring shift */
  partnerPickRecurringShiftCreate: Maybe<PartnerPickRecurringShiftCreatePayload>
  /** Delete a partner pick recurring shift by id, from some date onward */
  partnerPickRecurringShiftDelete: Maybe<PartnerPickRecurringShiftDeletePayload>
  /** Update an existing partner pick recurring shift */
  partnerPickRecurringShiftUpdate: Maybe<PartnerPickRecurringShiftUpdatePayload>
  privacyServiceCreatePiiRequestForRetailer: Maybe<CreatePiiRequestForRetailerResponse>
  /** Create a new report request */
  reportRequestCreate: Maybe<ReportRequestCreatePayload>
  retailerAislesUpdateRetailerAisleTemplate: Maybe<UpdateRetailerAisleTemplateResponse>
  /** Create a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionCreate: Maybe<RetailerAvailabilityVisibilityConditionCreatePayload>
  /** Update a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionUpdate: Maybe<RetailerAvailabilityVisibilityConditionUpdatePayload>
  retailerCampaignServiceCancelRetailerCampaign: Maybe<CancelRetailerCampaignResponse>
  retailerCampaignServiceCreateRetailerCampaign: Maybe<RetailerCampaignResponse>
  retailerCampaignServiceUpdateRetailerCampaign: Maybe<RetailerCampaignResponse>
  retailerCollectionsServiceAddProductsToRetailerCollection: Maybe<AddProductsToRetailerCollectionResponse>
  retailerCollectionsServiceCreateInventoryFileMapping: Maybe<CreateInventoryFileMappingResponse>
  retailerCollectionsServiceCreateRetailerCollection: Maybe<CreateRetailerCollectionResponse>
  retailerCollectionsServiceDeleteInventoryFileMapping: Maybe<DeleteInventoryFileMappingResponse>
  retailerCollectionsServiceDeleteNavigationCollectionsNode: Maybe<DeleteNavigationCollectionsNodeResponse>
  retailerCollectionsServiceDeleteRetailerCollection: Maybe<DeleteRetailerCollectionResponse>
  retailerCollectionsServiceDuplicateInstacartCollection: Maybe<DuplicateInstacartCollectionResponse>
  retailerCollectionsServiceDuplicateRetailerCollection: Maybe<DuplicateRetailerCollectionResponse>
  retailerCollectionsServiceProcessRetailerCollectionsCSV: Maybe<ProcessRetailerCollectionsCsvResponse>
  retailerCollectionsServiceRemoveProductsFromRetailerCollection: Maybe<RemoveProductsFromRetailerCollectionResponse>
  retailerCollectionsServiceSetCollectionFilters: Maybe<SetCollectionFiltersResponse>
  retailerCollectionsServiceUpdateInstacartCollection: Maybe<UpdateInstacartCollectionResponse>
  retailerCollectionsServiceUpdateRetailerCollection: Maybe<UpdateRetailerCollectionResponse>
  retailerCollectionsServiceUpdateRetailerCollectionInvfEnrollment: Maybe<UpdateRetailerCollectionInvfEnrollmentResponse>
  retailerCollectionsServiceUpdateRetailerCollectionPinnedStatus: Maybe<UpdateRetailerCollectionPinnedStatusResponse>
  retailerCollectionsServiceUpdateRetailerCollectionStatus: Maybe<UpdateRetailerCollectionStatusResponse>
  retailerCollectionsServiceUpsertNavigationCollectionsNode: Maybe<UpsertNavigationCollectionsNodeResponse>
  retailerCollectionsServiceUpsertRetailerConfig: Maybe<UpsertRetailerConfigResponse>
  retailerCollectionsServiceValidateRetailerCollectionsCSV: Maybe<ValidateRetailerCollectionsCsvResponse>
  /** Create a new retailer location group */
  retailerLocationGroupCreate: Maybe<RetailerLocationGroupCreatePayload>
  /** Delete an existing retailer location group */
  retailerLocationGroupDelete: Maybe<RetailerLocationGroupDeletePayload>
  /** Update an existing retailer location group */
  retailerLocationGroupUpdate: Maybe<RetailerLocationGroupUpdatePayload>
  retailerManagementServiceCreateClientConfiguration: Maybe<CreateClientConfigurationResponse>
  retailerManagementServiceCreateConnectRetailerCallbackConfiguration: Maybe<CreateConnectRetailerCallbackConfigurationResponse>
  retailerManagementServiceCreateStoreConfiguration: Maybe<CreateStoreConfigurationResponse>
  retailerManagementServiceDeleteConnectRetailerCallbackConfiguration: Maybe<DeleteConnectRetailerCallbackConfigurationResponse>
  retailerManagementServiceUpdateConnectRetailerCallbackConfiguration: Maybe<UpdateConnectRetailerCallbackConfigurationResponse>
  retailerProductAttributeEditServiceUpdateRetailerProductVisibilities: Maybe<UpdateRetailerProductVisibilitiesResponse>
  retailerSettingsServiceDeleteImage: Maybe<DeleteImageResponse>
  retailerSettingsServiceUpdateParkingSettings: Maybe<UpdateParkingSettingsResponse>
  retailerSettingsServiceUpdateStagingSettings: Maybe<UpdateStagingSettingsResponse>
  retailerStoreHoursUpdateConfirmStoreHours: Maybe<UpdateConfirmedStoreHoursResponse>
  retailerStoreHoursUpdateStoreHours: Maybe<UpdateStoreHoursResponse>
  retailersServiceMoveRetailerAssetsFromFilestackBucket: Maybe<MoveRetailerAssetsFromFilestackBucketResponse>
  /** Create a role */
  roleCreate: Maybe<RoleCreatePayload>
  /** Delete a role */
  roleDelete: Maybe<RoleDeletePayload>
  /** Update a role */
  roleUpdate: Maybe<RoleUpdatePayload>
  rppBulkImageUploadsServiceCreateImageUploadBatch: Maybe<CreateImageUploadBatchResponse>
  /** Simulate an event for an existing sandbox order */
  sandboxOrderSimulateEvent: Maybe<PartnerSandboxOrderSimulateEventPayload>
  /** Create a new home placement with SecondaryBanner banner */
  secondaryBannerPlacementCreate: Maybe<SecondaryBannerPlacementCreatePayload>
  /** Update an existing secondary_banner placement placement */
  secondaryBannerPlacementUpdate: Maybe<SecondaryBannerPlacementUpdatePayload>
  /** Create a ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionCreate: Maybe<ShoppedAtRetailerVisibilityConditionCreatePayload>
  /** Update an existing ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionUpdate: Maybe<ShoppedAtRetailerVisibilityConditionUpdatePayload>
  /** Create a shopped visibility condition */
  shoppedVisibilityConditionCreate: Maybe<ShoppedVisibilityConditionCreatePayload>
  /** Update an existing Shopped visibility condition */
  shoppedVisibilityConditionUpdate: Maybe<ShoppedVisibilityConditionUpdatePayload>
  storeConfigurationsDraftServiceCreateStoreConfigurationDraft: Maybe<CreateStoreConfigurationDraftResponse>
  storeConfigurationsDraftServicePublishStoreConfigurationDraft: Maybe<PublishStoreConfigurationDraftResponse>
  storeConfigurationsDraftServiceRollbackStoreConfiguration: Maybe<RollbackStoreConfigurationResponse>
  storeConfigurationsDraftServiceUpdateStoreConfigurationDraft: Maybe<UpdateStoreConfigurationDraftResponse>
  /** Create a new storefront placement */
  storefrontPlacementCreate: Maybe<StorefrontPlacementCreatePayload>
  /** Delete an existing storefront placement */
  storefrontPlacementDelete: Maybe<StorefrontPlacementDeletePayload>
  /** Update an existing storefront placement placement */
  storefrontPlacementUpdate: Maybe<StorefrontPlacementUpdatePayload>
  /** Create a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionCreate: Maybe<UserInteractionLimitVisibilityConditionCreatePayload>
  /** Update a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionUpdate: Maybe<UserInteractionLimitVisibilityConditionUpdatePayload>
  userSettingServiceSetUserSetting: Maybe<SetUserSettingResponse>
  usersServiceGrantImpersonation: Maybe<GrantImpersonationResponse>
  /** Create a UtmParameters visibility condition */
  utmParametersVisibilityConditionCreate: Maybe<UtmParametersVisibilityConditionCreatePayload>
  /** Update a UtmParameters visibility condition */
  utmParametersVisibilityConditionUpdate: Maybe<UtmParametersVisibilityConditionUpdatePayload>
  valueBasedOverrideServiceCreateValueBasedOverride: Maybe<CreateValueBasedOverrideResponse>
  /** Delete an existing visibility condition */
  visibilityConditionDelete: Maybe<VisibilityConditionDeletePayload>
  /** Create a WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionCreate: Maybe<WhitelistedPostalCodesVisibilityConditionCreatePayload>
  /** Update an existing WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionUpdate: Maybe<WhitelistedPostalCodesVisibilityConditionUpdatePayload>
  /** Create a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionCreate: Maybe<WhitelistedZonesVisibilityConditionCreatePayload>
  /** Update a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionUpdate: Maybe<WhitelistedZonesVisibilityConditionUpdatePayload>
  /** Update the wizard progress for the currently logged in account */
  wizardProgressUpdate: Maybe<WizardProgressUpdatePayload>
}

export type MutationApiIntegrationsServiceDeleteApiSettingArgs = {
  input?: InputMaybe<DeleteApiSettingRequestInput>
}

export type MutationApiIntegrationsServiceUpdateApiSettingArgs = {
  input?: InputMaybe<UpdateApiSettingRequestInput>
}

export type MutationAssignPermissionToRoleArgs = {
  permission: PermissionInput
  role: RoleInput
}

export type MutationBotEnterpriseAccountUpsertArgs = {
  email: Scalars['String']
  givenName: Scalars['String']
  partnerIds?: InputMaybe<Array<Scalars['ID']>>
  readOnly?: InputMaybe<Scalars['Boolean']>
  retailerIds?: InputMaybe<Array<Scalars['ID']>>
  role: BotAccountAssignableRoleEnum
  surname: Scalars['String']
}

export type MutationCallbackConfigurationUpdateArgs = {
  id: Scalars['ID']
  updatedCallbackConfiguration: CallbackConfigurationInput
}

export type MutationCatalogCodeLookupBatchCreateArgs = {
  codeLookupsData: Array<CodeLookupDataInput>
}

export type MutationCatalogImportProcessCodeLookupCreateArgs = {
  codeLookupType: ImportProcessCodeLookupTypeEnum
  codeLookupsData: Array<ImportProcessCodeLookupDataInput>
  source?: InputMaybe<Scalars['String']>
  workflowId: Scalars['ID']
}

export type MutationCatalogProblemTrackerServiceCreateTicketArgs = {
  input?: InputMaybe<CreateTicketRequestInput>
}

export type MutationCatalogWorkflowCreateArgs = {
  retailerId: Scalars['ID']
  workflowType: WorkflowTypeEnum
}

export type MutationCatalogWorkflowDeleteArgs = {
  id: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateArgs = {
  workflowEventCreationInput: WorkflowEventCreationInput
  workflowId: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetNewProductRequestsArgs = {
  aisleIdFilter?: InputMaybe<Scalars['ID']>
  changesetNewProductRequestIdsFilter?: InputMaybe<Array<Scalars['ID']>>
  classifiedCodeFilter?: InputMaybe<Scalars['String']>
  departmentIdFilter?: InputMaybe<Scalars['ID']>
  workflowId: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateBulkRemoveChangesetProductsArgs = {
  aisleIdFilter?: InputMaybe<Scalars['ID']>
  changesetProductIdsFilter?: InputMaybe<Array<Scalars['ID']>>
  classifiedCodeFilter?: InputMaybe<Scalars['String']>
  departmentIdFilter?: InputMaybe<Scalars['ID']>
  statusFilter?: InputMaybe<ChangesetProductStatusEnum>
  workflowId: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateBulkRemoveImportProcessCodeLookupsArgs = {
  hasAssociatedNewProductRequestFilter?: InputMaybe<Scalars['Boolean']>
  importProcessCodeLookupIdsFilter?: InputMaybe<Array<Scalars['ID']>>
  importProcessCodeLookupStateFilter?: InputMaybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatusFilter?: InputMaybe<ImportProcessCodeLookupStatusEnum>
  importProcessCodeLookupTypeFilter?: InputMaybe<ImportProcessCodeLookupTypeEnum>
  importProcessIdFilter?: InputMaybe<Scalars['ID']>
  workflowId: Scalars['ID']
}

export type MutationCatalogWorkflowEventCreateBulkUpdateChangesetProductsArgs = {
  aisleIdFilter?: InputMaybe<Scalars['ID']>
  changesetProductIdsFilter?: InputMaybe<Array<Scalars['ID']>>
  classifiedCodeFilter?: InputMaybe<Scalars['String']>
  departmentIdFilter?: InputMaybe<Scalars['ID']>
  statusFilter?: InputMaybe<ChangesetProductStatusEnum>
  updatedAisleId?: InputMaybe<Scalars['ID']>
  updatedCostUnit?: InputMaybe<CostUnitEnum>
  updatedDepartmentId?: InputMaybe<Scalars['ID']>
  updatedPricePerCostUnit?: InputMaybe<Scalars['Float']>
  workflowId: Scalars['ID']
}

export type MutationCatalogWorkflowSubmitArgs = {
  workflowId: Scalars['ID']
}

export type MutationCollectionCreateArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  activeAdminOnly?: InputMaybe<Scalars['Boolean']>
  childrenIds?: InputMaybe<Array<Scalars['ID']>>
  collectionName: Scalars['String']
  collectionType: CollectionTypeEnum
  endDate?: InputMaybe<Scalars['String']>
  headerData?: InputMaybe<CollectionHeaderInput>
  image?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['ID']>
  retailerIds?: InputMaybe<Array<Scalars['ID']>>
  startDate?: InputMaybe<Scalars['String']>
  storefrontBannerData?: InputMaybe<CollectionStorefrontBannerInput>
  subjectsData?: InputMaybe<Array<CollectionSubjectInput>>
}

export type MutationCollectionDeleteArgs = {
  collectionId: Scalars['ID']
}

export type MutationCollectionUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  activeAdminOnly?: InputMaybe<Scalars['Boolean']>
  childrenIds?: InputMaybe<Array<Scalars['ID']>>
  collectionId: Scalars['ID']
  collectionName?: InputMaybe<Scalars['String']>
  collectionType?: InputMaybe<CollectionTypeEnum>
  endDate?: InputMaybe<Scalars['String']>
  headerData?: InputMaybe<CollectionHeaderInput>
  image?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['ID']>
  retailerIds?: InputMaybe<Array<Scalars['ID']>>
  startDate?: InputMaybe<Scalars['String']>
  storefrontBannerData?: InputMaybe<CollectionStorefrontBannerInput>
  subjectsData?: InputMaybe<Array<CollectionSubjectInput>>
}

export type MutationConfigurableItemsServicePublishRppConfigurableItemsArgs = {
  input?: InputMaybe<PublishRppConfigurableItemsRequestInput>
}

export type MutationConnectPlatformServiceAdvanceBatchStateArgs = {
  input?: InputMaybe<AdvanceBatchStateRequestInput>
}

export type MutationConnectPlatformServiceAssignVirtualBatchArgs = {
  input?: InputMaybe<AssignVirtualBatchRequestInput>
}

export type MutationConnectPlatformServiceCreateDriverArgs = {
  input?: InputMaybe<CreateDriverRequestInput>
}

export type MutationConnectPlatformServiceGenerateBatchArgs = {
  input?: InputMaybe<GenerateBatchRequestInput>
}

export type MutationConnectPlatformServiceUpdateShopperOrderItemArgs = {
  input?: InputMaybe<UpdateShopperOrderItemRequestInput>
}

export type MutationContentManagementAdminServiceCreateContentPageArgs = {
  input?: InputMaybe<CreateContentPageRequestInput>
}

export type MutationContentManagementAdminServiceCreateContentPageV2Args = {
  input?: InputMaybe<CreateContentPageRequestV2Input>
}

export type MutationContentManagementAdminServiceCreateContentPageVersionArgs = {
  input?: InputMaybe<CreateContentPageVersionRequestInput>
}

export type MutationContentManagementAdminServiceCreateNavigationArgs = {
  input?: InputMaybe<CreateNavigationRequestInput>
}

export type MutationContentManagementAdminServiceCreateNavigationPreviewArgs = {
  input?: InputMaybe<CreateNavigationPreviewRequestInput>
}

export type MutationContentManagementAdminServiceCreatePlacementContentArgs = {
  input?: InputMaybe<CreatePlacementContentRequestInput>
}

export type MutationContentManagementAdminServiceDeleteContentPageArgs = {
  input?: InputMaybe<DeleteContentPageRequestInput>
}

export type MutationContentManagementAdminServiceDeleteContentPageVersionArgs = {
  input?: InputMaybe<DeleteContentPageVersionRequestInput>
}

export type MutationContentManagementAdminServiceDeleteNavigationArgs = {
  input?: InputMaybe<DeleteNavigationRequestInput>
}

export type MutationContentManagementAdminServiceDisablePlacementContentArgs = {
  input?: InputMaybe<DisablePlacementContentRequestInput>
}

export type MutationContentManagementAdminServiceUpdateContentPageV2Args = {
  input?: InputMaybe<UpdateContentPageRequestV2Input>
}

export type MutationContentManagementAdminServiceUpdateNavigationArgs = {
  input?: InputMaybe<UpdateNavigationRequestInput>
}

export type MutationContentManagementAdminServiceUpdatePlacementContentArgs = {
  input?: InputMaybe<UpdatePlacementContentRequestInput>
}

export type MutationContentManagementServiceBatchUpdatePlacementsArgs = {
  input?: InputMaybe<BatchUpdatePlacementsRequestInput>
}

export type MutationContentManagementServiceCreateLayoutVariantArgs = {
  input?: InputMaybe<CreateLayoutVariantRequestInput>
}

export type MutationContentManagementServiceCreatePlacementArgs = {
  input?: InputMaybe<CreatePlacementRequestInput>
}

export type MutationContentManagementServiceCreateThemePageArgs = {
  input?: InputMaybe<CreateThemePageRequestInput>
}

export type MutationContentManagementServiceDeleteLayoutVariantArgs = {
  input?: InputMaybe<DeleteLayoutVariantRequestInput>
}

export type MutationContentManagementServiceDeletePlacementArgs = {
  input?: InputMaybe<DeletePlacementRequestInput>
}

export type MutationContentManagementServiceDisableThemePageArgs = {
  input?: InputMaybe<DisableThemePageRequestInput>
}

export type MutationContentManagementServiceUpdateLayoutVariantArgs = {
  input?: InputMaybe<UpdateLayoutVariantRequestInput>
}

export type MutationContentManagementServiceUpdateThemePageArgs = {
  input?: InputMaybe<UpdateThemePageRequestInput>
}

export type MutationCountryIdsVisibilityConditionCreateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput
}

export type MutationCountryIdsVisibilityConditionUpdateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput
}

export type MutationDayOfWeekVisibilityConditionCreateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput
}

export type MutationDayOfWeekVisibilityConditionUpdateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput
}

export type MutationDemeterServiceCombineAuditBatchesArgs = {
  input?: InputMaybe<CombineAuditBatchesRequestInput>
}

export type MutationDemeterServiceReassignAuditBatchWorkflowArgs = {
  input?: InputMaybe<ReassignAuditBatchWorkflowRequestInput>
}

export type MutationDemeterServiceUpdateAuditBatchArgs = {
  input?: InputMaybe<UpdateAuditBatchRequestInput>
}

export type MutationDemeterServiceUpdateAuditTaskArgs = {
  input?: InputMaybe<UpdateAuditTaskRequestInput>
}

export type MutationEnterpriseAccountAccountSetupArgs = {
  givenName?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  rawToken: Scalars['String']
  surname?: InputMaybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticateEmailPasswordArgs = {
  email: Scalars['String']
  password: Scalars['String']
  reCaptchaToken?: InputMaybe<Scalars['String']>
}

export type MutationEnterpriseAccountAuthenticatePreflightArgs = {
  email: Scalars['String']
}

export type MutationEnterpriseAccountCreateArgs = {
  email: Scalars['String']
  givenName: Scalars['String']
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  partnerIds: Array<Scalars['ID']>
  phone?: InputMaybe<Scalars['String']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  roleIds: Array<Scalars['ID']>
  surname?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type MutationEnterpriseAccountPartnerOnboardingRequestAccountSetupEmailArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestAccountSetupEmailArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestEmailVerificationArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountRequestPasswordResetArgs = {
  email: Scalars['String']
  reCaptchaToken: Scalars['String']
}

export type MutationEnterpriseAccountResetPasswordArgs = {
  password: Scalars['String']
  rawToken: Scalars['String']
}

export type MutationEnterpriseAccountSetDisabledArgs = {
  accountCanonicalId: Scalars['ID']
  value: Scalars['Boolean']
}

export type MutationEnterpriseAccountSignUpEmailPasswordArgs = {
  email: Scalars['String']
  givenName?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  reCaptchaToken: Scalars['String']
  surname?: InputMaybe<Scalars['String']>
}

export type MutationEnterpriseAccountUpdateArgs = {
  canonicalId: Scalars['ID']
  givenName: Scalars['String']
  hasAllPartnersFullAccess: Scalars['Boolean']
  hasFullPartnerAccess: Scalars['Boolean']
  hasFullRetailerAccess: Scalars['Boolean']
  partnerIds: Array<Scalars['ID']>
  phone?: InputMaybe<Scalars['String']>
  retailerIds: Array<Scalars['ID']>
  retailerLocationIds: Array<Scalars['ID']>
  roleIds: Array<Scalars['ID']>
  surname?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type MutationEnterpriseAccountUpdateRolesArgs = {
  addRoleIds?: InputMaybe<Array<Scalars['ID']>>
  canonicalId: Scalars['ID']
  removeRoleIds?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationEnterpriseAccountVerifyAccountSetupTokenArgs = {
  rawToken: Scalars['String']
}

export type MutationEnterpriseAccountVerifyEmailArgs = {
  rawToken: Scalars['String']
}

export type MutationExperimentVariantVisibilityConditionCreateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput
}

export type MutationExperimentVariantVisibilityConditionUpdateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput
}

export type MutationExpressMembershipVisibilityConditionCreateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressMembershipVisibilityConditionUpdateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput
}

export type MutationExpressNonmemberLongTermHoldoutVisibilityConditionCreateArgs = {
  expressNonmemberLongTermHoldoutVisibilityConditionData: ExpressNonmemberLongTermHoldoutInput
}

export type MutationFeatureTourUpdateArgs = {
  name: Scalars['String']
  status: Status
}

export type MutationFlyoutPlacementCreateArgs = {
  flyoutPlacementData: FlyoutPlacementInput
}

export type MutationFlyoutPlacementUpdateArgs = {
  bannerId: Scalars['ID']
  flyoutPlacementData: FlyoutPlacementInput
  id: Scalars['ID']
}

export type MutationHeroBannerPlacementCreateArgs = {
  heroBannerPlacementData: HeroBannerPlacementInput
}

export type MutationHeroBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID']
  heroBannerPlacementData: HeroBannerPlacementInput
  id: Scalars['ID']
}

export type MutationInsightsPortalServiceCreateInsightsPortalCustomReportArgs = {
  input?: InputMaybe<InsightsPortalCreateCustomReportRequestInput>
}

export type MutationInsightsPortalServiceSetInsightsPortalCustomReportDisabledArgs = {
  input?: InputMaybe<InsightsPortalSetCustomReportDisabledRequestInput>
}

export type MutationInventoryIntelligenceServiceCreateOosAcknowledgmentArgs = {
  input?: InputMaybe<CreateOosAcknowledgmentRequestInput>
}

export type MutationLinkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminRequestInput>
}

export type MutationLinkAutosuggestServiceDeleteLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<DeleteLinkAutosuggestionAdminRequestInput>
}

export type MutationMatchesAnyRetailerIdVisibilityConditionCreateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput
}

export type MutationMatchesAnyRetailerIdVisibilityConditionUpdateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput
}

export type MutationMinimumPlatformVersionVisibilityConditionCreateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationMinimumPlatformVersionVisibilityConditionUpdateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput
}

export type MutationNewVerticalUserTargetingVisibilityConditionCreateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput
}

export type MutationNewVerticalUserTargetingVisibilityConditionUpdateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput
}

export type MutationNormalizedReportsMergeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>
  partnerId: Scalars['ID']
  reportType: MergeableReportTypeEnum
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
}

export type MutationNotificationSubscriptionCreateArgs = {
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
  retailerId: Scalars['ID']
}

export type MutationNotificationSubscriptionDeleteArgs = {
  accountId: Scalars['ID']
  notificationTypeId: Scalars['ID']
  retailerId: Scalars['ID']
}

export type MutationOnboardingServiceCreateOnboardingStoreLocationArgs = {
  input?: InputMaybe<CreateOnboardingStoreLocationRequestInput>
}

export type MutationOnboardingServiceCreateSignupArgs = {
  input?: InputMaybe<CreateSignupRequestInput>
}

export type MutationOnboardingServiceDeleteLaunchOnboardingWarehouseLocationArgs = {
  input?: InputMaybe<DeleteLaunchOnboardingWarehouseLocationRequestInput>
}

export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseInfoRequestInput>
}

export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseLocationInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseLocationInfoRequestInput>
}

export type MutationOnboardingServiceUpdateLaunchOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWorkflowStateRequestInput>
}

export type MutationOnboardingServiceUpdateOnboardingArgs = {
  input?: InputMaybe<UpdateOnboardingRequestInput>
}

export type MutationOnboardingServiceUpdateOnboardingBillingAddressArgs = {
  input?: InputMaybe<UpdateOnboardingBillingAddressRequestInput>
}

export type MutationOnboardingServiceUpdateOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateOnboardingWorkflowStateRequestInput>
}

export type MutationOrderServiceCancelOrderArgs = {
  input?: InputMaybe<CancelOrderRequestInput>
}

export type MutationOrderServiceCreateLastmileOrderFromDashboardArgs = {
  input?: InputMaybe<CreateLastmileOrderFromDashboardRequestInput>
}

export type MutationOrderServiceReopenLastmileOrderArgs = {
  input?: InputMaybe<ReopenLastmileOrderRequestInput>
}

export type MutationOrderServiceRescheduleOrderArgs = {
  input?: InputMaybe<RescheduleOrderRequestInput>
}

export type MutationOrderServiceStageLastmileOrderArgs = {
  input?: InputMaybe<StageLastmileOrderRequestInput>
}

export type MutationPartnerCallbackCreateArgs = {
  event: Scalars['String']
  orderId: Scalars['String']
  partnerId: Scalars['ID']
}

export type MutationPartnerPickDeviceCreateArgs = {
  deviceType: DeviceTypeEnum
  email: Scalars['String']
  firstName: Scalars['String']
  isPartnerPickStoreManager: Scalars['Boolean']
  lastName: Scalars['String']
  password?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  warehouseLocationId: Scalars['ID']
}

export type MutationPartnerPickDeviceSetStatusArgs = {
  active: Scalars['Boolean']
  id: Scalars['ID']
}

export type MutationPartnerPickDeviceUpdateArgs = {
  deviceType?: InputMaybe<DeviceTypeEnum>
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  isPartnerPickStoreManager?: InputMaybe<Scalars['Boolean']>
  lastName?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  warehouseLocationId?: InputMaybe<Scalars['ID']>
}

export type MutationPartnerPickRecurringShiftCreateArgs = {
  daysOfWeek: Array<Scalars['Int']>
  driverId: Scalars['ID']
  onCall?: InputMaybe<Scalars['Boolean']>
  recurEndDate?: InputMaybe<Scalars['String']>
  recurStartDate: Scalars['String']
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
  warehouseLocationId: Scalars['ID']
}

export type MutationPartnerPickRecurringShiftDeleteArgs = {
  deleteShiftsFromDate: Scalars['String']
  id: Scalars['ID']
}

export type MutationPartnerPickRecurringShiftUpdateArgs = {
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>
  id: Scalars['ID']
  onCall?: InputMaybe<Scalars['Boolean']>
  recurEndDate?: InputMaybe<Scalars['String']>
  recurStartDate?: InputMaybe<Scalars['String']>
  shiftLengthSeconds?: InputMaybe<Scalars['Int']>
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['Int']>
}

export type MutationPrivacyServiceCreatePiiRequestForRetailerArgs = {
  input?: InputMaybe<CreatePiiRequestForRetailerRequestInput>
}

export type MutationReportRequestCreateArgs = {
  associatedObjectId: Scalars['ID']
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum
  filters?: InputMaybe<ReportFilters>
  name: Scalars['String']
  reportId: Scalars['ID']
}

export type MutationRetailerAislesUpdateRetailerAisleTemplateArgs = {
  input?: InputMaybe<UpdateRetailerAisleTemplateRequestInput>
}

export type MutationRetailerAvailabilityVisibilityConditionCreateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput
}

export type MutationRetailerAvailabilityVisibilityConditionUpdateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput
}

export type MutationRetailerCampaignServiceCancelRetailerCampaignArgs = {
  input?: InputMaybe<CancelRetailerCampaignRequestInput>
}

export type MutationRetailerCampaignServiceCreateRetailerCampaignArgs = {
  input?: InputMaybe<CreateRetailerCampaignRequestInput>
}

export type MutationRetailerCampaignServiceUpdateRetailerCampaignArgs = {
  input?: InputMaybe<UpdateRetailerCampaignRequestInput>
}

export type MutationRetailerCollectionsServiceAddProductsToRetailerCollectionArgs = {
  input?: InputMaybe<AddProductsToRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceCreateInventoryFileMappingArgs = {
  input?: InputMaybe<CreateInventoryFileMappingRequestInput>
}

export type MutationRetailerCollectionsServiceCreateRetailerCollectionArgs = {
  input?: InputMaybe<CreateRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceDeleteInventoryFileMappingArgs = {
  input?: InputMaybe<DeleteInventoryFileMappingRequestInput>
}

export type MutationRetailerCollectionsServiceDeleteNavigationCollectionsNodeArgs = {
  input?: InputMaybe<DeleteNavigationCollectionsNodeRequestInput>
}

export type MutationRetailerCollectionsServiceDeleteRetailerCollectionArgs = {
  input?: InputMaybe<DeleteRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceDuplicateInstacartCollectionArgs = {
  input?: InputMaybe<DuplicateInstacartCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceDuplicateRetailerCollectionArgs = {
  input?: InputMaybe<DuplicateRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceProcessRetailerCollectionsCsvArgs = {
  input?: InputMaybe<ProcessRetailerCollectionsCsvRequestInput>
}

export type MutationRetailerCollectionsServiceRemoveProductsFromRetailerCollectionArgs = {
  input?: InputMaybe<RemoveProductsFromRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceSetCollectionFiltersArgs = {
  input?: InputMaybe<SetCollectionFiltersRequestInput>
}

export type MutationRetailerCollectionsServiceUpdateInstacartCollectionArgs = {
  input?: InputMaybe<UpdateInstacartCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceUpdateRetailerCollectionArgs = {
  input?: InputMaybe<UpdateRetailerCollectionRequestInput>
}

export type MutationRetailerCollectionsServiceUpdateRetailerCollectionInvfEnrollmentArgs = {
  input?: InputMaybe<UpdateRetailerCollectionInvfEnrollmentRequestInput>
}

export type MutationRetailerCollectionsServiceUpdateRetailerCollectionPinnedStatusArgs = {
  input?: InputMaybe<UpdateRetailerCollectionPinnedStatusRequestInput>
}

export type MutationRetailerCollectionsServiceUpdateRetailerCollectionStatusArgs = {
  input?: InputMaybe<UpdateRetailerCollectionStatusRequestInput>
}

export type MutationRetailerCollectionsServiceUpsertNavigationCollectionsNodeArgs = {
  input?: InputMaybe<UpsertNavigationCollectionsNodeRequestInput>
}

export type MutationRetailerCollectionsServiceUpsertRetailerConfigArgs = {
  input?: InputMaybe<UpsertRetailerConfigRequestInput>
}

export type MutationRetailerCollectionsServiceValidateRetailerCollectionsCsvArgs = {
  input?: InputMaybe<ValidateRetailerCollectionsCsvRequestInput>
}

export type MutationRetailerLocationGroupCreateArgs = {
  name: Scalars['String']
  retailerId: Scalars['ID']
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationRetailerLocationGroupDeleteArgs = {
  id: Scalars['ID']
}

export type MutationRetailerLocationGroupUpdateArgs = {
  id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
}

export type MutationRetailerManagementServiceCreateClientConfigurationArgs = {
  input?: InputMaybe<CreateClientConfigurationRequestInput>
}

export type MutationRetailerManagementServiceCreateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<CreateConnectRetailerCallbackConfigurationRequestInput>
}

export type MutationRetailerManagementServiceCreateStoreConfigurationArgs = {
  input?: InputMaybe<CreateStoreConfigurationRequestInput>
}

export type MutationRetailerManagementServiceDeleteConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<DeleteConnectRetailerCallbackConfigurationRequestInput>
}

export type MutationRetailerManagementServiceUpdateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<UpdateConnectRetailerCallbackConfigurationRequestInput>
}

export type MutationRetailerProductAttributeEditServiceUpdateRetailerProductVisibilitiesArgs = {
  input?: InputMaybe<UpdateRetailerProductVisibilitiesRequestInput>
}

export type MutationRetailerSettingsServiceDeleteImageArgs = {
  input?: InputMaybe<DeleteImageRequestInput>
}

export type MutationRetailerSettingsServiceUpdateParkingSettingsArgs = {
  input?: InputMaybe<UpdateParkingSettingsRequestInput>
}

export type MutationRetailerSettingsServiceUpdateStagingSettingsArgs = {
  input?: InputMaybe<UpdateStagingSettingsRequestInput>
}

export type MutationRetailerStoreHoursUpdateConfirmStoreHoursArgs = {
  input?: InputMaybe<UpdateConfirmedStoreHoursRequestInput>
}

export type MutationRetailerStoreHoursUpdateStoreHoursArgs = {
  input?: InputMaybe<UpdateStoreHoursRequestInput>
}

export type MutationRetailersServiceMoveRetailerAssetsFromFilestackBucketArgs = {
  input?: InputMaybe<MoveRetailerAssetsFromFilestackBucketRequestInput>
}

export type MutationRoleCreateArgs = {
  role: CreateRoleInput
}

export type MutationRoleDeleteArgs = {
  roleId: Scalars['ID']
}

export type MutationRoleUpdateArgs = {
  role: UpdateRoleInput
}

export type MutationRppBulkImageUploadsServiceCreateImageUploadBatchArgs = {
  input?: InputMaybe<CreateImageUploadBatchRequestInput>
}

export type MutationSandboxOrderSimulateEventArgs = {
  callbackEvent?: InputMaybe<Scalars['String']>
  orderId: Scalars['String']
  partnerId: Scalars['String']
  simulationEvent: Scalars['String']
  simulationEventArgs?: InputMaybe<Array<Scalars['String']>>
}

export type MutationSecondaryBannerPlacementCreateArgs = {
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationSecondaryBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID']
  id: Scalars['ID']
  secondaryBannerPlacementData: SecondaryBannerPlacementInput
}

export type MutationShoppedAtRetailerVisibilityConditionCreateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationShoppedAtRetailerVisibilityConditionUpdateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput
}

export type MutationShoppedVisibilityConditionCreateArgs = {
  shoppedVisibilityConditionData: ShoppedInput
}

export type MutationShoppedVisibilityConditionUpdateArgs = {
  shoppedVisibilityConditionData: ShoppedInput
}

export type MutationStoreConfigurationsDraftServiceCreateStoreConfigurationDraftArgs = {
  input?: InputMaybe<CreateStoreConfigurationDraftRequestInput>
}

export type MutationStoreConfigurationsDraftServicePublishStoreConfigurationDraftArgs = {
  input?: InputMaybe<PublishStoreConfigurationDraftRequestInput>
}

export type MutationStoreConfigurationsDraftServiceRollbackStoreConfigurationArgs = {
  input?: InputMaybe<RollbackStoreConfigurationRequestInput>
}

export type MutationStoreConfigurationsDraftServiceUpdateStoreConfigurationDraftArgs = {
  input?: InputMaybe<UpdateStoreConfigurationDraftRequestInput>
}

export type MutationStorefrontPlacementCreateArgs = {
  retailerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationStorefrontPlacementDeleteArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type MutationStorefrontPlacementUpdateArgs = {
  bannerId: Scalars['ID']
  id: Scalars['ID']
  retailerId: Scalars['ID']
  storefrontPlacementData: StorefrontPlacementInput
}

export type MutationUserInteractionLimitVisibilityConditionCreateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput
}

export type MutationUserInteractionLimitVisibilityConditionUpdateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput
}

export type MutationUserSettingServiceSetUserSettingArgs = {
  input?: InputMaybe<SetUserSettingRequestInput>
}

export type MutationUsersServiceGrantImpersonationArgs = {
  input?: InputMaybe<GrantImpersonationRequestInput>
}

export type MutationUtmParametersVisibilityConditionCreateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput
}

export type MutationUtmParametersVisibilityConditionUpdateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput
}

export type MutationValueBasedOverrideServiceCreateValueBasedOverrideArgs = {
  input?: InputMaybe<CreateValueBasedOverrideRequestInput>
}

export type MutationVisibilityConditionDeleteArgs = {
  id: Scalars['ID']
}

export type MutationWhitelistedPostalCodesVisibilityConditionCreateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationWhitelistedPostalCodesVisibilityConditionUpdateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput
}

export type MutationWhitelistedZonesVisibilityConditionCreateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput
}

export type MutationWhitelistedZonesVisibilityConditionUpdateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput
}

export type MutationWizardProgressUpdateArgs = {
  complete?: InputMaybe<Scalars['Boolean']>
  id: Scalars['ID']
}

export type NavigateToCategorySurface = {
  __typename?: 'NavigateToCategorySurface'
  categorySurfaceType: Maybe<CategorySurfaceType>
}

export type NavigateToCategorySurfaceInput = {
  categorySurfaceType?: InputMaybe<CategorySurfaceType>
}

export type NavigateToCollection = {
  __typename?: 'NavigateToCollection'
  legacyPath: Maybe<Scalars['String']>
  slug: Maybe<Scalars['String']>
}

export type NavigateToCollectionHub = {
  __typename?: 'NavigateToCollectionHub'
  category: Maybe<Scalars['String']>
}

export type NavigateToCollectionHubInput = {
  category?: InputMaybe<Scalars['String']>
}

export type NavigateToCollectionInput = {
  legacyPath?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
}

export type NavigateToContainerPathViaStoreSelector = {
  __typename?: 'NavigateToContainerPathViaStoreSelector'
  retailers: Maybe<Array<Maybe<RetailerContainerPath>>>
}

export type NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: InputMaybe<Array<InputMaybe<RetailerContainerPathInput>>>
}

export type NavigateToCouponRedemption = {
  __typename?: 'NavigateToCouponRedemption'
  couponCode: Maybe<Scalars['String']>
  landingUrl: Maybe<Scalars['String']>
  validateDays: Maybe<Scalars['BigInt']>
  visibleAfterRedeem: Maybe<Scalars['Boolean']>
}

export type NavigateToCouponRedemptionInput = {
  couponCode?: InputMaybe<Scalars['String']>
  landingUrl?: InputMaybe<Scalars['String']>
  validateDays?: InputMaybe<Scalars['BigInt']>
  visibleAfterRedeem?: InputMaybe<Scalars['Boolean']>
}

export type NavigateToDepartment = {
  __typename?: 'NavigateToDepartment'
  departmentId: Maybe<Scalars['BigInt']>
}

export type NavigateToDepartmentInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>
}

export type NavigateToPickupStoreSelector = {
  __typename?: 'NavigateToPickupStoreSelector'
  showDistance: Maybe<Scalars['Boolean']>
}

export type NavigateToPickupStoreSelectorInput = {
  showDistance?: InputMaybe<Scalars['Boolean']>
}

export type NavigateToProduct = {
  __typename?: 'NavigateToProduct'
  productId: Maybe<Scalars['BigInt']>
}

export type NavigateToProductInput = {
  productId?: InputMaybe<Scalars['BigInt']>
}

export type NavigateToPromoModal = {
  __typename?: 'NavigateToPromoModal'
  discountPolicyId: Maybe<Scalars['BigInt']>
}

export type NavigateToPromoModalInput = {
  discountPolicyId?: InputMaybe<Scalars['BigInt']>
}

export type NavigateToRetailerCollection = {
  __typename?: 'NavigateToRetailerCollection'
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
}

export type NavigateToRetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
}

export type NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'NavigateToRetailerCollectionViaStoreSelector'
  retailerCollections: Maybe<Array<Maybe<RetailerCollection>>>
}

export type NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: InputMaybe<Array<InputMaybe<RetailerCollectionInput>>>
}

export type NavigateToSsaStoreSelector = {
  __typename?: 'NavigateToSsaStoreSelector'
  serviceAreaType: Maybe<Scalars['String']>
}

export type NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: InputMaybe<Scalars['String']>
}

export type NavigateToStoreSelector = {
  __typename?: 'NavigateToStoreSelector'
  retailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type NavigateToStoreSelectorInput = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type NavigateToStorefront = {
  __typename?: 'NavigateToStorefront'
  retailerId: Maybe<Scalars['BigInt']>
}

export type NavigateToStorefrontInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type NavigateToUrl = {
  __typename?: 'NavigateToUrl'
  openInNewTab: Maybe<Scalars['Boolean']>
  openInNewWindow: Maybe<Scalars['Boolean']>
  url: Maybe<Scalars['String']>
}

export type NavigateToUrlInput = {
  openInNewTab?: InputMaybe<Scalars['Boolean']>
  openInNewWindow?: InputMaybe<Scalars['Boolean']>
  url?: InputMaybe<Scalars['String']>
}

export type Navigation = {
  __typename?: 'Navigation'
  id: Maybe<Scalars['BigInt']>
  items: Maybe<Array<Maybe<NavigationItem>>>
  locale: Maybe<InstacartCustomersSharedV1Locale>
  logoUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
}

export type NavigationAction = {
  __typename?: 'NavigationAction'
  data: Maybe<Scalars['JSONObject']>
  typeName: Maybe<Scalars['String']>
}

export type NavigationActionInput = {
  data?: InputMaybe<Scalars['JSONObject']>
  typeName?: InputMaybe<Scalars['String']>
}

export type NavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>
  items?: InputMaybe<Array<InputMaybe<NavigationItemInput>>>
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>
  logoUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
}

export type NavigationItem = {
  __typename?: 'NavigationItem'
  actions: Maybe<Array<Maybe<NavigationAction>>>
  groupPosition: Maybe<Scalars['String']>
  grouping: Maybe<Scalars['String']>
  icon: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  isNested: Maybe<Scalars['Boolean']>
  itemType: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  position: Maybe<Scalars['BigInt']>
  text: Maybe<Scalars['String']>
  variant: Maybe<Scalars['String']>
}

export type NavigationItemInput = {
  actions?: InputMaybe<Array<InputMaybe<NavigationActionInput>>>
  groupPosition?: InputMaybe<Scalars['String']>
  grouping?: InputMaybe<Scalars['String']>
  icon?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  imageUrl?: InputMaybe<Scalars['String']>
  isNested?: InputMaybe<Scalars['Boolean']>
  itemType?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['BigInt']>
  text?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<Scalars['String']>
}

export type NewVerticalUserTargetingInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** The module type */
  moduleType: Scalars['String']
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionCreate */
export type NewVerticalUserTargetingVisibilityConditionCreatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionCreatePayload'
  /** The newly created NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting
}

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionUpdate */
export type NewVerticalUserTargetingVisibilityConditionUpdatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionUpdatePayload'
  /** The newly updated NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting
}

export type NonenumeratedManagedAttributes = {
  __typename?: 'NonenumeratedManagedAttributes'
  lookupCodePluOnly: Maybe<Array<Maybe<Scalars['String']>>>
}

/** Autogenerated return type of NormalizedReportsMerge */
export type NormalizedReportsMergePayload = {
  __typename?: 'NormalizedReportsMergePayload'
  /** Merge successful */
  success: Scalars['Boolean']
}

export type NormalizedReportsNormalizedReport = {
  __typename?: 'NormalizedReportsNormalizedReport'
  /** Name of the bucket where the report comes from */
  bucketName: Scalars['String']
  /** Date at which the report was created in YYYY-MM-DD format */
  createdAt: Scalars['Time']
  /** Type of the file */
  fileType: Scalars['String']
  /** Name of the file */
  name: Scalars['String']
  /** Type of the report */
  reportType: ReportTypeEnum
  /** File path to the object in the bucket */
  s3Key: Scalars['String']
  /** Size in bytes of the object */
  size: Scalars['Int']
}

/** The connection type for NormalizedReportsNormalizedReport. */
export type NormalizedReportsNormalizedReportConnection = {
  __typename?: 'NormalizedReportsNormalizedReportConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NormalizedReportsNormalizedReportEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<NormalizedReportsNormalizedReport>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type NormalizedReportsNormalizedReportEdge = {
  __typename?: 'NormalizedReportsNormalizedReportEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<NormalizedReportsNormalizedReport>
}

export type NormalizedReportsNormalizedReportSignedUrl = {
  __typename?: 'NormalizedReportsNormalizedReportSignedUrl'
  /** Signed url for the object */
  signedUrl: Scalars['String']
}

export type NormalizedReportsReportType = {
  __typename?: 'NormalizedReportsReportType'
  /** Report type label */
  label: Scalars['String']
  /** The report type value */
  value: ReportTypeEnum
}

/** Autogenerated return type of NotificationSubscriptionCreate */
export type NotificationSubscriptionCreatePayload = {
  __typename?: 'NotificationSubscriptionCreatePayload'
  /** Subsription successful */
  success: Scalars['Boolean']
}

/** Autogenerated return type of NotificationSubscriptionDelete */
export type NotificationSubscriptionDeletePayload = {
  __typename?: 'NotificationSubscriptionDeletePayload'
  /** Unsubscribe successful */
  success: Scalars['Boolean']
}

export type NotificationsNotificationType = {
  __typename?: 'NotificationsNotificationType'
  /** Description of notification type, ie: Inventory File Normalization */
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** If the user making the request is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user making the request is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Name of notification type, ie: Inventory File Normalization */
  name: Scalars['String']
}

export type NotificationsNotificationTypeAccount = {
  __typename?: 'NotificationsNotificationTypeAccount'
  /** Account ID of user */
  accountId: Scalars['ID']
  /** Email of user */
  email: Scalars['ID']
  /** Given name of user */
  givenName: Scalars['String']
  /** If the user is eligible to subscribe to this notification */
  isEligible: Scalars['Boolean']
  /** If the user is subscribed to the notification type for the specified retailer */
  isSubscribed: Scalars['Boolean']
  /** Surname of user */
  surname: Maybe<Scalars['String']>
}

export type ObjectKeyMappingInput = {
  destinationObjectKey?: InputMaybe<Scalars['String']>
  sourceObjectKey?: InputMaybe<Scalars['String']>
}

export type Onboarding = {
  __typename?: 'Onboarding'
  billingAddress: Maybe<Address>
  contactInfo: Maybe<Contact>
  corporationType: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  duns: Maybe<Scalars['String']>
  entityName: Maybe<Scalars['String']>
  isaImageSignedUrls: Maybe<Array<Maybe<Scalars['String']>>>
  isaPdfSignedUrl: Maybe<Scalars['String']>
  ndaImageSignedUrls: Maybe<Array<Maybe<Scalars['String']>>>
  ndaPdfSignedUrl: Maybe<Scalars['String']>
  onboardingType: Maybe<Scalars['String']>
  posSystemName: Maybe<Scalars['String']>
  signupPartner: Maybe<SignupPartner>
  stateOfIncorporation: Maybe<Scalars['String']>
  storeCount: Maybe<Scalars['String']>
  storeLocation: Maybe<Address>
  updatedAt: Maybe<Scalars['DateTime']>
  w9Form: Maybe<Scalars['String']>
  website: Maybe<Scalars['String']>
  workflowState: Maybe<Scalars['String']>
}

export enum OnboardingWorkflowStateAction {
  OnboardingWorkflowStateActionComplete = 'ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE',
  OnboardingWorkflowStateActionProvideBillingAddress = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_BILLING_ADDRESS',
  OnboardingWorkflowStateActionProvideOnboardingInfo = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_ONBOARDING_INFO',
  OnboardingWorkflowStateActionProvideStoreLocations = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_STORE_LOCATIONS',
  OnboardingWorkflowStateActionSignIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_ISA',
  OnboardingWorkflowStateActionSignNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_NDA',
  OnboardingWorkflowStateActionStart = 'ONBOARDING_WORKFLOW_STATE_ACTION_START',
  OnboardingWorkflowStateActionUnknown = 'ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN',
  OnboardingWorkflowStateActionViewIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_ISA',
  OnboardingWorkflowStateActionViewNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_NDA',
}

export type OperationalHours = {
  __typename?: 'OperationalHours'
  displayableTimePeriods: Maybe<Array<Maybe<TimePeriod>>>
  isCrossDay: Maybe<Scalars['Boolean']>
  isOpenAllDay: Maybe<Scalars['Boolean']>
  timePeriods: Maybe<Array<Maybe<TimePeriod>>>
}

export type OrderByComponentInput = {
  asc?: InputMaybe<Scalars['Boolean']>
  component?: InputMaybe<Scalars['String']>
}

export type OrderInput = {
  checkoutRetailerLocationId?: InputMaybe<Scalars['BigInt']>
  id?: InputMaybe<Scalars['BigInt']>
  shoppedRetailerLocationId?: InputMaybe<Scalars['BigInt']>
  zoneId?: InputMaybe<Scalars['BigInt']>
}

export type OverrideHours = {
  __typename?: 'OverrideHours'
  date: Maybe<GoogleTypeDate>
  description: Maybe<Scalars['String']>
  endTime: Maybe<GoogleTypeTimeOfDay>
  serviceType: Maybe<RetailerServiceType>
  startTime: Maybe<GoogleTypeTimeOfDay>
}

export type OverrideHoursInput = {
  date?: InputMaybe<GoogleTypeDateInput>
  description?: InputMaybe<Scalars['String']>
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>
  serviceType?: InputMaybe<RetailerServiceType>
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>
}

export enum OverrideType {
  OverrideTypeExclude = 'OVERRIDE_TYPE_EXCLUDE',
  OverrideTypeReplace = 'OVERRIDE_TYPE_REPLACE',
  OverrideTypeUnknown = 'OVERRIDE_TYPE_UNKNOWN',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>
}

export type Pagination = {
  __typename?: 'Pagination'
  limit: Maybe<Scalars['BigInt']>
  offset: Maybe<Scalars['BigInt']>
}

export type PaginationInput = {
  limit?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
}

export type Partner = {
  __typename?: 'Partner'
  /** The callback configurations belonging to this partner */
  callbackConfigurations: Maybe<Array<PartnerCallbackConfiguration>>
  /** The client configuration belonging to this partner if it exists */
  clientConfiguration: Maybe<PartnerClientConfiguration>
  /** A unique identifier for the partner */
  id: Scalars['ID']
  /** The name of the partner */
  name: Scalars['String']
  /** The retailers belonging to this partner */
  retailers: Array<Retailer>
  /** A sandbox order belonging to the partner */
  sandboxOrder: Maybe<PartnerSandboxOrder>
}

export type PartnerSandboxOrderArgs = {
  id: Scalars['String']
}

export type PartnerCallbackConfiguration = {
  __typename?: 'PartnerCallbackConfiguration'
  /** The access token TTL */
  accessTokenTtl: Scalars['Int']
  /** The authentication URI */
  authUri: Scalars['String']
  /** The possible statuses to enable */
  availableStatuses: Array<Scalars['String']>
  /** The callback URI */
  callbackUri: Scalars['String']
  /** The client id */
  credentialsClientId: Scalars['String']
  /** The client credentials_client_secret */
  credentialsClientSecret: Scalars['String']
  /** The environment that the configuration belongs to */
  environment: Scalars['String']
  /** A unique identifier for the callback configuration */
  id: Scalars['ID']
  /** The enabled statusers */
  statusesOfInterest: Array<Scalars['String']>
}

/** Autogenerated return type of PartnerCallbackConfigurationUpdate */
export type PartnerCallbackConfigurationUpdatePayload = {
  __typename?: 'PartnerCallbackConfigurationUpdatePayload'
  /** The updated callback configuration */
  callbackConfiguration: PartnerCallbackConfiguration
}

/** Autogenerated return type of PartnerCallbackCreate */
export type PartnerCallbackCreatePayload = {
  __typename?: 'PartnerCallbackCreatePayload'
  /** The response(s) from the callback */
  callbackResponse: Array<PartnerCallbackResponse>
}

export type PartnerCallbackResponse = {
  __typename?: 'PartnerCallbackResponse'
  /** The body that was sent */
  body: Scalars['String']
  /** The headers that were sent */
  headers: Scalars['String']
  /** The type of the notification log */
  logType: Scalars['String']
  /** The response body */
  responseBody: Scalars['String']
  /** The response code */
  responseCode: Scalars['String']
  /** The time when the callback was sent */
  timestamp: Scalars['String']
  /** The url the callback was sent to */
  url: Scalars['String']
}

export type PartnerClientConfiguration = {
  __typename?: 'PartnerClientConfiguration'
  /** Does the partner have access to project shield */
  accessProjectShield: Scalars['String']
}

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartnerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Partner>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Partner>
}

export type PartnerPickCapacityGetCapacityRecommendationsResponse = {
  __typename?: 'PartnerPickCapacityGetCapacityRecommendationsResponse'
  allowedRecommendationTypes: Array<RecommendationTypeEnum>
  recommendations: Array<PartnerPickCapacityRecommendation>
}

export type PartnerPickCapacityRecommendation = {
  __typename?: 'PartnerPickCapacityRecommendation'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  recommendationType: RecommendationTypeEnum
  retailerLocationId: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

/** Autogenerated return type of PartnerPickDeviceCreate */
export type PartnerPickDeviceCreatePayload = {
  __typename?: 'PartnerPickDeviceCreatePayload'
  /** The newly created device */
  partnerPickDevice: PartnerPickDevicesDevice
}

/** Autogenerated return type of PartnerPickDeviceSetStatus */
export type PartnerPickDeviceSetStatusPayload = {
  __typename?: 'PartnerPickDeviceSetStatusPayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

/** Autogenerated return type of PartnerPickDeviceUpdate */
export type PartnerPickDeviceUpdatePayload = {
  __typename?: 'PartnerPickDeviceUpdatePayload'
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice
}

export type PartnerPickDevicesDevice = {
  __typename?: 'PartnerPickDevicesDevice'
  /** Status for the device */
  active: Scalars['Boolean']
  /** Type of device */
  deviceType: DeviceTypeEnum
  /** Email address for the device */
  email: Scalars['String']
  /** First name for the device */
  firstName: Scalars['String']
  /** A unique identifier for the device */
  id: Scalars['ID']
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: Scalars['Boolean']
  /** Last name for the device */
  lastName: Scalars['String']
  /** marqeta cards metatdata for the device */
  marqetaCardsMetadata: Maybe<PartnerPickDevicesMarqetaCardsMetadata>
  /** Phone number for the device */
  phone: Scalars['String']
}

export type PartnerPickDevicesDeviceSearch = {
  __typename?: 'PartnerPickDevicesDeviceSearch'
  devices: Array<PartnerPickDevicesDevice>
  meta: HubPaginationMeta
}

export type PartnerPickDevicesMarqetaCardsMetadata = {
  __typename?: 'PartnerPickDevicesMarqetaCardsMetadata'
  digital: Maybe<Scalars['Int']>
  inactive: Maybe<Scalars['Int']>
  physical: Maybe<Scalars['Int']>
  suspended: Maybe<Scalars['Int']>
  terminated: Maybe<Scalars['Int']>
}

/** Autogenerated return type of PartnerPickRecurringShiftCreate */
export type PartnerPickRecurringShiftCreatePayload = {
  __typename?: 'PartnerPickRecurringShiftCreatePayload'
  /** The newly created recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

/** Autogenerated return type of PartnerPickRecurringShiftDelete */
export type PartnerPickRecurringShiftDeletePayload = {
  __typename?: 'PartnerPickRecurringShiftDeletePayload'
  errorMessage: Maybe<Scalars['String']>
  /** Whether the deletion succeeded or not */
  success: Scalars['True']
}

/** Autogenerated return type of PartnerPickRecurringShiftUpdate */
export type PartnerPickRecurringShiftUpdatePayload = {
  __typename?: 'PartnerPickRecurringShiftUpdatePayload'
  /** The updated recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift
}

export type PartnerPickRecurringShiftsConflict = {
  __typename?: 'PartnerPickRecurringShiftsConflict'
  recurringShiftConflicts: Array<PartnerPickRecurringShiftsRecurringShiftConflict>
  singleShiftConflicts: Array<PartnerPickRecurringShiftsSingleShiftConflict>
}

export type PartnerPickRecurringShiftsRecurringShift = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShift'
  /** an array of Ruby Date wday that a shift recurs on (0-6, Sunday is zero) */
  daysOfWeek: Array<Scalars['Int']>
  driverId: Scalars['ID']
  driverShiftId: Maybe<Scalars['ID']>
  id: Scalars['ID']
  onCall: Maybe<Scalars['Boolean']>
  recurEndDate: Maybe<Scalars['ISO8601Date']>
  recurStartDate: Maybe<Scalars['ISO8601Date']>
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsRecurringShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShiftConflict'
  /** Days of the week when a shift occurs, represented as an Int (0-6). Sunday is 0 */
  daysOfWeek: Array<Scalars['Int']>
  id: Scalars['ID']
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  shiftType: ShiftTypeEnum
}

export type PartnerPickRecurringShiftsSingleShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsSingleShiftConflict'
  date: Scalars['ISO8601Date']
  endsAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  shiftType: ShiftTypeEnum
  startsAt: Scalars['ISO8601DateTime']
}

export type PartnerSandboxOrder = {
  __typename?: 'PartnerSandboxOrder'
  /** The logs from callback attempts for the sandbox order */
  callbackLogs: Maybe<Array<PartnerSandboxOrderCallbackLog>>
  /** Timestamp when the sandbox order was created */
  createdAt: Scalars['String']
  /** Timestamp when the sandbox order was delivered */
  deliveredAt: Maybe<Scalars['String']>
  /** A unique identifier for the sandbox order */
  id: Scalars['ID']
  /** Items within the sandbox order */
  items: Array<PartnerSandboxOrderItem>
  /** Events that can be simulated on this order */
  simulationEvents: Array<PartnerSandboxOrderSimulationEvent>
  /** The fulfillment status of the sandbox order */
  status: Scalars['String']
  /** Timestamp when the sandbox order delivery window ends */
  windowEndsAt: Scalars['String']
  /** Timestamp when the sandbox order delivery window starts */
  windowStartsAt: Scalars['String']
}

export type PartnerSandboxOrderCallbackLog = {
  __typename?: 'PartnerSandboxOrderCallbackLog'
  /** The event that the callback is for */
  event: Scalars['String']
  /** The response for the callback */
  logs: Maybe<Array<PartnerCallbackResponse>>
}

export type PartnerSandboxOrderItem = {
  __typename?: 'PartnerSandboxOrderItem'
  /** Retailer reference code to identify the item */
  itemRrc: Maybe<Scalars['String']>
  /** Universal product code to identify the item */
  itemUpc: Maybe<Scalars['String']>
  /** The unique line number decided by the partner */
  lineNum: Scalars['String']
  /** The quantity of items for the order */
  qty: Scalars['Float']
  /** The quantity unit the quantity value is in */
  qtyUnit: Scalars['String']
  /** Whether or not this item was replaced during fulfillment */
  replaced: Scalars['Boolean']
}

/** Autogenerated return type of PartnerSandboxOrderSimulateEvent */
export type PartnerSandboxOrderSimulateEventPayload = {
  __typename?: 'PartnerSandboxOrderSimulateEventPayload'
  /** The order that went through simulation */
  sandboxOrder: PartnerSandboxOrder
}

export type PartnerSandboxOrderSimulationEvent = {
  __typename?: 'PartnerSandboxOrderSimulationEvent'
  /** Arguments required when simulating this event */
  arguments: Array<Scalars['String']>
  /** The name of this simulation event */
  event: Scalars['String']
  /** The ID of the sandbox order these simulation events belong to */
  orderId: Scalars['String']
  /** The result when this event is simulated */
  outcome: PartnerSandboxOrderSimulationEventOutcome
}

export type PartnerSandboxOrderSimulationEventOutcome = {
  __typename?: 'PartnerSandboxOrderSimulationEventOutcome'
  /** A callback that will be triggered when the event is simulated */
  callback: Maybe<Scalars['String']>
  /** The status the order will be when the event is simulated */
  orderStatus: Scalars['String']
}

export type Permission = {
  __typename?: 'Permission'
  /** Indicates if the permission can be used for Retailer custom roles */
  isRetailerRoleAssignable: Scalars['Boolean']
  /** A unique identifier for the permission */
  slug: Scalars['ID']
}

export type PermissionInput = {
  /** A unique identifier for the permission */
  slug: Scalars['ID']
}

export enum PickingModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
  /** Partner managed */
  Retailer = 'RETAILER',
}

export enum PickupType {
  PickupTypeCurbside = 'PICKUP_TYPE_CURBSIDE',
  PickupTypeInStore = 'PICKUP_TYPE_IN_STORE',
  PickupTypeUnknown = 'PICKUP_TYPE_UNKNOWN',
}

export type PiiRequest = {
  __typename?: 'PiiRequest'
  createdAt: Maybe<Scalars['DateTime']>
  downloadLink: Maybe<Scalars['String']>
  requestId: Maybe<Scalars['BigInt']>
  requestType: Maybe<RequestType>
  updatedAt: Maybe<Scalars['DateTime']>
  userEmail: Maybe<Scalars['String']>
  userId: Maybe<Scalars['BigInt']>
  workflowStatus: Maybe<WorkflowStatus>
}

export enum PiiRequestCreationStatus {
  PiiRequestCreationStatusDuplicateError = 'PII_REQUEST_CREATION_STATUS_DUPLICATE_ERROR',
  PiiRequestCreationStatusInternalError = 'PII_REQUEST_CREATION_STATUS_INTERNAL_ERROR',
  PiiRequestCreationStatusNotFound = 'PII_REQUEST_CREATION_STATUS_NOT_FOUND',
  PiiRequestCreationStatusSuccess = 'PII_REQUEST_CREATION_STATUS_SUCCESS',
  PiiRequestCreationStatusUnspecified = 'PII_REQUEST_CREATION_STATUS_UNSPECIFIED',
  PiiRequestCreationStatusUserNotFound = 'PII_REQUEST_CREATION_STATUS_USER_NOT_FOUND',
  PiiRequestCreationStatusUserStoreConfigurationNotFound = 'PII_REQUEST_CREATION_STATUS_USER_STORE_CONFIGURATION_NOT_FOUND',
}

export type Placement = {
  __typename?: 'Placement'
  banner: Maybe<BannerType>
  banners: Maybe<Array<Maybe<BannerType>>>
  cardList: Maybe<CardList>
  contentPageVersionId: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  enabled: Maybe<Scalars['Boolean']>
  endDate: Maybe<Scalars['DateTime']>
  experimentMethod: Maybe<ExperimentMethod>
  experimentName: Maybe<Scalars['String']>
  experimentVariant: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  internalName: Maybe<Scalars['String']>
  itemList: Maybe<ItemList>
  layout: Maybe<Layout>
  layoutVariantId: Maybe<Scalars['BigInt']>
  platform: Maybe<Array<Maybe<PlatformType>>>
  rank: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  startDate: Maybe<Scalars['DateTime']>
  status: Maybe<Status>
  teamOwner: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
  type: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  userOwner: Maybe<Scalars['BigInt']>
  widget: Maybe<Widget>
}

export enum PlacementAdminContextAudience {
  AdminContextAudienceUnspecified = 'ADMIN_CONTEXT_AUDIENCE_UNSPECIFIED',
  InstacartAdmins = 'INSTACART_ADMINS',
  ThirdPartyAdmins = 'THIRD_PARTY_ADMINS',
}

export type PlacementAdminContextInput = {
  audience?: InputMaybe<PlacementAdminContextAudience>
}

export type PlacementContent = {
  __typename?: 'PlacementContent'
  contentPageVersionId: Maybe<Scalars['BigInt']>
  createdAt: Maybe<Scalars['DateTime']>
  deletedAt: Maybe<Scalars['DateTime']>
  enabled: Maybe<Scalars['Boolean']>
  endsAt: Maybe<Scalars['DateTime']>
  excludedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  excludedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  experimentMethod: Maybe<Scalars['String']>
  experimentName: Maybe<Scalars['String']>
  experimentVariant: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  includedRetailerIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  includedStoreConfigurationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  internalName: Maybe<Scalars['String']>
  layout: Maybe<Scalars['String']>
  layoutVariantId: Maybe<Scalars['BigInt']>
  parentPlacementId: Maybe<Scalars['BigInt']>
  placementBucketId: Maybe<Scalars['BigInt']>
  placementType: Maybe<Scalars['String']>
  placementTypeData: Maybe<Array<Maybe<PlacementContentDataStruct>>>
  platform: Maybe<Array<Maybe<Scalars['String']>>>
  rank: Maybe<Scalars['BigInt']>
  startsAt: Maybe<Scalars['DateTime']>
  teamOwner: Maybe<Scalars['String']>
  timezone: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
  userOwner: Maybe<Scalars['String']>
  visibilityConditions: Maybe<Array<Maybe<VisibilityConditionStruct>>>
}

export type PlacementContentDataStruct = {
  __typename?: 'PlacementContentDataStruct'
  contentData: Maybe<Scalars['JSONObject']>
  contentDataId: Maybe<Scalars['BigInt']>
  contentType: Maybe<Scalars['String']>
  contentVariant: Maybe<Scalars['String']>
}

export type PlacementContentDataStructInput = {
  contentData?: InputMaybe<Scalars['JSONObject']>
  contentDataId?: InputMaybe<Scalars['BigInt']>
  contentType?: InputMaybe<Scalars['String']>
  contentVariant?: InputMaybe<Scalars['String']>
}

export type PlacementContentInput = {
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  deletedAt?: InputMaybe<Scalars['DateTime']>
  enabled?: InputMaybe<Scalars['Boolean']>
  endsAt?: InputMaybe<Scalars['DateTime']>
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  experimentMethod?: InputMaybe<Scalars['String']>
  experimentName?: InputMaybe<Scalars['String']>
  experimentVariant?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  internalName?: InputMaybe<Scalars['String']>
  layout?: InputMaybe<Scalars['String']>
  layoutVariantId?: InputMaybe<Scalars['BigInt']>
  parentPlacementId?: InputMaybe<Scalars['BigInt']>
  placementBucketId?: InputMaybe<Scalars['BigInt']>
  placementType?: InputMaybe<Scalars['String']>
  placementTypeData?: InputMaybe<Array<InputMaybe<PlacementContentDataStructInput>>>
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  rank?: InputMaybe<Scalars['BigInt']>
  startsAt?: InputMaybe<Scalars['DateTime']>
  teamOwner?: InputMaybe<Scalars['String']>
  timezone?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  userOwner?: InputMaybe<Scalars['String']>
  visibilityConditions?: InputMaybe<Array<InputMaybe<VisibilityConditionStructInput>>>
}

export type PlacementContentRequestPagination = {
  __typename?: 'PlacementContentRequestPagination'
  orderBy: Maybe<Array<Maybe<PlacementContentRequestPaginationOrder>>>
  pageNumber: Maybe<Scalars['BigInt']>
  pageSize: Maybe<Scalars['BigInt']>
}

export type PlacementContentRequestPaginationInput = {
  orderBy?: InputMaybe<Array<InputMaybe<PlacementContentRequestPaginationOrderInput>>>
  pageNumber?: InputMaybe<Scalars['BigInt']>
  pageSize?: InputMaybe<Scalars['BigInt']>
}

export type PlacementContentRequestPaginationOrder = {
  __typename?: 'PlacementContentRequestPaginationOrder'
  descending: Maybe<Scalars['Boolean']>
  placementId: Maybe<Scalars['BigInt']>
  placementRank: Maybe<Scalars['BigInt']>
}

export type PlacementContentRequestPaginationOrderInput = {
  descending?: InputMaybe<Scalars['Boolean']>
  placementId?: InputMaybe<Scalars['BigInt']>
  placementRank?: InputMaybe<Scalars['BigInt']>
}

export type PlacementContentResponsePagination = {
  __typename?: 'PlacementContentResponsePagination'
  hasNextPage: Maybe<Scalars['Boolean']>
  requestPagination: Maybe<PlacementContentRequestPagination>
}

export type PlacementContentSurfaceInput = {
  surfaceIdentifier?: InputMaybe<Scalars['String']>
  surfaceType?: InputMaybe<Scalars['String']>
}

export type PlacementDestinationInput = {
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String']
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum
}

export enum PlacementDestinationTypeEnum {
  /** The placement links to a collection */
  Collection = 'COLLECTION',
  /** The placement links to a collection hub */
  CollectionHub = 'COLLECTION_HUB',
  /** The placement links to containers via a store selector */
  ContainerPathViaStoreSelector = 'CONTAINER_PATH_VIA_STORE_SELECTOR',
  /** The placement links to a department */
  Department = 'DEPARTMENT',
  /** The placement does not have an action */
  DoNotNavigate = 'DO_NOT_NAVIGATE',
  /** The placement links to an external url */
  External = 'EXTERNAL',
  /** The placement links to the pickup store selector */
  PickupStoreselector = 'PICKUP_STORESELECTOR',
  /** The placement links to a product */
  Product = 'PRODUCT',
  /** The placement links to the SSA store selector */
  SsaStoreselector = 'SSA_STORESELECTOR',
  /** The placement links to a storefront */
  Storefront = 'STOREFRONT',
  /** The placement links to a store selector */
  StoreSelector = 'STORE_SELECTOR',
  /** Unfamiliar Banner Action */
  Unknown = 'UNKNOWN',
}

export type PlacementExperimentInput = {
  /** Experiment Assignment or Lookup */
  accessMethod?: InputMaybe<PlacementExperimentMethodEnum>
  /** Name of the Experiment */
  name: Scalars['String']
  /** Variant of the Experiment for which placement should be visible */
  variant: Scalars['String']
}

export enum PlacementExperimentMethodEnum {
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether a variant lookup should occur */
  Lookup = 'LOOKUP',
  /** Whether a variant preview should occur */
  Preview = 'PREVIEW',
}

export type PlacementFilterInput = {
  /** The platform(s) the placement is configured for (Eg. [MOBILE, WEB]) */
  platform?: InputMaybe<Array<PlacementPlatformEnum>>
  /** A term to use to search for a placement */
  searchTerm?: InputMaybe<Scalars['String']>
  /** The current status of the placement (Eg. ACTIVE) */
  status?: InputMaybe<PlacementStatusEnum>
  /** The type of the placement (Eg. TEXT) */
  type?: InputMaybe<PlacementTypeEnum>
}

export type PlacementImagesInput = {
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url']
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url']
}

export type PlacementInput = {
  banner?: InputMaybe<BannerTypeInput>
  banners?: InputMaybe<Array<InputMaybe<BannerTypeInput>>>
  cardList?: InputMaybe<CardListInput>
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  enabled?: InputMaybe<Scalars['Boolean']>
  endDate?: InputMaybe<Scalars['DateTime']>
  experimentMethod?: InputMaybe<ExperimentMethod>
  experimentName?: InputMaybe<Scalars['String']>
  experimentVariant?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  internalName?: InputMaybe<Scalars['String']>
  itemList?: InputMaybe<ItemListInput>
  layout?: InputMaybe<Layout>
  layoutVariantId?: InputMaybe<Scalars['BigInt']>
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>
  rank?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<Status>
  teamOwner?: InputMaybe<Scalars['String']>
  timezone?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
  userOwner?: InputMaybe<Scalars['BigInt']>
  widget?: InputMaybe<WidgetInput>
}

export enum PlacementPlatformEnum {
  /** This placement should display on android */
  Android = 'ANDROID',
  /** This placement should display on ios */
  Ios = 'IOS',
  /** This placement should display on mobile */
  Mobile = 'MOBILE',
  /** This placement should display on web */
  Web = 'WEB',
}

export type PlacementScheduleInput = {
  /** When the placement should stop being active */
  endDate?: InputMaybe<Scalars['Time']>
  /** When the placement should become active */
  startDate: Scalars['Time']
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Scalars['String']
}

export type PlacementSortInput = {
  /** The direction to sort */
  direction?: InputMaybe<PlacementSortInputDirectionEnum>
  /** The field to sort on */
  field: PlacementSortInputFieldEnum
}

export enum PlacementSortInputDirectionEnum {
  /** Sort the results in ascending order */
  Asc = 'ASC',
  /** Sort the results in descending order */
  Desc = 'DESC',
}

export enum PlacementSortInputFieldEnum {
  /** Sort the results based on the status of the placement */
  CreatedAt = 'CREATED_AT',
  /** Sort the results based on the status of the placement */
  Status = 'STATUS',
}

export enum PlacementStatusEnum {
  /** The placement is currently active */
  Active = 'ACTIVE',
  /** The placement is not currently active */
  Inactive = 'INACTIVE',
  /** The placement is currently the live banner */
  Live = 'LIVE',
}

export enum PlacementTypeEnum {
  /** This is ASYNC_IMAGE placement */
  AsyncImage = 'ASYNC_IMAGE',
  /** This is ASYNC_MODAL placement */
  AsyncModal = 'ASYNC_MODAL',
  /** This is CAROUSEL_CARD placement */
  CarouselCard = 'CAROUSEL_CARD',
  /** This is CATEGORY_HUB placement */
  CategoryHub = 'CATEGORY_HUB',
  /** This is HEADER placement */
  Header = 'HEADER',
  /** This placement displays a HeroBanner Home Announcement Banner */
  HeroBanner = 'HERO_BANNER',
  /** This placement displays an image */
  Image = 'IMAGE',
  /** This placement displays an ImageForward Home Announcement Banner */
  ImageForward = 'IMAGE_FORWARD',
  /** This placement displays a ImageForwardFlex Home Announcement Banner */
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  /** This is INFORMATION_MODAL placement */
  InformationModal = 'INFORMATION_MODAL',
  /** This is LARGE placement */
  Large = 'LARGE',
  /** This is LOGO_WITH_TEXT placement */
  LogoWithText = 'LOGO_WITH_TEXT',
  /** This is MEGA placement */
  Mega = 'MEGA',
  /** This is OCCASION_HUB placement */
  OccasionHub = 'OCCASION_HUB',
  /** This is RICH_TEXT placement */
  RichText = 'RICH_TEXT',
  /** This placement displays a SecondaryBanner Home Announcement Banner */
  SecondaryBanner = 'SECONDARY_BANNER',
  /** This is flyout placement */
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  /** This is SURVEY placement */
  Survey = 'SURVEY',
  /** This placement displays text */
  Text = 'TEXT',
  /** This is TEXT_SLIM placement */
  TextSlim = 'TEXT_SLIM',
  /** This placement displays a TextWithThumbnail Home Announcement Banner */
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  /** This placement displays a TextWithThumbnailFlex Home Announcement Banner */
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  /** This is TITLED_MEDIA placement */
  TitledMedia = 'TITLED_MEDIA',
  /** This placement displays an ImageForward Home Announcement Banner */
  Unknown = 'UNKNOWN',
}

export type PlacementsResponse = {
  __typename?: 'PlacementsResponse'
  placements: Maybe<Array<Maybe<Placement>>>
}

export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Mobile = 'MOBILE',
  Web = 'WEB',
}

export type PricingSchema = {
  __typename?: 'PricingSchema'
  _: Maybe<Scalars['Boolean']>
}

export type ProblemTrackerEntityStatus = {
  __typename?: 'ProblemTrackerEntityStatus'
  calculatedEntityId: Maybe<EntityId>
  createdAt: Maybe<Scalars['DateTime']>
  explanation: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  providedEntityId: Maybe<EntityId>
  providedEntityType: Maybe<EntityType>
  status: Maybe<EntityStatus>
  ticketId: Maybe<Scalars['BigInt']>
}

export type ProblemTrackerTicket = {
  __typename?: 'ProblemTrackerTicket'
  assignee: Maybe<User>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  createdBy: Maybe<User>
  description: Maybe<Scalars['String']>
  entities: Maybe<Array<Maybe<Scalars['BigInt']>>>
  entityType: Maybe<EntityType>
  fixTaskGroupUuid: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  localeCode: Maybe<Scalars['String']>
  problemType: Maybe<ProblemType>
  reportedOnBehalfOf: Maybe<User>
  retailerId: Maybe<Scalars['BigInt']>
  severity: Maybe<Scalars['BigInt']>
  sourceAppName: Maybe<Scalars['String']>
  status: Maybe<TicketStatus>
  summaryStatus: Maybe<Array<Maybe<SummaryStatus>>>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type ProblemTrackerTicketComment = {
  __typename?: 'ProblemTrackerTicketComment'
  comment: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  createdBy: Maybe<User>
  id: Maybe<Scalars['BigInt']>
}

export enum ProblemType {
  ProblemTypeOther = 'PROBLEM_TYPE_OTHER',
  ProblemTypeProductAlcohol = 'PROBLEM_TYPE_PRODUCT_ALCOHOL',
  ProblemTypeProductAvailability = 'PROBLEM_TYPE_PRODUCT_AVAILABILITY',
  ProblemTypeProductBrand = 'PROBLEM_TYPE_PRODUCT_BRAND',
  ProblemTypeProductCharacteristics = 'PROBLEM_TYPE_PRODUCT_CHARACTERISTICS',
  ProblemTypeProductClassification = 'PROBLEM_TYPE_PRODUCT_CLASSIFICATION',
  ProblemTypeProductDetails = 'PROBLEM_TYPE_PRODUCT_DETAILS',
  ProblemTypeProductIdentity = 'PROBLEM_TYPE_PRODUCT_IDENTITY',
  ProblemTypeProductImage = 'PROBLEM_TYPE_PRODUCT_IMAGE',
  ProblemTypeProductSize = 'PROBLEM_TYPE_PRODUCT_SIZE',
  ProblemTypeProductTaxonomy = 'PROBLEM_TYPE_PRODUCT_TAXONOMY',
  ProblemTypeUnknown = 'PROBLEM_TYPE_UNKNOWN',
}

export type ProcessRetailerCollectionsCsvRequestInput = {
  bulkUploadType?: InputMaybe<RetailerCollectionBulkUploadType>
  fileName?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  timestamp?: InputMaybe<Scalars['DateTime']>
}

export type ProcessRetailerCollectionsCsvResponse = {
  __typename?: 'ProcessRetailerCollectionsCsvResponse'
  success: Maybe<Scalars['Boolean']>
}

export type ProductAnalyticSummaryRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ProductAnalyticsRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type ProductAnalyticsResponse = {
  __typename?: 'ProductAnalyticsResponse'
  analytics: Maybe<Analytics>
}

export type ProductAnalyticsSummary = {
  __typename?: 'ProductAnalyticsSummary'
  productId: Maybe<Scalars['BigInt']>
  totalSalesUsd: Maybe<Scalars['Float']>
}

export type ProductAnalyticsSummaryResponse = {
  __typename?: 'ProductAnalyticsSummaryResponse'
  analyticsSummary: Maybe<ProductAnalyticsSummary>
}

export type ProductAttributes = {
  __typename?: 'ProductAttributes'
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  size: Maybe<Scalars['String']>
  unitCount: Maybe<Scalars['String']>
}

export type ProductAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>
}

export type ProductAttributesResponse = {
  __typename?: 'ProductAttributesResponse'
  productAttributes: Maybe<ProductAttributes>
}

export type ProductBrandProfileAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>
}

export type ProductBrandProfileAttributesResponse = {
  __typename?: 'ProductBrandProfileAttributesResponse'
  brandProfileAttributes: Maybe<BrandProfileAttributes>
}

export type ProductCategory = {
  __typename?: 'ProductCategory'
  l1Category: Maybe<Scalars['String']>
  l1CategoryId: Maybe<Scalars['BigInt']>
  l2Category: Maybe<Scalars['String']>
  l2CategoryId: Maybe<Scalars['BigInt']>
  l3Category: Maybe<Scalars['String']>
  l3CategoryId: Maybe<Scalars['BigInt']>
  l4Category: Maybe<Scalars['String']>
  l4CategoryId: Maybe<Scalars['BigInt']>
  l5Category: Maybe<Scalars['String']>
  l5CategoryId: Maybe<Scalars['BigInt']>
  l6Category: Maybe<Scalars['String']>
  l6CategoryId: Maybe<Scalars['BigInt']>
  productCategory: Maybe<Scalars['String']>
  productCategoryId: Maybe<Scalars['BigInt']>
}

export type ProductCategoryTaxonomy = {
  __typename?: 'ProductCategoryTaxonomy'
  l1: Maybe<Scalars['String']>
  l2: Maybe<Scalars['String']>
  l3: Maybe<Scalars['String']>
  l4: Maybe<Scalars['String']>
  l5: Maybe<Scalars['String']>
  l6: Maybe<Scalars['String']>
}

export type ProductData = {
  __typename?: 'ProductData'
  attributeData: Maybe<Array<Maybe<AttributeData>>>
  localeId: Maybe<Scalars['String']>
}

export type ProductDisplay = {
  __typename?: 'ProductDisplay'
  imageAsset: Maybe<ImageAsset>
}

export type ProductId = {
  __typename?: 'ProductId'
  locale: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
}

export type ProductIdInput = {
  locale?: InputMaybe<Scalars['String']>
  productId?: InputMaybe<Scalars['BigInt']>
}

export type ProductSellSheetCardsRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>
}

export type ProductSellSheetCardsResponse = {
  __typename?: 'ProductSellSheetCardsResponse'
  sellSheetCards: Maybe<Array<Maybe<SellSheetCard>>>
}

export type ProductSource = {
  __typename?: 'ProductSource'
  defaultPriority: Maybe<Scalars['BigInt']>
  description: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  sourceLevel: Maybe<SourceLevel>
}

export type PublishRppConfigurableItemsRequestInput = {
  configurableProducts?: InputMaybe<Scalars['String']>
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type PublishRppConfigurableItemsResponse = {
  __typename?: 'PublishRppConfigurableItemsResponse'
  success: Maybe<Scalars['Boolean']>
}

export type PublishStoreConfigurationDraftRequestInput = {
  draftId?: InputMaybe<Scalars['String']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type PublishStoreConfigurationDraftResponse = {
  __typename?: 'PublishStoreConfigurationDraftResponse'
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
}

export type Query = {
  __typename?: 'Query'
  _noop: Maybe<Scalars['String']>
  /** The access control details for the account */
  accessControlConfiguration: AccessControlConfiguration
  /** Check if an account token (reset password or verify email) is valid */
  accountTokenValidate: TokensValidation
  /** Fetch list of users eligible to subscribe to an event. Also indicates if they are currently subscribed. */
  accountsByNotificationType: Array<NotificationsNotificationTypeAccount>
  /** Retrieve a paginated list of top products */
  analyticsTopProducts: SnowflakeTopProductsResult
  apiIntegrationsServiceGetApiSettings: Maybe<GetApiSettingsResponse>
  apiIntegrationsServiceGetAuthenticationUrl: Maybe<GetAuthenticationUrlResponse>
  apiIntegrationsServiceGetAvailableStoreLocations: Maybe<GetAvailableStoreLocationsResponse>
  assignmentsGetOrderFulfillmentOverview: Maybe<GetOrderFulfillmentOverviewResponse>
  /** Search for Audit Logs */
  auditLogSearch: AuditLogsAuditLogConnection
  availabilityGetStoreHoursByDate: Maybe<GetStoreHoursByDateResponse>
  availabilityGetStoreHoursByDayOfWeek: Maybe<GetStoreHoursByDayOfWeekResponse>
  availabilityGetStoreHoursByZoneRetailer: Maybe<GetStoreHoursByZoneRetailerResponse>
  /** Fetch a specific aisle by id */
  catalogAisle: CatalogAisle
  /** Fetch a specific catalog changeset new-product-request by id */
  catalogChangesetNewProductRequest: CatalogChangesetNewProductRequest
  /** Search for catalog changeset new-products-requests matching a set of criteria */
  catalogChangesetNewProductRequestSearch: CatalogChangesetNewProductRequestConnection
  /** Fetch a specific catalog changeset product by id */
  catalogChangesetProduct: CatalogChangesetProduct
  /** Search for catalog changeset products matching a set of criteria */
  catalogChangesetProductSearch: CatalogChangesetProductConnection
  /** Fetch a specific code lookup batch by id */
  catalogCodeLookupBatch: CatalogCodeLookupBatch
  /** Search for catalog code lookups matching a set of criteria */
  catalogCodeLookupSearch: CatalogCodeLookupConnection
  /** Fetch a specific department by id */
  catalogDepartment: CatalogDepartment
  /** Fetch a specific catalog import process by id */
  catalogImportProcess: CatalogImportProcess
  /** Fetch a specific catalog import process code-lookup by id */
  catalogImportProcessCodeLookup: CatalogImportProcessCodeLookup
  /** Search for catalog import process code lookups matching a set of criteria */
  catalogImportProcessCodeLookupSearch: CatalogImportProcessCodeLookupConnection
  /** Search for catalog import processes matching a set of criteria */
  catalogImportProcessSearch: CatalogImportProcessConnection
  catalogProblemTrackerServiceGetTicket: Maybe<GetTicketResponse>
  catalogProblemTrackerServiceListTickets: Maybe<ListTicketsResponse>
  /** Retrieve products by IDs */
  catalogProducts: Array<CatalogProduct>
  /** Retrieve a retailer-product by its ID */
  catalogRetailerProduct: CatalogRetailerProduct
  /** Search for retailer-products matching a set of criteria */
  catalogRetailerProductSearch: CatalogRetailerProductConnection
  /** Fetch a signed url for an S3 report */
  catalogSearchDownloadSignedUrl: CatalogSearchDownloadsCatalogSearchDownloadSignedUrl
  catalogToolsApiServiceDownloadCatalogSearchResults: Maybe<DownloadCatalogSearchResultsResponse>
  catalogToolsApiServiceGetLocalesByRetailer: Maybe<GetLocalesByRetailerResponse>
  catalogToolsApiServiceGetRetailerProductData: Maybe<GetRetailerProductDataResponse>
  /** Fetch a specific catalog workflow by id */
  catalogWorkflow: CatalogWorkflow
  /** Search for catalog workflows matching a set of criteria */
  catalogWorkflowSearch: CatalogWorkflowConnection
  /** Fetch a specific collection by id */
  collection: CollectionsCollection
  /** Fetch a list of collections allowed to be a child */
  collectionChildrenSearch: CollectionsCollectionConnection
  /** Fetch a list of collections allowed to be a parent */
  collectionParentSearch: CollectionsCollectionConnection
  /** Fetch a list of collections */
  collectionSearch: CollectionsCollectionConnection
  collectionsServiceGetCollections: Maybe<GetCollectionsResponse>
  configurableItemsServiceGetRppConfigurableItems: Maybe<GetRppConfigurableItemsResponse>
  connectPlatformServiceGetConnectSettings: Maybe<GetConnectSettingsResponse>
  connectPlatformServiceGetPartnerId: Maybe<GetPartnerIdResponse>
  connectPlatformServiceGetRequestContexts: Maybe<GetRequestContextsResponse>
  contentManagementAdminServiceGetNavigation: Maybe<GetNavigationResponse>
  contentManagementAdminServiceGetPlacementContentById: Maybe<GetPlacementContentByIdResponse>
  contentManagementAdminServiceListContentPageVersions: Maybe<ListContentPageVersionsResponse>
  contentManagementAdminServiceListContentPagesV2: Maybe<ListContentPagesResponseV2>
  contentManagementAdminServiceListPlacementContent: Maybe<ListPlacementContentResponse>
  contentManagementServiceGetLayoutVariants: Maybe<GetLayoutVariantsResponse>
  contentManagementServiceGetPlacements: Maybe<PlacementsResponse>
  contentManagementServiceGetThemePage: Maybe<GetThemePageResponse>
  contentManagementServiceListThemePages: Maybe<ListThemePagesResponse>
  /** The currently authenticated account */
  currentEnterpriseAccount: EnterpriseAccount
  /** Check if user has access to the given arguments */
  currentEnterpriseAccountAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck
  customersOrdersServiceGetHandlingDetails: Maybe<CustomersGetHandlingDetailsResponse>
  customersOrdersServiceGetOrder: Maybe<CustomersGetOrderResponse>
  customersOrdersServiceGetOrderAmountsSummaryV0: Maybe<CustomersGetOrderAmountsSummaryV0Response>
  customersOrdersServiceGetOrderLines: Maybe<CustomersGetOrderLinesResponse>
  customersOrdersServiceGetPaymentMethodSummary: Maybe<CustomersGetPaymentMethodSummaryResponse>
  customersOrdersServiceListOrders: Maybe<CustomersListOrdersResponse>
  customersOrdersServiceQueryOrderReference: Maybe<CustomersQueryOrderReferenceResponse>
  customersOrdersServiceQueryOrders: Maybe<CustomersQueryOrdersResponse>
  demeterServiceGetAuditBatch: Maybe<GetAuditBatchResponse>
  demeterServiceGetAuditTask: Maybe<GetAuditTaskResponse>
  demeterServiceListAuditBatches: Maybe<ListAuditBatchesResponse>
  demeterServiceListAuditWorkflows: Maybe<ListAuditWorkflowsResponse>
  emergingBrandPortalServiceGetBrandProfileAnalytics: Maybe<BrandProfileAnalyticsResponse>
  emergingBrandPortalServiceGetBrandProfileAnalyticsSummary: Maybe<BrandProfileAnalyticsSummaryResponse>
  emergingBrandPortalServiceGetBrandProfileAttributes: Maybe<BrandProfileAttributesResponse>
  emergingBrandPortalServiceGetBrandProfileSellSheetCards: Maybe<BrandProfileSellSheetCardsResponse>
  emergingBrandPortalServiceGetEBPProductAnalytics: Maybe<ProductAnalyticsResponse>
  emergingBrandPortalServiceGetEBPProductAnalyticsSummary: Maybe<ProductAnalyticsSummaryResponse>
  emergingBrandPortalServiceGetEBPProductAttributes: Maybe<ProductAttributesResponse>
  emergingBrandPortalServiceGetProductBrandProfileAttributes: Maybe<ProductBrandProfileAttributesResponse>
  emergingBrandPortalServiceGetProductSellSheetCards: Maybe<ProductSellSheetCardsResponse>
  emergingBrandPortalServiceGetSellSheetAnalytics: Maybe<SellSheetAnalyticsResponse>
  emergingBrandPortalServiceGetSellSheetAnalyticsSummary: Maybe<SellSheetAnalyticsSummaryResponse>
  emergingBrandPortalServiceGetSellSheetAttributes: Maybe<SellSheetAttributesResponse>
  emergingBrandPortalServiceGetSellSheetBrandProfileAttributes: Maybe<SellSheetBrandProfileAttributesResponse>
  emergingBrandPortalServiceGetSellSheetProductsAttributes: Maybe<SellSheetProductsAttributesResponse>
  /** Fetch an EnterpriseAccount by its canonical id */
  enterpriseAccount: EnterpriseAccount
  /** Search for EnterpriseAccounts matching a set of criteria */
  enterpriseAccountSearch: EnterpriseAccountConnection
  /** Check whether a given feature flag is fully/publicly enabled. */
  featureToggleFullyEnabled: FeatureTogglesEnabledCheck
  /** Fetch a list of feature tours and their statuses for the current user */
  featureTours: Array<EnterpriseFeatureTour>
  /** Check the health of the server */
  healthCheck: HealthCheck
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance: Maybe<HistoricalStorePerformanceResponse>
  /** Fetch a list of Marketplace Home placements */
  homePlacementSearch: Array<HomePlacement>
  /** Check if user has access to the given arguments */
  insightsPortalAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck
  insightsPortalServiceGetInsightsPortalCustomReport: Maybe<InsightsPortalGetCustomReportResponse>
  insightsPortalServiceGetInsightsPortalFilterOptions: Maybe<InsightsPortalFilterOptionsResponse>
  insightsPortalServiceGetInsightsPortalGroupComparison: Maybe<InsightsPortalGroupComparisonResponse>
  insightsPortalServiceGetInsightsPortalGroupMetricValue: Maybe<InsightsPortalGroupMetricValueResponse>
  insightsPortalServiceGetInsightsPortalMetricValues: Maybe<InsightsPortalMetricValuesResponse>
  insightsPortalServiceGetInsightsPortalMultiGroupData: Maybe<InsightsPortalMultiGroupResponse>
  insightsPortalServiceGetInsightsPortalSchemaMetadata: Maybe<InsightsPortalSchemaMetadataResponse>
  insightsPortalServiceGetInsightsPortalSnowflakeHeartbeat: Maybe<InsightsPortalSnowflakeHeartbeatResponse>
  insightsPortalServiceListInsightsPortalCustomReports: Maybe<InsightsPortalListCustomReportsResponse>
  inventoryIntelligenceServiceGetAcknowledgedOosIds: Maybe<GetAcknowledgedOosIdsResponse>
  /** Retrieve Configuration Information */
  legacyConfiguration: LegacyConfiguration
  /** Retrieve the current partner user */
  legacyCurrentPartnerUser: LegacyPartnerUser
  /** Check the health of the server */
  legacyHealthCheck: LegacyHealthCheck
  /** Query a Partner by id */
  legacyPartner: LegacyPartner
  /** Query a Warehouse by id */
  legacyWarehouse: LegacyWarehouse
  /** Query a WarehouseLocation by id */
  legacyWarehouseLocation: LegacyWarehouseLocation
  linkAutosuggestServiceListLinkAutosuggestionAdmin: Maybe<ListLinkAutosuggestionAdminResponse>
  /** Fetch a signed url for a single S3 report */
  normalizedReportSignedUrl: NormalizedReportsNormalizedReportSignedUrl
  /** Fetch a list of S3 report types */
  normalizedReportTypes: Array<NormalizedReportsReportType>
  /** Fetch a list of S3 reports */
  normalizedReportsSearch: NormalizedReportsNormalizedReportConnection
  /** Fetch list of notification types for a retailer */
  notificationTypesForCurrentAccountOnRetailer: Array<NotificationsNotificationType>
  onboardingServiceCheckIfLaunchOnboardingInProgressByPartner: Maybe<CheckIfLaunchOnboardingInProgressByPartnerResponse>
  onboardingServiceCheckLaunchOnboardingProgressByPartner: Maybe<CheckLaunchOnboardingProgressByPartnerResponse>
  onboardingServiceGetCatalogFaqFile: Maybe<GetCatalogFaqFileResponse>
  onboardingServiceGetLaunchOnboarding: Maybe<GetLaunchOnboardingResponse>
  onboardingServiceGetOnboarding: Maybe<GetOnboardingResponse>
  onboardingServiceGetSignupPartner: Maybe<GetSignupPartnerResponse>
  orderServiceGetDashboardOrder: Maybe<GetDashboardOrderResponse>
  orderServiceGetOrder: Maybe<GetOrderResponse>
  orderServiceGetOrderLocation: Maybe<GetOrderLocationResponse>
  /** Fetch a specific partner by id */
  partner: Partner
  /** Fetch a specific partner pick device by id */
  partnerPickDevice: PartnerPickDevicesDevice
  /** Fetch list of partner pick devices */
  partnerPickDeviceSearch: PartnerPickDevicesDeviceSearch
  /** Fetch capacity recommendations for a given retailer location and date */
  partnerPickGetCapacityRecommendations: PartnerPickCapacityGetCapacityRecommendationsResponse
  /** Check if recurring_shift being created will conflict with existing shifts */
  partnerPickRecurringShiftConflictCheck: PartnerPickRecurringShiftsConflict
  /** Search for partners matching a set of criteria */
  partnerSearch: PartnerConnection
  /** Fetches multiple partners by their ids */
  partners: Array<Partner>
  /** Fetches the list of permissions available for the current user */
  permissions: Array<Permission>
  /** Retrieve pickup retailer location groups that belong to a specific retailer */
  pickupRetailerLocationGroup: Array<RetailersPickupRetailerLocationGroup>
  privacyServiceGetPiiRequestsForRetailer: Maybe<GetPiiRequestsForRetailerResponse>
  productDataServiceGetProductData: Maybe<GetProductDataResponse>
  productSourceServiceGetProductSources: Maybe<GetProductSourcesResponse>
  productsServiceGetFlattenedTaxonomies: Maybe<GetFlattenedTaxonomiesResponse>
  productsServiceGetLegacyElasticsearch: Maybe<LegacyElasticsearchResponse>
  productsServiceGetLegacyItemsShoppers: Maybe<LegacyItemsTyped>
  productsServiceGetLegacyProducts: Maybe<LegacyProducts>
  /** Retrieve a list of reports requested by the retailer */
  reportRequests: ReportsReportRequestConnection
  /** Retrieve a report view by report view id */
  reportView: ReportViewsInterface
  /** Retrieve a list of available reports to request */
  reports: Array<ReportsReport>
  /** Fetch a specific retailer by id */
  retailer: Retailer
  retailerAislesGetRetailerAisleTemplate: Maybe<GetRetailerAisleTemplateResponse>
  retailerAislesGetRetailerLocationByLayout: Maybe<GetRetailerLocationByLayoutResponse>
  retailerCampaignServiceGetRetailerCampaign: Maybe<RetailerCampaignResponse>
  retailerCampaignServiceListRetailerCampaigns: Maybe<ListRetailerCampaignsResponse>
  retailerCollectionsServiceGetCollectionFilters: Maybe<GetCollectionFiltersResponse>
  retailerCollectionsServiceGetCollectionRules: Maybe<GetCollectionRulesResponse>
  retailerCollectionsServiceGetInstacartCollection: Maybe<GetInstacartCollectionResponse>
  retailerCollectionsServiceGetInstacartCollectionsTree: Maybe<GetInstacartCollectionsTreeResponse>
  retailerCollectionsServiceGetInventoryFileMappings: Maybe<GetInventoryFileMappingsResponse>
  retailerCollectionsServiceGetInventoryFileMismatches: Maybe<GetInventoryFileMismatchesResponse>
  retailerCollectionsServiceGetNavigationCollectionsTree: Maybe<GetNavigationCollectionsTreeResponse>
  retailerCollectionsServiceGetRetailerCollection: Maybe<GetRetailerCollectionResponse>
  retailerCollectionsServiceGetRetailerCollectionsCSV: Maybe<GetRetailerCollectionsCsvResponse>
  retailerCollectionsServiceGetRetailerCollectionsTree: Maybe<GetRetailerCollectionsTreeResponse>
  retailerCollectionsServiceGetRetailerConfig: Maybe<GetRetailerConfigResponse>
  retailerCollectionsServiceListInstacartCollections: Maybe<ListInstacartCollectionsResponse>
  retailerCollectionsServiceListRetailerCollectionProducts: Maybe<ListRetailerCollectionProductsResponse>
  retailerCollectionsServiceListRetailerCollections: Maybe<ListRetailerCollectionsResponse>
  retailerCollectionsServiceListStoreConfigurations: Maybe<ListStoreConfigurationsResponse>
  /** Fetch a specific retailer location by id */
  retailerLocation: RetailerLocation
  /** Retrieve a retailer location group by id */
  retailerLocationGroup: RetailersRetailerLocationGroup
  /** Retrieve retailer location groups that belong to a specific retailer */
  retailerLocationGroupsByRetailer: RetailersRetailerLocationGroupConnection
  /** Search for retailer locations matching a set of criteria */
  retailerLocationSearch: RetailerLocationConnection
  /** Search for retailer locations matching a set of criteria - returns an array instead of a connection type */
  retailerLocationSearchArray: Array<RetailerLocation>
  retailerManagementServiceGetConnectRetailerCallbackConfigurationById: Maybe<GetConnectRetailerCallbackConfigurationByIdResponse>
  retailerManagementServiceGetConnectRetailerCallbackConfigurations: Maybe<GetConnectRetailerCallbackConfigurationsResponse>
  /** Search for retailers matching a set of criteria */
  retailerSearch: RetailerConnection
  retailerSettingsServiceGetIsGrocer: Maybe<GetIsGrocerResponse>
  retailerSettingsServiceGetParkingSettings: Maybe<GetParkingSettingsResponse>
  retailerSettingsServiceGetPickupSettingsMetadata: Maybe<GetPickupSettingsMetadataResponse>
  retailerSettingsServiceGetStagingSettings: Maybe<GetStagingSettingsResponse>
  retailerStoreHoursGetConfirmedStoreHours: Maybe<GetConfirmedStoreHoursResponse>
  retailerStoreHoursGetRetailerHolidaysStatus: Maybe<GetHolidaysStatusResponse>
  retailerStoreHoursGetStoreHours: Maybe<GetStoreHoursResponse>
  retailerStoreHoursGetStoreHoursUpdateTasks: Maybe<GetStoreHoursUpdateTasksResponse>
  retailerToolsServiceGetCustomersContext: Maybe<GetCustomersContextResponse>
  retailerToolsServiceGetItems: Maybe<GetItemsResponse>
  retailerToolsServiceGetRetailerProducts: Maybe<GetRetailerProductsResponse>
  retailerToolsServiceGetVirtualRetailers: Maybe<GetVirtualRetailersResponse>
  retailersServiceGetRetailerLocationsByLocationCodes: Maybe<GetRetailerLocationsByLocationCodesResponse>
  retailersServiceGetRetailerLocationsDetails: Maybe<GetRetailerLocationsDetailsResponse>
  retailersServiceGetRetailerRegions: Maybe<GetRetailerRegionsResponse>
  /** Search for roles */
  roleSearch: Array<EnterpriseRole>
  rppBulkImageUploadsServiceGetImageUploadBatchDetails: Maybe<GetImageUploadBatchDetailsResponse>
  rppBulkImageUploadsServiceGetImageUploadBatches: Maybe<GetImageUploadBatchesResponse>
  serviceOptionServiceGetServiceOptions: Maybe<GetServiceOptionsResponse>
  /** Fetch list of Store Configurations by Partner/Retailer IDs */
  storeConfigurationsByRetailerIds: Array<InstacartStoreConfiguration>
  storeConfigurationsDraftServiceGetStoreConfigurationDrafts: Maybe<GetStoreConfigurationDraftsResponse>
  storeConfigurationsDraftServiceReadLatestStoreConfigurationDraft: Maybe<ReadLatestStoreConfigurationDraftResponse>
  storeConfigurationsDraftServiceReadStoreConfiguration: Maybe<ReadStoreConfigurationResponse>
  storePerformanceServiceGetAggregatedStorePerformance: Maybe<StorePerformanceResponse>
  /** Fetch a storefront placement by id */
  storefrontPlacement: ContentManagementStorefrontPlacement
  /** Fetch a list of storefront placements */
  storefrontPlacementSearch: ContentManagementStorefrontPlacementConnection
  /** Fetch taxonomy nodes */
  taxonomyNodes: Array<CatalogTaxonomyNode>
  userSettingServiceListUserSettings: Maybe<ListUserSettingsResponse>
  usersServiceBatchGetUsersByIdsStrict: Maybe<BatchGetUsersByIdsStrictResponse>
  usersServiceListUsersByPersonalIdentifiersStrict: Maybe<ListUsersByPersonalIdentifiersStrictResponse>
  valueBasedOverrideServiceGetValueBasedOverrides: Maybe<GetValueBasedOverridesResponse>
  /** Fetch visibility conditions */
  visibilityConditionSearch: Array<VisibilityCondition>
  /** Returns a WelcomeModal that should be shown to current user */
  welcomeModal: EnterpriseWelcomeModal
  /** Find progress of wizard for given partner/retailer/location and type */
  wizardProgress: Maybe<WizardsWizardProgress>
}

export type QueryAccountTokenValidateArgs = {
  rawToken: Scalars['String']
  tokenType: TokenTypeEnum
}

export type QueryAccountsByNotificationTypeArgs = {
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']>
  notificationTypeId: Scalars['ID']
  retailerId: Scalars['ID']
}

export type QueryAnalyticsTopProductsArgs = {
  endAt?: InputMaybe<Scalars['ISO8601Date']>
  limit?: InputMaybe<Scalars['Int']>
  page?: InputMaybe<Scalars['Int']>
  retailerId: Scalars['ID']
  startAt?: InputMaybe<Scalars['ISO8601Date']>
}

export type QueryApiIntegrationsServiceGetApiSettingsArgs = {
  input?: InputMaybe<GetApiSettingsRequestInput>
}

export type QueryApiIntegrationsServiceGetAuthenticationUrlArgs = {
  input?: InputMaybe<GetAuthenticationUrlRequestInput>
}

export type QueryApiIntegrationsServiceGetAvailableStoreLocationsArgs = {
  input?: InputMaybe<GetAvailableStoreLocationsRequestInput>
}

export type QueryAssignmentsGetOrderFulfillmentOverviewArgs = {
  input?: InputMaybe<GetOrderFulfillmentOverviewRequestInput>
}

export type QueryAuditLogSearchArgs = {
  accountEmails?: InputMaybe<Array<Scalars['String']>>
  accountUuids?: InputMaybe<Array<Scalars['ID']>>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  entityIds?: InputMaybe<Array<Scalars['ID']>>
  entityType?: InputMaybe<AuditLogEntityTypeEnum>
  eventName?: InputMaybe<Scalars['String']>
  eventTimeEndAt?: InputMaybe<Scalars['ISO8601DateTime']>
  eventTimeStartAt?: InputMaybe<Scalars['ISO8601DateTime']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  partnerId?: InputMaybe<Scalars['ID']>
  retailerId?: InputMaybe<Scalars['ID']>
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryAvailabilityGetStoreHoursByDateArgs = {
  input?: InputMaybe<GetStoreHoursByDateRequestInput>
}

export type QueryAvailabilityGetStoreHoursByDayOfWeekArgs = {
  input?: InputMaybe<GetStoreHoursByDayOfWeekRequestInput>
}

export type QueryAvailabilityGetStoreHoursByZoneRetailerArgs = {
  input?: InputMaybe<GetStoreHoursByZoneRetailerRequestInput>
}

export type QueryCatalogAisleArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetNewProductRequestSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  aisleId?: InputMaybe<Scalars['ID']>
  before?: InputMaybe<Scalars['String']>
  classifiedCode?: InputMaybe<Scalars['String']>
  departmentId?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  workflowId?: InputMaybe<Scalars['ID']>
}

export type QueryCatalogChangesetProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogChangesetProductSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  aisleId?: InputMaybe<Scalars['ID']>
  before?: InputMaybe<Scalars['String']>
  classifiedCode?: InputMaybe<Scalars['String']>
  departmentId?: InputMaybe<Scalars['ID']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  status?: InputMaybe<ChangesetProductStatusEnum>
  workflowId?: InputMaybe<Scalars['ID']>
}

export type QueryCatalogCodeLookupBatchArgs = {
  id: Scalars['ID']
}

export type QueryCatalogCodeLookupSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  batchId?: InputMaybe<Scalars['ID']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type QueryCatalogDepartmentArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupArgs = {
  id: Scalars['ID']
}

export type QueryCatalogImportProcessCodeLookupSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  hasAssociatedNewProductRequest?: InputMaybe<Scalars['Boolean']>
  importProcessCodeLookupState?: InputMaybe<ImportProcessCodeLookupStateEnum>
  importProcessCodeLookupStatus?: InputMaybe<ImportProcessCodeLookupStatusEnum>
  importProcessCodeLookupType?: InputMaybe<ImportProcessCodeLookupTypeEnum>
  importProcessId?: InputMaybe<Scalars['ID']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  workflowId?: InputMaybe<Scalars['ID']>
}

export type QueryCatalogImportProcessSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  importProcessOwnerId?: InputMaybe<Scalars['ID']>
  importProcessState?: InputMaybe<ImportProcessStateEnum>
  importProcessType?: InputMaybe<ImportProcessTypeEnum>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  workflowId?: InputMaybe<Scalars['ID']>
}

export type QueryCatalogProblemTrackerServiceGetTicketArgs = {
  input?: InputMaybe<GetTicketRequestInput>
}

export type QueryCatalogProblemTrackerServiceListTicketsArgs = {
  input?: InputMaybe<ListTicketsRequestInput>
}

export type QueryCatalogProductsArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryCatalogRetailerProductArgs = {
  id: Scalars['ID']
}

export type QueryCatalogRetailerProductSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  aisleIds?: InputMaybe<Array<Scalars['ID']>>
  available?: InputMaybe<Scalars['Boolean']>
  before?: InputMaybe<Scalars['String']>
  departmentIds?: InputMaybe<Array<Scalars['ID']>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  localeCode?: InputMaybe<Scalars['String']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId: Scalars['ID']
  searchLimit?: InputMaybe<Scalars['Int']>
  searchTerm: Scalars['String']
  searchType: Scalars['String']
}

export type QueryCatalogSearchDownloadSignedUrlArgs = {
  s3Key: Scalars['String']
}

export type QueryCatalogToolsApiServiceDownloadCatalogSearchResultsArgs = {
  input?: InputMaybe<DownloadCatalogSearchResultsRequestInput>
}

export type QueryCatalogToolsApiServiceGetLocalesByRetailerArgs = {
  input?: InputMaybe<GetLocalesByRetailerRequestInput>
}

export type QueryCatalogToolsApiServiceGetRetailerProductDataArgs = {
  input?: InputMaybe<GetRetailerProductDataRequestInput>
}

export type QueryCatalogWorkflowArgs = {
  id: Scalars['ID']
}

export type QueryCatalogWorkflowSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['ID']>
  workflowOwnerId?: InputMaybe<Scalars['ID']>
  workflowState?: InputMaybe<WorkflowStateEnum>
  workflowStates?: InputMaybe<Array<WorkflowStateEnum>>
  workflowType?: InputMaybe<WorkflowTypeEnum>
}

export type QueryCollectionArgs = {
  id: Scalars['ID']
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionChildrenSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['ID']>
  collectionName?: InputMaybe<Scalars['String']>
  collectionTypes: Array<CollectionTypeEnum>
  contentType?: InputMaybe<CollectionContentTypeEnum>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionParentSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionId?: InputMaybe<Scalars['ID']>
  collectionTypes: Array<CollectionTypeEnum>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  collectionName?: InputMaybe<Scalars['String']>
  collectionTypes: Array<CollectionTypeEnum>
  contentType?: InputMaybe<CollectionContentTypeEnum>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryCollectionsServiceGetCollectionsArgs = {
  input?: InputMaybe<GetCollectionsRequestInput>
}

export type QueryConfigurableItemsServiceGetRppConfigurableItemsArgs = {
  input?: InputMaybe<GetRppConfigurableItemsRequestInput>
}

export type QueryConnectPlatformServiceGetConnectSettingsArgs = {
  input?: InputMaybe<GetConnectSettingsRequestInput>
}

export type QueryConnectPlatformServiceGetPartnerIdArgs = {
  input?: InputMaybe<GetPartnerIdRequestInput>
}

export type QueryConnectPlatformServiceGetRequestContextsArgs = {
  input?: InputMaybe<GetRequestContextsRequestInput>
}

export type QueryContentManagementAdminServiceGetNavigationArgs = {
  input?: InputMaybe<GetNavigationRequestInput>
}

export type QueryContentManagementAdminServiceGetPlacementContentByIdArgs = {
  input?: InputMaybe<GetPlacementContentByIdRequestInput>
}

export type QueryContentManagementAdminServiceListContentPageVersionsArgs = {
  input?: InputMaybe<ListContentPageVersionsRequestInput>
}

export type QueryContentManagementAdminServiceListContentPagesV2Args = {
  input?: InputMaybe<ListContentPagesRequestV2Input>
}

export type QueryContentManagementAdminServiceListPlacementContentArgs = {
  input?: InputMaybe<ListPlacementContentRequestInput>
}

export type QueryContentManagementServiceGetLayoutVariantsArgs = {
  input?: InputMaybe<GetLayoutVariantsRequestInput>
}

export type QueryContentManagementServiceGetPlacementsArgs = {
  input?: InputMaybe<GetPlacementsRequestInput>
}

export type QueryContentManagementServiceGetThemePageArgs = {
  input?: InputMaybe<GetThemePageRequestInput>
}

export type QueryContentManagementServiceListThemePagesArgs = {
  input?: InputMaybe<ListThemePagesRequestInput>
}

export type QueryCurrentEnterpriseAccountAuthorizationCheckArgs = {
  accountFlippers?: InputMaybe<Array<Scalars['String']>>
  partnerIds?: InputMaybe<Array<Scalars['ID']>>
  permissions?: InputMaybe<Array<Scalars['String']>>
  requireWriteAccess?: InputMaybe<Scalars['Boolean']>
  retailerIds?: InputMaybe<Array<Scalars['ID']>>
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryCustomersOrdersServiceGetHandlingDetailsArgs = {
  input?: InputMaybe<CustomersGetHandlingDetailsRequestInput>
}

export type QueryCustomersOrdersServiceGetOrderArgs = {
  input?: InputMaybe<CustomersGetOrderRequestInput>
}

export type QueryCustomersOrdersServiceGetOrderAmountsSummaryV0Args = {
  input?: InputMaybe<CustomersGetOrderAmountsSummaryV0RequestInput>
}

export type QueryCustomersOrdersServiceGetOrderLinesArgs = {
  input?: InputMaybe<CustomersGetOrderLinesRequestInput>
}

export type QueryCustomersOrdersServiceGetPaymentMethodSummaryArgs = {
  input?: InputMaybe<CustomersGetPaymentMethodSummaryRequestInput>
}

export type QueryCustomersOrdersServiceListOrdersArgs = {
  input?: InputMaybe<CustomersListOrdersRequestInput>
}

export type QueryCustomersOrdersServiceQueryOrderReferenceArgs = {
  input?: InputMaybe<CustomersQueryOrderReferenceRequestInput>
}

export type QueryCustomersOrdersServiceQueryOrdersArgs = {
  input?: InputMaybe<CustomersQueryOrdersRequestInput>
}

export type QueryDemeterServiceGetAuditBatchArgs = {
  input?: InputMaybe<GetAuditBatchRequestInput>
}

export type QueryDemeterServiceGetAuditTaskArgs = {
  input?: InputMaybe<GetAuditTaskRequestInput>
}

export type QueryDemeterServiceListAuditBatchesArgs = {
  input?: InputMaybe<ListAuditBatchesRequestInput>
}

export type QueryDemeterServiceListAuditWorkflowsArgs = {
  input?: InputMaybe<ListAuditWorkflowsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetBrandProfileAnalyticsArgs = {
  input?: InputMaybe<BrandProfileAnalyticsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetBrandProfileAnalyticsSummaryArgs = {
  input?: InputMaybe<BrandProfileAnalyticsSummaryRequestInput>
}

export type QueryEmergingBrandPortalServiceGetBrandProfileAttributesArgs = {
  input?: InputMaybe<BrandProfileAttributesRequestInput>
}

export type QueryEmergingBrandPortalServiceGetBrandProfileSellSheetCardsArgs = {
  input?: InputMaybe<BrandProfileSellSheetCardsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetEbpProductAnalyticsArgs = {
  input?: InputMaybe<ProductAnalyticsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetEbpProductAnalyticsSummaryArgs = {
  input?: InputMaybe<ProductAnalyticSummaryRequestInput>
}

export type QueryEmergingBrandPortalServiceGetEbpProductAttributesArgs = {
  input?: InputMaybe<ProductAttributesRequestInput>
}

export type QueryEmergingBrandPortalServiceGetProductBrandProfileAttributesArgs = {
  input?: InputMaybe<ProductBrandProfileAttributesRequestInput>
}

export type QueryEmergingBrandPortalServiceGetProductSellSheetCardsArgs = {
  input?: InputMaybe<ProductSellSheetCardsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetSellSheetAnalyticsArgs = {
  input?: InputMaybe<SellSheetAnalyticsRequestInput>
}

export type QueryEmergingBrandPortalServiceGetSellSheetAnalyticsSummaryArgs = {
  input?: InputMaybe<SellSheetAnalyticsSummaryRequestInput>
}

export type QueryEmergingBrandPortalServiceGetSellSheetAttributesArgs = {
  input?: InputMaybe<SellSheetAttributesRequestInput>
}

export type QueryEmergingBrandPortalServiceGetSellSheetBrandProfileAttributesArgs = {
  input?: InputMaybe<SellSheetBrandProfileAttributesRequestInput>
}

export type QueryEmergingBrandPortalServiceGetSellSheetProductsAttributesArgs = {
  input?: InputMaybe<SellSheetProductsAttributesRequestInput>
}

export type QueryEnterpriseAccountArgs = {
  canonicalId?: InputMaybe<Scalars['ID']>
}

export type QueryEnterpriseAccountSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  canonicalIds?: InputMaybe<Array<Scalars['ID']>>
  email?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  partnerId?: InputMaybe<Scalars['ID']>
  retailerId?: InputMaybe<Scalars['ID']>
  roleId?: InputMaybe<Scalars['ID']>
  showDisabled?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<AccountStatusEnum>
}

export type QueryFeatureToggleFullyEnabledArgs = {
  featureName: Scalars['String']
}

export type QueryHealthCheckArgs = {
  metricsToken?: InputMaybe<Scalars['String']>
}

export type QueryHistoricalStorePerformanceServiceGetAggregatedHistoricalStorePerformanceArgs = {
  input?: InputMaybe<HistoricalStorePerformanceRequestInput>
}

export type QueryHomePlacementSearchArgs = {
  filter?: InputMaybe<PlacementFilterInput>
  placementId?: InputMaybe<Scalars['ID']>
  sort?: InputMaybe<PlacementSortInput>
}

export type QueryInsightsPortalAuthorizationCheckArgs = {
  partnerIds?: InputMaybe<Array<Scalars['ID']>>
  permissions?: InputMaybe<Array<Scalars['String']>>
  retailerIds?: InputMaybe<Array<Scalars['ID']>>
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
}

export type QueryInsightsPortalServiceGetInsightsPortalCustomReportArgs = {
  input?: InputMaybe<InsightsPortalGetCustomReportRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalFilterOptionsArgs = {
  input?: InputMaybe<InsightsPortalFilterOptionsRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalGroupComparisonArgs = {
  input?: InputMaybe<InsightsPortalGroupComparisonRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalGroupMetricValueArgs = {
  input?: InputMaybe<InsightsPortalGroupMetricValueRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalMetricValuesArgs = {
  input?: InputMaybe<InsightsPortalMetricValuesRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalMultiGroupDataArgs = {
  input?: InputMaybe<InsightsPortalMultiGroupRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalSchemaMetadataArgs = {
  input?: InputMaybe<InsightsPortalSchemaMetadataRequestInput>
}

export type QueryInsightsPortalServiceGetInsightsPortalSnowflakeHeartbeatArgs = {
  input?: InputMaybe<InsightsPortalSnowflakeHeartbeatRequestInput>
}

export type QueryInsightsPortalServiceListInsightsPortalCustomReportsArgs = {
  input?: InputMaybe<InsightsPortalListCustomReportsRequestInput>
}

export type QueryInventoryIntelligenceServiceGetAcknowledgedOosIdsArgs = {
  input?: InputMaybe<GetAcknowledgedOosIdsRequestInput>
}

export type QueryLegacyPartnerArgs = {
  id: Scalars['ID']
}

export type QueryLegacyWarehouseArgs = {
  id: Scalars['ID']
}

export type QueryLegacyWarehouseLocationArgs = {
  id: Scalars['ID']
}

export type QueryLinkAutosuggestServiceListLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<ListLinkAutosuggestionAdminRequestInput>
}

export type QueryNormalizedReportSignedUrlArgs = {
  bucketName: Scalars['String']
  s3Key: Scalars['String']
}

export type QueryNormalizedReportTypesArgs = {
  partnerId: Scalars['ID']
}

export type QueryNormalizedReportsSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['ISO8601Date']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  partnerId: Scalars['ID']
  reportType?: InputMaybe<ReportTypeEnum>
  retailerId: Scalars['ID']
  startDate: Scalars['ISO8601Date']
}

export type QueryNotificationTypesForCurrentAccountOnRetailerArgs = {
  retailerId: Scalars['ID']
}

export type QueryOnboardingServiceCheckIfLaunchOnboardingInProgressByPartnerArgs = {
  input?: InputMaybe<CheckIfLaunchOnboardingInProgressByPartnerRequestInput>
}

export type QueryOnboardingServiceCheckLaunchOnboardingProgressByPartnerArgs = {
  input?: InputMaybe<CheckLaunchOnboardingProgressByPartnerRequestInput>
}

export type QueryOnboardingServiceGetCatalogFaqFileArgs = {
  input?: InputMaybe<GetCatalogFaqFileRequestInput>
}

export type QueryOnboardingServiceGetLaunchOnboardingArgs = {
  input?: InputMaybe<GetLaunchOnboardingRequestInput>
}

export type QueryOnboardingServiceGetOnboardingArgs = {
  input?: InputMaybe<GetOnboardingRequestInput>
}

export type QueryOnboardingServiceGetSignupPartnerArgs = {
  input?: InputMaybe<GetSignupPartnerRequestInput>
}

export type QueryOrderServiceGetDashboardOrderArgs = {
  input?: InputMaybe<GetDashboardOrderRequestInput>
}

export type QueryOrderServiceGetOrderArgs = {
  input?: InputMaybe<GetOrderRequestInput>
}

export type QueryOrderServiceGetOrderLocationArgs = {
  input?: InputMaybe<GetOrderLocationRequestInput>
}

export type QueryPartnerArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceArgs = {
  id: Scalars['ID']
}

export type QueryPartnerPickDeviceSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  limit: Scalars['Int']
  offset: Scalars['Int']
  warehouseLocationId: Scalars['ID']
}

export type QueryPartnerPickGetCapacityRecommendationsArgs = {
  date: Scalars['ISO8601Date']
  retailerLocationId: Scalars['ID']
}

export type QueryPartnerPickRecurringShiftConflictCheckArgs = {
  daysOfWeek: Array<Scalars['Int']>
  driverId: Scalars['ID']
  existingDriverShiftId?: InputMaybe<Scalars['ID']>
  existingRecurringShiftId?: InputMaybe<Scalars['ID']>
  recurEndDate?: InputMaybe<Scalars['String']>
  recurStartDate?: InputMaybe<Scalars['String']>
  shiftLengthSeconds: Scalars['Int']
  shiftStartSecondsSinceMidnight: Scalars['Int']
  warehouseLocationId: Scalars['ID']
}

export type QueryPartnerSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']>
}

export type QueryPermissionsArgs = {
  roleId?: InputMaybe<Scalars['ID']>
}

export type QueryPickupRetailerLocationGroupArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>
  retailerId: Scalars['ID']
}

export type QueryPrivacyServiceGetPiiRequestsForRetailerArgs = {
  input?: InputMaybe<GetPiiRequestsForRetailerRequestInput>
}

export type QueryProductDataServiceGetProductDataArgs = {
  input?: InputMaybe<GetProductDataRequestInput>
}

export type QueryProductSourceServiceGetProductSourcesArgs = {
  input?: InputMaybe<GetProductSourcesRequestInput>
}

export type QueryProductsServiceGetFlattenedTaxonomiesArgs = {
  input?: InputMaybe<GetFlattenedTaxonomiesRequestInput>
}

export type QueryProductsServiceGetLegacyElasticsearchArgs = {
  input?: InputMaybe<GetLegacyElasticsearchRequestInput>
}

export type QueryProductsServiceGetLegacyItemsShoppersArgs = {
  input?: InputMaybe<GetLegacyItemsShoppersRequestInput>
}

export type QueryProductsServiceGetLegacyProductsArgs = {
  input?: InputMaybe<GetLegacyProductsRequestInput>
}

export type QueryReportRequestsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId: Scalars['ID']
}

export type QueryReportViewArgs = {
  reportViewId: Scalars['ID']
}

export type QueryRetailerArgs = {
  id: Scalars['ID']
}

export type QueryRetailerAislesGetRetailerAisleTemplateArgs = {
  input?: InputMaybe<GetRetailerAisleTemplateRequestInput>
}

export type QueryRetailerAislesGetRetailerLocationByLayoutArgs = {
  input?: InputMaybe<GetRetailerLocationByLayoutRequestInput>
}

export type QueryRetailerCampaignServiceGetRetailerCampaignArgs = {
  input?: InputMaybe<GetRetailerCampaignRequestInput>
}

export type QueryRetailerCampaignServiceListRetailerCampaignsArgs = {
  input?: InputMaybe<ListRetailerCampaignsRequestInput>
}

export type QueryRetailerCollectionsServiceGetCollectionFiltersArgs = {
  input?: InputMaybe<GetCollectionFiltersRequestInput>
}

export type QueryRetailerCollectionsServiceGetCollectionRulesArgs = {
  input?: InputMaybe<GetCollectionRulesRequestInput>
}

export type QueryRetailerCollectionsServiceGetInstacartCollectionArgs = {
  input?: InputMaybe<GetInstacartCollectionRequestInput>
}

export type QueryRetailerCollectionsServiceGetInstacartCollectionsTreeArgs = {
  input?: InputMaybe<GetInstacartCollectionsTreeRequestInput>
}

export type QueryRetailerCollectionsServiceGetInventoryFileMappingsArgs = {
  input?: InputMaybe<GetInventoryFileMappingsRequestInput>
}

export type QueryRetailerCollectionsServiceGetInventoryFileMismatchesArgs = {
  input?: InputMaybe<GetInventoryFileMismatchesRequestInput>
}

export type QueryRetailerCollectionsServiceGetNavigationCollectionsTreeArgs = {
  input?: InputMaybe<GetNavigationCollectionsTreeRequestInput>
}

export type QueryRetailerCollectionsServiceGetRetailerCollectionArgs = {
  input?: InputMaybe<GetRetailerCollectionRequestInput>
}

export type QueryRetailerCollectionsServiceGetRetailerCollectionsCsvArgs = {
  input?: InputMaybe<GetRetailerCollectionsCsvRequestInput>
}

export type QueryRetailerCollectionsServiceGetRetailerCollectionsTreeArgs = {
  input?: InputMaybe<GetRetailerCollectionsTreeRequestInput>
}

export type QueryRetailerCollectionsServiceGetRetailerConfigArgs = {
  input?: InputMaybe<GetRetailerConfigRequestInput>
}

export type QueryRetailerCollectionsServiceListInstacartCollectionsArgs = {
  input?: InputMaybe<ListInstacartCollectionsRequestInput>
}

export type QueryRetailerCollectionsServiceListRetailerCollectionProductsArgs = {
  input?: InputMaybe<ListRetailerCollectionProductsRequestInput>
}

export type QueryRetailerCollectionsServiceListRetailerCollectionsArgs = {
  input?: InputMaybe<ListRetailerCollectionsRequestInput>
}

export type QueryRetailerCollectionsServiceListStoreConfigurationsArgs = {
  input?: InputMaybe<ListStoreConfigurationsRequestInput>
}

export type QueryRetailerLocationArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupArgs = {
  id: Scalars['ID']
}

export type QueryRetailerLocationGroupsByRetailerArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId: Scalars['ID']
}

export type QueryRetailerLocationSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  pickup?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryRetailerLocationSearchArrayArgs = {
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>
  pickup?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['ID']>
}

export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationByIdArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationByIdRequestInput>
}

export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationsArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationsRequestInput>
}

export type QueryRetailerSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  partnerId?: InputMaybe<Scalars['ID']>
}

export type QueryRetailerSettingsServiceGetIsGrocerArgs = {
  input?: InputMaybe<GetIsGrocerRequestInput>
}

export type QueryRetailerSettingsServiceGetParkingSettingsArgs = {
  input?: InputMaybe<GetParkingSettingsRequestInput>
}

export type QueryRetailerSettingsServiceGetPickupSettingsMetadataArgs = {
  input?: InputMaybe<GetPickupSettingsMetadataRequestInput>
}

export type QueryRetailerSettingsServiceGetStagingSettingsArgs = {
  input?: InputMaybe<GetStagingSettingsRequestInput>
}

export type QueryRetailerStoreHoursGetConfirmedStoreHoursArgs = {
  input?: InputMaybe<GetConfirmedStoreHoursRequestInput>
}

export type QueryRetailerStoreHoursGetRetailerHolidaysStatusArgs = {
  input?: InputMaybe<GetHolidaysStatusRequestInput>
}

export type QueryRetailerStoreHoursGetStoreHoursArgs = {
  input?: InputMaybe<GetStoreHoursRequestInput>
}

export type QueryRetailerStoreHoursGetStoreHoursUpdateTasksArgs = {
  input?: InputMaybe<GetStoreHoursUpdateTasksRequestInput>
}

export type QueryRetailerToolsServiceGetCustomersContextArgs = {
  input?: InputMaybe<GetCustomersContextRequestInput>
}

export type QueryRetailerToolsServiceGetItemsArgs = {
  input?: InputMaybe<GetItemsRequestInput>
}

export type QueryRetailerToolsServiceGetRetailerProductsArgs = {
  input?: InputMaybe<GetRetailerProductsRequestInput>
}

export type QueryRetailerToolsServiceGetVirtualRetailersArgs = {
  input?: InputMaybe<GetVirtualRetailersRequestInput>
}

export type QueryRetailersServiceGetRetailerLocationsByLocationCodesArgs = {
  input?: InputMaybe<GetRetailerLocationsByLocationCodesRequestInput>
}

export type QueryRetailersServiceGetRetailerLocationsDetailsArgs = {
  input?: InputMaybe<GetRetailerLocationsDetailsRequestInput>
}

export type QueryRetailersServiceGetRetailerRegionsArgs = {
  input?: InputMaybe<GetRetailerRegionsRequestInput>
}

export type QueryRoleSearchArgs = {
  id?: InputMaybe<Scalars['ID']>
  includeGlobalRoles?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['ID']>
  retailerId?: InputMaybe<Scalars['ID']>
  slug?: InputMaybe<Scalars['String']>
}

export type QueryRppBulkImageUploadsServiceGetImageUploadBatchDetailsArgs = {
  input?: InputMaybe<GetImageUploadBatchDetailsRequestInput>
}

export type QueryRppBulkImageUploadsServiceGetImageUploadBatchesArgs = {
  input?: InputMaybe<GetImageUploadBatchesRequestInput>
}

export type QueryServiceOptionServiceGetServiceOptionsArgs = {
  input?: InputMaybe<GetServiceOptionsRequestInput>
}

export type QueryStoreConfigurationsByRetailerIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']>
  retailerIds: Array<Scalars['ID']>
  storeConfigRelationship: StoreConfigurationRelationshipEnum
}

export type QueryStoreConfigurationsDraftServiceGetStoreConfigurationDraftsArgs = {
  input?: InputMaybe<GetStoreConfigurationDraftsRequestInput>
}

export type QueryStoreConfigurationsDraftServiceReadLatestStoreConfigurationDraftArgs = {
  input?: InputMaybe<ReadLatestStoreConfigurationDraftRequestInput>
}

export type QueryStoreConfigurationsDraftServiceReadStoreConfigurationArgs = {
  input?: InputMaybe<ReadStoreConfigurationRequestInput>
}

export type QueryStorePerformanceServiceGetAggregatedStorePerformanceArgs = {
  input?: InputMaybe<StorePerformanceRequestInput>
}

export type QueryStorefrontPlacementArgs = {
  id: Scalars['ID']
  retailerId: Scalars['ID']
}

export type QueryStorefrontPlacementSearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  filter?: InputMaybe<PlacementFilterInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  retailerId: Scalars['ID']
  sort?: InputMaybe<PlacementSortInput>
}

export type QueryUserSettingServiceListUserSettingsArgs = {
  input?: InputMaybe<ListUserSettingsRequestInput>
}

export type QueryUsersServiceBatchGetUsersByIdsStrictArgs = {
  input?: InputMaybe<BatchGetUsersByIdsStrictRequestInput>
}

export type QueryUsersServiceListUsersByPersonalIdentifiersStrictArgs = {
  input?: InputMaybe<ListUsersByPersonalIdentifiersStrictRequestInput>
}

export type QueryValueBasedOverrideServiceGetValueBasedOverridesArgs = {
  input?: InputMaybe<GetValueBasedOverridesRequestInput>
}

export type QueryVisibilityConditionSearchArgs = {
  placementId?: InputMaybe<Scalars['ID']>
  visibilityConditionId?: InputMaybe<Scalars['ID']>
}

export type QueryWelcomeModalArgs = {
  partnerId?: InputMaybe<Scalars['ID']>
  retailerId?: InputMaybe<Scalars['ID']>
  retailerLocationId?: InputMaybe<Scalars['ID']>
}

export type QueryWizardProgressArgs = {
  partnerId?: InputMaybe<Scalars['ID']>
  retailerId?: InputMaybe<Scalars['ID']>
  retailerLocationId: Scalars['ID']
  wizardType: WizardTypeEnum
}

export type RadiusSchema = {
  __typename?: 'RadiusSchema'
  r0: Maybe<Scalars['BigInt']>
  r4: Maybe<Scalars['BigInt']>
  r8: Maybe<Scalars['BigInt']>
  r12: Maybe<Scalars['BigInt']>
  r24: Maybe<Scalars['BigInt']>
}

export type ReadLatestStoreConfigurationDraftRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type ReadLatestStoreConfigurationDraftResponse = {
  __typename?: 'ReadLatestStoreConfigurationDraftResponse'
  domainConfigurations: Maybe<DomainConfiguration>
  draftId: Maybe<Scalars['String']>
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
}

export type ReadStoreConfigurationRequestInput = {
  draftId?: InputMaybe<Scalars['String']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type ReadStoreConfigurationResponse = {
  __typename?: 'ReadStoreConfigurationResponse'
  domainConfigurations: Maybe<DomainConfiguration>
  draftId: Maybe<Scalars['String']>
  draftName: Maybe<Scalars['String']>
  parentDraftId: Maybe<Scalars['String']>
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
  storeConfigurationId: Maybe<Scalars['BigInt']>
}

export type ReassignAuditBatchWorkflowRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>
  client?: InputMaybe<Scalars['String']>
  newWorkflow?: InputMaybe<Scalars['String']>
  version?: InputMaybe<Scalars['BigInt']>
}

export type ReassignAuditBatchWorkflowResponse = {
  __typename?: 'ReassignAuditBatchWorkflowResponse'
  completedAt: Maybe<Scalars['DateTime']>
  message: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
}

export enum RecommendationTypeEnum {
  DemandSurge = 'DEMAND_SURGE',
  NoRunner = 'NO_RUNNER',
}

export type Region = {
  __typename?: 'Region'
  id: Maybe<Scalars['BigInt']>
  locationCodes: Maybe<Array<Maybe<Scalars['String']>>>
  name: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
}

export type RegularHours = {
  __typename?: 'RegularHours'
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>
  endTime: Maybe<GoogleTypeTimeOfDay>
  serviceType: Maybe<RetailerServiceType>
  startTime: Maybe<GoogleTypeTimeOfDay>
}

export type RegularHoursInput = {
  dayOfWeek?: InputMaybe<GoogleTypeDayOfWeek>
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>
  serviceType?: InputMaybe<RetailerServiceType>
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>
}

export enum RejectionReasonEnum {
  /** Whether the authorization check failed because of lack of write access */
  NoWriteAccess = 'no_write_access',
  /** Whether the authorization check failed because of unauthorized partners */
  UnauthorizedPartners = 'unauthorized_partners',
  /** Whether the authorization check failed because of unauthorized retailer locations */
  UnauthorizedRetailerLocations = 'unauthorized_retailer_locations',
  /** Whether the authorization check failed because of unauthorized retailers */
  UnauthorizedRetailers = 'unauthorized_retailers',
  /** Whether the authorization check failed because of unauthorized access to store configuration */
  UnauthorizedStoreConfigs = 'unauthorized_store_configs',
  /** Whether the authorization check failed because of unmet flippers */
  UnmetFlippers = 'unmet_flippers',
  /** Whether the authorization check failed because of unmet permissions */
  UnmetPermissions = 'unmet_permissions',
}

export type RemoveProductsFromRetailerCollectionRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type RemoveProductsFromRetailerCollectionResponse = {
  __typename?: 'RemoveProductsFromRetailerCollectionResponse'
  productIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type ReopenLastmileOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type ReopenLastmileOrderResponse = {
  __typename?: 'ReopenLastmileOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

/** A report filter definition */
export type ReportFilterDefinitionsInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export enum ReportFilterTypeEnum {
  /** A filter that allows selection of a date range. */
  DateRange = 'DATE_RANGE',
  /** A filter that allows selection of a list of retailer locations. */
  RetailerLocations = 'RETAILER_LOCATIONS',
}

/** Report filter values */
export type ReportFilterValuesInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
}

/** Report Filters */
export type ReportFilters = {
  dateRange?: InputMaybe<DateRange>
  retailerLocations?: InputMaybe<RetailerLocations>
}

export enum ReportRequestAssociatedObjectTypeEnum {
  /** Retailer type of associated object */
  Retailer = 'Retailer',
}

/** Autogenerated return type of ReportRequestCreate */
export type ReportRequestCreatePayload = {
  __typename?: 'ReportRequestCreatePayload'
  /** The newly created report request */
  reportRequest: Maybe<ReportsReportRequest>
}

export enum ReportRequestStateEnum {
  /** A report request that has been successfully processed */
  Complete = 'COMPLETE',
  /** A report request that has failed processing */
  Failed = 'FAILED',
  /** A report request that is currently being processed */
  InProgress = 'IN_PROGRESS',
  /** A report request that is new and not yet processed */
  New = 'NEW',
}

export enum ReportTypeEnum {
  /** Ads report daily */
  AdsDaily = 'ADS_DAILY',
  /** Ads report monthly */
  AdsMonthly = 'ADS_MONTHLY',
  /** Ads report weekly */
  AdsWeekly = 'ADS_WEEKLY',
  /** Associate level performance */
  AssociateLevelPartnerPerformanceReport = 'ASSOCIATE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Daily Ultrafast Dashboard */
  DailyUltrafastDashboard = 'DAILY_ULTRAFAST_DASHBOARD',
  /** Daily Ultrafast Order Reporting */
  DailyUltrafastOrderReporting = 'DAILY_ULTRAFAST_ORDER_REPORTING',
  /** Delivery Now By Marianos - Daily Adjustment Report */
  DeliveryNowByMarianosDailyAdjustmentReport = 'DELIVERY_NOW_BY_MARIANOS_DAILY_ADJUSTMENT_REPORT',
  /** Distribution System Report */
  DistributionSystemReport = 'DISTRIBUTION_SYSTEM_REPORT',
  /** Monthly DLOG report */
  DlogMonthly = 'DLOG_MONTHLY',
  /** Live Issue */
  LiveIssue = 'LIVE_ISSUE',
  /** Merged: Retailer Tax Logs */
  MergedRetailerTaxLogs = 'MERGED_RETAILER_TAX_LOGS',
  /** Merged: Taxes Paid at POS */
  MergedTaxesPaidAtPos = 'MERGED_TAXES_PAID_AT_POS',
  /** Monthly MLOG report */
  MlogMonthly = 'MLOG_MONTHLY',
  /** MPF Taxes Semi Monthly */
  MpfTaxesSemiMonthly = 'MPF_TAXES_SEMI_MONTHLY',
  /** New Verticals - Weekly Retailer Update */
  NewVerticalsWeeklyRetailerUpdate = 'NEW_VERTICALS_WEEKLY_RETAILER_UPDATE',
  /** Order ratings */
  OrderRatings = 'ORDER_RATINGS',
  /** Out of stock items */
  OutOfStock = 'OUT_OF_STOCK',
  /** Replacements and refunds */
  ReplacementsAndRefunds = 'REPLACEMENTS_AND_REFUNDS',
  /** Retailer Pickup */
  RetailerPickup = 'RETAILER_PICKUP',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Live Issue */
  RunnerHours = 'RUNNER_HOURS',
  /** Scan & Pay */
  ScanAndPay = 'SCAN_AND_PAY',
  /** Shopper Breaks */
  ShopperBreaks = 'SHOPPER_BREAKS',
  /** Store level performance */
  StoreLevelPartnerPerformanceReport = 'STORE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Top items */
  TopItems = 'TOP_ITEMS',
  /** Live Issue */
  UnataExpressWeekly = 'UNATA_EXPRESS_WEEKLY',
  /** UUID Compliance */
  UuidCompliance = 'UUID_COMPLIANCE',
  /** General weekly updates */
  WeeklyRetailerUpdate = 'WEEKLY_RETAILER_UPDATE',
}

/** A generated view of the report data */
export type ReportViewsInterface = {
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export type ReportsReport = {
  __typename?: 'ReportsReport'
  /** The time at which the report was created */
  createdAt: Scalars['Time']
  /** A unique identifier for the each report */
  id: Scalars['ID']
  /** A url-friendly ID for this report */
  slug: Scalars['String']
  supportedFilters: Array<ReportFilterDefinitionsInterface>
  /** The time at which the report was updated */
  updatedAt: Scalars['Time']
}

export type ReportsReportFilterDefinitionsDateRange = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsDateRange'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Maximum date allowed */
  maxDate: Scalars['ISO8601Date']
  /** Minimum date */
  minDate: Scalars['ISO8601Date']
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterDefinitionsRetailerLocations = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Whether this filter is required */
  required: Scalars['Boolean']
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportFilterValuesDateRange = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesDateRange'
  /** End date of date range */
  endDate: Scalars['ISO8601Date']
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** Identifier for this filter */
  slug: Scalars['String']
  /** Start date of date range */
  startDate: Scalars['ISO8601Date']
}

export type ReportsReportFilterValuesRetailerLocations = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesRetailerLocations'
  /** Type of filter */
  filterType: ReportFilterTypeEnum
  /** A retailer location group ID */
  retailerLocationGroupId: Maybe<Scalars['ID']>
  /** A list of retailer location IDs */
  retailerLocationIds: Maybe<Array<Scalars['ID']>>
  /** Identifier for this filter */
  slug: Scalars['String']
}

export type ReportsReportRequest = {
  __typename?: 'ReportsReportRequest'
  /** The time at which the report request was created */
  createdAt: Scalars['Time']
  enterpriseAccount: Maybe<EnterpriseAccount>
  /** The state the report request is currently in */
  generationState: ReportRequestStateEnum
  /** A unique identifier for the report request */
  id: Scalars['ID']
  /** The name of the report request */
  name: Scalars['String']
  report: ReportsReport
  reportFilters: Array<ReportFilterValuesInterface>
  reportViews: Array<ReportViewsInterface>
  /** The time at which the report request was updated */
  updatedAt: Scalars['Time']
}

/** The connection type for ReportsReportRequest. */
export type ReportsReportRequestConnection = {
  __typename?: 'ReportsReportRequestConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReportsReportRequestEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReportsReportRequest>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ReportsReportRequestEdge = {
  __typename?: 'ReportsReportRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<ReportsReportRequest>
}

export type ReportsReportViewsCsv = ReportViewsInterface & {
  __typename?: 'ReportsReportViewsCsv'
  /** download URL for the report view */
  downloadUrl: Maybe<Scalars['String']>
  /** A unique identifier for the report view */
  id: Scalars['ID']
}

export enum RequestType {
  RequestTypeAccess = 'REQUEST_TYPE_ACCESS',
  RequestTypeDeletion = 'REQUEST_TYPE_DELETION',
  RequestTypeUnspecified = 'REQUEST_TYPE_UNSPECIFIED',
}

export type RescheduleOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput>
  partnerId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type RescheduleOrderResponse = {
  __typename?: 'RescheduleOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type ResourceDataQuery = {
  __typename?: 'ResourceDataQuery'
  id: Maybe<Scalars['String']>
  resource: Maybe<Scalars['String']>
}

export type ResourceDataQueryInput = {
  id?: InputMaybe<Scalars['String']>
  resource?: InputMaybe<Scalars['String']>
}

export type Retailer = {
  __typename?: 'Retailer'
  /** An array of the retailer's departments */
  departments: Array<CatalogDepartment>
  /** The feature toggles associated with the retailer */
  featureToggles: Array<FeatureToggle>
  /** A url for header-specific version of the logo */
  headerLogoUrl: Maybe<Scalars['String']>
  /** A unique identifier for the retailer */
  id: Scalars['ID']
  /** Whether or not the retailer is on pbi */
  isPbi: Scalars['Boolean']
  /** The name of the retailer */
  name: Scalars['String']
  /** The partner that this retailer belongs to */
  partner: Partner
  /** The store configuration for the pbi retailer */
  pbiConfiguration: Maybe<ContentManagementPbiConfiguration>
  /** The warehouse slug for a retailer */
  slug: Scalars['String']
  /** A url for tiny version of the logo */
  tinyLogoUrl: Maybe<Scalars['String']>
  /** A url for the white label landing page */
  whiteLabelLandingPageUrl: Maybe<Scalars['String']>
}

export type RetailerAvailabilityInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** The ID of the retailer */
  retailerId: Scalars['Int']
}

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionCreate */
export type RetailerAvailabilityVisibilityConditionCreatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionCreatePayload'
  /** The newly created RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability
}

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionUpdate */
export type RetailerAvailabilityVisibilityConditionUpdatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionUpdatePayload'
  /** The newly updated RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability
}

export type RetailerCampaign = {
  __typename?: 'RetailerCampaign'
  campaignObjective: Maybe<CampaignObjective>
  createdAt: Maybe<Scalars['DateTime']>
  discountPolicyIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  endsAt: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  offerRequestKeys: Maybe<Array<Maybe<Scalars['String']>>>
  regionIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
  retailerId: Maybe<Scalars['BigInt']>
  segmentId: Maybe<Scalars['String']>
  startsAt: Maybe<Scalars['DateTime']>
  status: Maybe<Scalars['String']>
  targeting: Maybe<Array<Maybe<Targeting>>>
  updatedAt: Maybe<Scalars['DateTime']>
  validForDays: Maybe<Scalars['BigInt']>
}

export type RetailerCampaignResponse = {
  __typename?: 'RetailerCampaignResponse'
  offers: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOffer>>>
  retailerCampaign: Maybe<RetailerCampaign>
}

export type RetailerCollection = {
  __typename?: 'RetailerCollection'
  contentType: Maybe<RetailerCollectionContentType>
  createdAt: Maybe<Scalars['DateTime']>
  defaultSortOrder: Maybe<RetailerCollectionSortOrder>
  endDate: Maybe<Scalars['DateTime']>
  extCollectionId: Maybe<Scalars['BigInt']>
  filters: Maybe<Array<Maybe<RetailerCollectionFilter>>>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  parentId: Maybe<Scalars['BigInt']>
  position: Maybe<Scalars['Int']>
  productCount: Maybe<Scalars['Int']>
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
  startDate: Maybe<Scalars['DateTime']>
  status: Maybe<RetailerCollectionStatus>
  storeConfigurations: Maybe<Array<Maybe<RetailerCollectionStoreConfiguration>>>
  surfaces: Maybe<Array<Maybe<RetailerCollectionSurface>>>
  tileImageUrl: Maybe<Scalars['String']>
  translations: Maybe<Array<Maybe<RetailerCollectionTranslation>>>
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum RetailerCollectionBulkUploadType {
  CollectionHeirarchy = 'COLLECTION_HEIRARCHY',
  EnumTypeBulkUploadUnspecified = 'ENUM_TYPE_BULK_UPLOAD_UNSPECIFIED',
  ProductAssignment = 'PRODUCT_ASSIGNMENT',
}

export enum RetailerCollectionContentType {
  Collections = 'COLLECTIONS',
  EnumTypeContentTypeUnspecified = 'ENUM_TYPE_CONTENT_TYPE_UNSPECIFIED',
  Products = 'PRODUCTS',
}

export type RetailerCollectionFilter = {
  __typename?: 'RetailerCollectionFilter'
  collectionId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  intersectionGroup: Maybe<Scalars['BigInt']>
  ruleId: Maybe<Scalars['BigInt']>
  value: Maybe<Scalars['String']>
}

export type RetailerCollectionFilterInput = {
  collectionId?: InputMaybe<Scalars['BigInt']>
  id?: InputMaybe<Scalars['BigInt']>
  intersectionGroup?: InputMaybe<Scalars['BigInt']>
  ruleId?: InputMaybe<Scalars['BigInt']>
  value?: InputMaybe<Scalars['String']>
}

export type RetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
}

export type RetailerCollectionNavigationNode = {
  __typename?: 'RetailerCollectionNavigationNode'
  children: Maybe<Array<Maybe<RetailerCollectionNavigationNode>>>
  contentType: Maybe<RetailerCollectionNavigationNodeContentType>
  endDate: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  position: Maybe<Scalars['BigInt']>
  productCount: Maybe<Scalars['BigInt']>
  retailerCollectionId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  slug: Maybe<Scalars['String']>
  startDate: Maybe<Scalars['DateTime']>
  status: Maybe<RetailerCollectionStatus>
  storeConfigurationId: Maybe<Scalars['BigInt']>
  tileImageUrl: Maybe<Scalars['String']>
  translations: Maybe<Array<Maybe<RetailerCollectionNavigationNodeTranslation>>>
  updatedAt: Maybe<Scalars['DateTime']>
}

export enum RetailerCollectionNavigationNodeContentType {
  Collections = 'COLLECTIONS',
  Products = 'PRODUCTS',
  Root = 'ROOT',
  Unspecified = 'UNSPECIFIED',
}

export type RetailerCollectionNavigationNodeTranslation = {
  __typename?: 'RetailerCollectionNavigationNodeTranslation'
  localeCode: Maybe<InstacartCustomersSharedV1Locale>
  name: Maybe<Scalars['String']>
}

export type RetailerCollectionNavigationNodeTranslationInput = {
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  name?: InputMaybe<Scalars['String']>
}

export type RetailerCollectionProduct = {
  __typename?: 'RetailerCollectionProduct'
  cachedProductId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  lookupCode: Maybe<Scalars['String']>
}

export type RetailerCollectionProductPayloadInput = {
  id?: InputMaybe<Scalars['BigInt']>
  lookupCode?: InputMaybe<Scalars['String']>
  rrc?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
}

export type RetailerCollectionRule = {
  __typename?: 'RetailerCollectionRule'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  slug: Maybe<Scalars['String']>
  valueSource: Maybe<RetailerCollectionRuleValueSource>
  valueType: Maybe<RetailerCollectionRuleValueType>
}

export type RetailerCollectionRuleStaticOption = {
  __typename?: 'RetailerCollectionRuleStaticOption'
  label: Maybe<Scalars['String']>
  value: Maybe<Scalars['String']>
}

export enum RetailerCollectionRuleSupportedQuery {
  BrandNames = 'BRAND_NAMES',
  EnumTypeRuleValueSourceQueryUnspecified = 'ENUM_TYPE_RULE_VALUE_SOURCE_QUERY_UNSPECIFIED',
  TaxonomyNodes = 'TAXONOMY_NODES',
}

export type RetailerCollectionRuleValueSource = {
  __typename?: 'RetailerCollectionRuleValueSource'
  options: Maybe<Array<Maybe<RetailerCollectionRuleStaticOption>>>
  query: Maybe<RetailerCollectionRuleSupportedQuery>
  type: Maybe<RetailerCollectionRuleValueSourceType>
}

export enum RetailerCollectionRuleValueSourceType {
  EnumTypeRuleValueSourceTypeUnspecified = 'ENUM_TYPE_RULE_VALUE_SOURCE_TYPE_UNSPECIFIED',
  Query = 'QUERY',
  Static = 'STATIC',
}

export enum RetailerCollectionRuleValueType {
  Boolean = 'BOOLEAN',
  EnumTypeRuleValueTypeUnspecified = 'ENUM_TYPE_RULE_VALUE_TYPE_UNSPECIFIED',
  IntegerMultiselect = 'INTEGER_MULTISELECT',
  IntegerSelect = 'INTEGER_SELECT',
  StringMultiselect = 'STRING_MULTISELECT',
  StringSelect = 'STRING_SELECT',
  Text = 'TEXT',
}

export enum RetailerCollectionSortOrder {
  BestMatch = 'BEST_MATCH',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnumTypeSortOrderUnspecified = 'ENUM_TYPE_SORT_ORDER_UNSPECIFIED',
  Popularity = 'POPULARITY',
}

export enum RetailerCollectionStatus {
  Active = 'ACTIVE',
  ActiveAdminOnly = 'ACTIVE_ADMIN_ONLY',
  EnumTypeStatusUnspecified = 'ENUM_TYPE_STATUS_UNSPECIFIED',
  Inactive = 'INACTIVE',
}

export type RetailerCollectionStoreConfiguration = {
  __typename?: 'RetailerCollectionStoreConfiguration'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
  pinned: Maybe<Scalars['Boolean']>
  slug: Maybe<Scalars['String']>
  surface: Maybe<RetailerCollectionSurface>
  url: Maybe<Scalars['String']>
}

export type RetailerCollectionStoreConfigurationConfig = {
  __typename?: 'RetailerCollectionStoreConfigurationConfig'
  maxActiveTopLevelCollections: Maybe<Scalars['BigInt']>
  numActiveTopLevelCollections: Maybe<Scalars['BigInt']>
  storeConfigurationId: Maybe<Scalars['BigInt']>
}

export type RetailerCollectionStoreConfigurationInput = {
  id?: InputMaybe<Scalars['BigInt']>
  name?: InputMaybe<Scalars['String']>
  pinned?: InputMaybe<Scalars['Boolean']>
  slug?: InputMaybe<Scalars['String']>
  surface?: InputMaybe<RetailerCollectionSurface>
  url?: InputMaybe<Scalars['String']>
}

export enum RetailerCollectionSurface {
  EnumTypeSurfaceUnspecified = 'ENUM_TYPE_SURFACE_UNSPECIFIED',
  Marketplace = 'MARKETPLACE',
  Storefront = 'STOREFRONT',
  StorefrontPro = 'STOREFRONT_PRO',
}

export type RetailerCollectionTranslation = {
  __typename?: 'RetailerCollectionTranslation'
  localeCode: Maybe<InstacartCustomersSharedV1Locale>
  name: Maybe<Scalars['String']>
}

export type RetailerCollectionTranslationInput = {
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  name?: InputMaybe<Scalars['String']>
}

export type RetailerCollectionTreeNode = {
  __typename?: 'RetailerCollectionTreeNode'
  children: Maybe<Array<Maybe<RetailerCollectionTreeNode>>>
  contentType: Maybe<RetailerCollectionContentType>
  endDate: Maybe<Scalars['DateTime']>
  id: Maybe<Scalars['BigInt']>
  isInventoryFileEnrolled: Maybe<Scalars['Boolean']>
  name: Maybe<Scalars['String']>
  position: Maybe<Scalars['Int']>
  startDate: Maybe<Scalars['DateTime']>
  status: Maybe<RetailerCollectionStatus>
}

export type RetailerCollectionsCsvError = {
  __typename?: 'RetailerCollectionsCsvError'
  errorMessage: Maybe<Scalars['String']>
  identifiers: Maybe<Array<Maybe<Scalars['String']>>>
}

export type RetailerCollectionsCsvSummary = {
  __typename?: 'RetailerCollectionsCsvSummary'
  collectionCount: Maybe<Scalars['Int']>
  identifiers: Maybe<Array<Maybe<Scalars['String']>>>
  productCount: Maybe<Scalars['Int']>
  summaryType: Maybe<RetailerCollectionsCsvSummarySectionType>
}

export enum RetailerCollectionsCsvSummarySectionType {
  EnumTypeCsvSummaryUnspecified = 'ENUM_TYPE_CSV_SUMMARY_UNSPECIFIED',
  New = 'NEW',
  NewL1 = 'NEW_L1',
  NewL2 = 'NEW_L2',
  NewL3 = 'NEW_L3',
  NewL4 = 'NEW_L4',
  NewL5 = 'NEW_L5',
  NoChange = 'NO_CHANGE',
  Remove = 'REMOVE',
  Unmatched = 'UNMATCHED',
}

export type RetailerConfig = {
  __typename?: 'RetailerConfig'
  maxActiveTopLevelCollections: Maybe<Scalars['Int']>
  maxActiveTopLevelStorefrontCollections: Maybe<Scalars['Int']>
  maxActiveTopLevelStorefrontProCollections: Maybe<Scalars['Int']>
}

export type RetailerConfigInput = {
  maxActiveTopLevelCollections?: InputMaybe<Scalars['Int']>
  maxActiveTopLevelStorefrontCollections?: InputMaybe<Scalars['Int']>
  maxActiveTopLevelStorefrontProCollections?: InputMaybe<Scalars['Int']>
}

/** The connection type for Retailer. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Retailer>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RetailerContainerPath = {
  __typename?: 'RetailerContainerPath'
  containerPath: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['BigInt']>
}

export type RetailerContainerPathInput = {
  containerPath?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<Retailer>
}

export type RetailerLocale = {
  __typename?: 'RetailerLocale'
  localeCode: Maybe<Scalars['String']>
  localeId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
}

export type RetailerLocation = {
  __typename?: 'RetailerLocation'
  /** The active status for the location */
  active: Scalars['Boolean']
  /** The location's city */
  city: Maybe<Scalars['String']>
  /** Represents the set of 'Fullfillment Models' (how fulfillment is facilitated for the location) */
  fulfillmentModels: Maybe<Array<FulfillmentModelEnum>>
  /** Hybrid Picking setting for the location indicates combined ISS and Partner Pick */
  hybridPickingEnabled: Maybe<Scalars['Boolean']>
  /** A unique identifier for the retailer location */
  id: Scalars['ID']
  /** The retailer-assigned location code */
  locationCode: Maybe<Scalars['String']>
  /** The name of the retailer location */
  name: Maybe<Scalars['String']>
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean']
  /** Represents the 'Picking Model' (how picking is facilitated for the location) */
  pickingModel: Maybe<PickingModelEnum>
  /** A flag representing whether pickup is enabled */
  pickup: Scalars['Boolean']
  /** Identifies if the location does platform only deliveries */
  platformOnlyEnabled: Maybe<Scalars['Boolean']>
  /** The retailer that this location belongs to */
  retailer: Retailer
  /** The location's state */
  state: Maybe<Scalars['String']>
  /** The location's street (including street #) */
  street: Maybe<Scalars['String']>
  /** The location's zip code or postal code */
  zipCode: Maybe<Scalars['String']>
  /** The location's ZIP+4 (US-specific) */
  zipPlusFour: Maybe<Scalars['String']>
}

export type RetailerLocationAisle = {
  __typename?: 'RetailerLocationAisle'
  aisleCount: Maybe<Scalars['BigInt']>
  retailerLocationId: Maybe<Scalars['BigInt']>
  retailerLocationName: Maybe<Scalars['String']>
}

/** The connection type for RetailerLocation. */
export type RetailerLocationConnection = {
  __typename?: 'RetailerLocationConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailerLocationEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailerLocation>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RetailerLocationDetails = {
  __typename?: 'RetailerLocationDetails'
  address: Maybe<Scalars['String']>
  city: Maybe<Scalars['String']>
  coordinates: Maybe<GoogleTypeLatLng>
  flags: Maybe<RetailerLocationFlags>
  id: Maybe<Scalars['Int']>
  inventoryAreaId: Maybe<Scalars['Int']>
  locationCode: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  postalCode: Maybe<Scalars['String']>
  retailerId: Maybe<Scalars['Int']>
  state: Maybe<Scalars['String']>
}

/** An edge in a connection. */
export type RetailerLocationEdge = {
  __typename?: 'RetailerLocationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailerLocation>
}

export type RetailerLocationFlags = {
  __typename?: 'RetailerLocationFlags'
  active: Maybe<Scalars['Boolean']>
  alcohol: Maybe<Scalars['Boolean']>
  available: Maybe<Scalars['Boolean']>
  closed: Maybe<Scalars['Boolean']>
  curbsidePickup: Maybe<Scalars['Boolean']>
  pickup: Maybe<Scalars['Boolean']>
  pickupOnly: Maybe<Scalars['Boolean']>
  rx: Maybe<Scalars['Boolean']>
  serviceable: Maybe<Scalars['Boolean']>
  unavailable: Maybe<Scalars['Boolean']>
}

/** Autogenerated return type of RetailerLocationGroupCreate */
export type RetailerLocationGroupCreatePayload = {
  __typename?: 'RetailerLocationGroupCreatePayload'
  /** The newly created group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

/** Autogenerated return type of RetailerLocationGroupDelete */
export type RetailerLocationGroupDeletePayload = {
  __typename?: 'RetailerLocationGroupDeletePayload'
  /** A status which is true if no errors were encountered */
  success: Scalars['True']
}

/** Autogenerated return type of RetailerLocationGroupUpdate */
export type RetailerLocationGroupUpdatePayload = {
  __typename?: 'RetailerLocationGroupUpdatePayload'
  /** The updated group */
  retailerLocationGroup: RetailersRetailerLocationGroup
}

export type RetailerLocationInfo = {
  __typename?: 'RetailerLocationInfo'
  name: Maybe<Scalars['String']>
  retailerName: Maybe<Scalars['String']>
  street: Maybe<Scalars['String']>
}

/** Attributes for a retailer location filter */
export type RetailerLocations = {
  /** A retailer location group ID */
  retailerLocationGroupId?: InputMaybe<Scalars['ID']>
  /** A list of retailer location IDs */
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>
}

export type RetailerProduct = {
  __typename?: 'RetailerProduct'
  aisleName: Maybe<Scalars['String']>
  aisles: Maybe<Array<Maybe<RetailerProductAisle>>>
  alcoholic: Maybe<Scalars['Boolean']>
  atkinsDiet: Maybe<Scalars['Boolean']>
  bottle: Maybe<Scalars['Boolean']>
  brandId: Maybe<Scalars['BigInt']>
  brandName: Maybe<Scalars['String']>
  calories: Maybe<Scalars['Float']>
  carbFree: Maybe<Scalars['Boolean']>
  carbohydrate: Maybe<Scalars['Float']>
  cchGroupCode: Maybe<Scalars['String']>
  cchItemCode: Maybe<Scalars['String']>
  coldPrepared: Maybe<Scalars['Boolean']>
  containsFlour: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  dairyFree: Maybe<Scalars['Boolean']>
  departments: Maybe<Array<Maybe<RetailerProductDepartment>>>
  description: Maybe<Scalars['String']>
  details: Maybe<Scalars['String']>
  directions: Maybe<Scalars['String']>
  fatFree: Maybe<Scalars['Boolean']>
  glutenFree: Maybe<Scalars['Boolean']>
  hasImage: Maybe<Scalars['Boolean']>
  highCarb: Maybe<Scalars['Boolean']>
  highFat: Maybe<Scalars['Boolean']>
  highProtein: Maybe<Scalars['Boolean']>
  imageList: Maybe<Array<Maybe<RetailerProductImageInfo>>>
  ingredients: Maybe<Scalars['String']>
  isOrganic: Maybe<Scalars['Boolean']>
  ketoDiet: Maybe<Scalars['Boolean']>
  kidFriendly: Maybe<Scalars['Boolean']>
  kosher: Maybe<Scalars['Boolean']>
  lactoseFree: Maybe<Scalars['Boolean']>
  localeCode: Maybe<Scalars['String']>
  lowCarb: Maybe<Scalars['Boolean']>
  lowFat: Maybe<Scalars['Boolean']>
  lowSodium: Maybe<Scalars['Boolean']>
  lowSugar: Maybe<Scalars['Boolean']>
  name: Maybe<Scalars['String']>
  organic: Maybe<Scalars['Boolean']>
  originalName: Maybe<Scalars['String']>
  paleoDiet: Maybe<Scalars['Boolean']>
  prepSlicedRepackagedPasteurizedByRetailer: Maybe<Scalars['Boolean']>
  primaryAisleId: Maybe<Scalars['BigInt']>
  primaryDepartmentId: Maybe<Scalars['BigInt']>
  primaryImageUrl: Maybe<Scalars['String']>
  productCategory: Maybe<Scalars['String']>
  productCategoryTaxonomy: Maybe<RetailerProductProductCategoryTaxonomy>
  productCodes: Maybe<Array<Maybe<Scalars['String']>>>
  productDisplayName: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  productTags: Maybe<Scalars['String']>
  prop65Text: Maybe<Scalars['String']>
  requireReheating: Maybe<Scalars['Boolean']>
  requiresKeepFrozen: Maybe<Scalars['Boolean']>
  requiresRefrigeration: Maybe<Scalars['Boolean']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerReferenceCode: Maybe<Scalars['String']>
  score: Maybe<Scalars['Float']>
  seasonality: Maybe<Scalars['JSONObject']>
  size: Maybe<Scalars['String']>
  sizeUom: Maybe<Scalars['String']>
  storeBrand: Maybe<Scalars['Boolean']>
  sugarFree: Maybe<Scalars['Boolean']>
  suggestedIncrementalWeight: Maybe<Scalars['Float']>
  unitCount: Maybe<Scalars['BigInt']>
  vegan: Maybe<Scalars['Boolean']>
  vegetarian: Maybe<Scalars['Boolean']>
  vertexTaxOverrideAttribute: Maybe<Scalars['String']>
  weightWatchers: Maybe<Scalars['Boolean']>
  wholeGrain: Maybe<Scalars['Boolean']>
}

export type RetailerProductAisle = {
  __typename?: 'RetailerProductAisle'
  departmentId: Maybe<Scalars['BigInt']>
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
}

export type RetailerProductData = {
  __typename?: 'RetailerProductData'
  availableItemsCount: Maybe<Scalars['BigInt']>
  generatedAt: Maybe<Scalars['DateTime']>
  itemsCount: Maybe<Scalars['BigInt']>
  maxPriceCents: Maybe<Scalars['BigInt']>
  minPriceCents: Maybe<Scalars['BigInt']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  visibleItemsCount: Maybe<Scalars['BigInt']>
}

export type RetailerProductDepartment = {
  __typename?: 'RetailerProductDepartment'
  id: Maybe<Scalars['BigInt']>
  name: Maybe<Scalars['String']>
}

export type RetailerProductId = {
  __typename?: 'RetailerProductId'
  locale: Maybe<Scalars['String']>
  productId: Maybe<Scalars['BigInt']>
  retailerId: Maybe<Scalars['BigInt']>
  retailerProductId: Maybe<Scalars['BigInt']>
}

export type RetailerProductIdInput = {
  locale?: InputMaybe<Scalars['String']>
  productId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerProductId?: InputMaybe<Scalars['BigInt']>
}

export type RetailerProductImageInfo = {
  __typename?: 'RetailerProductImageInfo'
  imageId: Maybe<Scalars['String']>
  imageType: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  sourceType: Maybe<Scalars['String']>
}

export type RetailerProductProductCategoryTaxonomy = {
  __typename?: 'RetailerProductProductCategoryTaxonomy'
  l1: Maybe<Scalars['String']>
  l2: Maybe<Scalars['String']>
  l3: Maybe<Scalars['String']>
  l4: Maybe<Scalars['String']>
  l5: Maybe<Scalars['String']>
  l6: Maybe<Scalars['String']>
}

export enum RetailerServiceType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  ServiceTypeUndefined = 'SERVICE_TYPE_UNDEFINED',
}

export type RetailersPickupRetailerLocationGroup = {
  __typename?: 'RetailersPickupRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The retailer locations associated with the group */
  retailerLocations: Array<RetailerLocation>
}

export type RetailersRetailerLocationGroup = {
  __typename?: 'RetailersRetailerLocationGroup'
  /** A unique identifier for the location group */
  id: Scalars['ID']
  /** A name for this location group */
  name: Scalars['String']
  /** The identifier for the retailer which all locations in the group belong to */
  retailerId: Scalars['ID']
  /** The ids for the retailer locations associated with the group */
  retailerLocationIds: Array<Scalars['ID']>
  /** The retailer locations associated with the group */
  retailerLocations: RetailerLocationConnection
  /** The time at which the group was last updated */
  updatedAt: Scalars['Time']
}

export type RetailersRetailerLocationGroupRetailerLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

/** The connection type for RetailersRetailerLocationGroup. */
export type RetailersRetailerLocationGroupConnection = {
  __typename?: 'RetailersRetailerLocationGroupConnection'
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RetailersRetailerLocationGroupEdge>>>
  /** Metadata regarding the connection */
  meta: ConnectionMeta
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<RetailersRetailerLocationGroup>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RetailersRetailerLocationGroupEdge = {
  __typename?: 'RetailersRetailerLocationGroupEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: Maybe<RetailersRetailerLocationGroup>
}

/** Autogenerated return type of RoleCreate */
export type RoleCreatePayload = {
  __typename?: 'RoleCreatePayload'
  /** The created role object */
  role: EnterpriseRole
}

/** Autogenerated return type of RoleDelete */
export type RoleDeletePayload = {
  __typename?: 'RoleDeletePayload'
  /** The delete role object */
  role: EnterpriseRole
}

export type RoleInput = {
  /** A unique identifier for the role */
  id: Scalars['ID']
}

/** Autogenerated return type of RoleUpdate */
export type RoleUpdatePayload = {
  __typename?: 'RoleUpdatePayload'
  /** The update role object */
  role: EnterpriseRole
}

export type RollbackStoreConfigurationRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type RollbackStoreConfigurationResponse = {
  __typename?: 'RollbackStoreConfigurationResponse'
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
}

export type SecondaryBanner = {
  __typename?: 'SecondaryBanner'
  backgroundColorHex: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  mobileImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  secondaryText: Maybe<Scalars['String']>
  secondaryTextColorHex: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type SecondaryBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  desktopImageUrl?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  mobileImageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  secondaryText?: InputMaybe<Scalars['String']>
  secondaryTextColorHex?: InputMaybe<Scalars['String']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

/** Autogenerated return type of SecondaryBannerPlacementCreate */
export type SecondaryBannerPlacementCreatePayload = {
  __typename?: 'SecondaryBannerPlacementCreatePayload'
  /** The newly created secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export type SecondaryBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>
  enabled?: InputMaybe<Scalars['Boolean']>
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** The images on the banner */
  images: GenericImagesInput
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the secondary text */
  secondaryText?: InputMaybe<ConfigurableTextInput>
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The type of this placement */
  type: PlacementTypeEnum
}

/** Autogenerated return type of SecondaryBannerPlacementUpdate */
export type SecondaryBannerPlacementUpdatePayload = {
  __typename?: 'SecondaryBannerPlacementUpdatePayload'
  /** The updated secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement
}

export type SellSheetAnalyticsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  sellSheetId?: InputMaybe<Scalars['String']>
}

export type SellSheetAnalyticsResponse = {
  __typename?: 'SellSheetAnalyticsResponse'
  analytics: Maybe<Analytics>
}

export type SellSheetAnalyticsSummary = {
  __typename?: 'SellSheetAnalyticsSummary'
  sellSheetId: Maybe<Scalars['String']>
  totalSalesUsd: Maybe<Scalars['Float']>
}

export type SellSheetAnalyticsSummaryRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>
  sellSheetId?: InputMaybe<Scalars['String']>
}

export type SellSheetAnalyticsSummaryResponse = {
  __typename?: 'SellSheetAnalyticsSummaryResponse'
  analyticsSummary: Maybe<SellSheetAnalyticsSummary>
}

export type SellSheetAttributes = {
  __typename?: 'SellSheetAttributes'
  id: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  overview: Maybe<Scalars['String']>
}

export type SellSheetAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>
}

export type SellSheetAttributesResponse = {
  __typename?: 'SellSheetAttributesResponse'
  sellSheetAttributes: Maybe<SellSheetAttributes>
}

export type SellSheetBrandProfileAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>
}

export type SellSheetBrandProfileAttributesResponse = {
  __typename?: 'SellSheetBrandProfileAttributesResponse'
  brandProfileAttributes: Maybe<BrandProfileAttributes>
}

export type SellSheetCard = {
  __typename?: 'SellSheetCard'
  productDisplays: Maybe<Array<Maybe<ProductDisplay>>>
  sellSheetAnalyticsSummary: Maybe<SellSheetAnalyticsSummary>
  sellSheetAttributes: Maybe<SellSheetAttributes>
}

export type SellSheetProductsAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>
}

export type SellSheetProductsAttributesResponse = {
  __typename?: 'SellSheetProductsAttributesResponse'
  productsAttributes: Maybe<Array<Maybe<ProductAttributes>>>
}

export type SetCollectionFiltersRequestInput = {
  collectionId?: InputMaybe<Scalars['BigInt']>
  filters?: InputMaybe<Array<InputMaybe<RetailerCollectionFilterInput>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type SetCollectionFiltersResponse = {
  __typename?: 'SetCollectionFiltersResponse'
  filters: Maybe<Array<Maybe<RetailerCollectionFilter>>>
}

export type SetUserSettingRequestInput = {
  client?: InputMaybe<ClientInput>
  setting?: InputMaybe<UserSettingInput>
}

export type SetUserSettingResponse = {
  __typename?: 'SetUserSettingResponse'
  _: Maybe<Scalars['Boolean']>
}

export enum ShiftTypeEnum {
  FullService = 'FULL_SERVICE',
  PickingOnly = 'PICKING_ONLY',
  Runner = 'RUNNER',
}

export type ShoppedAtRetailerInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the Retailer */
  retailerId: Scalars['Int']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionCreate */
export type ShoppedAtRetailerVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionCreatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionUpdate */
export type ShoppedAtRetailerVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionUpdatePayload'
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer
}

export type ShoppedInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean']
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>
  /** Number of times in the past to check */
  numberOfTimes?: InputMaybe<Scalars['Int']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>
}

/** Autogenerated return type of ShoppedVisibilityConditionCreate */
export type ShoppedVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedVisibilityConditionCreatePayload'
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped
}

/** Autogenerated return type of ShoppedVisibilityConditionUpdate */
export type ShoppedVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedVisibilityConditionUpdatePayload'
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped
}

export type ShopperOrderItemScanInput = {
  scannedString?: InputMaybe<Scalars['String']>
  scannedStringType?: InputMaybe<Scalars['String']>
}

export type ShopperOrderProfile = {
  __typename?: 'ShopperOrderProfile'
  avatarUrl: Maybe<Scalars['String']>
  batchId: Maybe<Scalars['BigInt']>
  canChat: Maybe<Scalars['Boolean']>
  canReceiveTips: Maybe<Scalars['Boolean']>
  canTakeAlcoholOrders: Maybe<Scalars['Boolean']>
  deliverer: Maybe<Scalars['Boolean']>
  displayName: Maybe<Scalars['String']>
  email: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  lastName: Maybe<Scalars['String']>
  partnerId: Maybe<Scalars['BigInt']>
  partnerType: Maybe<Scalars['String']>
  phone: Maybe<Scalars['String']>
  picker: Maybe<Scalars['Boolean']>
  primaryZoneId: Maybe<Scalars['BigInt']>
  retailerLocationId: Maybe<Scalars['BigInt']>
  rolesMask: Maybe<Scalars['Int']>
  runner: Maybe<Scalars['Boolean']>
  shareCode: Maybe<Scalars['String']>
  signatureUrl: Maybe<Scalars['String']>
  userId: Maybe<Scalars['BigInt']>
}

export enum ShopperType {
  ShopperTypeFss = 'SHOPPER_TYPE_FSS',
  ShopperTypePartnerPick = 'SHOPPER_TYPE_PARTNER_PICK',
  ShopperTypeUnknown = 'SHOPPER_TYPE_UNKNOWN',
}

export type SignupPartner = {
  __typename?: 'SignupPartner'
  description: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  logo: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
}

export type SnowflakeTopProductsItem = {
  __typename?: 'SnowflakeTopProductsItem'
  /** Availability of the product, denoted as percentage */
  availabilityPercentage: Scalars['Float']
  /** Name of the department the product belongs to */
  department: Scalars['String']
  /** How often an item was found, denoted as percentage */
  foundRatePercentage: Scalars['Float']
  /** Total GMV for the product */
  gmv: Scalars['Float']
  /** Unique identifier */
  id: Scalars['ID']
  /** The image url for the product */
  imageUrl: Scalars['String']
  /** Total number of items this ordered for this product */
  orderedItems: Scalars['Int']
  /** The product's name */
  productName: Scalars['String']
  /** How often an item was refunded, denoted as percentage */
  refundRatePercentage: Scalars['Float']
}

export type SnowflakeTopProductsResult = {
  __typename?: 'SnowflakeTopProductsResult'
  /** A list of top items */
  topProducts: Array<SnowflakeTopProductsItem>
  /** Total number of results */
  totalCount: Scalars['Int']
}

export enum SourceLevel {
  SourceLevelMulti = 'SOURCE_LEVEL_MULTI',
  SourceLevelProduct = 'SOURCE_LEVEL_PRODUCT',
  SourceLevelRetailerProduct = 'SOURCE_LEVEL_RETAILER_PRODUCT',
  SourceLevelUnknown = 'SOURCE_LEVEL_UNKNOWN',
}

export type StageLastmileOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>
  orderId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>
  userId?: InputMaybe<Scalars['BigInt']>
}

export type StageLastmileOrderResponse = {
  __typename?: 'StageLastmileOrderResponse'
  order: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>
}

export type StandardInfoModalSheet = {
  __typename?: 'StandardInfoModalSheet'
  description: Maybe<Scalars['String']>
  desktopImageUrl: Maybe<Scalars['String']>
  disclaimer: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imageAltText: Maybe<Scalars['String']>
  linkCta: Maybe<Scalars['String']>
  linkCtaAction: Maybe<BannerAction>
  linkCtaButtonStyle: Maybe<ButtonStyle>
  locale: Maybe<Scalars['String']>
  mobileImageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  primaryCta: Maybe<Scalars['String']>
  primaryCtaAction: Maybe<BannerAction>
  primaryCtaButtonStyle: Maybe<ButtonStyle>
  secondaryCta: Maybe<Scalars['String']>
  secondaryCtaAction: Maybe<BannerAction>
  secondaryCtaButtonStyle: Maybe<ButtonStyle>
  title: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type StandardInfoModalSheetInput = {
  description?: InputMaybe<Scalars['String']>
  desktopImageUrl?: InputMaybe<Scalars['String']>
  disclaimer?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  imageAltText?: InputMaybe<Scalars['String']>
  linkCta?: InputMaybe<Scalars['String']>
  linkCtaAction?: InputMaybe<BannerActionInput>
  linkCtaButtonStyle?: InputMaybe<ButtonStyle>
  locale?: InputMaybe<Scalars['String']>
  mobileImageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  primaryCta?: InputMaybe<Scalars['String']>
  primaryCtaAction?: InputMaybe<BannerActionInput>
  primaryCtaButtonStyle?: InputMaybe<ButtonStyle>
  secondaryCta?: InputMaybe<Scalars['String']>
  secondaryCtaAction?: InputMaybe<BannerActionInput>
  secondaryCtaButtonStyle?: InputMaybe<ButtonStyle>
  title?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export enum Status {
  Active = 'ACTIVE',
  /** The tour has been finished by the user */
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
  Live = 'LIVE',
  /** The tour has not been seen by the user */
  Pending = 'PENDING',
  /** The tour has been displayed to the user, but not finished */
  Shown = 'SHOWN',
}

export type StoreConfiguration = {
  __typename?: 'StoreConfiguration'
  enterpriseRetailerSettings: Maybe<Scalars['JSONObject']>
  id: Maybe<Scalars['Int']>
  settings: Maybe<Scalars['JSONObject']>
  userIsolationContextId: Maybe<Scalars['Int']>
}

export type StoreConfigurationDraft = {
  __typename?: 'StoreConfigurationDraft'
  createdAt: Maybe<Scalars['DateTime']>
  domainConfigurations: Maybe<DomainConfiguration>
  draftId: Maybe<Scalars['String']>
  draftName: Maybe<Scalars['String']>
  parentDraftId: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type StoreConfigurationInput = {
  enterpriseRetailerSettings?: InputMaybe<Scalars['JSONObject']>
  id?: InputMaybe<Scalars['Int']>
  settings?: InputMaybe<Scalars['JSONObject']>
  userIsolationContextId?: InputMaybe<Scalars['Int']>
}

export enum StoreConfigurationRelationshipEnum {
  /** StoreConfigurations that are associated */
  Associated = 'ASSOCIATED',
  /** StoreConfigurations that are owned */
  Owner = 'OWNER',
}

export type StoreHours = {
  __typename?: 'StoreHours'
  overrideHours: Maybe<Array<Maybe<OverrideHours>>>
  regularHours: Maybe<Array<Maybe<RegularHours>>>
  retailerLocationId: Maybe<Scalars['BigInt']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type StoreHoursByDate = {
  __typename?: 'StoreHoursByDate'
  createdAt: Maybe<Scalars['DateTime']>
  date: Maybe<GoogleTypeDate>
  endsAt: Maybe<GoogleTypeTimeOfDay>
  operationalHours: Maybe<OperationalHours>
  retailerId: Maybe<Scalars['BigInt']>
  retailerLocationFlags: Maybe<RetailerLocationFlags>
  retailerLocationId: Maybe<Scalars['BigInt']>
  startsAt: Maybe<GoogleTypeTimeOfDay>
  updatedAt: Maybe<Scalars['DateTime']>
  zoneId: Maybe<Scalars['BigInt']>
}

export type StoreHoursByDayOfWeek = {
  __typename?: 'StoreHoursByDayOfWeek'
  createdAt: Maybe<Scalars['DateTime']>
  dayOfWeek: Maybe<GoogleTypeDayOfWeek>
  endsAt: Maybe<GoogleTypeTimeOfDay>
  operationalHours: Maybe<OperationalHours>
  retailerId: Maybe<Scalars['BigInt']>
  retailerLocationFlags: Maybe<RetailerLocationFlags>
  retailerLocationId: Maybe<Scalars['BigInt']>
  startsAt: Maybe<GoogleTypeTimeOfDay>
  updatedAt: Maybe<Scalars['DateTime']>
  zoneId: Maybe<Scalars['BigInt']>
}

export type StoreHoursByZoneRetailer = {
  __typename?: 'StoreHoursByZoneRetailer'
  createdAt: Maybe<Scalars['DateTime']>
  date: Maybe<GoogleTypeDate>
  endsAt: Maybe<GoogleTypeTimeOfDay>
  retailerId: Maybe<Scalars['BigInt']>
  startsAt: Maybe<GoogleTypeTimeOfDay>
  updatedAt: Maybe<Scalars['DateTime']>
  zoneId: Maybe<Scalars['BigInt']>
}

export type StoreHoursUpdateTask = {
  __typename?: 'StoreHoursUpdateTask'
  author: Maybe<Scalars['String']>
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Maybe<Scalars['DateTime']>
  failedUpdates: Maybe<Array<Maybe<FailedUpdate>>>
  id: Maybe<Scalars['BigInt']>
  status: Maybe<TaskStatus>
  updateSource: Maybe<Scalars['String']>
  updatedRetailerLocationIds: Maybe<Array<Maybe<Scalars['BigInt']>>>
}

export type StorePerformanceRecord = {
  __typename?: 'StorePerformanceRecord'
  name: Maybe<Scalars['String']>
  overstaffedHours: Maybe<InstacartTypesV1BigDecimal>
  recommendedHours: Maybe<InstacartTypesV1BigDecimal>
  scheduledDevices: Maybe<Scalars['Int']>
  scheduledGaps: Maybe<Scalars['Int']>
  scheduledHours: Maybe<InstacartTypesV1BigDecimal>
  understaffedHours: Maybe<InstacartTypesV1BigDecimal>
  warehouseLocationId: Maybe<Scalars['BigInt']>
}

export type StorePerformanceRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>
  startDate?: InputMaybe<GoogleTypeDateInput>
  warehouseId?: InputMaybe<Scalars['BigInt']>
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
}

export type StorePerformanceResponse = {
  __typename?: 'StorePerformanceResponse'
  metric: Maybe<Array<Maybe<StorePerformanceRecord>>>
  updatedAt: Maybe<Scalars['DateTime']>
  warehouseId: Maybe<Scalars['BigInt']>
}

export type StorefrontPlacementBannerInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** A unique identifier of the banner associated with the placement */
  id?: InputMaybe<Scalars['ID']>
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** The banner's locale (not used right now) */
  locale: BannerLocaleEnum
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
}

/** Autogenerated return type of StorefrontPlacementCreate */
export type StorefrontPlacementCreatePayload = {
  __typename?: 'StorefrontPlacementCreatePayload'
  /** The newly created storefront storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

/** Autogenerated return type of StorefrontPlacementDelete */
export type StorefrontPlacementDeletePayload = {
  __typename?: 'StorefrontPlacementDeletePayload'
  /** Whether deleting the storefront placement succeeded or not */
  success: Scalars['Boolean']
}

export type StorefrontPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String']
  /** The banners configured to the placement */
  banners?: InputMaybe<Array<StorefrontPlacementBannerInput>>
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>
  /** The style and text of the heading */
  headingText: ConfigurableTextInput
  /** the alt text for the placement images */
  imageAltText: Scalars['String']
  /** The possible placement images to display */
  images: PlacementImagesInput
  /** The name of the placement */
  name: Scalars['String']
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput
  /** The type of this placement */
  type: PlacementTypeEnum
}

/** Autogenerated return type of StorefrontPlacementUpdate */
export type StorefrontPlacementUpdatePayload = {
  __typename?: 'StorefrontPlacementUpdatePayload'
  /** The updated storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement
}

export type StringsInput = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

export type SummaryStatus = {
  __typename?: 'SummaryStatus'
  count: Maybe<Scalars['BigInt']>
  status: Maybe<Scalars['String']>
}

export enum Targeting {
  ActivatedCustomer = 'ACTIVATED_CUSTOMER',
  ChurnedCustomer = 'CHURNED_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  Unknown = 'UNKNOWN',
}

export enum TaskStatus {
  CompletedFailure = 'COMPLETED_FAILURE',
  CompletedSuccess = 'COMPLETED_SUCCESS',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  TaskStatusUndefined = 'TASK_STATUS_UNDEFINED',
}

export type TextWithThumbnail = {
  __typename?: 'TextWithThumbnail'
  backgroundColorHex: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type TextWithThumbnailFlex = {
  __typename?: 'TextWithThumbnailFlex'
  backgroundColorHex: Maybe<Scalars['String']>
  backgroundImageUrl: Maybe<Scalars['String']>
  cta: Maybe<Scalars['String']>
  ctaAction: Maybe<BannerAction>
  ctaBackgroundColorHex: Maybe<Scalars['String']>
  ctaColorHex: Maybe<Scalars['String']>
  id: Maybe<Scalars['BigInt']>
  imageUrl: Maybe<Scalars['String']>
  placementId: Maybe<Scalars['BigInt']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
  variant: Maybe<BannerVariant>
}

export type TextWithThumbnailFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  backgroundImageUrl?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  imageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type TextWithThumbnailInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  backgroundImageUrl?: InputMaybe<Scalars['String']>
  cta?: InputMaybe<Scalars['String']>
  ctaAction?: InputMaybe<BannerActionInput>
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>
  ctaColorHex?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['BigInt']>
  imageUrl?: InputMaybe<Scalars['String']>
  placementId?: InputMaybe<Scalars['BigInt']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
  variant?: InputMaybe<BannerVariant>
}

export type ThemePage = {
  __typename?: 'ThemePage'
  active: Maybe<Scalars['Boolean']>
  createdAt: Maybe<Scalars['DateTime']>
  deletedAt: Maybe<Scalars['DateTime']>
  headerSection: Maybe<ThemePageHeader>
  id: Maybe<Scalars['BigInt']>
  retailerPicker: Maybe<ThemePageRetailerPicker>
  searchBar: Maybe<ThemePageSearchBar>
  slug: Maybe<Scalars['String']>
  updatedAt: Maybe<Scalars['DateTime']>
}

export type ThemePageHeader = {
  __typename?: 'ThemePageHeader'
  backgroundColorHex: Maybe<Scalars['String']>
  disclaimerUrl: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
  imageAltText: Maybe<Scalars['String']>
  imageMobileUrl: Maybe<Scalars['String']>
  imageUrl: Maybe<Scalars['String']>
  subTitle: Maybe<Scalars['String']>
  subTitleColorHex: Maybe<Scalars['String']>
  title: Maybe<Scalars['String']>
  titleColorHex: Maybe<Scalars['String']>
}

export type ThemePageHeaderInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>
  disclaimerUrl?: InputMaybe<Scalars['String']>
  enabled?: InputMaybe<Scalars['Boolean']>
  imageAltText?: InputMaybe<Scalars['String']>
  imageMobileUrl?: InputMaybe<Scalars['String']>
  imageUrl?: InputMaybe<Scalars['String']>
  subTitle?: InputMaybe<Scalars['String']>
  subTitleColorHex?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  titleColorHex?: InputMaybe<Scalars['String']>
}

export type ThemePageInput = {
  active?: InputMaybe<Scalars['Boolean']>
  createdAt?: InputMaybe<Scalars['DateTime']>
  deletedAt?: InputMaybe<Scalars['DateTime']>
  headerSection?: InputMaybe<ThemePageHeaderInput>
  id?: InputMaybe<Scalars['BigInt']>
  retailerPicker?: InputMaybe<ThemePageRetailerPickerInput>
  searchBar?: InputMaybe<ThemePageSearchBarInput>
  slug?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['DateTime']>
}

export type ThemePageRetailerPicker = {
  __typename?: 'ThemePageRetailerPicker'
  enabled: Maybe<Scalars['Boolean']>
}

export type ThemePageRetailerPickerInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
}

export type ThemePageSearchBar = {
  __typename?: 'ThemePageSearchBar'
  enabled: Maybe<Scalars['Boolean']>
}

export type ThemePageSearchBarInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
}

export type ThemeSchema = {
  __typename?: 'ThemeSchema'
  idsTheme: Maybe<IdsThemeSchema>
  items: Maybe<ItemsSchema>
}

export enum TicketStatus {
  TicketStatusCompleted = 'TICKET_STATUS_COMPLETED',
  TicketStatusInProgress = 'TICKET_STATUS_IN_PROGRESS',
  TicketStatusUnknown = 'TICKET_STATUS_UNKNOWN',
  TicketStatusWontDo = 'TICKET_STATUS_WONT_DO',
}

export type TimePeriod = {
  __typename?: 'TimePeriod'
  closesAt: Maybe<Scalars['DateTime']>
  opensAt: Maybe<Scalars['DateTime']>
}

export enum TokenTypeEnum {
  /** Email Verification Token Type */
  EmailVerification = 'email_verification',
  /** Password Reset Token Type */
  PasswordReset = 'password_reset',
}

export type TokensValidation = {
  __typename?: 'TokensValidation'
  /** Whether the token is valid */
  valid: Scalars['Boolean']
}

export type TypographyFontSchema = {
  __typename?: 'TypographyFontSchema'
  fontFamily: Maybe<Scalars['String']>
  fontWeight: Maybe<Scalars['String']>
}

export type TypographySchema = {
  __typename?: 'TypographySchema'
  subtitleLarge: Maybe<TypographyFontSchema>
  subtitleMedium: Maybe<TypographyFontSchema>
  subtitleSmall: Maybe<TypographyFontSchema>
  titleLarge: Maybe<TypographyFontSchema>
  titleMedium: Maybe<TypographyFontSchema>
}

export type UnknownBanner = {
  __typename?: 'UnknownBanner'
  id: Maybe<Scalars['BigInt']>
}

export type UnknownBannerInput = {
  id?: InputMaybe<Scalars['BigInt']>
}

export type Upc = {
  __typename?: 'Upc'
  upc: Maybe<Scalars['String']>
}

export type UpcInput = {
  upc?: InputMaybe<Scalars['String']>
}

export type UpdateApiSettingRequestInput = {
  apiType?: InputMaybe<Scalars['String']>
  cron?: InputMaybe<Scalars['String']>
  enabled?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['BigInt']>
  integrationType?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateApiSettingResponse = {
  __typename?: 'UpdateApiSettingResponse'
  apiType: Maybe<Scalars['String']>
  cron: Maybe<Scalars['String']>
  enabled: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['BigInt']>
  integrationType: Maybe<Scalars['String']>
  partnerId: Maybe<Scalars['BigInt']>
}

export type UpdateAuditBatchRequestInput = {
  action?: InputMaybe<Scalars['String']>
  batchUuid?: InputMaybe<Scalars['String']>
  changeSampleSizeValue?: InputMaybe<Scalars['BigInt']>
  client?: InputMaybe<Scalars['String']>
  overrideDueDate?: InputMaybe<Scalars['DateTime']>
  version?: InputMaybe<Scalars['BigInt']>
}

export type UpdateAuditBatchResponse = {
  __typename?: 'UpdateAuditBatchResponse'
  completedAt: Maybe<Scalars['DateTime']>
  message: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
}

export type UpdateAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>
  extComment?: InputMaybe<Scalars['String']>
  intComment?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  taskComponents?: InputMaybe<Array<InputMaybe<UpdateAuditTaskRequestUpdateTaskComponentInput>>>
  taskUuid?: InputMaybe<Scalars['String']>
  version?: InputMaybe<Scalars['BigInt']>
}

export type UpdateAuditTaskRequestUpdateTaskComponentInput = {
  explicitAuditFailed?: InputMaybe<Scalars['Boolean']>
  extComment?: InputMaybe<Scalars['String']>
  intComment?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  suggestedValue?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

export type UpdateAuditTaskResponse = {
  __typename?: 'UpdateAuditTaskResponse'
  batchVersion: Maybe<Scalars['BigInt']>
  message: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
}

export type UpdateConfirmedStoreHoursRequestInput = {
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateConfirmedStoreHoursResponse = {
  __typename?: 'UpdateConfirmedStoreHoursResponse'
  confirmations: Maybe<Array<Maybe<ConfirmedStoreHours>>>
}

export type UpdateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>
  ignoreV1Settings?: InputMaybe<Scalars['Boolean']>
}

export type UpdateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'UpdateConnectRetailerCallbackConfigurationResponse'
  callbackConfiguration: Maybe<ConnectRetailerCallbackConfiguration>
  errorMessage: Maybe<Scalars['String']>
  success: Maybe<Scalars['Boolean']>
}

export type UpdateContentPageRequestV2Input = {
  activeVersionId?: InputMaybe<Scalars['BigInt']>
  authContext?: InputMaybe<AuthorizationContextInput>
  id?: InputMaybe<Scalars['BigInt']>
  internalName?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
}

export type UpdateContentPageResponseV2 = {
  __typename?: 'UpdateContentPageResponseV2'
  contentPage: Maybe<ContentPageV2>
}

export type UpdateInstacartCollectionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurations?: InputMaybe<Array<InputMaybe<RetailerCollectionStoreConfigurationInput>>>
}

export type UpdateInstacartCollectionResponse = {
  __typename?: 'UpdateInstacartCollectionResponse'
  instacartCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type UpdateLaunchOnboardingWarehouseInfoRequestInput = {
  allowAlcohol?: InputMaybe<Scalars['Boolean']>
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  certifiedDeliveryThreshold?: InputMaybe<Scalars['Float']>
  country?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  logo?: InputMaybe<Scalars['String']>
  merchantId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  pricingPolicy?: InputMaybe<Scalars['String']>
  pricingPolicyText?: InputMaybe<Scalars['String']>
  retailerType?: InputMaybe<Scalars['String']>
  token?: InputMaybe<Scalars['String']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateLaunchOnboardingWarehouseInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseInfoResponse'
  launchOnboarding: Maybe<LaunchOnboarding>
}

export type UpdateLaunchOnboardingWarehouseLocationInfoRequestInput = {
  address?: InputMaybe<LaunchOnboardingAddressInput>
  locationCode?: InputMaybe<Scalars['String']>
  merchantId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  partnerId?: InputMaybe<Scalars['BigInt']>
  token?: InputMaybe<Scalars['String']>
  warehouseId?: InputMaybe<Scalars['BigInt']>
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateLaunchOnboardingWarehouseLocationInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseLocationInfoResponse'
  launchOnboarding: Maybe<LaunchOnboarding>
}

export type UpdateLaunchOnboardingWorkflowStateRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>
  stateAction?: InputMaybe<LaunchOnboardingWorkflowStateAction>
  token?: InputMaybe<Scalars['String']>
}

export type UpdateLaunchOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateLaunchOnboardingWorkflowStateResponse'
  launchOnboarding: Maybe<LaunchOnboarding>
}

export type UpdateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateLayoutVariantResponse = {
  __typename?: 'UpdateLayoutVariantResponse'
  layoutVariant: Maybe<LayoutVariant>
}

export type UpdateNavigationRequestInput = {
  navigation?: InputMaybe<NavigationInput>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateNavigationResponse = {
  __typename?: 'UpdateNavigationResponse'
  navigation: Maybe<Navigation>
}

export type UpdateOnboardingBillingAddressRequestInput = {
  billingAddress?: InputMaybe<AddressInput>
  token?: InputMaybe<Scalars['String']>
}

export type UpdateOnboardingBillingAddressResponse = {
  __typename?: 'UpdateOnboardingBillingAddressResponse'
  onboarding: Maybe<Onboarding>
}

export type UpdateOnboardingRequestInput = {
  contactInfo?: InputMaybe<ContactInput>
  corporationType?: InputMaybe<Scalars['String']>
  duns?: InputMaybe<Scalars['String']>
  entityName?: InputMaybe<Scalars['String']>
  onboardingType?: InputMaybe<Scalars['String']>
  posSystemName?: InputMaybe<Scalars['String']>
  stateOfIncorporation?: InputMaybe<Scalars['String']>
  storeCount?: InputMaybe<Scalars['String']>
  token?: InputMaybe<Scalars['String']>
  w9Form?: InputMaybe<Scalars['String']>
  website?: InputMaybe<Scalars['String']>
}

export type UpdateOnboardingResponse = {
  __typename?: 'UpdateOnboardingResponse'
  onboarding: Maybe<Onboarding>
}

export type UpdateOnboardingWorkflowStateRequestInput = {
  ipAddress?: InputMaybe<Scalars['String']>
  stateAction?: InputMaybe<OnboardingWorkflowStateAction>
  token?: InputMaybe<Scalars['String']>
}

export type UpdateOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateOnboardingWorkflowStateResponse'
  onboarding: Maybe<Onboarding>
}

export type UpdateParkingSettingsRequestInput = {
  imageConfigs?: InputMaybe<Array<InputMaybe<ImageConfigInput>>>
  instruction?: InputMaybe<Scalars['String']>
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
  setDefault?: InputMaybe<Scalars['Boolean']>
  type?: InputMaybe<PickupType>
}

export type UpdateParkingSettingsResponse = {
  __typename?: 'UpdateParkingSettingsResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  imageConfigs: Maybe<Array<Maybe<ImageConfig>>>
  instruction: Maybe<Scalars['String']>
  retailerLocationConfig: Maybe<RetailerLocationInfo>
}

export type UpdatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>
  content?: InputMaybe<PlacementContentInput>
}

export type UpdatePlacementContentResponse = {
  __typename?: 'UpdatePlacementContentResponse'
  content: Maybe<PlacementContent>
}

export type UpdateRetailerAisleTemplateRequestInput = {
  aisleOrders?: InputMaybe<Array<InputMaybe<AisleOrderInput>>>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  shopperType?: InputMaybe<ShopperType>
}

export type UpdateRetailerAisleTemplateResponse = {
  __typename?: 'UpdateRetailerAisleTemplateResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  updated: Maybe<Scalars['Boolean']>
}

export type UpdateRetailerCampaignRequestInput = {
  campaignObjective?: InputMaybe<CampaignObjective>
  couponCount?: InputMaybe<Scalars['BigInt']>
  endsAt?: InputMaybe<Scalars['DateTime']>
  name?: InputMaybe<Scalars['String']>
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  startsAt?: InputMaybe<Scalars['DateTime']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>
}

export type UpdateRetailerCollectionInvfEnrollmentRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  isInventoryFileEnrolled?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateRetailerCollectionInvfEnrollmentResponse = {
  __typename?: 'UpdateRetailerCollectionInvfEnrollmentResponse'
  success: Maybe<Scalars['Boolean']>
}

export type UpdateRetailerCollectionPinnedStatusRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  pinned?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateRetailerCollectionPinnedStatusResponse = {
  __typename?: 'UpdateRetailerCollectionPinnedStatusResponse'
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type UpdateRetailerCollectionRequestInput = {
  contentType?: InputMaybe<RetailerCollectionContentType>
  defaultSortOrder?: InputMaybe<RetailerCollectionSortOrder>
  endDate?: InputMaybe<Scalars['DateTime']>
  filters?: InputMaybe<Array<InputMaybe<RetailerCollectionFilterInput>>>
  id?: InputMaybe<Scalars['BigInt']>
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['Int']>
  productsToAdd?: InputMaybe<Array<InputMaybe<RetailerCollectionProductPayloadInput>>>
  productsToDelete?: InputMaybe<Array<InputMaybe<RetailerCollectionProductPayloadInput>>>
  resetAllProducts?: InputMaybe<Scalars['Boolean']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  source?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<RetailerCollectionStatus>
  storeConfigurations?: InputMaybe<Array<InputMaybe<RetailerCollectionStoreConfigurationInput>>>
  surfaces?: InputMaybe<Array<InputMaybe<RetailerCollectionSurface>>>
  tileImageUrl?: InputMaybe<Scalars['String']>
  translations?: InputMaybe<Array<InputMaybe<RetailerCollectionTranslationInput>>>
}

export type UpdateRetailerCollectionResponse = {
  __typename?: 'UpdateRetailerCollectionResponse'
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type UpdateRetailerCollectionStatusRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  status?: InputMaybe<RetailerCollectionStatus>
}

export type UpdateRetailerCollectionStatusResponse = {
  __typename?: 'UpdateRetailerCollectionStatusResponse'
  retailerCollection: Maybe<RetailerCollection>
  retailerId: Maybe<Scalars['BigInt']>
}

export type UpdateRetailerProductVisibilitiesRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>
  inAssortment?: InputMaybe<Scalars['Boolean']>
  outOfAssortmentEndAt?: InputMaybe<Scalars['DateTime']>
  outOfAssortmentStartAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdateRetailerProductVisibilitiesResponse = {
  __typename?: 'UpdateRetailerProductVisibilitiesResponse'
  entityId: Maybe<Array<Maybe<EntityId>>>
}

export type UpdateRoleInput = {
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>
  /** The role ID */
  id: Scalars['ID']
  /** The name of the role */
  name?: InputMaybe<Scalars['String']>
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>
}

export type UpdateShopperOrderItemRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>
  deliveredCount?: InputMaybe<Scalars['BigInt']>
  deliveredWeight?: InputMaybe<GoogleProtobufDoubleValueInput>
  lineNum?: InputMaybe<Scalars['String']>
  orderId?: InputMaybe<Scalars['String']>
  orderItemId?: InputMaybe<Scalars['BigInt']>
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>
  rrc?: InputMaybe<Scalars['String']>
  scans?: InputMaybe<Array<InputMaybe<ShopperOrderItemScanInput>>>
  shopperId?: InputMaybe<Scalars['BigInt']>
  status?: InputMaybe<Scalars['String']>
  substituteId?: InputMaybe<Scalars['BigInt']>
  upc?: InputMaybe<Scalars['String']>
}

export type UpdateShopperOrderItemResponse = {
  __typename?: 'UpdateShopperOrderItemResponse'
  success: Maybe<Scalars['Boolean']>
}

export type UpdateStagingSettingsRequestInput = {
  freezer?: InputMaybe<StringsInput>
  fridge?: InputMaybe<StringsInput>
  imageUrl?: InputMaybe<Scalars['String']>
  instruction?: InputMaybe<Scalars['String']>
  retailerLocationId?: InputMaybe<Scalars['BigInt']>
  shelf?: InputMaybe<StringsInput>
}

export type UpdateStagingSettingsResponse = {
  __typename?: 'UpdateStagingSettingsResponse'
  errors: Maybe<Array<Maybe<Scalars['String']>>>
  freezer: Maybe<Array<Maybe<Scalars['String']>>>
  fridge: Maybe<Array<Maybe<Scalars['String']>>>
  imageUrl: Maybe<Scalars['String']>
  instruction: Maybe<Scalars['String']>
  retailerLocationConfig: Maybe<RetailerLocationInfo>
  shelf: Maybe<Array<Maybe<Scalars['String']>>>
}

export type UpdateStoreConfigurationDraftRequestInput = {
  domainConfigurations?: InputMaybe<Scalars['JSONObject']>
  draftId?: InputMaybe<Scalars['String']>
  draftName?: InputMaybe<Scalars['String']>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
}

export type UpdateStoreConfigurationDraftResponse = {
  __typename?: 'UpdateStoreConfigurationDraftResponse'
  domainConfigurations: Maybe<DomainConfiguration>
  draftId: Maybe<Scalars['String']>
  draftName: Maybe<Scalars['String']>
  errorMessage: Maybe<Scalars['String']>
  errorReason: Maybe<ErrorReason>
  isSuccessful: Maybe<Scalars['Boolean']>
}

export type UpdateStoreHoursRequestInput = {
  author?: InputMaybe<Scalars['String']>
  clearOverrideHoursByType?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>
  clearOverrideHoursCriteria?: InputMaybe<Array<InputMaybe<ClearOverrideHoursCriteriaInput>>>
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>
  retailerId?: InputMaybe<Scalars['BigInt']>
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>
  updateRegularHours?: InputMaybe<Array<InputMaybe<RegularHoursInput>>>
  updateSource?: InputMaybe<Scalars['String']>
  upsertOverrideHours?: InputMaybe<Array<InputMaybe<OverrideHoursInput>>>
}

export type UpdateStoreHoursResponse = {
  __typename?: 'UpdateStoreHoursResponse'
  taskId: Maybe<Scalars['BigInt']>
}

export type UpdateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>
}

export type UpdateThemePageResponse = {
  __typename?: 'UpdateThemePageResponse'
  themePage: Maybe<ThemePage>
}

export type UpsertNavigationCollectionsNodeRequestInput = {
  contentType?: InputMaybe<RetailerCollectionNavigationNodeContentType>
  endDate?: InputMaybe<Scalars['DateTime']>
  id?: InputMaybe<Scalars['BigInt']>
  name?: InputMaybe<Scalars['String']>
  parentId?: InputMaybe<Scalars['BigInt']>
  position?: InputMaybe<Scalars['BigInt']>
  retailerCollectionId?: InputMaybe<Scalars['BigInt']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  slug?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['DateTime']>
  status?: InputMaybe<RetailerCollectionStatus>
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>
  tileImageUrl?: InputMaybe<Scalars['String']>
  translations?: InputMaybe<Array<InputMaybe<RetailerCollectionNavigationNodeTranslationInput>>>
}

export type UpsertNavigationCollectionsNodeResponse = {
  __typename?: 'UpsertNavigationCollectionsNodeResponse'
  success: Maybe<Scalars['Boolean']>
}

export type UpsertRetailerConfigRequestInput = {
  config?: InputMaybe<RetailerConfigInput>
  retailerId?: InputMaybe<Scalars['BigInt']>
}

export type UpsertRetailerConfigResponse = {
  __typename?: 'UpsertRetailerConfigResponse'
  config: Maybe<RetailerConfig>
  retailerId: Maybe<Scalars['BigInt']>
}

export type User = {
  __typename?: 'User'
  active: Maybe<Scalars['Boolean']>
  email: Maybe<Scalars['String']>
  firstName: Maybe<Scalars['String']>
  guest: Maybe<Scalars['Boolean']>
  id: Maybe<Scalars['BigInt']>
  lastName: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  phone: Maybe<Scalars['String']>
  roles: Maybe<Array<Maybe<Scalars['String']>>>
  userId: Maybe<Scalars['String']>
  userType: Maybe<Scalars['String']>
  vip: Maybe<Scalars['Boolean']>
}

export type UserInput = {
  userId?: InputMaybe<Scalars['String']>
  userType?: InputMaybe<Scalars['String']>
}

export type UserInteractionLimitInput = {
  /** number of seconds to wait before resetting the counter */
  countCooldownSec?: InputMaybe<Scalars['Int']>
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** maximum number of dismiss events */
  maxDismissedCount?: InputMaybe<Scalars['Int']>
  /** maximum number of click events */
  maxEngagementsCount?: InputMaybe<Scalars['Int']>
  /** maximum number of view events */
  maxImpressionsCount?: InputMaybe<Scalars['Int']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
}

/** Autogenerated return type of UserInteractionLimitVisibilityConditionCreate */
export type UserInteractionLimitVisibilityConditionCreatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionCreatePayload'
  /** The newly created UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit
}

/** Autogenerated return type of UserInteractionLimitVisibilityConditionUpdate */
export type UserInteractionLimitVisibilityConditionUpdatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionUpdatePayload'
  /** The newly updated UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit
}

export type UserSetting = {
  __typename?: 'UserSetting'
  key: Maybe<UserSettingKey>
  value: Maybe<Scalars['String']>
  version: Maybe<Scalars['BigInt']>
}

export type UserSettingInput = {
  key?: InputMaybe<UserSettingKeyInput>
  value?: InputMaybe<Scalars['String']>
  version?: InputMaybe<Scalars['BigInt']>
}

export type UserSettingKey = {
  __typename?: 'UserSettingKey'
  app: Maybe<Scalars['String']>
  domain: Maybe<Scalars['String']>
  name: Maybe<Scalars['String']>
  userId: Maybe<Scalars['String']>
}

export type UserSettingKeyInput = {
  app?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type UtmParametersInput = {
  /** coupon_code */
  couponCode?: InputMaybe<Scalars['String']>
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** utm_campaign */
  utmCampaign?: InputMaybe<Scalars['String']>
  /** utm_content */
  utmContent?: InputMaybe<Scalars['String']>
  /** utm_medium */
  utmMedium?: InputMaybe<Scalars['String']>
  /** utm_source */
  utmSource?: InputMaybe<Scalars['String']>
  /** utm_term */
  utmTerm?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UtmParametersVisibilityConditionCreate */
export type UtmParametersVisibilityConditionCreatePayload = {
  __typename?: 'UtmParametersVisibilityConditionCreatePayload'
  /** The newly created UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters
}

/** Autogenerated return type of UtmParametersVisibilityConditionUpdate */
export type UtmParametersVisibilityConditionUpdatePayload = {
  __typename?: 'UtmParametersVisibilityConditionUpdatePayload'
  /** The newly updated UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters
}

export type ValidateRetailerCollectionsCsvRequestInput = {
  bulkUploadType?: InputMaybe<RetailerCollectionBulkUploadType>
  fileName?: InputMaybe<Scalars['String']>
  retailerId?: InputMaybe<Scalars['BigInt']>
  timestamp?: InputMaybe<Scalars['DateTime']>
}

export type ValidateRetailerCollectionsCsvResponse = {
  __typename?: 'ValidateRetailerCollectionsCsvResponse'
  errors: Maybe<Array<Maybe<RetailerCollectionsCsvError>>>
  reviewSummaries: Maybe<Array<Maybe<RetailerCollectionsCsvSummary>>>
  valid: Maybe<Scalars['Boolean']>
}

export type ValueBasedOverrideRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>
  createdBy?: InputMaybe<ClientInput>
  createdWhy?: InputMaybe<Scalars['String']>
  entityId?: InputMaybe<EntityIdInput>
  expiryDate?: InputMaybe<Scalars['DateTime']>
  overrideType?: InputMaybe<OverrideType>
  overrideValue?: InputMaybe<Scalars['String']>
  sourceType?: InputMaybe<Scalars['String']>
  sourceValue?: InputMaybe<Scalars['String']>
  ticketUrl?: InputMaybe<Scalars['String']>
}

export type ValueBasedOverrideResponse = {
  __typename?: 'ValueBasedOverrideResponse'
  attributeName: Maybe<Scalars['String']>
  createdAt: Maybe<Scalars['DateTime']>
  createdByJson: Maybe<Scalars['String']>
  createdWhy: Maybe<Scalars['String']>
  entityId: Maybe<EntityId>
  expiryDate: Maybe<Scalars['DateTime']>
  overrideType: Maybe<OverrideType>
  overrideValue: Maybe<Scalars['String']>
  rowId: Maybe<Scalars['BigInt']>
  sourceType: Maybe<Scalars['String']>
  sourceValue: Maybe<Scalars['String']>
  ticketUrl: Maybe<Scalars['String']>
}

export enum VerticalType {
  DeliveryHours = 'DELIVERY_HOURS',
  IssHours = 'ISS_HOURS',
  PickupHours = 'PICKUP_HOURS',
  PickupOverrideHours = 'PICKUP_OVERRIDE_HOURS',
}

export type VirtualRetailer = {
  __typename?: 'VirtualRetailer'
  coreRetailerId: Maybe<Scalars['BigInt']>
  virtualRetailerId: Maybe<Scalars['BigInt']>
}

/** Union of the Types of Visibility Conditions which may be returned */
export type VisibilityCondition =
  | ContentManagementVisibilityConditionCountryIds
  | ContentManagementVisibilityConditionDayOfWeek
  | ContentManagementVisibilityConditionExperimentVariant
  | ContentManagementVisibilityConditionExpressMembership
  | ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout
  | ContentManagementVisibilityConditionMatchesAnyRetailerId
  | ContentManagementVisibilityConditionMinimumPlatformVersion
  | ContentManagementVisibilityConditionNewVerticalUserTargeting
  | ContentManagementVisibilityConditionRetailerAvailability
  | ContentManagementVisibilityConditionShopped
  | ContentManagementVisibilityConditionShoppedAtRetailer
  | ContentManagementVisibilityConditionUnknownVisibilityCondition
  | ContentManagementVisibilityConditionUserInteractionLimit
  | ContentManagementVisibilityConditionUtmParameters
  | ContentManagementVisibilityConditionWhitelistedPostalCodes
  | ContentManagementVisibilityConditionWhitelistedZones

/** Autogenerated return type of VisibilityConditionDelete */
export type VisibilityConditionDeletePayload = {
  __typename?: 'VisibilityConditionDeletePayload'
  /** Whether deleting the visibility condition succeeded or not */
  success: Scalars['Boolean']
}

export type VisibilityConditionStruct = {
  __typename?: 'VisibilityConditionStruct'
  data: Maybe<Scalars['JSONObject']>
  typeName: Maybe<Scalars['String']>
}

export type VisibilityConditionStructInput = {
  data?: InputMaybe<Scalars['JSONObject']>
  typeName?: InputMaybe<Scalars['String']>
}

export type WhitelistedPostalCodesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionCreate */
export type WhitelistedPostalCodesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionCreatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionUpdate */
export type WhitelistedPostalCodesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionUpdatePayload'
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes
}

export type WhitelistedZonesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID']
  /** List of zones ids */
  zones: Array<Scalars['String']>
}

/** Autogenerated return type of WhitelistedZonesVisibilityConditionCreate */
export type WhitelistedZonesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionCreatePayload'
  /** The newly created whitelisted_zones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones
}

/** Autogenerated return type of WhitelistedZonesVisibilityConditionUpdate */
export type WhitelistedZonesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionUpdatePayload'
  /** The updated WhitelistedZones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones
}

export type Widget = {
  __typename?: 'Widget'
  dataQuery: Maybe<DataQuery>
  id: Maybe<Scalars['BigInt']>
  variant: Maybe<WidgetVariant>
}

export type WidgetInput = {
  dataQuery?: InputMaybe<DataQueryInput>
  id?: InputMaybe<Scalars['BigInt']>
  variant?: InputMaybe<WidgetVariant>
}

export enum WidgetVariant {
  NavigationList = 'NAVIGATION_LIST',
  OrderHistory = 'ORDER_HISTORY',
  QuickLinks = 'QUICK_LINKS',
  ServiceOptionSelector = 'SERVICE_OPTION_SELECTOR',
  UnspecifiedWidget = 'UNSPECIFIED_WIDGET',
  WaysToShop = 'WAYS_TO_SHOP',
}

/** Autogenerated return type of WizardProgressUpdate */
export type WizardProgressUpdatePayload = {
  __typename?: 'WizardProgressUpdatePayload'
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True']
}

export enum WizardStatusEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export enum WizardTypeEnum {
  PickupSettingsOnboarding = 'PICKUP_SETTINGS_ONBOARDING',
}

export type WizardsWizardProgress = {
  __typename?: 'WizardsWizardProgress'
  id: Scalars['ID']
  status: WizardStatusEnum
  wizardType: WizardTypeEnum
}

/** Event type and payload [attributes] for creating a workflow event */
export type WorkflowEventCreationInput = {
  /** The event payload attributes associated with this workflow event */
  workflowEventPayload: WorkflowEventPayloadInput
  /** The kind of workflow event which should be created */
  workflowEventType: WorkflowEventTypeEnum
}

/** Payload attributes for creating a workflow event - note that this lists the allowed attributes for all event payloads */
export type WorkflowEventPayloadInput = {
  /** The id for the aisle that the product should be added to */
  aisleId?: InputMaybe<Scalars['ID']>
  /** Is the product alcoholic? - (true, false) */
  alcoholic?: InputMaybe<Scalars['Boolean']>
  /** The brand which should be set for the product - `Hershey's` */
  brand?: InputMaybe<Scalars['String']>
  /** The id for the changeset product associated with this event */
  changesetProductId?: InputMaybe<Scalars['ID']>
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo?: InputMaybe<ClassificationInfoInput>
  /** The cost unit which should be set for the product - (each, lb, ...) */
  costUnit?: InputMaybe<CostUnitEnum>
  /** The id for the department that the product should be added to */
  departmentId?: InputMaybe<Scalars['ID']>
  /** Details about the product, e.g. `Brown, overripe bananas, suitable for baking` */
  description?: InputMaybe<Scalars['String']>
  /** Is the product fat_free? - (true, false) */
  fatFree?: InputMaybe<Scalars['Boolean']>
  /** Is the product gluten_free? - (true, false) */
  glutenFree?: InputMaybe<Scalars['Boolean']>
  /** An absolute url representing the 'back' angle - `https://www.example.com/etc` */
  imageUrlBack?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'drug facts' angle - `https://www.example.com/etc` */
  imageUrlDrugFacts?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'ingredients' angle - `https://www.example.com/etc` */
  imageUrlIngredients?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'left' angle - `https://www.example.com/etc` */
  imageUrlLeft?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'lifestyle' angle - `https://www.example.com/etc` */
  imageUrlLifestyle?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'nutrition' angle - `https://www.example.com/etc` */
  imageUrlNutrition?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'primary' angle - `https://www.example.com/etc` */
  imageUrlPrimary?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'right' angle - `https://www.example.com/etc` */
  imageUrlRight?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'supplement facts' angle - `https://www.example.com/etc` */
  imageUrlSupplementFacts?: InputMaybe<Scalars['Url']>
  /** An absolute url representing the 'top' angle - `https://www.example.com/etc` */
  imageUrlTop?: InputMaybe<Scalars['Url']>
  /** The id for the import process code-lookup associated with this event */
  importProcessCodeLookupId?: InputMaybe<Scalars['ID']>
  /** Is the product kosher? - (true, false) */
  kosher?: InputMaybe<Scalars['Boolean']>
  /** Is the product low_fat? - (true, false) */
  lowFat?: InputMaybe<Scalars['Boolean']>
  /** The name which should be set for the product - `Hershey's Extra Large Chocolate Bar` */
  name?: InputMaybe<Scalars['String']>
  /** Is the product organic? - (true, false) */
  organic?: InputMaybe<Scalars['Boolean']>
  /** The price which should be set for the product - (12.99) */
  pricePerCostUnit?: InputMaybe<Scalars['Float']>
  /** The id for the the product associated with this event */
  productId?: InputMaybe<Scalars['ID']>
  /** The size of the product - (`12 kg`, `14 oz`, ...) */
  size?: InputMaybe<Scalars['String']>
  /** Is the product sugar_free? - (true, false) */
  sugarFree?: InputMaybe<Scalars['Boolean']>
  /** Is the product taxable? - (true, false) */
  taxable?: InputMaybe<Scalars['Boolean']>
  /** Is the product vegan? - (true, false) */
  vegan?: InputMaybe<Scalars['Boolean']>
  /** Is the product vegetarian? - (true, false) */
  vegetarian?: InputMaybe<Scalars['Boolean']>
}

export enum WorkflowEventTypeEnum {
  /** Import a product from the global catalog into our workflow */
  ImportGlobalProduct = 'IMPORT_GLOBAL_PRODUCT',
  /** Set the aisle for an imported changeset product */
  SetProductAisle = 'SET_PRODUCT_AISLE',
  /** Set the cost unit for an imported changeset product - (each, lb, ...) */
  SetProductCostUnit = 'SET_PRODUCT_COST_UNIT',
  /** Set the department for an imported changeset product */
  SetProductDepartment = 'SET_PRODUCT_DEPARTMENT',
  /** Set the price for an imported changeset product - (12.99) */
  SetProductPricePerCostUnit = 'SET_PRODUCT_PRICE_PER_COST_UNIT',
  /** Create or update a 'New-Product-Request' (A request to add a new product to Instacart's catalog) */
  UpsertNewProductRequest = 'UPSERT_NEW_PRODUCT_REQUEST',
}

export enum WorkflowStateEnum {
  /** A workflow that has been sent to the catalog successfully */
  Completed = 'COMPLETED',
  /** A workflow that has been sent to the catalog, with one or more items failing to imprt */
  CompletedWithError = 'COMPLETED_WITH_ERROR',
  /** A workflow that is currently in-progress, and is editable */
  Draft = 'DRAFT',
  /** A workflow that has been submitted, and is no longer editable */
  Submitted = 'SUBMITTED',
}

export enum WorkflowStatus {
  WorkflowStatusCompleted = 'WORKFLOW_STATUS_COMPLETED',
  WorkflowStatusDeactivate = 'WORKFLOW_STATUS_DEACTIVATE',
  WorkflowStatusExpired = 'WORKFLOW_STATUS_EXPIRED',
  WorkflowStatusFailed = 'WORKFLOW_STATUS_FAILED',
  WorkflowStatusGetData = 'WORKFLOW_STATUS_GET_DATA',
  WorkflowStatusInProgress = 'WORKFLOW_STATUS_IN_PROGRESS',
  WorkflowStatusReadyToDelete = 'WORKFLOW_STATUS_READY_TO_DELETE',
  WorkflowStatusUnspecified = 'WORKFLOW_STATUS_UNSPECIFIED',
}

export enum WorkflowTypeEnum {
  /** An add-to-catalog type workflow */
  AddToCatalog = 'ADD_TO_CATALOG',
}

export type FetchCurrentEnterpriseAccountQueryVariables = Exact<{ [key: string]: never }>

export type FetchCurrentEnterpriseAccountQuery = {
  __typename?: 'Query'
  currentEnterpriseAccount: {
    __typename?: 'EnterpriseAccount'
    canonicalId: string
    id: string
    createdAt: string
    givenName: string
    surname: string
    email: string
    accountStateValid: boolean
    isInternal: boolean
    authServiceRequired: boolean
    authentication: { __typename?: 'EnterpriseAuthenticationEmailPassword'; emailVerified: boolean }
    featureToggles: Array<{ __typename?: 'FeatureToggle'; name: string }>
    policies: {
      __typename?: 'AccessControlPolicies'
      viewAdminToolsSection: boolean
      viewRetailerDashboardSection: boolean
    }
    internalAccessConfiguration: {
      __typename?: 'EnterpriseInternalAccessConfiguration'
      hasAllPartnersFullAccess: boolean
      hasFullPartnerAccess: boolean
      hasFullRetailerAccess: boolean
      hasNothingAccessible: boolean
      assignedPartners: Array<{ __typename?: 'Partner'; id: string }>
      assignedRetailers: Array<{ __typename?: 'Retailer'; id: string }>
      assignedRetailerLocations: Array<{ __typename?: 'RetailerLocation'; id: string }>
    }
    permissions: Array<{ __typename?: 'EnterprisePermission'; slug: string }>
  }
}

export type FetchFeatureToggleFullyEnabledQueryVariables = Exact<{
  featureName: Scalars['String']
}>

export type FetchFeatureToggleFullyEnabledQuery = {
  __typename?: 'Query'
  featureToggleFullyEnabled: { __typename?: 'FeatureTogglesEnabledCheck'; enabled: boolean }
}

export type CurrentEnterpriseAccountOverviewFragmentFragment = {
  __typename?: 'EnterpriseAccount'
  canonicalId: string
  id: string
  createdAt: string
  givenName: string
  surname: string
  email: string
  accountStateValid: boolean
  isInternal: boolean
  authServiceRequired: boolean
  authentication: { __typename?: 'EnterpriseAuthenticationEmailPassword'; emailVerified: boolean }
  featureToggles: Array<{ __typename?: 'FeatureToggle'; name: string }>
  policies: {
    __typename?: 'AccessControlPolicies'
    viewAdminToolsSection: boolean
    viewRetailerDashboardSection: boolean
  }
  internalAccessConfiguration: {
    __typename?: 'EnterpriseInternalAccessConfiguration'
    hasAllPartnersFullAccess: boolean
    hasFullPartnerAccess: boolean
    hasFullRetailerAccess: boolean
    hasNothingAccessible: boolean
    assignedPartners: Array<{ __typename?: 'Partner'; id: string }>
    assignedRetailers: Array<{ __typename?: 'Retailer'; id: string }>
    assignedRetailerLocations: Array<{ __typename?: 'RetailerLocation'; id: string }>
  }
  permissions: Array<{ __typename?: 'EnterprisePermission'; slug: string }>
}

export type FetchDepartmentsAndAislesItemsMeshQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  primaryAisleId?: InputMaybe<Scalars['BigInt']>
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>
  offset?: InputMaybe<Scalars['BigInt']>
  limit?: InputMaybe<Scalars['BigInt']>
  localeCode: InstacartCustomersSharedV1Locale
}>

export type FetchDepartmentsAndAislesItemsMeshQuery = {
  __typename?: 'Query'
  retailerToolsServiceGetItems: {
    __typename?: 'GetItemsResponse'
    totalCount: string
    results: Array<{
      __typename?: 'Item'
      localeCode: string
      primaryAisleId: string
      primaryImageUrl: string
      productCodes: Array<string>
      productDisplayName: string
      productId: string
      retailerId: string
      retailerReferenceCode: string
    }>
  }
}

export type FetchDepartmentsAndAislesProductsInfoMeshQueryVariables = Exact<{
  retailerId: Scalars['BigInt']
  productIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>
}>

export type FetchDepartmentsAndAislesProductsInfoMeshQuery = {
  __typename?: 'Query'
  catalogToolsApiServiceGetRetailerProductData: {
    __typename?: 'GetRetailerProductDataResponse'
    retailerProductData: Array<{
      __typename?: 'RetailerProductData'
      productId: string
      availableItemsCount: string
    }>
  }
}

export type FetchDepartmentsAndAislesProductsMeshQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  offset?: InputMaybe<Scalars['BigInt']>
  limit?: InputMaybe<Scalars['BigInt']>
  primaryAisleId?: InputMaybe<Scalars['BigInt']>
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>
  localeCode: InstacartCustomersSharedV1Locale
}>

export type FetchDepartmentsAndAislesProductsMeshQuery = {
  __typename?: 'Query'
  retailerToolsServiceGetRetailerProducts: {
    __typename?: 'GetRetailerProductsResponse'
    totalCount: string
    results: Array<{
      __typename?: 'RetailerProduct'
      productDisplayName: string
      primaryImageUrl: string
      productId: string
      productCodes: Array<string>
    }>
  }
}

export type FetchPrimaryAisleProductCountQueryVariables = Exact<{
  retailerId?: InputMaybe<Scalars['BigInt']>
  primaryAisleId?: InputMaybe<Scalars['BigInt']>
}>

export type FetchPrimaryAisleProductCountQuery = {
  __typename?: 'Query'
  retailerToolsServiceGetRetailerProducts: {
    __typename?: 'GetRetailerProductsResponse'
    totalCount: string
  }
}

export type GetAllRetailerLocationsForRetailerQueryVariables = Exact<{
  retailerId: Scalars['ID']
}>

export type GetAllRetailerLocationsForRetailerQuery = {
  __typename?: 'Query'
  retailerLocationSearchArray: Array<{
    __typename?: 'RetailerLocation'
    id: string
    name: string
    street: string
    city: string
    state: string
    zipCode: string
    locationCode: string
    active: boolean
    pickup: boolean
    pickingModel: PickingModelEnum
    fulfillmentModels: Array<FulfillmentModelEnum>
    partnerAlcoholDelivery: boolean
    hybridPickingEnabled: boolean
  }>
}

export type GetRetailerQueryVariables = Exact<{
  retailerId: Scalars['ID']
}>

export type GetRetailerQuery = {
  __typename?: 'Query'
  retailer: {
    __typename?: 'Retailer'
    id: string
    name: string
    slug: string
    partner: { __typename?: 'Partner'; id: string; name: string }
    featureToggles: Array<{ __typename?: 'FeatureToggle'; name: string }>
  }
}

export type GetRetailerLocalesMeshQueryVariables = Exact<{
  retailerId: Scalars['BigInt']
}>

export type GetRetailerLocalesMeshQuery = {
  __typename?: 'Query'
  catalogToolsApiServiceGetLocalesByRetailer: {
    __typename?: 'GetLocalesByRetailerResponse'
    retailerLocales: Array<{ __typename?: 'RetailerLocale'; localeId: string; localeCode: string }>
  }
}

export type GetStoreConfigsQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID']
  storeConfigRelationship: StoreConfigurationRelationshipEnum
  active?: InputMaybe<Scalars['Boolean']>
}>

export type GetStoreConfigsQuery = {
  __typename?: 'Query'
  storeConfigurationsByRetailerIds: Array<{
    __typename?: 'InstacartStoreConfiguration'
    id: string
    slug: string
    brandedName: string
    whitelistedWarehouseIds: Array<string>
    domainName: string
    deApplicationPlatform: string
    createdAt: string
    updatedAt: string
    allowAllWarehouses: boolean
    logoUrl: string
    userAccessToModify: boolean
    active: boolean
    userIsolationContextId: string
    legal: { __typename?: 'InstacartStoreConfigurationLegal'; shortName: string }
    partnerAccessSettings: {
      __typename?: 'InstacartStoreConfigurationPartnerAccessSettings'
      visibleToPartnersOnIpp: boolean
      modificationRules: {
        __typename?: 'InstacartStoreConfigurationModificationRules'
        allowlistPartnerIds: Array<string>
      }
    }
  }>
}

export type GetTaxonomyNodesQueryVariables = Exact<{ [key: string]: never }>

export type GetTaxonomyNodesQuery = {
  __typename?: 'Query'
  taxonomyNodes: Array<{
    __typename?: 'CatalogTaxonomyNode'
    id: string
    name: string
    parentId: string
  }>
}

export type SearchEnterpriseAccountsAccountSelectQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>
  partnerId: Scalars['ID']
  canonicalIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>
}>

export type SearchEnterpriseAccountsAccountSelectQuery = {
  __typename?: 'Query'
  enterpriseAccountSearch: {
    __typename?: 'EnterpriseAccountConnection'
    edges: Array<{
      __typename?: 'EnterpriseAccountEdge'
      node: {
        __typename?: 'EnterpriseAccount'
        givenName: string
        surname: string
        email: string
        canonicalId: string
      }
    }>
  }
}

export type FetchAislesForDepartmentQueryVariables = Exact<{
  departmentId: Scalars['ID']
}>

export type FetchAislesForDepartmentQuery = {
  __typename?: 'Query'
  catalogDepartment: {
    __typename?: 'CatalogDepartment'
    aisles: Array<{ __typename?: 'CatalogAisle'; id: string; name: string }>
  }
}

export type FetchDepartmentsForRetailerQueryVariables = Exact<{
  retailerId: Scalars['ID']
}>

export type FetchDepartmentsForRetailerQuery = {
  __typename?: 'Query'
  retailer: {
    __typename?: 'Retailer'
    departments: Array<{ __typename?: 'CatalogDepartment'; id: string; name: string }>
  }
}

export type ListStoreGroupsQueryVariables = Exact<{
  retailerId: Scalars['ID']
  numGroups?: InputMaybe<Scalars['Int']>
  afterGroup?: InputMaybe<Scalars['String']>
}>

export type ListStoreGroupsQuery = {
  __typename?: 'Query'
  retailerLocationGroupsByRetailer: {
    __typename?: 'RetailersRetailerLocationGroupConnection'
    edges: Array<{
      __typename?: 'RetailersRetailerLocationGroupEdge'
      cursor: string
      node: {
        __typename?: 'RetailersRetailerLocationGroup'
        id: string
        name: string
        updatedAt: string
        retailerLocationIds: Array<string>
      }
    }>
  }
}

export type ListTopProductsQueryVariables = Exact<{
  retailerId: Scalars['ID']
  startAt?: InputMaybe<Scalars['ISO8601Date']>
  endAt?: InputMaybe<Scalars['ISO8601Date']>
  page?: InputMaybe<Scalars['Int']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type ListTopProductsQuery = {
  __typename?: 'Query'
  analyticsTopProducts: {
    __typename?: 'SnowflakeTopProductsResult'
    totalCount: number
    topProducts: Array<{
      __typename?: 'SnowflakeTopProductsItem'
      id: string
      productName: string
      imageUrl: string
      availabilityPercentage: number
      foundRatePercentage: number
      orderedItems: number
      refundRatePercentage: number
      gmv: number
      department: string
    }>
  }
}

export type RetailerProductAggregateDataQueryVariables = Exact<{
  retailerId: Scalars['BigInt']
  productIds?: InputMaybe<Array<Scalars['BigInt']> | Scalars['BigInt']>
}>

export type RetailerProductAggregateDataQuery = {
  __typename?: 'Query'
  catalogToolsApiServiceGetRetailerProductData: {
    __typename?: 'GetRetailerProductDataResponse'
    retailerProductData: Array<{
      __typename?: 'RetailerProductData'
      retailerId: string
      productId: string
      maxPriceCents: string
      minPriceCents: string
      availableItemsCount: string
      visibleItemsCount: string
      itemsCount: string
      generatedAt: any
    }>
  }
}

export type RetailerProductSearchQueryVariables = Exact<{
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>> | InputMaybe<Scalars['BigInt']>>
  limit?: InputMaybe<Scalars['BigInt']>
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>
  offset?: InputMaybe<Scalars['BigInt']>
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>
  query?: InputMaybe<Scalars['String']>
  retailerId: Scalars['BigInt']
  retailerReferenceCodes?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
}>

export type RetailerProductSearchQuery = {
  __typename?: 'Query'
  retailerToolsServiceGetRetailerProducts: {
    __typename?: 'GetRetailerProductsResponse'
    totalCount: string
    results: Array<{
      __typename?: 'RetailerProduct'
      localeCode: string
      primaryAisleId: string
      primaryDepartmentId: string
      primaryImageUrl: string
      productCodes: Array<string>
      productDisplayName: string
      productId: string
      retailerId: string
      retailerReferenceCode: string
      score: number
      aisles: Array<{ __typename?: 'RetailerProductAisle'; id: string; name: string }>
      departments: Array<{ __typename?: 'RetailerProductDepartment'; id: string; name: string }>
    }>
  }
}

export type ListReportRequestsQueryVariables = Exact<{
  retailerId: Scalars['ID']
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}>

export type ListReportRequestsQuery = {
  __typename?: 'Query'
  reportRequests: {
    __typename?: 'ReportsReportRequestConnection'
    edges: Array<{
      __typename?: 'ReportsReportRequestEdge'
      node: {
        __typename?: 'ReportsReportRequest'
        id: string
        name: string
        generationState: ReportRequestStateEnum
        createdAt: string
        updatedAt: string
        report: { __typename?: 'ReportsReport'; slug: string }
        enterpriseAccount: { __typename?: 'EnterpriseAccount'; givenName: string; surname: string }
        reportViews: Array<{ __typename: 'ReportsReportViewsCsv'; downloadUrl: string; id: string }>
      }
    }>
    meta: { __typename?: 'ConnectionMeta'; totalCount: number }
  }
}

export type ReportListQueryVariables = Exact<{ [key: string]: never }>

export type ReportListQuery = {
  __typename?: 'Query'
  reports: Array<{
    __typename?: 'ReportsReport'
    id: string
    slug: string
    createdAt: string
    updatedAt: string
    supportedFilters: Array<
      | {
          __typename?: 'ReportsReportFilterDefinitionsDateRange'
          minDate: any
          maxDate: any
          filterType: ReportFilterTypeEnum
          required: boolean
          slug: string
        }
      | {
          __typename?: 'ReportsReportFilterDefinitionsRetailerLocations'
          filterType: ReportFilterTypeEnum
          required: boolean
          slug: string
        }
    >
  }>
}

export type ReportRequestCreateMutationVariables = Exact<{
  name: Scalars['String']
  reportId: Scalars['ID']
  associatedObjectId: Scalars['ID']
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum
  reportFilters?: InputMaybe<ReportFilters>
}>

export type ReportRequestCreateMutation = {
  __typename?: 'Mutation'
  reportRequestCreate: {
    __typename?: 'ReportRequestCreatePayload'
    reportRequest: {
      __typename?: 'ReportsReportRequest'
      id: string
      generationState: ReportRequestStateEnum
      name: string
    }
  }
}

export type ReportViewDownloadUrlQueryVariables = Exact<{
  reportViewId: Scalars['ID']
}>

export type ReportViewDownloadUrlQuery = {
  __typename?: 'Query'
  reportView: { __typename: 'ReportsReportViewsCsv'; downloadUrl: string }
}

export const CurrentEnterpriseAccountOverviewFragmentFragmentDoc = gql`
  fragment CurrentEnterpriseAccountOverviewFragment on EnterpriseAccount {
    canonicalId
    id
    createdAt
    givenName
    surname
    email
    accountStateValid
    isInternal
    authServiceRequired
    authentication {
      ... on EnterpriseAuthenticationEmailPassword {
        emailVerified
      }
    }
    featureToggles {
      name
    }
    policies {
      viewAdminToolsSection
      viewRetailerDashboardSection
    }
    internalAccessConfiguration {
      hasAllPartnersFullAccess
      hasFullPartnerAccess
      hasFullRetailerAccess
      hasNothingAccessible
      assignedPartners {
        id
      }
      assignedRetailers {
        id
      }
      assignedRetailerLocations {
        id
      }
    }
    permissions {
      slug
    }
  }
`
export const FetchCurrentEnterpriseAccountDocument = gql`
  query fetchCurrentEnterpriseAccount {
    currentEnterpriseAccount {
      ...CurrentEnterpriseAccountOverviewFragment
    }
  }
  ${CurrentEnterpriseAccountOverviewFragmentFragmentDoc}
`

/**
 * __useFetchCurrentEnterpriseAccountQuery__
 *
 * To run a query within a React component, call `useFetchCurrentEnterpriseAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentEnterpriseAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentEnterpriseAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentEnterpriseAccountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FetchCurrentEnterpriseAccountQuery,
    FetchCurrentEnterpriseAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchCurrentEnterpriseAccountQuery,
    FetchCurrentEnterpriseAccountQueryVariables
  >(FetchCurrentEnterpriseAccountDocument, options)
}
export function useFetchCurrentEnterpriseAccountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchCurrentEnterpriseAccountQuery,
    FetchCurrentEnterpriseAccountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchCurrentEnterpriseAccountQuery,
    FetchCurrentEnterpriseAccountQueryVariables
  >(FetchCurrentEnterpriseAccountDocument, options)
}
export type FetchCurrentEnterpriseAccountQueryHookResult = ReturnType<
  typeof useFetchCurrentEnterpriseAccountQuery
>
export type FetchCurrentEnterpriseAccountLazyQueryHookResult = ReturnType<
  typeof useFetchCurrentEnterpriseAccountLazyQuery
>
export type FetchCurrentEnterpriseAccountQueryResult = ApolloReactCommon.QueryResult<
  FetchCurrentEnterpriseAccountQuery,
  FetchCurrentEnterpriseAccountQueryVariables
>
export const FetchFeatureToggleFullyEnabledDocument = gql`
  query fetchFeatureToggleFullyEnabled($featureName: String!) {
    featureToggleFullyEnabled(featureName: $featureName) {
      enabled
    }
  }
`

/**
 * __useFetchFeatureToggleFullyEnabledQuery__
 *
 * To run a query within a React component, call `useFetchFeatureToggleFullyEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFeatureToggleFullyEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFeatureToggleFullyEnabledQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useFetchFeatureToggleFullyEnabledQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchFeatureToggleFullyEnabledQuery,
    FetchFeatureToggleFullyEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchFeatureToggleFullyEnabledQuery,
    FetchFeatureToggleFullyEnabledQueryVariables
  >(FetchFeatureToggleFullyEnabledDocument, options)
}
export function useFetchFeatureToggleFullyEnabledLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchFeatureToggleFullyEnabledQuery,
    FetchFeatureToggleFullyEnabledQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchFeatureToggleFullyEnabledQuery,
    FetchFeatureToggleFullyEnabledQueryVariables
  >(FetchFeatureToggleFullyEnabledDocument, options)
}
export type FetchFeatureToggleFullyEnabledQueryHookResult = ReturnType<
  typeof useFetchFeatureToggleFullyEnabledQuery
>
export type FetchFeatureToggleFullyEnabledLazyQueryHookResult = ReturnType<
  typeof useFetchFeatureToggleFullyEnabledLazyQuery
>
export type FetchFeatureToggleFullyEnabledQueryResult = ApolloReactCommon.QueryResult<
  FetchFeatureToggleFullyEnabledQuery,
  FetchFeatureToggleFullyEnabledQueryVariables
>
export const FetchDepartmentsAndAislesItemsMeshDocument = gql`
  query fetchDepartmentsAndAislesItemsMesh(
    $retailerId: BigInt
    $inventoryAreaId: BigInt
    $aisleIds: [BigInt]
    $departmentIds: [BigInt]
    $primaryAisleId: BigInt
    $primaryDepartmentId: BigInt
    $offset: BigInt
    $limit: BigInt
    $localeCode: InstacartCustomersSharedV1Locale!
  ) {
    retailerToolsServiceGetItems(
      input: {
        parameters: {
          limit: $limit
          offset: $offset
          aisleIds: $aisleIds
          departmentIds: $departmentIds
          inventoryAreaId: $inventoryAreaId
          primaryAisleId: $primaryAisleId
          primaryDepartmentId: $primaryDepartmentId
          retailerId: $retailerId
          localeCode: $localeCode
        }
      }
    ) {
      results {
        localeCode
        primaryAisleId
        primaryImageUrl
        productCodes
        productDisplayName
        productId
        retailerId
        retailerReferenceCode
      }
      totalCount
    }
  }
`

/**
 * __useFetchDepartmentsAndAislesItemsMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesItemsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesItemsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesItemsMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      inventoryAreaId: // value for 'inventoryAreaId'
 *      aisleIds: // value for 'aisleIds'
 *      departmentIds: // value for 'departmentIds'
 *      primaryAisleId: // value for 'primaryAisleId'
 *      primaryDepartmentId: // value for 'primaryDepartmentId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      localeCode: // value for 'localeCode'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesItemsMeshQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchDepartmentsAndAislesItemsMeshQuery,
    FetchDepartmentsAndAislesItemsMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchDepartmentsAndAislesItemsMeshQuery,
    FetchDepartmentsAndAislesItemsMeshQueryVariables
  >(FetchDepartmentsAndAislesItemsMeshDocument, options)
}
export function useFetchDepartmentsAndAislesItemsMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchDepartmentsAndAislesItemsMeshQuery,
    FetchDepartmentsAndAislesItemsMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchDepartmentsAndAislesItemsMeshQuery,
    FetchDepartmentsAndAislesItemsMeshQueryVariables
  >(FetchDepartmentsAndAislesItemsMeshDocument, options)
}
export type FetchDepartmentsAndAislesItemsMeshQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesItemsMeshQuery
>
export type FetchDepartmentsAndAislesItemsMeshLazyQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesItemsMeshLazyQuery
>
export type FetchDepartmentsAndAislesItemsMeshQueryResult = ApolloReactCommon.QueryResult<
  FetchDepartmentsAndAislesItemsMeshQuery,
  FetchDepartmentsAndAislesItemsMeshQueryVariables
>
export const FetchDepartmentsAndAislesProductsInfoMeshDocument = gql`
  query fetchDepartmentsAndAislesProductsInfoMesh($retailerId: BigInt!, $productIds: [BigInt!]) {
    catalogToolsApiServiceGetRetailerProductData(
      input: { retailerId: $retailerId, productIds: $productIds }
    ) {
      retailerProductData {
        productId
        availableItemsCount
      }
    }
  }
`

/**
 * __useFetchDepartmentsAndAislesProductsInfoMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesProductsInfoMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesProductsInfoMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesProductsInfoMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesProductsInfoMeshQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchDepartmentsAndAislesProductsInfoMeshQuery,
    FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchDepartmentsAndAislesProductsInfoMeshQuery,
    FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
  >(FetchDepartmentsAndAislesProductsInfoMeshDocument, options)
}
export function useFetchDepartmentsAndAislesProductsInfoMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchDepartmentsAndAislesProductsInfoMeshQuery,
    FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchDepartmentsAndAislesProductsInfoMeshQuery,
    FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
  >(FetchDepartmentsAndAislesProductsInfoMeshDocument, options)
}
export type FetchDepartmentsAndAislesProductsInfoMeshQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesProductsInfoMeshQuery
>
export type FetchDepartmentsAndAislesProductsInfoMeshLazyQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesProductsInfoMeshLazyQuery
>
export type FetchDepartmentsAndAislesProductsInfoMeshQueryResult = ApolloReactCommon.QueryResult<
  FetchDepartmentsAndAislesProductsInfoMeshQuery,
  FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
>
export const FetchDepartmentsAndAislesProductsMeshDocument = gql`
  query fetchDepartmentsAndAislesProductsMesh(
    $retailerId: BigInt
    $departmentIds: [BigInt]
    $aisleIds: [BigInt]
    $offset: BigInt
    $limit: BigInt
    $primaryAisleId: BigInt
    $primaryDepartmentId: BigInt
    $localeCode: InstacartCustomersSharedV1Locale!
  ) {
    retailerToolsServiceGetRetailerProducts(
      input: {
        parameters: {
          limit: $limit
          offset: $offset
          aisleIds: $aisleIds
          primaryAisleId: $primaryAisleId
          departmentIds: $departmentIds
          primaryDepartmentId: $primaryDepartmentId
          retailerId: $retailerId
          localeCode: $localeCode
        }
      }
    ) {
      results {
        productDisplayName
        primaryImageUrl
        productId
        productCodes
      }
      totalCount
    }
  }
`

/**
 * __useFetchDepartmentsAndAislesProductsMeshQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsAndAislesProductsMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsAndAislesProductsMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsAndAislesProductsMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      departmentIds: // value for 'departmentIds'
 *      aisleIds: // value for 'aisleIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      primaryAisleId: // value for 'primaryAisleId'
 *      primaryDepartmentId: // value for 'primaryDepartmentId'
 *      localeCode: // value for 'localeCode'
 *   },
 * });
 */
export function useFetchDepartmentsAndAislesProductsMeshQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchDepartmentsAndAislesProductsMeshQuery,
    FetchDepartmentsAndAislesProductsMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchDepartmentsAndAislesProductsMeshQuery,
    FetchDepartmentsAndAislesProductsMeshQueryVariables
  >(FetchDepartmentsAndAislesProductsMeshDocument, options)
}
export function useFetchDepartmentsAndAislesProductsMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchDepartmentsAndAislesProductsMeshQuery,
    FetchDepartmentsAndAislesProductsMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchDepartmentsAndAislesProductsMeshQuery,
    FetchDepartmentsAndAislesProductsMeshQueryVariables
  >(FetchDepartmentsAndAislesProductsMeshDocument, options)
}
export type FetchDepartmentsAndAislesProductsMeshQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesProductsMeshQuery
>
export type FetchDepartmentsAndAislesProductsMeshLazyQueryHookResult = ReturnType<
  typeof useFetchDepartmentsAndAislesProductsMeshLazyQuery
>
export type FetchDepartmentsAndAislesProductsMeshQueryResult = ApolloReactCommon.QueryResult<
  FetchDepartmentsAndAislesProductsMeshQuery,
  FetchDepartmentsAndAislesProductsMeshQueryVariables
>
export const FetchPrimaryAisleProductCountDocument = gql`
  query fetchPrimaryAisleProductCount($retailerId: BigInt, $primaryAisleId: BigInt) {
    retailerToolsServiceGetRetailerProducts(
      input: { parameters: { primaryAisleId: $primaryAisleId, retailerId: $retailerId } }
    ) {
      totalCount
    }
  }
`

/**
 * __useFetchPrimaryAisleProductCountQuery__
 *
 * To run a query within a React component, call `useFetchPrimaryAisleProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPrimaryAisleProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPrimaryAisleProductCountQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      primaryAisleId: // value for 'primaryAisleId'
 *   },
 * });
 */
export function useFetchPrimaryAisleProductCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FetchPrimaryAisleProductCountQuery,
    FetchPrimaryAisleProductCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchPrimaryAisleProductCountQuery,
    FetchPrimaryAisleProductCountQueryVariables
  >(FetchPrimaryAisleProductCountDocument, options)
}
export function useFetchPrimaryAisleProductCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchPrimaryAisleProductCountQuery,
    FetchPrimaryAisleProductCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchPrimaryAisleProductCountQuery,
    FetchPrimaryAisleProductCountQueryVariables
  >(FetchPrimaryAisleProductCountDocument, options)
}
export type FetchPrimaryAisleProductCountQueryHookResult = ReturnType<
  typeof useFetchPrimaryAisleProductCountQuery
>
export type FetchPrimaryAisleProductCountLazyQueryHookResult = ReturnType<
  typeof useFetchPrimaryAisleProductCountLazyQuery
>
export type FetchPrimaryAisleProductCountQueryResult = ApolloReactCommon.QueryResult<
  FetchPrimaryAisleProductCountQuery,
  FetchPrimaryAisleProductCountQueryVariables
>
export const GetAllRetailerLocationsForRetailerDocument = gql`
  query getAllRetailerLocationsForRetailer($retailerId: ID!) {
    retailerLocationSearchArray(retailerId: $retailerId, includeInactiveLocations: true) {
      id
      name
      street
      city
      state
      zipCode
      locationCode
      active
      pickup
      pickingModel
      fulfillmentModels
      partnerAlcoholDelivery
      hybridPickingEnabled
    }
  }
`

/**
 * __useGetAllRetailerLocationsForRetailerQuery__
 *
 * To run a query within a React component, call `useGetAllRetailerLocationsForRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRetailerLocationsForRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRetailerLocationsForRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetAllRetailerLocationsForRetailerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetAllRetailerLocationsForRetailerQuery,
    GetAllRetailerLocationsForRetailerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAllRetailerLocationsForRetailerQuery,
    GetAllRetailerLocationsForRetailerQueryVariables
  >(GetAllRetailerLocationsForRetailerDocument, options)
}
export function useGetAllRetailerLocationsForRetailerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllRetailerLocationsForRetailerQuery,
    GetAllRetailerLocationsForRetailerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAllRetailerLocationsForRetailerQuery,
    GetAllRetailerLocationsForRetailerQueryVariables
  >(GetAllRetailerLocationsForRetailerDocument, options)
}
export type GetAllRetailerLocationsForRetailerQueryHookResult = ReturnType<
  typeof useGetAllRetailerLocationsForRetailerQuery
>
export type GetAllRetailerLocationsForRetailerLazyQueryHookResult = ReturnType<
  typeof useGetAllRetailerLocationsForRetailerLazyQuery
>
export type GetAllRetailerLocationsForRetailerQueryResult = ApolloReactCommon.QueryResult<
  GetAllRetailerLocationsForRetailerQuery,
  GetAllRetailerLocationsForRetailerQueryVariables
>
export const GetRetailerDocument = gql`
  query getRetailer($retailerId: ID!) {
    retailer(id: $retailerId) {
      id
      name
      partner {
        id
        name
      }
      featureToggles {
        name
      }
      slug
    }
  }
`

/**
 * __useGetRetailerQuery__
 *
 * To run a query within a React component, call `useGetRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetRetailerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<GetRetailerQuery, GetRetailerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetRetailerQuery, GetRetailerQueryVariables>(
    GetRetailerDocument,
    options
  )
}
export function useGetRetailerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRetailerQuery, GetRetailerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetRetailerQuery, GetRetailerQueryVariables>(
    GetRetailerDocument,
    options
  )
}
export type GetRetailerQueryHookResult = ReturnType<typeof useGetRetailerQuery>
export type GetRetailerLazyQueryHookResult = ReturnType<typeof useGetRetailerLazyQuery>
export type GetRetailerQueryResult = ApolloReactCommon.QueryResult<
  GetRetailerQuery,
  GetRetailerQueryVariables
>
export const GetRetailerLocalesMeshDocument = gql`
  query getRetailerLocalesMesh($retailerId: BigInt!) {
    catalogToolsApiServiceGetLocalesByRetailer(input: { retailerId: $retailerId }) {
      retailerLocales {
        localeId
        localeCode
      }
    }
  }
`

/**
 * __useGetRetailerLocalesMeshQuery__
 *
 * To run a query within a React component, call `useGetRetailerLocalesMeshQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetailerLocalesMeshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetailerLocalesMeshQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useGetRetailerLocalesMeshQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetRetailerLocalesMeshQuery,
    GetRetailerLocalesMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetRetailerLocalesMeshQuery,
    GetRetailerLocalesMeshQueryVariables
  >(GetRetailerLocalesMeshDocument, options)
}
export function useGetRetailerLocalesMeshLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRetailerLocalesMeshQuery,
    GetRetailerLocalesMeshQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRetailerLocalesMeshQuery,
    GetRetailerLocalesMeshQueryVariables
  >(GetRetailerLocalesMeshDocument, options)
}
export type GetRetailerLocalesMeshQueryHookResult = ReturnType<
  typeof useGetRetailerLocalesMeshQuery
>
export type GetRetailerLocalesMeshLazyQueryHookResult = ReturnType<
  typeof useGetRetailerLocalesMeshLazyQuery
>
export type GetRetailerLocalesMeshQueryResult = ApolloReactCommon.QueryResult<
  GetRetailerLocalesMeshQuery,
  GetRetailerLocalesMeshQueryVariables
>
export const GetStoreConfigsDocument = gql`
  query getStoreConfigs(
    $retailerIds: [ID!]!
    $storeConfigRelationship: StoreConfigurationRelationshipEnum!
    $active: Boolean
  ) {
    storeConfigurationsByRetailerIds(
      retailerIds: $retailerIds
      storeConfigRelationship: $storeConfigRelationship
      active: $active
    ) {
      id
      slug
      brandedName
      whitelistedWarehouseIds
      domainName
      legal {
        shortName
      }
      deApplicationPlatform
      createdAt
      updatedAt
      allowAllWarehouses
      logoUrl
      userAccessToModify
      active
      partnerAccessSettings {
        visibleToPartnersOnIpp
        modificationRules {
          allowlistPartnerIds
        }
      }
      userIsolationContextId
    }
  }
`

/**
 * __useGetStoreConfigsQuery__
 *
 * To run a query within a React component, call `useGetStoreConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreConfigsQuery({
 *   variables: {
 *      retailerIds: // value for 'retailerIds'
 *      storeConfigRelationship: // value for 'storeConfigRelationship'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetStoreConfigsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetStoreConfigsQuery,
    GetStoreConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>(
    GetStoreConfigsDocument,
    options
  )
}
export function useGetStoreConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetStoreConfigsQuery,
    GetStoreConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetStoreConfigsQuery, GetStoreConfigsQueryVariables>(
    GetStoreConfigsDocument,
    options
  )
}
export type GetStoreConfigsQueryHookResult = ReturnType<typeof useGetStoreConfigsQuery>
export type GetStoreConfigsLazyQueryHookResult = ReturnType<typeof useGetStoreConfigsLazyQuery>
export type GetStoreConfigsQueryResult = ApolloReactCommon.QueryResult<
  GetStoreConfigsQuery,
  GetStoreConfigsQueryVariables
>
export const GetTaxonomyNodesDocument = gql`
  query getTaxonomyNodes {
    taxonomyNodes {
      id
      name
      parentId
    }
  }
`

/**
 * __useGetTaxonomyNodesQuery__
 *
 * To run a query within a React component, call `useGetTaxonomyNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxonomyNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxonomyNodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxonomyNodesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetTaxonomyNodesQuery,
    GetTaxonomyNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>(
    GetTaxonomyNodesDocument,
    options
  )
}
export function useGetTaxonomyNodesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTaxonomyNodesQuery,
    GetTaxonomyNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetTaxonomyNodesQuery, GetTaxonomyNodesQueryVariables>(
    GetTaxonomyNodesDocument,
    options
  )
}
export type GetTaxonomyNodesQueryHookResult = ReturnType<typeof useGetTaxonomyNodesQuery>
export type GetTaxonomyNodesLazyQueryHookResult = ReturnType<typeof useGetTaxonomyNodesLazyQuery>
export type GetTaxonomyNodesQueryResult = ApolloReactCommon.QueryResult<
  GetTaxonomyNodesQuery,
  GetTaxonomyNodesQueryVariables
>
export const SearchEnterpriseAccountsAccountSelectDocument = gql`
  query searchEnterpriseAccountsAccountSelect(
    $email: String
    $partnerId: ID!
    $canonicalIds: [ID!]
  ) {
    enterpriseAccountSearch(
      email: $email
      canonicalIds: $canonicalIds
      partnerId: $partnerId
      limit: 20
    ) {
      edges {
        node {
          givenName
          surname
          email
          canonicalId
        }
      }
    }
  }
`

/**
 * __useSearchEnterpriseAccountsAccountSelectQuery__
 *
 * To run a query within a React component, call `useSearchEnterpriseAccountsAccountSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEnterpriseAccountsAccountSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEnterpriseAccountsAccountSelectQuery({
 *   variables: {
 *      email: // value for 'email'
 *      partnerId: // value for 'partnerId'
 *      canonicalIds: // value for 'canonicalIds'
 *   },
 * });
 */
export function useSearchEnterpriseAccountsAccountSelectQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchEnterpriseAccountsAccountSelectQuery,
    SearchEnterpriseAccountsAccountSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SearchEnterpriseAccountsAccountSelectQuery,
    SearchEnterpriseAccountsAccountSelectQueryVariables
  >(SearchEnterpriseAccountsAccountSelectDocument, options)
}
export function useSearchEnterpriseAccountsAccountSelectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchEnterpriseAccountsAccountSelectQuery,
    SearchEnterpriseAccountsAccountSelectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SearchEnterpriseAccountsAccountSelectQuery,
    SearchEnterpriseAccountsAccountSelectQueryVariables
  >(SearchEnterpriseAccountsAccountSelectDocument, options)
}
export type SearchEnterpriseAccountsAccountSelectQueryHookResult = ReturnType<
  typeof useSearchEnterpriseAccountsAccountSelectQuery
>
export type SearchEnterpriseAccountsAccountSelectLazyQueryHookResult = ReturnType<
  typeof useSearchEnterpriseAccountsAccountSelectLazyQuery
>
export type SearchEnterpriseAccountsAccountSelectQueryResult = ApolloReactCommon.QueryResult<
  SearchEnterpriseAccountsAccountSelectQuery,
  SearchEnterpriseAccountsAccountSelectQueryVariables
>
export const FetchAislesForDepartmentDocument = gql`
  query fetchAislesForDepartment($departmentId: ID!) {
    catalogDepartment(id: $departmentId) {
      aisles {
        id
        name
      }
    }
  }
`

/**
 * __useFetchAislesForDepartmentQuery__
 *
 * To run a query within a React component, call `useFetchAislesForDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAislesForDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAislesForDepartmentQuery({
 *   variables: {
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useFetchAislesForDepartmentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchAislesForDepartmentQuery,
    FetchAislesForDepartmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchAislesForDepartmentQuery,
    FetchAislesForDepartmentQueryVariables
  >(FetchAislesForDepartmentDocument, options)
}
export function useFetchAislesForDepartmentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchAislesForDepartmentQuery,
    FetchAislesForDepartmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchAislesForDepartmentQuery,
    FetchAislesForDepartmentQueryVariables
  >(FetchAislesForDepartmentDocument, options)
}
export type FetchAislesForDepartmentQueryHookResult = ReturnType<
  typeof useFetchAislesForDepartmentQuery
>
export type FetchAislesForDepartmentLazyQueryHookResult = ReturnType<
  typeof useFetchAislesForDepartmentLazyQuery
>
export type FetchAislesForDepartmentQueryResult = ApolloReactCommon.QueryResult<
  FetchAislesForDepartmentQuery,
  FetchAislesForDepartmentQueryVariables
>
export const FetchDepartmentsForRetailerDocument = gql`
  query fetchDepartmentsForRetailer($retailerId: ID!) {
    retailer(id: $retailerId) {
      departments {
        id
        name
      }
    }
  }
`

/**
 * __useFetchDepartmentsForRetailerQuery__
 *
 * To run a query within a React component, call `useFetchDepartmentsForRetailerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDepartmentsForRetailerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDepartmentsForRetailerQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *   },
 * });
 */
export function useFetchDepartmentsForRetailerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FetchDepartmentsForRetailerQuery,
    FetchDepartmentsForRetailerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FetchDepartmentsForRetailerQuery,
    FetchDepartmentsForRetailerQueryVariables
  >(FetchDepartmentsForRetailerDocument, options)
}
export function useFetchDepartmentsForRetailerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FetchDepartmentsForRetailerQuery,
    FetchDepartmentsForRetailerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FetchDepartmentsForRetailerQuery,
    FetchDepartmentsForRetailerQueryVariables
  >(FetchDepartmentsForRetailerDocument, options)
}
export type FetchDepartmentsForRetailerQueryHookResult = ReturnType<
  typeof useFetchDepartmentsForRetailerQuery
>
export type FetchDepartmentsForRetailerLazyQueryHookResult = ReturnType<
  typeof useFetchDepartmentsForRetailerLazyQuery
>
export type FetchDepartmentsForRetailerQueryResult = ApolloReactCommon.QueryResult<
  FetchDepartmentsForRetailerQuery,
  FetchDepartmentsForRetailerQueryVariables
>
export const ListStoreGroupsDocument = gql`
  query listStoreGroups($retailerId: ID!, $numGroups: Int, $afterGroup: String) {
    retailerLocationGroupsByRetailer(
      retailerId: $retailerId
      first: $numGroups
      after: $afterGroup
    ) {
      edges {
        node {
          id
          name
          updatedAt
          retailerLocationIds
        }
        cursor
      }
    }
  }
`

/**
 * __useListStoreGroupsQuery__
 *
 * To run a query within a React component, call `useListStoreGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStoreGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStoreGroupsQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      numGroups: // value for 'numGroups'
 *      afterGroup: // value for 'afterGroup'
 *   },
 * });
 */
export function useListStoreGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ListStoreGroupsQuery,
    ListStoreGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>(
    ListStoreGroupsDocument,
    options
  )
}
export function useListStoreGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListStoreGroupsQuery,
    ListStoreGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ListStoreGroupsQuery, ListStoreGroupsQueryVariables>(
    ListStoreGroupsDocument,
    options
  )
}
export type ListStoreGroupsQueryHookResult = ReturnType<typeof useListStoreGroupsQuery>
export type ListStoreGroupsLazyQueryHookResult = ReturnType<typeof useListStoreGroupsLazyQuery>
export type ListStoreGroupsQueryResult = ApolloReactCommon.QueryResult<
  ListStoreGroupsQuery,
  ListStoreGroupsQueryVariables
>
export const ListTopProductsDocument = gql`
  query listTopProducts(
    $retailerId: ID!
    $startAt: ISO8601Date
    $endAt: ISO8601Date
    $page: Int
    $limit: Int
  ) {
    analyticsTopProducts(
      retailerId: $retailerId
      startAt: $startAt
      endAt: $endAt
      page: $page
      limit: $limit
    ) {
      topProducts {
        id
        productName
        imageUrl
        availabilityPercentage
        foundRatePercentage
        orderedItems
        refundRatePercentage
        gmv
        department
      }
      totalCount
    }
  }
`

/**
 * __useListTopProductsQuery__
 *
 * To run a query within a React component, call `useListTopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTopProductsQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTopProductsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ListTopProductsQuery,
    ListTopProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ListTopProductsQuery, ListTopProductsQueryVariables>(
    ListTopProductsDocument,
    options
  )
}
export function useListTopProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListTopProductsQuery,
    ListTopProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ListTopProductsQuery, ListTopProductsQueryVariables>(
    ListTopProductsDocument,
    options
  )
}
export type ListTopProductsQueryHookResult = ReturnType<typeof useListTopProductsQuery>
export type ListTopProductsLazyQueryHookResult = ReturnType<typeof useListTopProductsLazyQuery>
export type ListTopProductsQueryResult = ApolloReactCommon.QueryResult<
  ListTopProductsQuery,
  ListTopProductsQueryVariables
>
export const RetailerProductAggregateDataDocument = gql`
  query retailerProductAggregateData($retailerId: BigInt!, $productIds: [BigInt!]) {
    catalogToolsApiServiceGetRetailerProductData(
      input: { retailerId: $retailerId, productIds: $productIds }
    ) {
      retailerProductData {
        retailerId
        productId
        maxPriceCents
        minPriceCents
        availableItemsCount
        visibleItemsCount
        itemsCount
        generatedAt
      }
    }
  }
`

/**
 * __useRetailerProductAggregateDataQuery__
 *
 * To run a query within a React component, call `useRetailerProductAggregateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerProductAggregateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerProductAggregateDataQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useRetailerProductAggregateDataQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RetailerProductAggregateDataQuery,
    RetailerProductAggregateDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RetailerProductAggregateDataQuery,
    RetailerProductAggregateDataQueryVariables
  >(RetailerProductAggregateDataDocument, options)
}
export function useRetailerProductAggregateDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RetailerProductAggregateDataQuery,
    RetailerProductAggregateDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RetailerProductAggregateDataQuery,
    RetailerProductAggregateDataQueryVariables
  >(RetailerProductAggregateDataDocument, options)
}
export type RetailerProductAggregateDataQueryHookResult = ReturnType<
  typeof useRetailerProductAggregateDataQuery
>
export type RetailerProductAggregateDataLazyQueryHookResult = ReturnType<
  typeof useRetailerProductAggregateDataLazyQuery
>
export type RetailerProductAggregateDataQueryResult = ApolloReactCommon.QueryResult<
  RetailerProductAggregateDataQuery,
  RetailerProductAggregateDataQueryVariables
>
export const RetailerProductSearchDocument = gql`
  query retailerProductSearch(
    $aisleIds: [BigInt]
    $departmentIds: [BigInt]
    $limit: BigInt
    $localeCode: InstacartCustomersSharedV1Locale
    $offset: BigInt
    $productCodes: [String]
    $query: String
    $retailerId: BigInt!
    $retailerReferenceCodes: [String]
  ) {
    retailerToolsServiceGetRetailerProducts(
      input: {
        parameters: {
          aisleIds: $aisleIds
          departmentIds: $departmentIds
          limit: $limit
          localeCode: $localeCode
          offset: $offset
          productCodes: $productCodes
          query: $query
          retailerId: $retailerId
          retailerReferenceCodes: $retailerReferenceCodes
        }
      }
    ) {
      results {
        aisles {
          id
          name
        }
        departments {
          id
          name
        }
        localeCode
        primaryAisleId
        primaryDepartmentId
        primaryImageUrl
        productCodes
        productDisplayName
        productId
        retailerId
        retailerReferenceCode
        score
      }
      totalCount
    }
  }
`

/**
 * __useRetailerProductSearchQuery__
 *
 * To run a query within a React component, call `useRetailerProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetailerProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetailerProductSearchQuery({
 *   variables: {
 *      aisleIds: // value for 'aisleIds'
 *      departmentIds: // value for 'departmentIds'
 *      limit: // value for 'limit'
 *      localeCode: // value for 'localeCode'
 *      offset: // value for 'offset'
 *      productCodes: // value for 'productCodes'
 *      query: // value for 'query'
 *      retailerId: // value for 'retailerId'
 *      retailerReferenceCodes: // value for 'retailerReferenceCodes'
 *   },
 * });
 */
export function useRetailerProductSearchQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RetailerProductSearchQuery,
    RetailerProductSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<RetailerProductSearchQuery, RetailerProductSearchQueryVariables>(
    RetailerProductSearchDocument,
    options
  )
}
export function useRetailerProductSearchLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RetailerProductSearchQuery,
    RetailerProductSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RetailerProductSearchQuery,
    RetailerProductSearchQueryVariables
  >(RetailerProductSearchDocument, options)
}
export type RetailerProductSearchQueryHookResult = ReturnType<typeof useRetailerProductSearchQuery>
export type RetailerProductSearchLazyQueryHookResult = ReturnType<
  typeof useRetailerProductSearchLazyQuery
>
export type RetailerProductSearchQueryResult = ApolloReactCommon.QueryResult<
  RetailerProductSearchQuery,
  RetailerProductSearchQueryVariables
>
export const ListReportRequestsDocument = gql`
  query listReportRequests($retailerId: ID!, $limit: Int, $offset: Int) {
    reportRequests(retailerId: $retailerId, limit: $limit, offset: $offset) {
      edges {
        node {
          id
          name
          generationState
          createdAt
          updatedAt
          report {
            slug
          }
          enterpriseAccount {
            givenName
            surname
          }
          reportViews {
            id
            __typename
            ... on ReportsReportViewsCsv {
              downloadUrl
            }
          }
        }
      }
      meta {
        totalCount
      }
    }
  }
`

/**
 * __useListReportRequestsQuery__
 *
 * To run a query within a React component, call `useListReportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReportRequestsQuery({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListReportRequestsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ListReportRequestsQuery,
    ListReportRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ListReportRequestsQuery, ListReportRequestsQueryVariables>(
    ListReportRequestsDocument,
    options
  )
}
export function useListReportRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListReportRequestsQuery,
    ListReportRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ListReportRequestsQuery, ListReportRequestsQueryVariables>(
    ListReportRequestsDocument,
    options
  )
}
export type ListReportRequestsQueryHookResult = ReturnType<typeof useListReportRequestsQuery>
export type ListReportRequestsLazyQueryHookResult = ReturnType<
  typeof useListReportRequestsLazyQuery
>
export type ListReportRequestsQueryResult = ApolloReactCommon.QueryResult<
  ListReportRequestsQuery,
  ListReportRequestsQueryVariables
>
export const ReportListDocument = gql`
  query reportList {
    reports {
      id
      slug
      createdAt
      updatedAt
      supportedFilters {
        filterType
        required
        slug
        ... on ReportsReportFilterDefinitionsDateRange {
          minDate
          maxDate
        }
      }
    }
  }
`

/**
 * __useReportListQuery__
 *
 * To run a query within a React component, call `useReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportListQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportListQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ReportListQuery, ReportListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ReportListQuery, ReportListQueryVariables>(
    ReportListDocument,
    options
  )
}
export function useReportListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportListQuery, ReportListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ReportListQuery, ReportListQueryVariables>(
    ReportListDocument,
    options
  )
}
export type ReportListQueryHookResult = ReturnType<typeof useReportListQuery>
export type ReportListLazyQueryHookResult = ReturnType<typeof useReportListLazyQuery>
export type ReportListQueryResult = ApolloReactCommon.QueryResult<
  ReportListQuery,
  ReportListQueryVariables
>
export const ReportRequestCreateDocument = gql`
  mutation reportRequestCreate(
    $name: String!
    $reportId: ID!
    $associatedObjectId: ID!
    $associatedObjectType: ReportRequestAssociatedObjectTypeEnum!
    $reportFilters: ReportFilters
  ) {
    reportRequestCreate(
      name: $name
      reportId: $reportId
      associatedObjectId: $associatedObjectId
      associatedObjectType: $associatedObjectType
      filters: $reportFilters
    ) {
      reportRequest {
        id
        generationState
        name
      }
    }
  }
`

/**
 * __useReportRequestCreateMutation__
 *
 * To run a mutation, you first call `useReportRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRequestCreateMutation, { data, loading, error }] = useReportRequestCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      reportId: // value for 'reportId'
 *      associatedObjectId: // value for 'associatedObjectId'
 *      associatedObjectType: // value for 'associatedObjectType'
 *      reportFilters: // value for 'reportFilters'
 *   },
 * });
 */
export function useReportRequestCreateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReportRequestCreateMutation,
    ReportRequestCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReportRequestCreateMutation,
    ReportRequestCreateMutationVariables
  >(ReportRequestCreateDocument, options)
}
export type ReportRequestCreateMutationHookResult = ReturnType<
  typeof useReportRequestCreateMutation
>
export type ReportRequestCreateMutationResult =
  ApolloReactCommon.MutationResult<ReportRequestCreateMutation>
export type ReportRequestCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ReportRequestCreateMutation,
  ReportRequestCreateMutationVariables
>
export const ReportViewDownloadUrlDocument = gql`
  query reportViewDownloadUrl($reportViewId: ID!) {
    reportView(reportViewId: $reportViewId) {
      __typename
      ... on ReportsReportViewsCsv {
        downloadUrl
      }
    }
  }
`

/**
 * __useReportViewDownloadUrlQuery__
 *
 * To run a query within a React component, call `useReportViewDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportViewDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportViewDownloadUrlQuery({
 *   variables: {
 *      reportViewId: // value for 'reportViewId'
 *   },
 * });
 */
export function useReportViewDownloadUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ReportViewDownloadUrlQuery,
    ReportViewDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ReportViewDownloadUrlQuery, ReportViewDownloadUrlQueryVariables>(
    ReportViewDownloadUrlDocument,
    options
  )
}
export function useReportViewDownloadUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ReportViewDownloadUrlQuery,
    ReportViewDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ReportViewDownloadUrlQuery,
    ReportViewDownloadUrlQueryVariables
  >(ReportViewDownloadUrlDocument, options)
}
export type ReportViewDownloadUrlQueryHookResult = ReturnType<typeof useReportViewDownloadUrlQuery>
export type ReportViewDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useReportViewDownloadUrlLazyQuery
>
export type ReportViewDownloadUrlQueryResult = ApolloReactCommon.QueryResult<
  ReportViewDownloadUrlQuery,
  ReportViewDownloadUrlQueryVariables
>
export const usePaginatedSearchEnterpriseAccountsAccountSelectQuery = withPaginationDetails(
  useSearchEnterpriseAccountsAccountSelectQuery,
  'enterpriseAccountSearch'
)
export const usePaginatedListStoreGroupsQuery = withPaginationDetails(
  useListStoreGroupsQuery,
  'retailerLocationGroupsByRetailer'
)
export const usePaginatedListReportRequestsQuery = withPaginationDetails(
  useListReportRequestsQuery,
  'reportRequests'
)
